msgid ""
msgstr ""
"Project-Id-Version: \n"
"POT-Creation-Date: 2026-02-03 12:52+0100\n"
"PO-Revision-Date: 2026-06-04 10:13+0200\n"
"Last-Translator: \n"
"Language-Team: \n"
"Language: hu\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"
"X-Generator: Poedit 3.9\n"
"X-Poedit-Basepath: ..\n"
"X-Poedit-SearchPath-0: .\n"
"X-Poedit-SearchPath-1: components\n"
"X-Poedit-SearchPathExcluded-0: assets\n"
"X-Poedit-SearchPathExcluded-1: connections\n"
"X-Poedit-SearchPathExcluded-2: messages\n"

msgctxt "RouterTab"
msgid "Close above"
msgstr "Felfele lévő oldalak bezárása"

msgctxt "RouterTab"
msgid "Close below"
msgstr "Lefelé lévő oldalak bezárása"

msgctxt "RouterTab"
msgid "Are you sure you want to close this page?"
msgstr "Biztosan be akarja zárni ezt az oldalt?"

msgctxt "RouterTab"
msgid "Are you sure you want to close the other pages?"
msgstr "Biztosan be akarja zárni a többi oldalt?"

msgctxt "RouterTab"
msgid "Are you sure you want to close all the pages?"
msgstr "Biztosan be akarja zárni az összes oldalt?"

msgctxt "RouterTab"
msgid "Are you sure you want to close all pages to the left?"
msgstr "Biztosan be akarja zárni az összes balra lévő oldalt?"

msgctxt "RouterTab"
msgid "Are you sure you want to close all pages to the right?"
msgstr "Biztosan be akarja zárni az összes jobbra lévő oldalt?"

msgctxt "RouterTab"
msgid "Close"
msgstr "Bezárás"

msgctxt "RouterTab"
msgid "Close to the left"
msgstr "Balra lévő oldalak bezárása"

msgctxt "RouterTab"
msgid "Close to the right"
msgstr "Jobbra lévő oldalak bezárása"

msgctxt "RouterTab"
msgid "Close others"
msgstr "Többi oldal bezárása"

msgctxt "RouterTab"
msgid "Close all"
msgstr "Minden oldal bezárása"

msgctxt "RouterTab"
msgid "Refresh"
msgstr "Frissítés"

msgctxt "RouterTab"
msgid "Refresh all"
msgstr "Minden oldal frissítése"

msgctxt "RentalServices"
msgid "Active"
msgstr "Aktív"

msgctxt "RentalServices"
msgid "Inactive"
msgstr "Inaktív"

msgctxt "RentalServices"
msgid "Oldest first"
msgstr "Legrégebbi előre"

msgctxt "RentalServices"
msgid "Newest first"
msgstr "Legújabb előre"

msgctxt "RentalServices"
msgid "Valid from ascending"
msgstr "Kezdő érvényesség szerint növekvő"

msgctxt "RentalServices"
msgid "Valid from descending"
msgstr "Kezdő érvényesség szerint csökkenő"

#: components/MainMenu.yaml:39
msgctxt "MainMenu"
msgid "Finance"
msgstr "Pénzügy"

#: components/MainMenu.yaml:44
msgctxt "MainMenu"
msgid "Register"
msgstr "Iktatás"

#: components/MainMenu.yaml:50
msgctxt "MainMenu"
msgid "Registers"
msgstr "Iktatókönyvek"

#: components/MainMenu.yaml:57
msgctxt "MainMenu"
msgid "Letter register"
msgstr "Levelek iktatása"

#: components/MainMenu.yaml:64 components/charts/Charts.yaml:70
msgctxt "MainMenu"
msgid "Invoice register"
msgstr "Számlák iktatása"

#: components/MainMenu.yaml:72
msgctxt "MainMenu"
msgid "Customer invoices"
msgstr "Vevőszámlák"

#: components/MainMenu.yaml:83
msgctxt "MainMenu"
msgid "New Customer Invoice..."
msgstr "Új vevőszámla..."

#: components/MainMenu.yaml:99
msgctxt "MainMenu"
msgid "Billing List"
msgstr "Számlázandó tételek"

#: components/MainMenu.yaml:106
msgctxt "MainMenu"
msgid "Invoice Generation"
msgstr "Számlagenerálás"

#: components/MainMenu.yaml:113
msgctxt "MainMenu"
msgid "Draft Invoice Summary"
msgstr "Számlatervezet összesítő"

#: components/MainMenu.yaml:121
msgctxt "MainMenu/Finance/Downloads"
msgid "Download outgoing invoice lines"
msgstr "Számlasorok letöltése"

#: components/MainMenu.yaml:133
msgctxt "MainMenu/Finance/Downloads"
msgid "Download outgoing invoice lines (exp)"
msgstr "Számlasorok letöltése (kísérleti)"

#: components/MainMenu.yaml:145
msgctxt "MainMenu"
msgid "Incoming invoices"
msgstr "Szállítói számlák"

#: components/MainMenu.yaml:156
msgctxt "MainMenu"
msgid "New Incoming Invoice..."
msgstr "Új szállítói számla..."

#: components/MainMenu.yaml:173
msgctxt "MainMenu/Finance/Downloads"
msgid "Download incoming invoice lines"
msgstr "Szállítói számlasorok letöltése"

#: components/MainMenu.yaml:185
msgctxt "MainMenu"
msgid "Payments"
msgstr "Pénzforgalom"

#: components/MainMenu.yaml:191 components/payments/Payments.yaml:4
#: components/payments/views/PaymentsView.yaml:69
msgctxt "PaymentsView"
msgid "Payments"
msgstr "Pénzforgalom"

#: components/MainMenu.yaml:198
msgctxt "MainMenu"
msgid "Accounts Daily Flow"
msgstr "Napi pénzforgalom"

#: components/MainMenu.yaml:203
msgctxt "Create Payment"
msgid "New Cash In..."
msgstr "Új pénztári befizetés..."

#: components/MainMenu.yaml:218
msgctxt "Create Payment"
msgid "New Cash Out..."
msgstr "Új pénztári kifizetés..."

#: components/MainMenu.yaml:233
msgctxt "Create Payment"
msgid "New Banking..."
msgstr "Új Banki tétel..."

#: components/MainMenu.yaml:247
msgctxt "MeinMenu"
msgid "Account statement report..."
msgstr "Pénztári elszámolás..."

#: components/MainMenu.yaml:261
msgctxt "MainMenu"
msgid "Invoice Payments"
msgstr "Számla kiegyenlítések"

#: components/MainMenu.yaml:269
msgctxt "MainMenu/Finance/Downloads"
msgid "Download payments"
msgstr "Fizetések letöltése"

#: components/MainMenu.yaml:281
msgctxt "MainMenu/Finance/Downloads"
msgid "Download invoice payments"
msgstr "Számla kiegyenlítések letöltése"

#: components/MainMenu.yaml:293
msgctxt "MainMenu/Finance/Downloads"
msgid "Download invoice info"
msgstr "Számla info letöltése"

#: components/MainMenu.yaml:305
msgctxt "MainMenu"
msgid "Claims management"
msgstr "Követeléskezelés"

#: components/MainMenu.yaml:311
msgctxt "MainMenu"
msgid "Claims"
msgstr "Követelések"

#: components/MainMenu.yaml:318
msgctxt "MainMenu"
msgid "Dunning letters"
msgstr "Felszólítólevelek"

#: components/MainMenu.yaml:325
msgctxt "MainMenu"
msgid "Invoice Claims"
msgstr "Vevőtartozások"

#: components/MainMenu.yaml:333
msgctxt "MainMenu"
msgid "Assets"
msgstr "Eszközök"

#: components/MainMenu.yaml:339
msgctxt "MainMenu"
msgid "Fixed Assets"
msgstr "Tárgyi eszközök"

#: components/MainMenu.yaml:344
msgctxt "MainMenu"
msgid "Create Asset..."
msgstr "Tárgyi eszköz felvétele..."

#: components/MainMenu.yaml:362
msgctxt "MainMenu"
msgid "Waste Bins"
msgstr "Hulladékgyűjtők"

#: components/MainMenu.yaml:369
msgctxt "MainMenu"
msgid "Waste Bin Readings"
msgstr "Hulladékgyűjtő leolvasások"

#: components/MainMenu.yaml:374
msgctxt "MainMenu"
msgid "Create Waste Bin..."
msgstr "Hulladékgyűjtő felvétele..."

#: components/MainMenu.yaml:389
msgctxt "MainMenu"
msgid "Meters"
msgstr "Mérőórák"

#: components/MainMenu.yaml:400
msgctxt "MainMenu"
msgid "Add Meter..."
msgstr "Új mérőóra felvétele..."

#: components/MainMenu.yaml:414
msgctxt "MainMenu"
msgid "Replace meter..."
msgstr "Mérőóra csere..."

#: components/MainMenu.yaml:427
msgctxt "MainMenu"
msgid "Auto Readings"
msgstr "Automata adatszolgáltatás"

#: components/MainMenu.yaml:434
msgctxt "MainMenu"
msgid "Meter Data Exchange..."
msgstr "Mérőóra adatcsere..."

#: components/MainMenu.yaml:447
msgctxt "MainMenu"
msgid "Meter consumptions"
msgstr "Mérőóra Fogyasztások"

#: components/MainMenu.yaml:454
msgctxt "MainMenu"
msgid "Reading Data"
msgstr "Leolvasások"

#: components/MainMenu.yaml:466
msgctxt "MainMenu/Meters/Downloads"
msgid "Download meter consumptions"
msgstr "Energia controlling file letöltése"

#: components/MainMenu.yaml:478
msgctxt "MainMenu"
msgid "Contracts"
msgstr "Szerződések"

#: components/MainMenu.yaml:489
msgctxt "MainMenu"
msgid "Create Contract..."
msgstr "Új szerződés..."

#: components/MainMenu.yaml:503
msgctxt "MainMenu"
msgid "Contract services"
msgstr "Szerződött szolgáltatások"

#: components/MainMenu.yaml:510
msgctxt "MainMenu"
msgid "Contract service fees"
msgstr "Szerződött szolgáltatás díjak"

#: components/MainMenu.yaml:517
msgctxt "MainMenu"
msgid "Contract attachments"
msgstr "Szerződés csatolmányok"

#: components/MainMenu.yaml:524
msgctxt "MainMenu"
msgid "Contract events"
msgstr "Szerződés események"

#: components/MainMenu.yaml:533
msgctxt "MainMenu"
msgid "Overlapping Revisions"
msgstr "Egymást átfedő szerződések"

#: components/MainMenu.yaml:540
msgctxt "MainMenu"
msgid "Billing rules"
msgstr "Számlázási szabályok"

#: components/MainMenu.yaml:553
msgctxt "MainMenu"
msgid "Fees"
msgstr "Díjak"

#: components/MainMenu.yaml:559
msgctxt "MainMenu"
msgid "Parking spots"
msgstr "Gépkocsibeállók"

#: components/MainMenu.yaml:567
msgctxt "MainMenu"
msgid "Worksheets"
msgstr "Munkalapok"

#: components/MainMenu.yaml:578
msgctxt "MainMenu"
msgid "New Worksheet..."
msgstr "Új munkalap..."

#: components/MainMenu.yaml:594
msgctxt "MainMenu"
msgid "Work summary"
msgstr "Munkák összesítése"

#: components/MainMenu.yaml:602
msgctxt "MainMenu"
msgid "Master data"
msgstr "Törzsadatok"

#: components/MainMenu.yaml:608
msgctxt "MainMenu"
msgid "Products"
msgstr "Termékek"

#: components/MainMenu.yaml:613
msgctxt "MainMenu"
msgid "New product/service..."
msgstr "Új termék/szolgáltatás..."

#: components/MainMenu.yaml:625
msgctxt "MainMenu"
msgid "Tariffs..."
msgstr "Tarifák..."

#: components/MainMenu.yaml:641
msgctxt "MainMenu"
msgid "Rentals"
msgstr "Bérlemények"

#: components/MainMenu.yaml:646
msgctxt "MainMenu"
msgid "Add Rental..."
msgstr "Új bérlemény..."

#: components/MainMenu.yaml:660
msgctxt "MainMenu"
msgid "Rental services"
msgstr "Bérlemény Szolgáltatások"

#: components/MainMenu.yaml:669
msgctxt "MainMenu"
msgid "Projects"
msgstr "Projektek"

#: components/MainMenu.yaml:674
msgctxt "MainMenu"
msgid "Add project..."
msgstr "Új projekt..."

#: components/MainMenu.yaml:690
msgctxt "MainMenu"
msgid "Locations"
msgstr "Helyek"

#: components/MainMenu.yaml:695
msgctxt "MainMenu"
msgid "Add property..."
msgstr "Új hely.."

#: components/MainMenu.yaml:711
msgctxt "MainMenu"
msgid "Partners"
msgstr "Ügyfelek"

#: components/MainMenu.yaml:716
msgctxt "MainMenu"
msgid "Add partner..."
msgstr "Új ügyfél felvétele..."

#: components/MainMenu.yaml:734
msgctxt "MainMenu"
msgid "Own companies"
msgstr "Saját cégek"

#: components/MainMenu.yaml:739
msgctxt "MainMenu"
msgid "Add company..."
msgstr "Új saját cég..."

#: components/MainMenu.yaml:778
msgctxt "MainMenu"
msgid "Profile"
msgstr "Profil"

#: components/MainMenu.yaml:803
msgctxt "MainMenu"
msgid "Confirm page close"
msgstr "Figyelmeztetés az oldal bezárásakor"

msgctxt "LayoutMode"
msgid "Tabbed layout"
msgstr "Füles elrendezés"

msgctxt "LayoutMode"
msgid "Sidebar layout"
msgstr "Oldalsávos elrendezés"

#: components/MainMenu.yaml:815
msgctxt "MainMenu"
msgid "Sign out"
msgstr "Kijelentkezés"

#: components/MainMenu.yaml:837
msgctxt "MainMenu"
msgid "Jobs"
msgstr "Folyamatok"

#: components/MainMenu.yaml:844
msgctxt "MainMenu"
msgid "Attachments"
msgstr "Csatolmányok"

#: components/MainMenu.yaml:851
msgctxt "MainMenu"
msgid "Templates"
msgstr "Sablonok"

#: components/MainMenu.yaml:860
msgctxt "MainMenu"
msgid "Settings"
msgstr "Beállítások"

#: components/MainMenu.yaml:866
msgctxt "MainMenu"
msgid "About Integro"
msgstr "Integro névjegy"

#: components/accounts/Account.yaml:7
msgid "New Cash or Bank Account"
msgstr "Új készpénz vagy bankszámla"

#: components/accounts/Account.yaml:8
msgid "Account"
msgstr "Folyószámla"

#: components/accounts/Account.yaml:85
#: components/common/BtnDeleteResource.yaml:61
#: components/common/UcAttachmentsList.yaml:150
#: components/companies/form/addresses/UcAddressList.yaml:127
#: components/companies/form/bank-accounts/UcCompanyBankAccounts.yaml:110
#: components/contracts/primitives/UcContractRevisionDropdown.yaml:96
#: components/finance/dunning-letter/DunningLetter.yaml:123
#: components/invoice/form/UcInvoiceViewDocumentDropdown.yaml:119
#: components/rental/form/properties/UcRentalFormProperties.yaml:48
msgid "Please confirm delete."
msgstr "A művelet nem visszavonható, jóváhagyás szükséges."

#: components/accounts/Account.yaml:86
#: components/assets/WasteBinReadingsList.yaml:38
#: components/billing/UcBillingList.yaml:489
#: components/common/BtnDeleteResource.yaml:62
#: components/common/UcAttachmentsList.yaml:151
#: components/companies/form/addresses/UcAddressList.yaml:128
#: components/companies/form/bank-accounts/UcCompanyBankAccounts.yaml:111
#: components/contracts/primitives/UcContractRevisionDropdown.yaml:97
#: components/finance/dunning-letter/DunningLetter.yaml:124
#: components/invoice/form/UcInvoiceViewDocumentDropdown.yaml:120
#: components/invoice/invoice-generation/UcInvoiceGenerationInvoiceLines.yaml:188
#: components/meters/MeterConsumptionBrowser.yaml:391
#: components/registers/form/UcRegister.yaml:72
#: components/rental/form/properties/UcRentalFormProperties.yaml:49
#: components/worksheets/WorksheetList.yaml:155
msgid "Delete"
msgstr "Törlés"

#: components/accounts/Account.yaml:173 components/common/WComment.yaml:109
#: components/companies/form/addresses/Address.yaml:94
#: components/companies/form/contacts/WContactModal.yaml:92
#: components/companies/form/employees/WEmployeeModal.yaml:91
#: components/contracts/InflationIndexedPriceChange.yaml:241
#: components/finance/dunning-letter/DunningLetter.yaml:408
#: components/invoice/form/InvoiceLineGroup.yaml:259
#: components/multilineNotes/MultilineNotes.yaml:117
#: components/rental/form/properties/RentalProperty.yaml:184
msgid "Save"
msgstr "Mentés"

#: components/accounts/Account.yaml:179
#: components/assets/CreateWorksheetsFromWasteBinReadingsModal.yaml:184
#: components/assets/WasteBinReadingModal.yaml:9
#: components/billing/BatchBillingListEditor.yaml:415
#: components/billing/CopyBillingListItems.yaml:557
#: components/billingRules/BillingRules.yaml:301
#: components/common/FileSelector.yaml:10
#: components/common/WAttachmentModal.yaml:128
#: components/companies/CreateCompany.yaml:154
#: components/companies/form/addresses/Address.yaml:100
#: components/companies/form/contacts/WContactModal.yaml:98
#: components/companies/form/employees/WEmployeeModal.yaml:97
#: components/contracts/ContractEditor.yaml:9
#: components/contracts/CreateContractRevision.yaml:274
#: components/contracts/form/services/BulkContractServiceEditor.yaml:9
#: components/contracts/form/statuses/ContractStatusTransition.yaml:253
#: components/finance/Tariffs.yaml:91
#: components/invoice/BatchInvoiceEditor.yaml:392
#: components/invoice/InvoiceEditor.yaml:126
#: components/invoice/form/InvoiceLineGroup.yaml:267
#: components/jobs/job/Job.yaml:80 components/meters/CreateMeter.yaml:10
#: components/meters/ReplaceMeter.yaml:448
#: components/meters/form/general/MeterEditor.yaml:9
#: components/multilineNotes/TextTemplates.yaml:130
#: components/payments/ImportBankStatement.yaml:228
#: components/product/CreateProduct.yaml:153
#: components/product/ProductEditor.yaml:9
#: components/projects/CreateProject.yaml:135
#: components/property/CreateProperty.yaml:124
#: components/registers/RegisterEntry.yaml:331
#: components/rental/CreateRental.yaml:126
#: components/rental/form/general/MRentalGeneralDataEditor.yaml:9
#: components/rental/form/services/BulkRentalServiceEditor.yaml:432
#: components/tasks/TaskViewModal.yaml:10
#: components/worksheets/WorksheetEditor.yaml:9
msgid "Close"
msgstr "Bezárás"

#: components/accounts/AccountsView.yaml:5
msgctxt "AccountsView"
msgid "Cash and Bank Accounts"
msgstr "Készpénz- és bankszámlák"

#: components/accounts/AccountsView.yaml:34
msgctxt "ExportFilename"
msgid "accounts"
msgstr "folyószámlák"

#: components/accounts/AccountsView.yaml:41
msgctxt "AccountsView"
msgid "Owner"
msgstr "Tulajdonos"

#: components/accounts/AccountsView.yaml:51
msgctxt "AccountsView"
msgid "Name"
msgstr "Megnevezés"

#: components/accounts/AccountsView.yaml:58
msgctxt "AccountsView"
msgid "Type"
msgstr "Típus"

#: components/accounts/AccountsView.yaml:66
msgctxt "AccountsView"
msgid "Currency"
msgstr "Pénznem"

#: components/accounts/AccountsView.yaml:69
msgctxt "AccountsView"
msgid "Description"
msgstr "Leírás"

#: components/accounts/AccountsView.yaml:72
msgctxt "AccountsView"
msgid "Account nr"
msgstr "Számlaszám"

#: components/accounts/AccountsView.yaml:75
msgctxt "AccountsView"
msgid "Bank"
msgstr "Bank"

#: components/accounts/AccountsView.yaml:78
msgctxt "AccountsView"
msgid "IBAN"
msgstr "IBAN"

#: components/accounts/AccountsView.yaml:81
msgctxt "AccountsView"
msgid "SWIFT"
msgstr "SWIFT"

#: components/accounts/AccountsView.yaml:84
msgctxt "AccountsView"
msgid "Branch"
msgstr "Fiók"

#: components/accounts/AccountsView.yaml:87
#: components/assets/FixedAssetBrowser.yaml:71
#: components/assets/WasteBinsBrowser.yaml:88
#: components/attachments/AttachmentBrowser.yaml:53
#: components/billing/UcBillingList.yaml:374
#: components/companies/views/CompaniesView.yaml:119
#: components/contracts/views/ContractAttachments.yaml:78
#: components/finance/dunning-letter/DunningLetters.yaml:110
#: components/invoice/InvoiceBrowser.yaml:447
#: components/invoice/Invoices.yaml:397
#: components/invoice/invoice-generation/UcInvoiceGenerationInvoices.yaml:316
#: components/invoice/views/InvoiceLinesView.yaml:129
#: components/meters/MeterBrowser.yaml:204
#: components/meters/MeterConsumptionBrowser.yaml:291
#: components/product/ProductBrowser.yaml:80
#: components/projects/Projects.yaml:54
#: components/property/PropertyBrowser.yaml:69
#: components/registers/RegisterView.yaml:312
#: components/rental/RentalBrowser.yaml:156
#: components/rental/views/RentalServices.yaml:256
#: components/worksheets/WorksheetList.yaml:118
msgctxt "BrowserColumn"
msgid "Create time"
msgstr "Létrehozva"

#: components/accounts/AccountsView.yaml:100
msgctxt "AccountsView"
msgid "Add Account"
msgstr "Számla hozzáadása"

#: components/accounts/form/FieldsetAccountGeneral.yaml:23
msgctxt "RoundingType"
msgid "no rounding"
msgstr "nincs kerekítés"

#: components/accounts/form/FieldsetAccountGeneral.yaml:26
msgctxt "RoundingType"
msgid "round to 1"
msgstr "1-re"

#: components/accounts/form/FieldsetAccountGeneral.yaml:29
msgctxt "RoundingType"
msgid "round to 5"
msgstr "5-re"

#: components/accounts/form/FieldsetAccountGeneral.yaml:32
msgctxt "RoundingType"
msgid "round to 10"
msgstr "10-re"

#: components/accounts/form/FieldsetAccountGeneral.yaml:50
msgid "Owner"
msgstr "Tulajdonos"

#: components/accounts/form/FieldsetAccountGeneral.yaml:68
msgid "Account type"
msgstr "Számla típusa"

#: components/accounts/form/FieldsetAccountGeneral.yaml:85
#: components/settings/ExpenseTypes.yaml:50
msgid "Name"
msgstr "Megnevezés"

#: components/accounts/form/FieldsetAccountGeneral.yaml:101
#: components/companies/form/FieldsetCompanyGeneral.yaml:114
#: components/companies/form/addresses/FieldsetAddress.yaml:49
msgid "Default"
msgstr "Alapértelmezett"

#: components/accounts/form/FieldsetAccountGeneral.yaml:116
#: components/invoice/form/UcInvoiceExchangeRateEditor.yaml:62
#: components/product/ProductPricesDataTable.yaml:83
msgid "Currency"
msgstr "Pénznem"

#: components/accounts/form/FieldsetAccountGeneral.yaml:135
msgctxt "Account"
msgid "Rounding"
msgstr "Kerekítés"

#: components/accounts/form/FieldsetAccountGeneral.yaml:150
msgctxt "Account"
msgid "Invoice settlement tolerance"
msgstr "Számlarendezési eltérés"

#: components/accounts/form/FieldsetAccountGeneral.yaml:152
msgctxt "Account"
msgid "The excess settlement amount to allow on payments."
msgstr "A fizetések során engedélyezett többletkiegyenlítés maximális összege."

#: components/accounts/form/FieldsetAccountGeneral.yaml:167
msgctxt "Account"
msgid "Numbering (Pay in)"
msgstr "Sorszámozás (befizetés)"

#: components/accounts/form/FieldsetAccountGeneral.yaml:183
msgctxt "Account"
msgid "Numbering (Pay out)"
msgstr "Sorszámozás (kifizetés)"

#: components/accounts/form/FieldsetAccountGeneral.yaml:198
#: components/common/WAttachmentModal.yaml:101
#: components/settings/ExpenseTypes.yaml:55
#: components/worksheets/form/UcWorksheetInvoiceLineAccountings.yaml:84
msgid "Description"
msgstr "Leírás"

#: components/accounts/form/FieldsetAccountGeneral.yaml:216
msgid "Account number"
msgstr "Számlaszám"

#: components/accounts/form/FieldsetAccountGeneral.yaml:230
msgid "IBAN"
msgstr "IBAN"

#: components/accounts/form/FieldsetAccountGeneral.yaml:244
msgid "SWIFT"
msgstr "SWIFT"

#: components/accounts/form/FieldsetAccountGeneral.yaml:258
#: components/invoice/form/UcInvoiceExchangeRateEditor.yaml:104
#: components/invoice/form/UcInvoicePartyPanel.yaml:30
msgid "Bank"
msgstr "Bank"

#: components/accounts/form/FieldsetAccountGeneral.yaml:272
msgid "Branch"
msgstr "Fiók"

#: components/accounts/form/UcAccountHeader.yaml:13
msgctxt "Account"
msgid "Account"
msgstr "Folyószámla"

#: components/accounts/form/UcAccountHeader.yaml:14
msgctxt "Account"
msgid "New account"
msgstr "Új folyószámla"

#: components/accounts/form/UcAccountHeader.yaml:56
#: components/assets/FixedAsset.yaml:67
#: components/billing/form/UcBillingListItemHeader.yaml:127
#: components/billingRules/BillingRules.yaml:94
#: components/companies/Company.yaml:109 components/contracts/Contract.yaml:82
#: components/contracts/form/events/UcContractProtocolHeader.yaml:62
#: components/dashboard/Notifications.yaml:59
#: components/finance/dunning-letter/DunningLetter.yaml:395
#: components/invoice/form/UcInvoiceHeader.yaml:397
#: components/invoice/invoice-generation/InvoiceGeneration.yaml:50
#: components/jobs/job/JobHeader.yaml:105 components/meters/Meter.yaml:63
#: components/payments/form/UcPaymentHeader.yaml:107
#: components/product/Product.yaml:55 components/projects/Project.yaml:55
#: components/property/Property.yaml:70
#: components/registers/form/UcRegisterEntryHeader.yaml:141
#: components/rental/Rental.yaml:69
#: components/settings/JobSchedulerConfigurations.yaml:51
#: components/settings/Printers.yaml:51 components/settings/UnitsEditor.yaml:33
#: components/worksheets/form/UcWorksheetHeader.yaml:94
msgid "Reload"
msgstr "Frissítés"

#: components/accounts/form/UcAccountHeader.yaml:86
msgctxt "Account"
msgid "Delete account"
msgstr "Folyószámla törlése"

#: components/accounts/primitives/UcAccountSelector.yaml:102
msgctxt "AccountSelector"
msgid "Select account"
msgstr "Folyószámla kiválasztása"

#: components/accounts/primitives/UcAccountSelector.yaml:114
msgctxt "AccountSelector"
msgid "Show inactive"
msgstr "Inaktív megjelenítése"

#: components/assets/AddFixedAssetToRentalModal.yaml:4
msgctxt "AddFixedAssetToRentalModal"
msgid "Add to Rental"
msgstr "Hozzáadás bérleményhez"

#: components/assets/AddFixedAssetToRentalModal.yaml:60
msgctxt "AddFixedAssetToRentalModal"
msgid "Rental"
msgstr "Bérlemény"

#: components/assets/AddFixedAssetToRentalModal.yaml:78
msgctxt "AddFixedAssetToRentalModal"
msgid "Valid From"
msgstr "Érvényesség kezdete"

#: components/assets/AddFixedAssetToRentalModal.yaml:93
msgctxt "AddFixedAssetToRentalModal"
msgid "Valid To"
msgstr "Érvényesség vége"

#: components/assets/AddFixedAssetToRentalModal.yaml:108
msgctxt "AddFixedAssetToRentalModal"
msgid "Notes"
msgstr "Megjegyzés"

#: components/assets/AddFixedAssetToRentalModal.yaml:146
msgctxt "AddFixedAssetToRentalModal"
msgid "Add"
msgstr "Hozzáadás"

#: components/assets/AddFixedAssetToRentalModal.yaml:152
#: components/billingRules/BillingRule.yaml:137
#: components/companies/CompanyDataImportModal.yaml:208
#: components/contracts/InflationIndexedPriceChange.yaml:248
#: components/finance/SendMails.yaml:137
#: components/finance/dunning-letter/CreateDunningLetter.yaml:163
#: components/invoice/PrintInvoices.yaml:119
#: components/invoice/form/ConfirmSyncInvoice.yaml:138
#: components/invoice/form/invoice-lines/UploadInvoiceLines.yaml:188
#: components/meters/GenerateMeterConsumptions.yaml:290
#: components/meters/MeterDataExchange.yaml:188
#: components/multilineNotes/MultilineNotes.yaml:130
msgid "Cancel"
msgstr "Mégsem"

#: components/assets/CreateWorksheetsFromWasteBinReadingsModal.yaml:4
msgctxt "CreateWorksheetsFromWasteBinReadingsModal"
msgid "Create Worksheets"
msgstr "Munkalapok létrehozása"

#: components/assets/CreateWorksheetsFromWasteBinReadingsModal.yaml:79
msgctxt "CreateWorksheetsFromWasteBinReadingsModal"
msgid "Service"
msgstr "Szolgáltatás"

#: components/assets/CreateWorksheetsFromWasteBinReadingsModal.yaml:80
msgctxt "CreateWorksheetsFromWasteBinReadingsModal"
msgid "Create line items with the selected service."
msgstr "A tételsorokat a megadott szolgáltatással hozzuk létre."

#: components/assets/CreateWorksheetsFromWasteBinReadingsModal.yaml:100
msgctxt "CreateWorksheetsFromWasteBinReadingsModal"
msgid "Worksheet description"
msgstr "Munkalap megnevezése"

#: components/assets/CreateWorksheetsFromWasteBinReadingsModal.yaml:101
msgctxt "CreateWorksheetsFromWasteBinReadingsModal"
msgid ""
"The given value will be the description of the created worksheet. Otherwise "
"the selected service name."
msgstr ""
"A megadott érték lesz a munkalap leírása. Ha nincs megadva semmi, akkor a "
"kiválasztott szolgáltatás lesz a leírás."

#: components/assets/CreateWorksheetsFromWasteBinReadingsModal.yaml:114
#: components/worksheets/form/UcWorksheetData.yaml:79
msgctxt "Worksheet"
msgid "Contractor"
msgstr "Alvállalkozó"

#: components/assets/CreateWorksheetsFromWasteBinReadingsModal.yaml:136
msgctxt "Worksheet"
msgid "Worker"
msgstr "Munkavállaló"

#: components/assets/CreateWorksheetsFromWasteBinReadingsModal.yaml:156
msgctxt "CreateWorksheetsFromWasteBinReadingsModal"
msgid "GL Account Number"
msgstr "Főkönyvi szám"

#: components/assets/CreateWorksheetsFromWasteBinReadingsModal.yaml:175
msgctxt "CreateWorksheetsFromWasteBinReadingsModal"
msgid "Create worksheets"
msgstr "Munkalapok létrehozása"

#: components/assets/FixedAsset.yaml:6
#: components/rental/form/assets/UcRentalFormFixedAssets.yaml:76
msgid "Fixed Asset"
msgstr "Tárgyi eszköz"

#: components/assets/FixedAsset.yaml:33
msgctxt "FixedAsset|Header"
msgid "Delete fixed asset"
msgstr "Tárgyi eszköz törlése"

#: components/assets/FixedAsset.yaml:53 components/rental/Rental.yaml:190
msgid "Fixed Assets"
msgstr "Tárgyi eszközök"

#: components/assets/FixedAsset.yaml:89 components/companies/Company.yaml:143
#: components/contracts/Contract.yaml:109 components/meters/Meter.yaml:99
#: components/product/Product.yaml:88 components/projects/Project.yaml:77
#: components/property/Property.yaml:81 components/rental/Rental.yaml:92
#: components/settings/Settings.yaml:15
msgid "General"
msgstr "Általános"

#: components/assets/FixedAssetBrowser.yaml:25
msgid "Fixed assets"
msgstr "Tárgyi eszközök"

#: components/assets/FixedAssetBrowser.yaml:35
msgctxt "FixedAssetBrowser"
msgid "Name"
msgstr "Megnevezés"

#: components/assets/FixedAssetBrowser.yaml:43
msgctxt "FixedAssetBrowser"
msgid "Type"
msgstr "Típus"

#: components/assets/FixedAssetBrowser.yaml:54
msgctxt "FixedAssetBrowser"
msgid "Description"
msgstr "Leírás"

#: components/assets/FixedAssetBrowser.yaml:57
msgctxt "FixedAssetBrowser"
msgid "Inventory Number"
msgstr "Leltári szám"

#: components/assets/FixedAssetBrowser.yaml:60
msgctxt "FixedAssetBrowser"
msgid "SKU"
msgstr "Cikkszám"

#: components/assets/FixedAssetBrowser.yaml:63
msgctxt "FixedAssetBrowser"
msgid "Quantity"
msgstr "Mennyiség"

#: components/assets/FixedAssetBrowser.yaml:68
msgctxt "FixedAssetBrowser"
msgid "Acquisition Date"
msgstr "Beszerzés dátuma"

#: components/assets/FixedAssetBrowser.yaml:84
msgctxt "FixedAssets"
msgid "Create fixed asset..."
msgstr "Új tárgyi eszköz..."

#: components/assets/MCreateFixedAsset.yaml:4
msgid "Create Fixed Asset"
msgstr "Új tárgyi eszköz felvétele"

#: components/assets/MCreateFixedAsset.yaml:42
#: components/assets/form/FieldsetFixedAssetGeneral.yaml:30
#: components/assets/primitives/UcFixedAssetTypeBadge.yaml:14 config.yaml:172
msgctxt "FixedAssetTypes"
msgid "General"
msgstr "Általános"

#: components/assets/MCreateFixedAsset.yaml:45
#: components/assets/form/FieldsetFixedAssetGeneral.yaml:31
#: components/assets/primitives/UcFixedAssetTypeBadge.yaml:15 config.yaml:173
msgctxt "FixedAssetTypes"
msgid "Waste Bin"
msgstr "Hulladékgyűjtő"

#: components/assets/MCreateFixedAsset.yaml:141
#: components/billing/BatchBillingListEditor.yaml:405
#: components/billing/CopyBillingListItems.yaml:547
#: components/billingRules/BillingRule.yaml:126
#: components/common/WAttachmentModal.yaml:118
#: components/companies/MCompanyEditor.yaml:114
#: components/contracts/ContractEditor.yaml:128
#: components/contracts/form/services/BulkContractServiceEditor.yaml:330
#: components/contracts/form/statuses/ContractStatusTransition.yaml:243
#: components/invoice/BatchInvoiceEditor.yaml:382
#: components/invoice/InvoiceEditor.yaml:116
#: components/meters/CreateMeter.yaml:144
#: components/multilineNotes/TextTemplate.yaml:160
#: components/product/CreateProduct.yaml:146
#: components/product/ProductEditor.yaml:128
#: components/projects/ProjectEditor.yaml:128
#: components/property/CreateProperty.yaml:117
#: components/rental/CreateRental.yaml:119
#: components/rental/form/services/BulkRentalServiceEditor.yaml:422
#: components/settings/InvoicingProviderSettings.yaml:204
#: components/settings/JobSchedulerConfig.yaml:246
msgctxt "Button"
msgid "Save"
msgstr "Mentés"

#: components/assets/MFixedAssetEditor.yaml:21
msgctxt "FixedAsset"
msgid "Edit General Information"
msgstr "Általános adatok szerkesztése"

#: components/assets/MFixedAssetEditor.yaml:26
msgctxt "FixedAsset"
msgid "Edit general data"
msgstr "Általános adatok  szerkesztése"

#: components/assets/MFixedAssetEditor.yaml:30
msgctxt "FixedAsset"
msgid "Edit waste bin data"
msgstr "Hulladékgyűjtő adatok szerkesztése"

#: components/assets/WasteBinReadingModal.yaml:4
msgid "Waste bin reading"
msgstr "Hulladékgyűjtő leolvasás"

#: components/assets/WasteBinReadingModal.yaml:67
msgctxt "WasteBinReadingModal"
msgid "Bin Number"
msgstr "Azonosító"

#: components/assets/WasteBinReadingModal.yaml:81
msgctxt "WasteBinReadingModal"
msgid "Time"
msgstr "Időpont"

#: components/assets/WasteBinReadingModal.yaml:99
msgctxt "WasteBinReadingModal"
msgid "Device"
msgstr "Eszköz"

#: components/assets/WasteBinReadingModal.yaml:118
msgctxt "WasteBinReadingModal"
msgid "State"
msgstr "Státusz"

#: components/assets/WasteBinReadingModal.yaml:133
msgctxt "WasteBinReadingStates"
msgid "StartCase"
msgstr "StartCase"

#: components/assets/WasteBinReadingModal.yaml:137
msgctxt "WasteBinReadingModal"
msgid "Toggle state"
msgstr "Státusz váltása"

#: components/assets/WasteBinReadingsList.yaml:2
msgctxt "WasteBinReadingStates"
msgid "Empty"
msgstr "Üres"

#: components/assets/WasteBinReadingsList.yaml:3
msgctxt "WasteBinReadingStates"
msgid "Full"
msgstr "Teli"

#: components/assets/WasteBinReadingsList.yaml:8
msgid "Waste Bin Readings"
msgstr "Hulladékgyűjtő leolvasások"

#: components/assets/WasteBinReadingsList.yaml:37
msgid "This action cannot be undone."
msgstr "A művelet nem visszavonható."

#: components/assets/WasteBinReadingsList.yaml:58
msgctxt "ExportFilename"
msgid "waste-bin-readings"
msgstr "hulladékgyűjtő-leolvasások"

#: components/assets/WasteBinReadingsList.yaml:67
msgctxt "WasteBinReadings"
msgid "Reading Time"
msgstr "Leolvasás ideje"

#: components/assets/WasteBinReadingsList.yaml:79
msgctxt "WasteBinReadings"
msgid "Bin Name"
msgstr "Hulladékgyűjtő"

#: components/assets/WasteBinReadingsList.yaml:87
msgctxt "WasteBinReadings"
msgid "Bin Number"
msgstr "Hulladékgyűjtő sorszám"

#: components/assets/WasteBinReadingsList.yaml:90
msgctxt "WasteBinReadings"
msgid "Capacity (liters)"
msgstr "Kapacitás (liter)"

#: components/assets/WasteBinReadingsList.yaml:93
msgctxt "WasteBinReadings"
msgid "State"
msgstr "Státusz"

#: components/assets/WasteBinReadingsList.yaml:109
msgctxt "WasteBinReadings"
msgid "Rental"
msgstr "Bérlemény"

#: components/assets/WasteBinReadingsList.yaml:118
msgctxt "WasteBinReadings"
msgid "Client Number"
msgstr "Ügyfélszám"

#: components/assets/WasteBinReadingsList.yaml:126
msgctxt "WasteBinReadings"
msgid "Client Name"
msgstr "Ügyfélnév"

#: components/assets/WasteBinReadingsList.yaml:134
msgctxt "WasteBinReadings"
msgid "Cycle"
msgstr "Ütem"

#: components/assets/WasteBinReadingsList.yaml:137
msgctxt "WasteBinReadings"
msgid "Device ID"
msgstr "Eszköz azonosító"

#: components/assets/WasteBinReadingsList.yaml:140
msgctxt "WasteBinReadings"
msgid "Worksheets"
msgstr "Munkalapok"

#: components/assets/WasteBinReadingsList.yaml:204
msgctxt "WasteBinReadings"
msgid "Include handled readings"
msgstr "A már kezelt leolvasások megjelenítése"

#: components/assets/WasteBinReadingsList.yaml:212
msgid "Create Worksheets..."
msgstr "Munkalapok létrehozása..."

#: components/assets/WasteBinsBrowser.yaml:2
msgctxt "WasteBinTypes"
msgid "Communal"
msgstr "Kommunális"

#: components/assets/WasteBinsBrowser.yaml:3
msgctxt "WasteBinTypes"
msgid "Paper"
msgstr "Papír"

#: components/assets/WasteBinsBrowser.yaml:4
msgctxt "WasteBinTypes"
msgid "Plastic"
msgstr "Műanyag"

#: components/assets/WasteBinsBrowser.yaml:11
msgid "Waste Bins"
msgstr "Hulladékgyűjtők"

#: components/assets/WasteBinsBrowser.yaml:32
msgid "Waste bins"
msgstr "Hulladékgyűjtők"

#: components/assets/WasteBinsBrowser.yaml:35
msgctxt "ExportFilename"
msgid "waste-bins"
msgstr "hulladékgyűjtők"

#: components/assets/WasteBinsBrowser.yaml:44
msgctxt "WasteBinsBrowser"
msgid "Name"
msgstr "Megnevezés"

#: components/assets/WasteBinsBrowser.yaml:53
msgctxt "WasteBinsBrowser"
msgid "Capacity (liters)"
msgstr "Kapacitás (liter)"

#: components/assets/WasteBinsBrowser.yaml:57
msgctxt "WasteBinsBrowser"
msgid "Bin Name"
msgstr "Hulladékgyűjtő"

#: components/assets/WasteBinsBrowser.yaml:60
msgctxt "WasteBinsBrowser"
msgid "Worksheets"
msgstr "Munkalapok"

#: components/assets/WasteBinsBrowser.yaml:63
msgctxt "WasteBinsBrowser"
msgid "Bin Type"
msgstr "Típus"

#: components/assets/WasteBinsBrowser.yaml:70
msgctxt "WasteBinsBrowser"
msgid "Rental"
msgstr "Bérlemény"

#: components/assets/WasteBinsBrowser.yaml:79
msgctxt "WasteBinsBrowser"
msgid "Tenant"
msgstr "Bérlő"

#: components/assets/WasteBinsBrowser.yaml:108
msgctxt "WasteBins"
msgid "Create Waste Bin..."
msgstr "Hulladékgyűjtő felvétele..."

#: components/assets/form/FieldsetFixedAssetGeneral.yaml:39
msgctxt "FixedAsset"
msgid "Asset Type"
msgstr "Eszköz típusa"

#: components/assets/form/FieldsetFixedAssetGeneral.yaml:55
msgctxt "FixedAsset"
msgid "Name"
msgstr "Megnevezés"

#: components/assets/form/FieldsetFixedAssetGeneral.yaml:71
msgctxt "FixedAsset"
msgid "Quantity"
msgstr "Mennyiség"

#: components/assets/form/FieldsetFixedAssetGeneral.yaml:87
msgctxt "FixedAsset"
msgid "Inventory Number"
msgstr "Leltári szám"

#: components/assets/form/FieldsetFixedAssetGeneral.yaml:101
msgctxt "FixedAsset"
msgid "SKU"
msgstr "Cikkszám"

#: components/assets/form/FieldsetFixedAssetGeneral.yaml:115
msgctxt "FixedAsset"
msgid "Description"
msgstr "Leírás"

#: components/assets/form/FieldsetFixedAssetGeneral.yaml:129
msgctxt "FixedAsset"
msgid "Type Number"
msgstr "Típus"

#: components/assets/form/FieldsetFixedAssetGeneral.yaml:143
msgctxt "FixedAsset"
msgid "Cost"
msgstr "Költség"

#: components/assets/form/FieldsetFixedAssetGeneral.yaml:158
msgctxt "FixedAsset"
msgid "General Ledger Code"
msgstr "Főkönyvi szám"

#: components/assets/form/FieldsetFixedAssetGeneral.yaml:173
msgctxt "FixedAsset"
msgid "Year of Production"
msgstr "Gyártás éve"

#: components/assets/form/FieldsetFixedAssetGeneral.yaml:188
msgctxt "FixedAsset"
msgid "Manufacturer"
msgstr "Gyártó"

#: components/assets/form/FieldsetFixedAssetGeneral.yaml:202
msgctxt "FixedAsset"
msgid "Serial Number"
msgstr "Sorozatszám"

#: components/assets/form/FieldsetFixedAssetGeneral.yaml:216
msgctxt "FixedAsset"
msgid "Category"
msgstr "Kategória"

#: components/assets/form/FieldsetFixedAssetGeneral.yaml:230
msgctxt "FixedAsset"
msgid "Groups"
msgstr "Csoportok"

#: components/assets/form/FieldsetFixedAssetWasteBin.yaml:18
msgctxt "BinTypes"
msgid "Communal"
msgstr "Kommunális"

#: components/assets/form/FieldsetFixedAssetWasteBin.yaml:21
msgctxt "BinTypes"
msgid "Paper"
msgstr "Papír"

#: components/assets/form/FieldsetFixedAssetWasteBin.yaml:24
msgctxt "BinTypes"
msgid "Plastic"
msgstr "Műanyag"

#: components/assets/form/FieldsetFixedAssetWasteBin.yaml:33
#: components/assets/form/UcFixedAssetWasteBin.yaml:52
msgctxt "FixedAssetWasteBin"
msgid "Type"
msgstr "Típus"

#: components/assets/form/FieldsetFixedAssetWasteBin.yaml:52
#: components/assets/form/UcFixedAssetWasteBin.yaml:60
msgctxt "FixedAssetWasteBin"
msgid "Number"
msgstr "Sorszám"

#: components/assets/form/FieldsetFixedAssetWasteBin.yaml:68
#: components/assets/form/UcFixedAssetWasteBin.yaml:66
msgctxt "FixedAssetWasteBin"
msgid "Capacity"
msgstr "Hulladékgyűjtő kapacitása (liter)"

#: components/assets/form/FieldsetFixedAssetWasteBin.yaml:70
msgctxt "InputAddon"
msgid "liter"
msgstr "liter"

#: components/assets/form/UcFixedAssetGeneral.yaml:21
msgctxt "FixedAsset"
msgid "General"
msgstr "Általános"

#: components/assets/form/UcFixedAssetGeneral.yaml:27
#: components/assets/form/UcFixedAssetWasteBin.yaml:27
#: components/companies/form/UcCompanyGeneral.yaml:32
#: components/contracts/form/general/UcContractGeneralInfo.yaml:27
#: components/meters/form/general/UcMeterGeneralPanel.yaml:30
#: components/product/form/UcProductGeneral.yaml:23
#: components/projects/form/UcProjectGeneral.yaml:23
#: components/property/form/UcPropertyGeneralData.yaml:23
#: components/rental/form/general/UcRentalGeneralPanel.yaml:23
msgid "Edit..."
msgstr "Szerkesztés..."

#: components/assets/form/UcFixedAssetGeneral.yaml:77
msgctxt "FixedAsset"
msgid "Rental"
msgstr "Bérlemény"

#: components/assets/form/UcFixedAssetGeneral.yaml:160
msgctxt "FixedAsset"
msgid "Folder number"
msgstr "Mappaszám"

#: components/assets/form/UcFixedAssetGeneral.yaml:166
msgctxt "FixedAsset"
msgid "Reference number"
msgstr "Hivatkozási szám"

#: components/assets/form/UcFixedAssetGeneral.yaml:171
msgctxt "FixedAsset"
msgid "Lessor"
msgstr "Bérbeadó"

#: components/assets/form/UcFixedAssetGeneral.yaml:218
msgctxt "FixedAsset"
msgid "Tenant"
msgstr "Bérlő"

#: components/assets/form/UcFixedAssetRentalCard.yaml:72
msgctxt "FixedAsset"
msgid "Add to rental..."
msgstr "Hozzáadás bérleményhez..."

#: components/assets/form/UcFixedAssetRentals.yaml:43
msgctxt "FixedAssetRentals"
msgid "Rentals"
msgstr "Bérlemények"

#: components/assets/form/UcFixedAssetRentals.yaml:48
msgctxt "FixedAssetRentals"
msgid "Assign to rental..."
msgstr "Hozzáadás bérleményhez..."

#: components/assets/form/UcFixedAssetRentals.yaml:77
msgctxt "FixedAssetRentals"
msgid "No rentals."
msgstr "Nincsenek kapcsolódó bérlemények."

#: components/assets/form/UcFixedAssetRentals.yaml:129
#: components/billing/UcBillingMultiplierBadge.yaml:14
#: components/invoice/form/InvoiceLineMeterReadingSelector.yaml:214
msgid "Billing multiplier"
msgstr "Számlázási szorzó"

#: components/assets/form/UcFixedAssetRentals.yaml:151
#: components/contracts/form/services/UcContractServiceFees.yaml:109
#: components/invoice/form/UcInvoiceHeader.yaml:374
#: components/meters/form/consumptions/UcMeterConsumptions.yaml:192
#: components/product/form/UcProductPrices.yaml:143
#: components/property/form/UcPropertyUnits.yaml:75
#: components/worksheets/form/UcWorksheetHeader.yaml:71
msgid "Edit"
msgstr "Szerkesztés"

#: components/assets/form/UcFixedAssetWasteBin.yaml:21
msgctxt "FixedAsset"
msgid "Waste Bin"
msgstr "Hulladékgyűjtő"

#: components/assets/form/UcFixedAssetWasteBin.yaml:55
msgctxt "BinTypes"
msgid "StartCase"
msgstr "StartCase"

#: components/assets/form/UcFixedAssetWasteBin.yaml:74
msgctxt "FixedAssetWasteBin"
msgid "Label"
msgstr "Címke"

#: components/assets/form/UcFixedAssetWasteBin.yaml:78
msgctxt "Button"
msgid "Display label..."
msgstr "Címke megtekintése..."

#: components/assets/form/UcFixedAssetWorkItemsPanel.yaml:57
msgctxt "FixedAssetWorkItems"
msgid "Works"
msgstr "Munkák"

#: components/assets/form/UcFixedAssetWorkItemsPanel.yaml:72
msgctxt "FixedAssetWorkItems"
msgid "No related items."
msgstr "Nincsenek kapcsolódó munkalapok."

#: components/assets/form/UcFixedAssetWorkItemsPanel.yaml:186
msgctxt "FixedAssetWorkItems"
msgid "Billing Period"
msgstr "Számlázási időszak"

#: components/assets/form/UcFixedAssetWorkItemsPanel.yaml:200
#: components/contracts/form/services/UcContractServiceFees.yaml:134
msgid "Show less"
msgstr "Kevesebb megjelenítése"

#: components/assets/form/UcFixedAssetWorkItemsPanel.yaml:212
#: components/contracts/form/services/UcContractServiceFees.yaml:146
msgid "Show more"
msgstr "Több megjelenítése"

#: components/attachments/AttachmentBrowser.yaml:4
msgctxt "AttachmentsView"
msgid "Attachments"
msgstr "Csatolmányok"

#: components/attachments/AttachmentBrowser.yaml:28
msgctxt "ExportFilename"
msgid "attachments"
msgstr "ssatolmányok"

#: components/attachments/AttachmentBrowser.yaml:35
msgctxt "AttachmentsView"
msgid "Key"
msgstr "Azonosító"

#: components/attachments/AttachmentBrowser.yaml:38
msgctxt "AttachmentsView"
msgid "Object type"
msgstr "Típus"

#: components/attachments/AttachmentBrowser.yaml:41
msgctxt "AttachmentsView"
msgid "File name"
msgstr "Filenév"

#: components/attachments/AttachmentBrowser.yaml:44
msgctxt "AttachmentsView"
msgid "File type"
msgstr "File típus"

#: components/attachments/AttachmentBrowser.yaml:47
msgctxt "AttachmentsView"
msgid "File size"
msgstr "File méret"

#: components/attachments/AttachmentBrowser.yaml:50
msgctxt "AttachmentsView"
msgid "Description"
msgstr "Leírás"

#: components/attachments/AttachmentBrowser.yaml:57
msgctxt "AttachmentsView"
msgid "Created by"
msgstr "Készítette"

#: components/attachments/AttachmentBrowser.yaml:71
#: components/contracts/views/ContractAttachments.yaml:96
#: components/product/ProductBrowser.yaml:93
msgid "Dataimport..."
msgstr "Adatimport..."

#: components/attachments/AttachmentBrowser.yaml:85
msgctxt "AttachmentsView"
msgid "New Attachment/Service..."
msgstr "Új csatolmány..."

#: components/billing/BatchBillingListEditor.yaml:4
msgctxt "BatchBillingListEditor|Title"
msgid "Batch Edit Billint List Items"
msgstr "Tömeges szerkesztés"

#: components/billing/BatchBillingListEditor.yaml:156
#: components/invoice/BatchInvoiceEditor.yaml:159
#: components/invoice/form/FieldsetInvoiceHeader.yaml:369
msgid "Fulfillment Date"
msgstr "Teljesítés dátuma"

#: components/billing/BatchBillingListEditor.yaml:184
#: components/invoice/BatchInvoiceEditor.yaml:187
#: components/invoice/form/FieldsetInvoiceHeader.yaml:385
msgctxt "Invoice"
msgid "Due Date"
msgstr "Esedékesség"

#: components/billing/BatchBillingListEditor.yaml:214
#: components/invoice/BatchInvoiceEditor.yaml:273
#: components/invoice/form/FieldsetInvoiceHeader.yaml:457
msgid "Billing Period"
msgstr "Számlázási időszak"

#: components/billing/BatchBillingListEditor.yaml:241
#: components/billing/form/FieldsetBillingListItem.yaml:284
#: components/invoice/BatchInvoiceEditor.yaml:300
#: components/invoice/form/FieldsetInvoiceHeader.yaml:471
msgctxt "BillingPeriod"
msgid "From"
msgstr "-tól"

#: components/billing/BatchBillingListEditor.yaml:251
#: components/billing/form/FieldsetBillingListItem.yaml:293
#: components/invoice/BatchInvoiceEditor.yaml:310
#: components/invoice/form/FieldsetInvoiceHeader.yaml:481
msgctxt "BillingPeriod"
msgid "To"
msgstr "-ig"

#: components/billing/BatchBillingListEditor.yaml:258
#: components/invoice/BatchInvoiceEditor.yaml:317
#: components/invoice/form/FieldsetInvoiceHeader.yaml:487
#: components/invoice/views/InvoiceLinesView.yaml:118
msgctxt "Invoice"
msgid "Currency"
msgstr "Pénznem"

#: components/billing/BatchBillingListEditor.yaml:288
#: components/invoice/form/FieldsetInvoiceHeader.yaml:505
msgctxt "Invoice"
msgid "Exchange rate"
msgstr "Árfolyam"

#: components/billing/BatchBillingListEditor.yaml:319
#: components/billing/form/FieldsetBillingListItem.yaml:340
#: components/invoice/form/FieldsetInvoiceHeader.yaml:520
msgctxt "Invoice"
msgid "Rate"
msgstr "Árfolyam"

#: components/billing/BatchBillingListEditor.yaml:336
#: components/billing/form/FieldsetBillingListItem.yaml:356
#: components/invoice/form/FieldsetInvoiceHeader.yaml:530
msgctxt "Invoice"
msgid "Date"
msgstr "Dátum"

#: components/billing/BatchBillingListEditor.yaml:354
#: components/billing/form/FieldsetBillingListItem.yaml:373
msgctxt "ExchangeRateFieldset"
msgid "Source"
msgstr "Adatforrás"

#: components/billing/BatchBillingListEditor.yaml:373
#: components/billing/CopyBillingListItems.yaml:514
#: components/contracts/form/services/BulkContractServiceFeeEditor.yaml:362
#: components/invoice/BatchInvoiceEditor.yaml:350
#: components/invoice/form/FieldsetInvoiceHeader.yaml:666
msgctxt "Invoice"
msgid "Notes"
msgstr "Megjegyzés"

#: components/billing/BillingListItem.yaml:31
msgctxt "BillingListItem"
msgid "New billing list item"
msgstr "Új tétel"

#: components/billing/BillingListItem.yaml:171
msgctxt "BillingListItem/Button"
msgid "Create item"
msgstr "Tétel hozzáadása"

#: components/billing/BillingListItem.yaml:180
#: components/meters/form/general/MeterEditor.yaml:82
#: components/payments/Payment.yaml:53
#: components/registers/RegisterEntry.yaml:324
#: components/rental/form/general/MRentalGeneralDataEditor.yaml:82
#: components/worksheets/WorksheetEditor.yaml:124
msgctxt "Button"
msgid "Save changes"
msgstr "Változtatások mentése"

#: components/billing/BillingListView.yaml:15
#: components/billing/UcBillingList.yaml:24
msgctxt "billingList|Title"
msgid "Billing list"
msgstr "Számlázandó tételek"

#: components/billing/CopyBillingListItems.yaml:4
msgctxt "CopyBillingListItems|Title"
msgid "Copy Billing List Items"
msgstr "Számlázandó Tételek Másolása"

#: components/billing/CopyBillingListItems.yaml:22
msgctxt "CopyBillingListItems"
msgid "Simple discount"
msgstr "Egyszerű kedvezmény"

#: components/billing/CopyBillingListItems.yaml:25
msgctxt "CopyBillingListItems"
msgid "Complex calculations"
msgstr "Komplex kalkulációk"

#: components/billing/CopyBillingListItems.yaml:36
msgctxt "CopyBillingListItems"
msgid "Override the product or service reference for this line."
msgstr ""
"A tételhez tartozó termék vagy szolgáltatás hivatkozásának a felülírása."

#: components/billing/CopyBillingListItems.yaml:39
msgctxt "CopyBillingListItems"
msgid "Override the line description with any freeform text."
msgstr "A tételsor megnevezésének a felülírása tetszőleges szöveggel."

#: components/billing/CopyBillingListItems.yaml:42
msgctxt "CopyBillingListItems"
msgid "Set or override whether this line represents an intermediated service."
msgstr "A közvetített szolgáltatás kapcsoló beállítása."

#: components/billing/CopyBillingListItems.yaml:45
msgctxt "CopyBillingListItems"
msgid "The unit to use to generate the new items."
msgstr "Az új tételek létrehozásához használt mértékegység."

#: components/billing/CopyBillingListItems.yaml:51
msgctxt "CopyBillingListItems"
msgid "Define a fixed quantity to use when generating the new items."
msgstr ""
"Az új tételek létrehozásakor használt fix mennyiség, felülírva az eredeti "
"mennyiséget."

#: components/billing/CopyBillingListItems.yaml:61
msgctxt "CopyBillingListItems"
msgid ""
"Set a fixed price to apply to the new items, overriding the original price."
msgstr ""
"Az új tételek létrehozásakor használt fix egységár, felülírva az eredeti "
"árat."

#: components/billing/CopyBillingListItems.yaml:71
msgctxt "CopyBillingListItems"
msgid "Apply a discount percentage to the new items."
msgstr "Alkalmazzon kedvezményt az új tételekre százalékos formában."

#: components/billing/CopyBillingListItems.yaml:76
msgctxt "CopyBillingListItems"
msgid "Add or override the internal notes for the generated invoice line."
msgstr "Adja hozzá vagy írja felül a létrehozott számlatétel megjegyzést."

#: components/billing/CopyBillingListItems.yaml:203
msgctxt "CopyBillingListItems"
msgid "Mode"
msgstr "Mód"

#: components/billing/CopyBillingListItems.yaml:221
msgctxt "CopyBillingListItems"
msgid "Service"
msgstr "Szolgáltatás"

#: components/billing/CopyBillingListItems.yaml:261
msgctxt "Invoice"
msgid "Description"
msgstr "Megnevezés"

#: components/billing/CopyBillingListItems.yaml:290
msgctxt "Invoice"
msgid "Intermediated service"
msgstr "Közvetített szolgáltatás"

#: components/billing/CopyBillingListItems.yaml:322
msgctxt "Invoice"
msgid "Quantity"
msgstr "Mennyiség"

#: components/billing/CopyBillingListItems.yaml:354
msgctxt "Invoice"
msgid "Quantity %"
msgstr "Mennyiség %"

#: components/billing/CopyBillingListItems.yaml:387
msgctxt "Invoice"
msgid "Unit"
msgstr "Egység"

#: components/billing/CopyBillingListItems.yaml:416
msgctxt "Invoice"
msgid "Price"
msgstr "Egységár"

#: components/billing/CopyBillingListItems.yaml:448
msgctxt "Invoice"
msgid "Price %"
msgstr "Egységár %"

#: components/billing/CopyBillingListItems.yaml:481
msgctxt "Invoice"
msgid "Discount %"
msgstr "Kedvezmény %"

#: components/billing/CreateBillingPlan.yaml:4
msgctxt "CreateBillingPlan|Title"
msgid "Create Billing Plan"
msgstr "Számlázandó Tételek Gyűjtése"

#: components/billing/CreateBillingPlan.yaml:57
msgctxt "CreateBillingPlan|ResourceTitle"
msgid "Billing Plan"
msgstr "Számlázandó tételek"

#: components/billing/CreateBillingPlan.yaml:58
msgctxt "CreateBillingPlan|ResourceKey"
msgid "Collect items"
msgstr "Tételek gyűjtése"

#: components/billing/CreateBillingPlan.yaml:82
msgctxt "CreateBillingPlan"
msgid "Target date"
msgstr "Számlázás dátuma"

#: components/billing/CreateBillingPlan.yaml:83
msgctxt "CreateBillingPlan"
msgid "The date from which the system looks for billable items."
msgstr "Az a dátum, amelytől kezdve a rendszer a számlázható tételeket keresi."

#: components/billing/CreateBillingPlan.yaml:97
msgctxt "CreateBillingPlan"
msgid "Max date"
msgstr "Záró dátum"

#: components/billing/CreateBillingPlan.yaml:98
msgctxt "CreateBillingPlan"
msgid ""
"If no closing date is provided, items due within ten days of the specified "
"date will be collected."
msgstr ""
"Amennyiben nincs megadva záró dátum, a megadott dátumtól számított tíz napon "
"belül esedékes tételek kerülnek összegyűjtésre."

#: components/billing/CreateBillingPlan.yaml:111
msgctxt "CreateBillingPlan"
msgid "Contracts"
msgstr "Szerződések"

#: components/billing/CreateBillingPlan.yaml:112
msgctxt "CreateBillingPlan"
msgid "Search for the selected contract's billable services."
msgstr ""
"A kiválasztott szerződéshez tartozó számlázható szolgáltatások keresése."

#: components/billing/CreateBillingPlan.yaml:128
msgctxt "CreateBillingPlan"
msgid "Companies"
msgstr "Saját cégek"

#: components/billing/CreateBillingPlan.yaml:129
msgctxt "CreateBillingPlan"
msgid "Search for the selected companies' services."
msgstr "A kiválasztott cégekhez tartozó szolgáltatások keresése."

#: components/billing/CreateBillingPlan.yaml:145
msgctxt "CreateBillingPlan"
msgid "Partners"
msgstr "Ügyfelek"

#: components/billing/CreateBillingPlan.yaml:146
msgctxt "CreateBillingPlan"
msgid "Search for the selected partners' services."
msgstr "A kiválasztott partnerekhez tartozó szolgáltatások keresése."

#: components/billing/CreateBillingPlan.yaml:162
msgctxt "CreateBillingPlan"
msgid "Rentals"
msgstr "Bérlemények"

#: components/billing/CreateBillingPlan.yaml:163
msgctxt "CreateBillingPlan"
msgid "Search for the selected rentals' services."
msgstr "A kiválasztott bérleményekhez tartozó szolgáltatások keresése."

#: components/billing/CreateBillingPlan.yaml:189
msgctxt "BillingList|Submit"
msgid "Create billing plan"
msgstr "Tételek gyűjtése"

#: components/billing/CreateBillingPlan.yaml:202
msgctxt "CreateBillingPlan"
msgid "Close"
msgstr "Bezárás"

#: components/billing/UcBillingList.yaml:25
msgctxt "billingList|Export|Filename"
msgid "billing-list"
msgstr "számlázandó-tételek"

#: components/billing/UcBillingList.yaml:182
msgctxt "BillingList"
msgid "Billing due date"
msgstr "Számlázandó"

#: components/billing/UcBillingList.yaml:186
#: components/invoice/invoice-generation/UcInvoiceGenerationInvoices.yaml:150
msgctxt "BillingList"
msgid "Invoice"
msgstr "Számla"

#: components/billing/UcBillingList.yaml:206
msgctxt "BillingList"
msgid "Payment due date"
msgstr "Fizetendő"

#: components/billing/UcBillingList.yaml:209
msgctxt "BillingList"
msgid "Period start"
msgstr "Időszak kezdete"

#: components/billing/UcBillingList.yaml:219
msgctxt "BillingList"
msgid "Period end"
msgstr "Időszak vége"

#: components/billing/UcBillingList.yaml:230
#: components/invoice/invoice-generation/UcInvoiceGenerationInvoices.yaml:170
msgctxt "BillingList"
msgid "Company"
msgstr "Saját cég"

#: components/billing/UcBillingList.yaml:255
#: components/invoice/invoice-generation/UcInvoiceGenerationInvoices.yaml:195
msgctxt "BillingList"
msgid "Partner"
msgstr "Ügyfél"

#: components/billing/UcBillingList.yaml:280
msgctxt "BillingList"
msgid "Contract"
msgstr "Szerződés"

msgctxt "BillingList"
msgid "Rental"
msgstr "Bérlemény"

#: components/billing/UcBillingList.yaml:303
msgctxt "BillingList"
msgid "Description"
msgstr "Megnevezés"

#: components/billing/UcBillingList.yaml:307
msgctxt "BillingList"
msgid "Billing category"
msgstr "Számlázási kategória"

#: components/billing/UcBillingList.yaml:310
msgctxt "BillingList"
msgid "Notes"
msgstr "Megjegyzés"

#: components/billing/UcBillingList.yaml:313
msgctxt "BillingList"
msgid "Quantity"
msgstr "Mennyiség"

#: components/billing/UcBillingList.yaml:318
msgctxt "BillingList"
msgid "Unit"
msgstr "Egység"

#: components/billing/UcBillingList.yaml:321
msgctxt "BillingList"
msgid "Price"
msgstr "Ár"

#: components/billing/UcBillingList.yaml:326
msgctxt "BillingList"
msgid "Currency"
msgstr "Pénznem"

#: components/billing/UcBillingList.yaml:329
msgctxt "BillingList"
msgid "Discount"
msgstr "Kedvezmény"

#: components/billing/UcBillingList.yaml:334
msgctxt "BillingList"
msgid "Net"
msgstr "Nettó"

#: components/billing/UcBillingList.yaml:339
msgctxt "BillingList"
msgid "Tax code"
msgstr "ÁFA kód"

#: components/billing/UcBillingList.yaml:342
msgctxt "BillingList"
msgid "Exchrate"
msgstr "Árfolyam"

#: components/billing/UcBillingList.yaml:370
msgctxt "BillingList"
msgid "Intermediated Service"
msgstr "Közvetített szolgáltatás"

#: components/billing/UcBillingList.yaml:430
msgctxt "BillingList"
msgid "Billing plan"
msgstr "Számlázandó tételek"

#: components/billing/UcBillingList.yaml:435
msgctxt "BillingList"
msgid "Create billing plan..."
msgstr "Tételek gyűjtése..."

#: components/billing/UcBillingList.yaml:452
msgctxt "BillingList"
msgid "Add item..."
msgstr "Tétel hozzáadása..."

#: components/billing/UcBillingList.yaml:469
msgctxt "BillingList"
msgid "Copy items..."
msgstr "Tételek másolása..."

#: components/billing/UcBillingList.yaml:501
msgctxt "BillingList"
msgid "Bulk edit..."
msgstr "Csoportos szerkesztés..."

#: components/billing/UcBillingList.yaml:525
msgctxt "BillingList"
msgid "Bulk upload..."
msgstr "Feltöltés..."

#: components/billing/UcBillingList.yaml:550
msgctxt "BillingList|Submit"
msgid "Generate invoices"
msgstr "Számlák generálása"

#: components/billing/UcBillingList.yaml:560
#: components/invoice/invoice-generation/UcInvoiceGenerationInvoices.yaml:393
msgid "Merge invoices"
msgstr "Számlák egyesítése"

#: components/billing/UcBillingList.yaml:573
msgid "Delete invoices"
msgstr "Számlák törlése"

#: components/billing/UcBillingList.yaml:586
#: components/invoice/Invoices.yaml:489
#: components/invoice/invoice-generation/UcInvoiceGenerationInvoices.yaml:439
msgid "Download views"
msgstr "Nyomtatási képek letöltése"

#: components/billing/UploadBillingListItems.yaml:4
msgctxt "UploadBillingListItems|Title"
msgid "Upload Billing List Items"
msgstr "Számlázandó Tételek Feltöltése"

#: components/billing/UploadBillingListItems.yaml:27
msgctxt "UploadBillingListItems"
msgid "No records have been imported."
msgstr "Nem importáltunk egy tételt sem."

#: components/billing/UploadBillingListItems.yaml:28
msgctxt "UploadBillingListItems"
msgid "%(items)s items have been imported."
msgstr "Nem importáltunk egy tételt sem."

#: components/billing/UploadBillingListItems.yaml:74
msgctxt "UploadBillingListItems|ResourceTitle"
msgid "Billing Plan"
msgstr "Számlázandó tételek"

#: components/billing/UploadBillingListItems.yaml:75
msgctxt "UploadBillingListItems|ResourceTitle"
msgid "Upload Items"
msgstr "Tételek feltöltése"

#: components/billing/UploadBillingListItems.yaml:99
msgctxt "UploadBillingListItems"
msgid "Upload billing list items from a template file."
msgstr "Számlázandó tételek feltöltése kitöltött sablon fájlból."

#: components/billing/UploadBillingListItems.yaml:119
msgctxt "UploadBillingListItems"
msgid "Input file"
msgstr "Feltöltendő állomány"

#: components/billing/UploadBillingListItems.yaml:139
msgctxt "UploadBillingListItems"
msgid "Only XLSX files are allowed."
msgstr "Csak XLSX fájlok engedélyezettek."

#: components/billing/UploadBillingListItems.yaml:143
msgctxt "UploadBillingListItems"
msgid "Download template"
msgstr "Sablon letöltése"

#: components/billing/UploadBillingListItems.yaml:171
msgctxt "UploadBillingListItems"
msgid "Upload"
msgstr "Feltöltés"

#: components/billing/form/FieldsetBillingListItem.yaml:127
msgctxt "BillingListItem"
msgid "Contract service"
msgstr "Szerződött szolgáltatás"

#: components/billing/form/FieldsetBillingListItem.yaml:149
msgctxt "BillingListItem"
msgid "Contract"
msgstr "Szerződés"

#: components/billing/form/FieldsetBillingListItem.yaml:171
msgctxt "BillingListItem"
msgid "Description"
msgstr "Megnevezés"

#: components/billing/form/FieldsetBillingListItem.yaml:187
msgctxt "BillingListItem"
msgid "Note"
msgstr "Megjegyzés"

#: components/billing/form/FieldsetBillingListItem.yaml:203
msgctxt "BillingListItem"
msgid "Billing due date"
msgstr "Számlázandó"

msgctxt "BillingListItem"
msgid "Billing category"
msgstr "Számlázási kategória"

#: components/billing/form/FieldsetBillingListItem.yaml:217
msgctxt "BillingListItem"
msgid "Billing company"
msgstr "Számlázó cég"

#: components/billing/form/FieldsetBillingListItem.yaml:236
msgctxt "BillingListItem"
msgid "Client"
msgstr "Ügyfél"

#: components/billing/form/FieldsetBillingListItem.yaml:255
msgctxt "BillingListItem"
msgid "Payment due date"
msgstr "Fizetendő"

#: components/billing/form/FieldsetBillingListItem.yaml:270
msgctxt "BillingListItem"
msgid "Billing period"
msgstr "Számlázási időszak"

#: components/billing/form/FieldsetBillingListItem.yaml:301
msgctxt "BillingListItem"
msgid "Base price"
msgstr "Alapár"

#: components/billing/form/FieldsetBillingListItem.yaml:323
msgctxt "BillingListItem"
msgid "Exchange rate"
msgstr "Árfolyam"

#: components/billing/form/FieldsetBillingListItem.yaml:389
msgctxt "BillingListItem"
msgid "Quantity"
msgstr "Mennyiség"

#: components/billing/form/FieldsetBillingListItem.yaml:428
msgctxt "BillingListItem"
msgid "Price"
msgstr "Ár"

#: components/billing/form/FieldsetBillingListItem.yaml:474
msgctxt "BillingListItem"
msgid "Discount"
msgstr "Kedvezmény"

#: components/billing/form/FieldsetBillingListItem.yaml:507
msgctxt "BillingListItem"
msgid "Net"
msgstr "Nettó"

#: components/billing/form/FieldsetBillingListItem.yaml:532
msgctxt "BillingListItem"
msgid "VAT code"
msgstr "ÁFA kód"

#: components/billing/form/FieldsetBillingListItem.yaml:557
msgctxt "BillingListItem"
msgid "Amount"
msgstr "Összeg"

#: components/billing/form/UcBillingListItemHeader.yaml:13
msgctxt "BillingListItem"
msgid "New item"
msgstr "Új tétel"

#: components/billing/form/UcBillingListItemHeader.yaml:14
msgctxt "BillingListItem"
msgid "Edit item"
msgstr "Tétel szerkesztése"

#: components/billing/form/UcBillingListItemHeader.yaml:18
msgctxt "BillingListItem"
msgid "Billing list item"
msgstr "Számlázandó tételek"

#: components/billing/form/UcBillingListItemHeader.yaml:59
msgctxt "BillingListItemHeader"
msgid "Invoice number"
msgstr "Számlaszám"

#: components/billing/form/UcBillingListItemHeader.yaml:84
#: components/registers/form/UcRegisterEntryHeader.yaml:98
msgctxt "ResourceStatus"
msgid "Locked"
msgstr "Zárolva"

#: components/billing/form/UcBillingListItemHeader.yaml:103
#: components/registers/form/UcRegisterEntryHeader.yaml:117
msgctxt "ResourceStatus"
msgid "Void"
msgstr "Érvénytelen"

#: components/billing/form/UcBillingListItemHeader.yaml:157
#: components/common/BtnLockResource.yaml:67
#: components/contracts/form/events/UcContractProtocolHeader.yaml:171
#: components/registers/form/UcRegisterEntryHeader.yaml:171
msgctxt "BtnLockText"
msgid "Lock"
msgstr "Zárolás"

#: components/billing/form/UcBillingListItemHeader.yaml:158
#: components/common/BtnLockResource.yaml:68
#: components/contracts/form/events/UcContractProtocolHeader.yaml:172
#: components/registers/form/UcRegisterEntryHeader.yaml:172
msgctxt "BtnLockTooltip"
msgid "Lock"
msgstr "Zárolás"

#: components/billing/form/UcBillingListItemHeader.yaml:192
#: components/contracts/form/events/UcContractProtocolHeader.yaml:201
#: components/registers/form/UcRegisterEntryHeader.yaml:206
msgctxt "BtnLockText"
msgid "Unlock"
msgstr "Zárolás feloldása"

#: components/billing/form/UcBillingListItemHeader.yaml:193
#: components/contracts/form/events/UcContractProtocolHeader.yaml:202
#: components/registers/form/UcRegisterEntryHeader.yaml:207
msgctxt "BtnLockTooltip"
msgid "Unlock"
msgstr "Zárolás feloldása"

#: components/billing/form/UcBillingListItemHeader.yaml:227
#: components/registers/form/UcRegisterEntryHeader.yaml:241
msgctxt "BtnLockText"
msgid "Invalidate"
msgstr "Érvénytelenítés"

#: components/billing/form/UcBillingListItemHeader.yaml:228
#: components/registers/form/UcRegisterEntryHeader.yaml:242
msgctxt "BtnLockTooltip"
msgid "Invalidate"
msgstr "Érvénytelenítés"

#: components/billing/form/UcBillingListItemHeader.yaml:262
#: components/registers/form/UcRegisterEntryHeader.yaml:276
msgctxt "BtnLockText"
msgid "Revoke invalidated"
msgstr "Érvénytelenítés visszavonása"

#: components/billing/form/UcBillingListItemHeader.yaml:263
#: components/registers/form/UcRegisterEntryHeader.yaml:277
msgctxt "BtnLockTooltip"
msgid "Revoke invalidated"
msgstr "Érvénytelenítés visszavonása"

#: components/billing/form/UcBillingListItemHeader.yaml:298
msgctxt "Resource|Command"
msgid "Delete"
msgstr "Törlés"

#: components/billingRules/BillingDateRule.yaml:54
msgctxt "BillingDateRule"
msgid "Description"
msgstr "Megnevezés"

#: components/billingRules/BillingDateRule.yaml:67
msgctxt "BillingDateRule"
msgid "Anchor date"
msgstr "Referencia dátum"

#: components/billingRules/BillingDateRule.yaml:85
msgctxt "BillingDateRule"
msgid "Offset"
msgstr "Eltolás"

#: components/billingRules/BillingDateRule.yaml:120
#: components/billingRules/ExchangeRateDateRule.yaml:109
msgctxt "InputGroupAddon"
msgid "day"
msgstr "nap"

#: components/billingRules/BillingRule.yaml:85
msgctxt "BillingRule"
msgid "Rule type"
msgstr "Szabály típusa"

#: components/billingRules/BillingRules.yaml:5
msgctxt "BillingRules|Title"
msgid "Billing Rules"
msgstr "Számlázási szabályok"

#: components/billingRules/BillingRules.yaml:107
#: components/templates/Templates.yaml:209
msgctxt "Templates"
msgid "Import"
msgstr "Importálás"

#: components/billingRules/BillingRules.yaml:127
msgctxt "BillingRules"
msgid "Export"
msgstr "Exportálás"

#: components/billingRules/BillingRules.yaml:202
#: components/common/UcAttachmentsList.yaml:126
#: components/companies/form/addresses/UcAddressList.yaml:97
#: components/companies/form/bank-accounts/UcCompanyBankAccounts.yaml:87
#: components/contracts/form/services/UcContractServices.yaml:109
#: components/rental/form/services/UcRentalServiceCostAllocators.yaml:69
msgctxt "Command"
msgid "Edit"
msgstr "Szerkesztés"

#: components/billingRules/BillingRules.yaml:211
#: components/common/UcAttachmentsList.yaml:145
#: components/companies/form/addresses/UcAddressList.yaml:120
#: components/companies/form/bank-accounts/UcCompanyBankAccounts.yaml:103
#: components/rental/form/services/UcRentalServiceCostAllocators.yaml:90
msgctxt "Command"
msgid "Delete"
msgstr "Törlés"

#: components/billingRules/BillingRules.yaml:263
msgctxt "BillingRules"
msgid "Create rule"
msgstr "Szabály létrehozása"

#: components/billingRules/BillingRules.yaml:279
msgctxt "BillingRules"
msgid "No rules have been defined yet."
msgstr "Nincsenek szabályok létrehozva."

#: components/billingRules/ExchangeRateDateRule.yaml:44
msgctxt "ExchangeRateDateRule"
msgid "Description"
msgstr "Megnevezés"

#: components/billingRules/ExchangeRateDateRule.yaml:57
msgctxt "ExchangeRateDateRule"
msgid "Reference month"
msgstr "Referencia hónap"

#: components/billingRules/ExchangeRateDateRule.yaml:75
msgctxt "ExchangeRateDateRule"
msgid "Day specifier"
msgstr "Nap meghatározó"

#: components/billingRules/ExchangeRateDateRule.yaml:93
msgctxt "ExchangeRateDateRule"
msgid "Day value"
msgstr "Nap értéke"

#: components/billingRules/form/BillingDateRuleFields.yaml:88
msgctxt "BillingDateRule"
msgid "Select predefined rule to add."
msgstr "Előre definiált szabály hozzáadása."

#: components/billingRules/form/BillingDateRuleFields.yaml:97
msgctxt "BillingDateRule"
msgid "Add rule configuration"
msgstr "Szabály beállítás hozzáadása"

#: components/billingRules/form/BillingDateRuleFields.yaml:175
msgctxt "BillingDateRule"
msgid "Rule description"
msgstr "Szabály megnevezése"

#: components/billingRules/form/DueDateRuleFields.yaml:86
msgctxt "DueDateRule"
msgid "Select predefined rule to add."
msgstr "Előre definiált szabály hozzáadása."

#: components/billingRules/form/DueDateRuleFields.yaml:95
msgctxt "DueDateRule"
msgid "Add rule configuration"
msgstr "Szabály beállítás hozzáadása"

#: components/billingRules/form/DueDateRuleFields.yaml:173
msgctxt "DueDateRule"
msgid "Rule description"
msgstr "Szabály megnevezése"

#: components/billingRules/form/ExchangeRateDateRuleFields.yaml:169
msgctxt "ExchangeRateDateRule"
msgid "Rule description"
msgstr "Szabály megnevezése"

#: components/billingRules/form/ExchangeRateSourceSpecEditor.yaml:95
msgctxt "ExchangeRateSourceSpec"
msgid "Invoice description"
msgstr "Számlázási név"

#: components/charts/Charts.yaml:38
msgctxt "MainMenu"
msgid "Reports"
msgstr "Kimutatások"

#: components/common/AboutModal.yaml:4
msgid "About Integro"
msgstr "Integro névjegy"

#: components/common/AboutModal.yaml:66
msgid "Component"
msgstr "Komponens"

#: components/common/AboutModal.yaml:67
msgid "Version"
msgstr "Verzió"

#: components/common/BtnDeleteResource.yaml:80
msgctxt "BtnDeleteResource"
msgid "Delete"
msgstr "Törlés"

#: components/common/BtnDeleteResource.yaml:81
msgctxt "BtnDeleteResource|Tooltip"
msgid "Delete"
msgstr "Törlés"

#: components/common/BtnLoad.yaml:15
msgctxt "Button"
msgid "Load"
msgstr "Betöltés"

#: components/common/BtnLoad.yaml:16
msgctxt "Button|Title"
msgid "Load data"
msgstr "Adatok betöltése"

#: components/common/BtnLockResource.yaml:44
msgid "Locking prevents further modifications. Please confirm this operation."
msgstr "Figyelem, zárolás után módosítás már nem lehetséges!"

#: components/common/BtnLockResource.yaml:45
#: components/rental/form/properties/RentalProperty.yaml:173
msgid "Lock"
msgstr "Zárolás"

#: components/common/DataViewerModal.yaml:4
msgid "View Data"
msgstr "Adatok megtekintése"

#: components/common/DateRangeSelector.yaml:32
msgctxt "DateRangeSelector"
msgid "Custom"
msgstr "Egyedi"

#: components/common/DateRangeSelector.yaml:35
msgctxt "DateRangeSelector"
msgid "Current week"
msgstr "Aktuális hét"

#: components/common/DateRangeSelector.yaml:39
msgctxt "DateRangeSelector"
msgid "Current month"
msgstr "Aktuális hónap"

#: components/common/DateRangeSelector.yaml:43
msgctxt "DateRangeSelector"
msgid "Current year"
msgstr "Aktuális év"

#: components/common/DateRangeSelector.yaml:47
msgctxt "DateRangeSelector"
msgid "Previous week"
msgstr "Előző hét"

#: components/common/DateRangeSelector.yaml:51
msgctxt "DateRangeSelector"
msgid "Previous month"
msgstr "Előző hónap"

#: components/common/DateRangeSelector.yaml:55
msgctxt "DateRangeSelector"
msgid "Previous year"
msgstr "Előző év"

#: components/common/DateRangeSelector.yaml:59
msgctxt "DateRangeSelector"
msgid "Previous seven days"
msgstr "Előző hét nap"

#: components/common/DateRangeSelector.yaml:63
msgctxt "DateRangeSelector"
msgid "Previous thirty days"
msgstr "Előző harminc nap"

#: components/common/DateRangeSelector.yaml:67
msgctxt "DateRangeSelector"
msgid "Previous sixty days"
msgstr "Előző hatvan nap"

#: components/common/EntityEvents.yaml:4
msgctxt "EntityEvents/header"
msgid "Entity events"
msgstr "Eseménynapló"

#: components/common/EntityEvents.yaml:70
msgctxt "EntityEvents"
msgid "Events"
msgstr "Események"

#: components/common/EntityEvents.yaml:76 components/payments/Payments.yaml:96
#: components/payments/views/PaymentsView.yaml:76
msgctxt "ExportFilename"
msgid "payments"
msgstr "kiegyenlítések"

#: components/common/EntityEvents.yaml:79
msgctxt "EntityEvents"
msgid "Event"
msgstr "Esemény"

#: components/common/EntityEvents.yaml:83
msgctxt "EntityEvents"
msgid "Timestamp"
msgstr "Időbélyeg"

#: components/common/EntityEvents.yaml:88
msgctxt "EntityEvents"
msgid "User"
msgstr "Felhasználó"

#: components/common/FileSelector.yaml:4
msgctxt "FileSelector|Header"
msgid "Select file(s)"
msgstr "File(ok) kiválasztása"

#: components/common/FileSelector.yaml:65
msgctxt "FileSelector"
msgid "Browse"
msgstr "Tallózás"

#: components/common/FileSelector.yaml:77
msgctxt "FileSelector"
msgid "Choose a file or drop it here"
msgstr "File kiválasztása"

#: components/common/FileSelector.yaml:78
msgctxt "FileSelector"
msgid "Drop file here"
msgstr "Húzza a file-t ide"

#: components/common/FileSelector.yaml:86
msgid "Upload"
msgstr "Feltöltés"

#: components/common/FileSelector.yaml:95
msgctxt "FileSelector"
msgid "Scanned Documents"
msgstr "Scannelt dokumentumok"

#: components/common/FileSelector.yaml:104
msgctxt "FileSelector"
msgid "There are no documents in the scan folder."
msgstr "Nincsenek dokumentumok a beolvasási mappában."

#: components/common/PageHelp.yaml:29 templates.yaml:16
msgid "Help"
msgstr "Súgó"

#: components/common/TransactionNotesDisplay.yaml:32
msgctxt "TransactionNotesDisplay"
msgid "Displays"
msgstr "Megjelenítések"

#: components/common/TransactionNotesEditor.yaml:94
msgctxt "TransactionNotesEditor"
msgid "The message to include to the invoice."
msgstr "A számlán feltüntetendő megjegyzés."

#: components/common/TransactionNotesEditor.yaml:113
msgctxt "TransactionNotesEditor"
msgid "Valid from"
msgstr "Érvényesség kezdete"

#: components/common/TransactionNotesEditor.yaml:130
msgctxt "TransactionNotesEditor"
msgid "Valid to"
msgstr "Érvényesség vége"

#: components/common/TransactionNotesEditor.yaml:148
msgctxt "TransactionNotesEditor"
msgid "Counter"
msgstr "Számláló"

#: components/common/TransactionNotesEditor.yaml:166
msgctxt "TransactionNotesEditor"
msgid "Max displays"
msgstr "Max megjelenítés"

#: components/common/TransactionNotesEditor.yaml:184
msgctxt "TransactionNotesEditor"
msgid "Remove"
msgstr "Eltávolítás"

#: components/common/TransactionNotesEditor.yaml:203
msgctxt "TransactionNotesEditor"
msgid "Add"
msgstr "Hozzáadás"

#: components/common/UcAttachmentsList.yaml:46
msgid "Attachments"
msgstr "Csatolmányok"

#: components/common/UcAttachmentsList.yaml:52
msgctxt "Attachments"
msgid "Upload file..."
msgstr "Fájl feltöltése..."

#: components/common/UcAttachmentsList.yaml:66
msgid "No attachments have been added yet."
msgstr "Nincsenek csatolmányok."

#: components/common/UcCommentsList.yaml:43
msgid "Comments"
msgstr "Megjegyzések"

#: components/common/UcCommentsList.yaml:49
msgid "Add comment..."
msgstr "Megjegyzés hozzáadása..."

#: components/common/UcCommentsList.yaml:63
msgid "No comments have been added yet."
msgstr "Nincsenek megjegyzések."

#: components/common/UcCommentsList.yaml:153
#: components/companies/form/addresses/UcAddressList.yaml:155
#: components/companies/form/bank-accounts/UcCompanyBankAccounts.yaml:138
#: components/contracts/form/events/UcContractEvents.yaml:132
#: components/contracts/form/services/UcContractServiceCard.yaml:52
#: components/property/PropertyBrowser.yaml:63
#: components/property/form/UcPropertyUnits.yaml:67
#: components/rental/form/properties/UcRentalFormProperties.yaml:140
#: templates.yaml:109
msgid "Locked"
msgstr "Zárolva"

#: components/common/UcInactive.yaml:15 components/meters/MeterBrowser.yaml:67
#: components/property/PropertyBrowser.yaml:57
#: components/rental/form/properties/RentalProperty.yaml:146
#: components/rental/form/properties/UcRentalFormProperties.yaml:146
#: templates.yaml:86
msgid "Inactive"
msgstr "Inaktív"

#: components/common/UcInactive.yaml:15
msgid "Active"
msgstr "Aktív"

#: components/common/UcResourceStatusCard.yaml:50
msgctxt "UcResourceStatusCard"
msgid "Activate"
msgstr "Aktiválás"

#: components/common/UcResourceStatusCard.yaml:61
msgctxt "UcResourceStatusCard"
msgid "Inactivate"
msgstr "Inaktiválás"

#: components/common/UcStatusBadge.yaml:13
msgctxt "Status"
msgid "Archived"
msgstr "Archiválva"

#: components/common/UcStatusBadge.yaml:14 translations-extra.yaml:30
msgctxt "Status"
msgid "Draft"
msgstr "Tervezet"

#: components/common/UcStatusBadge.yaml:15 translations-extra.yaml:33
msgctxt "Status"
msgid "Pending"
msgstr "Várakozik"

#: components/common/UcStatusBadge.yaml:16
msgctxt "Status"
msgid "Retry"
msgstr "Újrakezdés"

#: components/common/UcStatusBadge.yaml:17
msgctxt "Status"
msgid "Running"
msgstr "Fut"

#: components/common/UcStatusBadge.yaml:18 translations-extra.yaml:47
msgctxt "Status"
msgid "Completed"
msgstr "Kész"

#: components/common/UcStatusBadge.yaml:19
msgctxt "Status"
msgid "Failed"
msgstr "Hiba"

#: components/common/UcStatusBadge.yaml:20 translations-extra.yaml:48
msgctxt "Status"
msgid "Cancelled"
msgstr "Megszakítva"

#: components/common/UcStatusBadge.yaml:21
msgctxt "Status"
msgid "Deleted"
msgstr "Törölve"

#: components/common/UcStatusBadge.yaml:22
msgctxt "Status"
msgid "Invalid"
msgstr "Érvénytelen"

#: components/common/UcValidityPeriod.yaml:26
msgctxt "ValidityPeriod"
msgid "Valid from"
msgstr "Érvényesség kezdete"

#: components/common/UcValidityPeriod.yaml:29
msgctxt "ValidityPeriod"
msgid "Valid to"
msgstr "Érvényesség vége"

#: components/common/UcValidityPeriod.yaml:32
msgctxt "UcValidityPeriod"
msgid "N/A"
msgstr "N/A"

#: components/common/UcValidityPeriod.yaml:35
msgctxt "UcValidityPeriod"
msgid "Indefinite"
msgstr "Határozatlan ideig"

#: components/common/WAttachmentModal.yaml:23
msgctxt "Attachments"
msgid "Upload file"
msgstr "Fájl feltöltése"

#: components/common/WAttachmentModal.yaml:26
msgctxt "Attachments"
msgid "Edit description"
msgstr "Leírás szerkesztése"

#: components/common/WAttachmentModal.yaml:82
msgctxt "Attachment"
msgid "File"
msgstr "Fájl"

#: components/common/WAttachmentModal.yaml:92
msgid "Choose a file or drop it here"
msgstr "File kiválasztása"

#: components/common/WAttachmentModal.yaml:93
msgid "Drop file here"
msgstr "Húzza a file-t ide"

#: components/common/WComment.yaml:31
msgctxt "Comments"
msgid "Add comment"
msgstr "Új megjegyzés"

#: components/common/WComment.yaml:34
msgctxt "Comments"
msgid "Edit comment"
msgstr "Megjegyzés szerkesztése"

#: components/common/WComment.yaml:97
msgid "Comment message"
msgstr "Megjegyzés tartalma"

#: components/companies/Company.yaml:44
#: components/companies/CreateCompany.yaml:18
msgctxt "Company|Header"
msgid "New own company"
msgstr "Új saját cég"

#: components/companies/Company.yaml:45
#: components/companies/CreateCompany.yaml:19
msgctxt "Company|Header"
msgid "New partner"
msgstr "Új ügyfél"

#: components/companies/Company.yaml:47
msgctxt "Company|Header"
msgid "Companies"
msgstr "Saját cégek"

#: components/companies/Company.yaml:48
msgctxt "Company|Header"
msgid "Partners"
msgstr "Ügyfelek"

#: components/companies/Company.yaml:50
msgctxt "Company|Header"
msgid "Delete own company"
msgstr "Saját cég törlése"

#: components/companies/Company.yaml:51
msgctxt "Company|Header"
msgid "Delete partner"
msgstr "Ügyfél törlése"

#: components/companies/Company.yaml:231
msgctxt "Company"
msgid "Billing list"
msgstr "Számlázandók"

#: components/companies/Company.yaml:244
msgctxt "Company"
msgid "Invoices"
msgstr "Számlák"

#: components/companies/Company.yaml:258
msgctxt "Company"
msgid "Payments"
msgstr "Pénzforgalom"

#: components/companies/Company.yaml:276
msgctxt "Company"
msgid "Statement"
msgstr "Egyenleg"

#: components/companies/Company.yaml:289
msgctxt "Company"
msgid "Accounts"
msgstr "Folyószámlák"

#: components/companies/CompanyDataImportModal.yaml:4
msgid "Import client data"
msgstr "Ügyfelek adatimport"

#: components/companies/CompanyDataImportModal.yaml:47
#: components/meters/MeterDataExchange.yaml:64
#: components/payments/ImportBankStatement.yaml:97
msgid "One record imported."
msgid_plural "${n} records imported."
msgstr[0] "Importálva egy rekord."
msgstr[1] "Importálva ${n} rekord."

#: components/companies/CompanyDataImportModal.yaml:54
#: components/invoice/form/invoice-lines/UploadInvoiceLines.yaml:78
#: components/meters/MeterDataExchange.yaml:71
#: components/payments/ImportBankStatement.yaml:104
msgid "Nothing has been imported."
msgstr "Nem történt változás."

#: components/companies/CompanyDataImportModal.yaml:108
msgid "File"
msgstr "File"

#: components/companies/CompanyDataImportModal.yaml:131
msgid "Import file has header"
msgstr "Fejléccel ellátott import állomány"

#: components/companies/CompanyDataImportModal.yaml:139
msgid "Number column number"
msgstr "Ügyfélkód oszlop száma"

#: components/companies/CompanyDataImportModal.yaml:157
msgid "Name column number"
msgstr "Ügyfélnév oszlop száma"

#: components/companies/CompanyDataImportModal.yaml:175
msgid "Email column number"
msgstr "Email oszlop száma"

#: components/companies/CompanyDataImportModal.yaml:199
msgid "Import"
msgstr "Importálás"

#: components/companies/CreateCompany.yaml:22
msgctxt "Company|ResourceTitle"
msgid "Company"
msgstr "Saját cég"

#: components/companies/CreateCompany.yaml:23
msgctxt "Company|ResourceTitle"
msgid "Partner"
msgstr "Ügyfél"

#: components/companies/CreateCompany.yaml:26
msgctxt "Button"
msgid "Create company"
msgstr "Saját cég létrehozása"

#: components/companies/CreateCompany.yaml:27
msgctxt "Button"
msgid "Create partner"
msgstr "Ügyfél létrehozása"

#: components/companies/CreateCompany.yaml:130
msgctxt "CreateCompany"
msgid "Address"
msgstr "Cím"

#: components/companies/MCompanyEditor.yaml:21
msgctxt "Company"
msgid "Edit General Information"
msgstr "Általános adatok szerkesztése"

#: components/companies/MCompanyEditor.yaml:26
msgctxt "Company"
msgid "Edit general data"
msgstr "Általános adatok  szerkesztése"

#: components/companies/form/FieldsetCompanyGeneral.yaml:84
msgctxt "Company"
msgid "Name"
msgstr "Név"

#: components/companies/form/FieldsetCompanyGeneral.yaml:99
msgctxt "Company"
msgid "Code"
msgstr "Kód"

#: components/companies/form/FieldsetCompanyGeneral.yaml:130
msgctxt "Company"
msgid "Type"
msgstr "Típus"

#: components/companies/form/FieldsetCompanyGeneral.yaml:146
msgctxt "Company"
msgid "Groups"
msgstr "Csoportok"

#: components/companies/form/FieldsetCompanyGeneral.yaml:161
msgctxt "Company"
msgid "Email"
msgstr "Email"

#: components/companies/form/FieldsetCompanyGeneral.yaml:163
msgctxt "Company"
msgid "Multiple email addresses should be separated by semicolon."
msgstr "Pontosvesszővel elválasztva több email cím is megadható."

#: components/companies/form/FieldsetCompanyGeneral.yaml:176
msgctxt "Company"
msgid "External key"
msgstr "Külső azonosító"

#: components/companies/form/FieldsetCompanyGeneral.yaml:191
msgctxt "Company"
msgid "Notes"
msgstr "Megjegyzés"

#: components/companies/form/FieldsetCompanyGeneral.yaml:215
msgctxt "Company"
msgid ""
"By providing the tax number, the company data can be directly retrieved from "
"the NAV database."
msgstr ""
"Az adószám megadásával a cégadatok közvetlenül a NAV adatbázisából "
"lekérdezhetőek."

#: components/companies/form/FieldsetCompanyGeneral.yaml:221
msgctxt "Company"
msgid "Tax number"
msgstr "Adószám"

#: components/companies/form/FieldsetCompanyGeneral.yaml:237
msgctxt "Company"
msgid "Fetch taxpayer data from NAV database"
msgstr "Az adatok lekérdezése a NAV-tól"

#: components/companies/form/FieldsetCompanyGeneral.yaml:241
msgctxt "Company"
msgid "Retrieve data"
msgstr "Adatok lekérdezése"

#: components/companies/form/FieldsetCompanyGeneral.yaml:250
msgctxt "Company"
msgid "Tax number history"
msgstr "Előző adószámok"

#: components/companies/form/FieldsetCompanyGeneral.yaml:263
msgctxt "Company"
msgid "Group member tax number"
msgstr "Csoportazonosító szám"

#: components/companies/form/FieldsetCompanyGeneral.yaml:275
msgctxt "Company"
msgid "EU tax number"
msgstr "EU adószám"

#: components/companies/form/FieldsetCompanyGeneral.yaml:287
#: components/contracts/form/general/FieldsetContractClientData.yaml:111
msgctxt "Company"
msgid "Registration number"
msgstr "Nyilvántartási szám"

#: components/companies/form/FieldsetCompanyGeneral.yaml:309
msgctxt "Company"
msgid "Send invoice notifications"
msgstr "Számlaértesítés küldése"

#: components/companies/form/FieldsetCompanyGeneral.yaml:324
msgctxt "Company"
msgid "SMTP Mail Account"
msgstr "SMTP email fiók"

#: components/companies/form/FieldsetCompanyGeneral.yaml:350
msgctxt "Company"
msgid "Payment period"
msgstr "Fizetési határidő"

#: components/companies/form/FieldsetCompanyGeneral.yaml:367
#: components/contracts/form/lifecycle/FieldsetContractLifecycle.yaml:164
#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:273
msgctxt "InputGroupAddon"
msgid "days"
msgstr "nap"

#: components/companies/form/FieldsetCompanyGeneral.yaml:372
msgctxt "Company"
msgid "Discount"
msgstr "Kedvezmény"

#: components/companies/form/FieldsetCompanyGeneral.yaml:402
msgctxt "Company"
msgid "Contractor"
msgstr "Alvállalkozó"

#: components/companies/form/FieldsetCompanyGeneral.yaml:414
msgctxt "Company"
msgid "Sole proprietor"
msgstr "Egyéni vállalkozó"

#: components/companies/form/FieldsetCompanyGeneral.yaml:426
msgctxt "Company"
msgid "Natural person"
msgstr "Magánszemély"

#: components/companies/form/FieldsetCompanyGeneral.yaml:438
msgctxt "Company"
msgid "VAT exempt"
msgstr "Alanyi adómentes"

#: components/companies/form/FieldsetCompanyGeneral.yaml:450
msgctxt "Company"
msgid "Exclude from claims"
msgstr "Követeléskezelés alól kivont"

#: components/companies/form/FieldsetCompanyGeneral.yaml:464
msgctxt "Company"
msgid "Notifications enabled"
msgstr "Értesítések engedélyezése"

#: components/companies/form/FieldsetCompanyGeneral.yaml:496
msgctxt "Company"
msgid "Email recipients"
msgstr "Email címzettek"

#: components/companies/form/FieldsetCompanyGeneral.yaml:498
msgctxt "Company"
msgid "Input one email address per row."
msgstr "Az email címeket soronként kell megadni"

#: components/companies/form/UcCompanyFormContracts.yaml:47
msgctxt "Company"
msgid "Contracts"
msgstr "Szerződések"

#: components/companies/form/UcCompanyFormContracts.yaml:52
#: components/rental/form/contracts/UcRentalFormContracts.yaml:52
msgid "Create contract..."
msgstr "Új szerződés..."

#: components/companies/form/UcCompanyFormContracts.yaml:67
msgctxt "Company"
msgid "No related contracts."
msgstr "Nincsenek kapcsolódó szerződések."

#: components/companies/form/UcCompanyGeneral.yaml:26
msgctxt "Company"
msgid "General"
msgstr "Általános"

#: components/companies/form/UcCompanyGeneral.yaml:70
#: components/companies/form/bank-accounts/UcCompanyBankAccountFieldset.yaml:87
msgctxt "Company"
msgid "Default"
msgstr "Alapértelmezett"

#: components/companies/form/UcCompanyGeneral.yaml:78
msgctxt "Company"
msgid "Number"
msgstr "Sorszám"

#: components/companies/form/UcCompanyGeneral.yaml:84
#: components/meters/form/general/UcMeterGeneralPanel.yaml:138
msgctxt "Meter"
msgid "Status"
msgstr "Státusz"

#: components/companies/form/UcCompanyGeneral.yaml:100
msgctxt "Company"
msgid "Client relation"
msgstr "Kapcsolat jellege"

#: components/companies/form/UcCompanyGeneral.yaml:187
#: components/finance/Claims.yaml:121
#: components/meters/form/general/UcMeterGeneralPanel.yaml:122
#: components/product/form/UcProductGeneral.yaml:102 templates.yaml:101
msgid "Yes"
msgstr "Igen"

#: components/companies/form/UcCompanyStatement.yaml:2
msgctxt "CompanyStatementType"
msgid "Invoice"
msgstr "Számla"

#: components/companies/form/UcCompanyStatement.yaml:3
msgctxt "CompanyStatementType"
msgid "Payment"
msgstr "Kiegyenlítés"

#: components/companies/form/UcCompanyStatement.yaml:56
msgctxt "client|Statement"
msgid "Statement"
msgstr "Folyószámla"

#: components/companies/form/UcCompanyStatement.yaml:61
msgctxt "filename"
msgid "client-statement"
msgstr "ügyfél-folyószámla"

#: components/companies/form/UcCompanyStatement.yaml:68
msgctxt "CompanyStatement"
msgid "Date"
msgstr "Dátum"

#: components/companies/form/UcCompanyStatement.yaml:72
msgctxt "CompanyStatement"
msgid "Type"
msgstr "Típus"

#: components/companies/form/UcCompanyStatement.yaml:93
msgctxt "CompanyStatement"
msgid "Number"
msgstr "Sorszám"

#: components/companies/form/UcCompanyStatement.yaml:101
msgctxt "CompanyStatement"
msgid "Amount"
msgstr "Összeg"

#: components/companies/form/UcCompanyStatement.yaml:106
msgctxt "CompanyStatement"
msgid "Currency"
msgstr "Pénznem"

#: components/companies/form/UcCompanyStatement.yaml:109
msgctxt "CompanyStatement"
msgid "Balance"
msgstr "Egyenleg"

#: components/companies/form/addresses/Address.yaml:25
msgctxt "Addresses"
msgid "Add address"
msgstr "Cím hozzáadása"

#: components/companies/form/addresses/Address.yaml:28
msgctxt "Addresses"
msgid "Edit address"
msgstr "Cím szerkesztése"

#: components/companies/form/addresses/FieldsetAddress.yaml:25
msgctxt "Address"
msgid "Address Type"
msgstr "Cím típusa"

#: components/companies/form/addresses/FieldsetAddress.yaml:65
msgctxt "Address"
msgid "Country"
msgstr "Ország"

#: components/companies/form/addresses/FieldsetAddress.yaml:77
msgctxt "Address"
msgid "Region"
msgstr "Megye/régió"

#: components/companies/form/addresses/FieldsetAddress.yaml:93
msgctxt "Address"
msgid "Postal Code"
msgstr "Irányítószám"

#: components/companies/form/addresses/FieldsetAddress.yaml:105
msgctxt "Address"
msgid "City"
msgstr "Város"

#: components/companies/form/addresses/FieldsetAddress.yaml:117
msgctxt "Address"
msgid "District"
msgstr "Kerület"

#: components/companies/form/addresses/FieldsetAddress.yaml:130
msgctxt "Address"
msgid "Address Line 1"
msgstr "Cím első sora"

#: components/companies/form/addresses/FieldsetAddress.yaml:143
msgctxt "Address"
msgid "Address Line 2"
msgstr "Cím második sora"

#: components/companies/form/addresses/FieldsetAddress.yaml:156
msgctxt "Address"
msgid "Address Line 3"
msgstr "Cím harmadik sora"

#: components/companies/form/addresses/FieldsetAddress.yaml:169
msgctxt "Address"
msgid "Street Address"
msgstr "Cím"

#: components/companies/form/addresses/FieldsetAddress.yaml:189
msgctxt "Address"
msgid "Public Place"
msgstr "Közterület neve"

#: components/companies/form/addresses/FieldsetAddress.yaml:201
msgctxt "Address"
msgid "Public Place Type"
msgstr "Közterület jellege"

#: components/companies/form/addresses/FieldsetAddress.yaml:216
msgctxt "Address"
msgid "House Nr"
msgstr "Házszám"

#: components/companies/form/addresses/FieldsetAddress.yaml:228
msgctxt "Address"
msgid "Building Nr"
msgstr "Épület"

#: components/companies/form/addresses/FieldsetAddress.yaml:240
msgctxt "Address"
msgid "Sub Building Nr"
msgstr "Lépcsőház"

#: components/companies/form/addresses/FieldsetAddress.yaml:252
msgctxt "Address"
msgid "Floor Nr"
msgstr "Szint"

#: components/companies/form/addresses/FieldsetAddress.yaml:264
msgctxt "Address"
msgid "Door Nr"
msgstr "Ajtó"

#: components/companies/form/addresses/FieldsetAddress.yaml:277
msgctxt "Address"
msgid "Other Details"
msgstr "Részletek"

#: components/companies/form/addresses/UcAddressList.yaml:41
msgid "Addresses"
msgstr "Címek"

#: components/companies/form/addresses/UcAddressList.yaml:47
msgid "Add address..."
msgstr "Új cím..."

#: components/companies/form/addresses/UcAddressList.yaml:61
msgid "No addresses have been added yet."
msgstr "Nincsenek címek."

#: components/companies/form/addresses/UcAddressTypeBadge.yaml:13
msgctxt "AddressType"
msgid "Sentence"
msgstr "Mondat"

#: components/companies/form/bank-accounts/CompanyBankAccount.yaml:25
msgctxt "CompanyBankAccounts"
msgid "Add bank account"
msgstr "Bankszámla hozzáadása"

#: components/companies/form/bank-accounts/CompanyBankAccount.yaml:28
msgctxt "CompanyBankAccounts"
msgid "Edit bank account"
msgstr "Bankszámla szerkesztése"

#: components/companies/form/bank-accounts/UcCompanyBankAccountCard.yaml:46
msgctxt "BankAccount"
msgid "Bank"
msgstr "Bank"

#: components/companies/form/bank-accounts/UcCompanyBankAccountCard.yaml:54
msgctxt "BankAccount"
msgid "IBAN"
msgstr "IBAN"

#: components/companies/form/bank-accounts/UcCompanyBankAccountFieldset.yaml:17
msgctxt "CompanyBankAccount"
msgid "Account Number"
msgstr "Számlaszám"

#: components/companies/form/bank-accounts/UcCompanyBankAccountFieldset.yaml:33
msgctxt "CompanyBankAccount"
msgid "Description"
msgstr "Leírás"

#: components/companies/form/bank-accounts/UcCompanyBankAccountFieldset.yaml:46
msgctxt "CompanyBankAccount"
msgid "IBAN"
msgstr "IBAN"

#: components/companies/form/bank-accounts/UcCompanyBankAccountFieldset.yaml:62
msgctxt "CompanyBankAccount"
msgid "Validity"
msgstr "Érvényesség"

#: components/companies/form/bank-accounts/UcCompanyBankAccounts.yaml:31
msgctxt "CompanyBankAccounts"
msgid "Bank accounts"
msgstr "Bankszámlák"

#: components/companies/form/bank-accounts/UcCompanyBankAccounts.yaml:37
msgid "Add bank account..."
msgstr "Új bankszámla..."

#: components/companies/form/bank-accounts/UcCompanyBankAccounts.yaml:51
msgid "No bank accounts have been added yet."
msgstr "Nincsenek bankszámlák."

#: components/companies/form/contacts/UcContactCard.yaml:31
msgctxt "Contact"
msgid "Job title"
msgstr "Munkakör / pozíció"

#: components/companies/form/contacts/UcContactCard.yaml:48
msgctxt "Contact"
msgid "Phone Number"
msgstr "Telefonszám"

#: components/companies/form/contacts/UcContactCard.yaml:64
msgctxt "Contact"
msgid "Mobile"
msgstr "Mobil"

#: components/companies/form/contacts/UcContactCard.yaml:80
msgctxt "Contact"
msgid "Fax"
msgstr "Fax"

#: components/companies/form/contacts/UcContactCard.yaml:96
msgctxt "Contact"
msgid "Email"
msgstr "Email"

#: components/companies/form/contacts/UcContactCard.yaml:109
msgctxt "Contact"
msgid "Notes"
msgstr "Megjegyzés"

#: components/companies/form/contacts/UcContactFieldset.yaml:17
msgctxt "Contact"
msgid "Name"
msgstr "Név"

#: components/companies/form/contacts/UcContactFieldset.yaml:33
msgctxt "Contact"
msgid "Job Title"
msgstr "Munkakör / pozíció"

#: components/companies/form/contacts/UcContactFieldset.yaml:59
msgctxt "Contact"
msgid "Mobile Number"
msgstr "Mobilszám"

#: components/companies/form/contacts/UcContactList.yaml:31
msgid "Contacts"
msgstr "Kapcsolatok"

#: components/companies/form/contacts/UcContactList.yaml:37
msgid "Add contact..."
msgstr "Kapcsolat hozzáadása..."

#: components/companies/form/contacts/UcContactList.yaml:51
msgid "No contacts have been added yet."
msgstr "Nincsenek kapcsolat adatok."

#: components/companies/form/contacts/WContactModal.yaml:24
msgctxt "Contactes"
msgid "Add contact"
msgstr "Kapcsolat hozzáadása"

#: components/companies/form/contacts/WContactModal.yaml:27
msgctxt "Contactes"
msgid "Edit contact"
msgstr "Kapcsolat szerkesztése"

#: components/companies/form/employees/UcEmployeeFieldset.yaml:17
msgctxt "Employee"
msgid "Name"
msgstr "Név"

#: components/companies/form/employees/UcEmployeeFieldset.yaml:33
msgctxt "Employee"
msgid "Job Title"
msgstr "Munkakör / pozíció"

#: components/companies/form/employees/UcEmployeeFieldset.yaml:46
msgctxt "Employee"
msgid "Phone Number"
msgstr "Telefonszám"

#: components/companies/form/employees/UcEmployeeFieldset.yaml:59
msgctxt "Employee"
msgid "Mobile Number"
msgstr "Mobilszám"

#: components/companies/form/employees/UcEmployeeFieldset.yaml:72
msgctxt "Employee"
msgid "Email"
msgstr "Email cím"

#: components/companies/form/employees/UcEmployeeFieldset.yaml:85
msgctxt "Employee"
msgid "Fax"
msgstr "Fax"

#: components/companies/form/employees/UcEmployeeFieldset.yaml:99
msgctxt "Employee"
msgid "Notes"
msgstr "Megjegyzés"

#: components/companies/form/employees/UcEmployeeList.yaml:34
msgid "Employees"
msgstr "Alkalmazottak"

#: components/companies/form/employees/UcEmployeeList.yaml:40
msgid "Add employee..."
msgstr "Új alkalmazott..."

#: components/companies/form/employees/UcEmployeeList.yaml:54
msgid "No employees have been added yet."
msgstr "Nincsenek alkalmazottak."

#: components/companies/form/employees/WEmployeeModal.yaml:24
msgctxt "Employeees"
msgid "Add employee"
msgstr "Alkalmazott hozzáadása"

#: components/companies/form/employees/WEmployeeModal.yaml:27
msgctxt "Employeees"
msgid "Edit employee"
msgstr "Alkalmazott szerkesztése"

#: components/companies/primitives/UcCompanyPanel.yaml:16
#: components/invoice/form/UcInvoicePartyPanel.yaml:24
msgid "Tax Number"
msgstr "Adószám"

#: components/companies/primitives/UcCompanyPanel.yaml:17
#: components/invoice/form/UcInvoicePartyPanel.yaml:27
msgid "Account Number"
msgstr "Számlaszám"

#: components/companies/primitives/UcCompanyTypeBadge.yaml:14
msgctxt "CompanyRelation"
msgid "Sentence"
msgstr "Mondat"

#: components/companies/views/CompaniesView.yaml:38
msgctxt "Companies"
msgid "Own companies"
msgstr "Saját cégek"

#: components/companies/views/CompaniesView.yaml:39
msgctxt "Companies"
msgid "Partners"
msgstr "Ügyfelek"

#: components/companies/views/CompaniesView.yaml:41
msgctxt "Companies|Command"
msgid "New company..."
msgstr "Új saját cég..."

#: components/companies/views/CompaniesView.yaml:42
msgctxt "Companies|Command"
msgid "New partner..."
msgstr "Új ügyfél..."

#: components/companies/views/CompaniesView.yaml:56
msgctxt "CompaniesView"
msgid "Companies"
msgstr "Saját cégek"

#: components/companies/views/CompaniesView.yaml:60
msgctxt "filename"
msgid "companies"
msgstr "saját-cégek"

#: components/companies/views/CompaniesView.yaml:67
msgctxt "Companies"
msgid "Code"
msgstr "Kód"

#: components/companies/views/CompaniesView.yaml:75
msgctxt "Companies"
msgid "Name"
msgstr "Név"

#: components/companies/views/CompaniesView.yaml:83
msgctxt "Companies"
msgid "Tax number"
msgstr "Adószám"

#: components/companies/views/CompaniesView.yaml:86
msgctxt "Companies"
msgid "Registration number"
msgstr "Nyilvántartási szám"

#: components/companies/views/CompaniesView.yaml:90
msgctxt "Companies"
msgid "Company relation"
msgstr "Kapcsolat jellege"

#: components/companies/views/CompaniesView.yaml:98
msgctxt "Companies"
msgid "Natural person"
msgstr "Magánszemély"

#: components/companies/views/CompaniesView.yaml:104
msgctxt "Companies"
msgid "Sole proprietor"
msgstr "Egyéni vállalkozó"

#: components/companies/views/CompaniesView.yaml:110
msgctxt "Companies"
msgid "Contractor"
msgstr "Alvállalkozó"

#: components/companies/views/CompaniesView.yaml:116
msgctxt "Companies"
msgid "External key"
msgstr "Külső azonosító"

#: components/companies/views/CompaniesView.yaml:139
msgctxt "CompaniesView"
msgid "Dataimport..."
msgstr "Adatimport..."

#: components/contracts/Contract.yaml:11
msgid "Contract"
msgstr "Szerződés"

#: components/contracts/Contract.yaml:68
#: components/invoice/form/invoice-references/InvoiceReferenceSearch.yaml:34
#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:99
msgid "Contracts"
msgstr "Szerződések"

#: components/contracts/Contract.yaml:96
msgctxt "Contract/DialogTitle"
msgid "Delete contract"
msgstr "Szerződés törlése"

#: components/contracts/Contract.yaml:211
msgctxt "Contract"
msgid "Billing list"
msgstr "Számlázandók"

#: components/contracts/Contract.yaml:223
msgctxt "Contract"
msgid "Invoices"
msgstr "Számlák"

#: components/contracts/ContractEditor.yaml:24
msgctxt "Contract"
msgid "Edit General Information"
msgstr "Általános információk szerkesztése"

#: components/contracts/ContractEditor.yaml:29
msgctxt "Contract"
msgid "Edit company"
msgstr "Saját cég szerkesztése"

#: components/contracts/ContractEditor.yaml:32
msgctxt "Contract"
msgid "Edit counterparty"
msgstr "Szerződő partner"

#: components/contracts/ContractEditor.yaml:35
msgctxt "Contract"
msgid "Edit invoicing information"
msgstr "Számlázási adatok szerkesztése"

#: components/contracts/ContractEditor.yaml:38
msgctxt "Contract"
msgid "Edit lifecycle information"
msgstr "Életciklus jellemzők szerkesztése"

#: components/contracts/ContractEditor.yaml:41
msgctxt "Contract"
msgid "Edit rental"
msgstr "Bérlemény szerkesztése"

#: components/contracts/ContractEditor.yaml:44
msgctxt "Contract"
msgid "Edit general data"
msgstr "Általános információk szerkesztése"

#: components/contracts/ContractService.yaml:37
#: components/contracts/form/services/ContractServiceEditor.yaml:99
msgctxt "Contract"
msgid "Add Service"
msgstr "Szolgáltatás hozzáadása"

#: components/contracts/ContractService.yaml:39
#: components/contracts/form/services/ContractServiceEditor.yaml:101
msgctxt "Contract"
msgid "Edit Service"
msgstr "Szolgáltatás szerkesztése"

#: components/contracts/ContractService.yaml:41
#: components/contracts/form/services/ContractServiceEditor.yaml:103
msgctxt "Contract"
msgid "Add Service Fee"
msgstr "Szolgáltatási díj hozzáadása"

#: components/contracts/ContractService.yaml:43
#: components/contracts/form/services/ContractServiceEditor.yaml:105
msgctxt "Contract"
msgid "Edit Service Fee"
msgstr "Szolgáltatási díj szerkesztése"

#: components/contracts/ContractService.yaml:91
msgctxt "ResourceTitle"
msgid "Contract Service"
msgstr "Szerződött szolgáltatás"

#: components/contracts/ContractService.yaml:117
msgctxt "ContractService"
msgid "General"
msgstr "Általános"

#: components/contracts/ContractService.yaml:157
#: components/contracts/form/services/UCContractServiceFeesEditor.yaml:78
msgctxt "ContractService"
msgid "Fees"
msgstr "Díjak"

#: components/contracts/ContractService.yaml:175
#: components/contracts/form/services/ContractServiceEditor.yaml:798
msgctxt "Button"
msgid "Lock Service"
msgstr "Szolgáltatás lezárása"

#: components/contracts/ContractService.yaml:187
#: components/contracts/form/services/ContractServiceEditor.yaml:810
msgctxt "Button"
msgid "Delete Service"
msgstr "Szolgáltatás törlése"

#: components/contracts/ContractService.yaml:199
#: components/contracts/form/services/ContractServiceEditor.yaml:822
msgctxt "Button"
msgid "Delete Fee"
msgstr "Díj törlése"

#: components/contracts/ContractServiceFee.yaml:6
msgctxt "ContractServiceFee"
msgid "fee"
msgstr "díj"

#: components/contracts/ContractServiceFee.yaml:144
msgctxt "ContractServiceEditor"
msgid "Contract"
msgstr "Szerződés"

#: components/contracts/ContractServiceFee.yaml:159
#: components/contracts/form/services/ContractServiceEditor.yaml:243
msgctxt "ContractServiceEditor"
msgid "Service"
msgstr "Szolgáltatás"

#: components/contracts/ContractServiceFee.yaml:194
#: components/contracts/form/services/ContractServiceEditor.yaml:748
msgctxt "Button"
msgid "Lock Service Fee"
msgstr "Szolgáltatási díj lezárása"

#: components/contracts/Contracts.yaml:32
msgctxt "Contracts"
msgid "Contracts"
msgstr "Szerződések"

#: components/contracts/Contracts.yaml:36
msgctxt "filename"
msgid "contracts"
msgstr "szerződések"

#: components/contracts/Contracts.yaml:44
msgctxt "Contracts"
msgid "Contract number"
msgstr "Szerződésszám"

#: components/contracts/Contracts.yaml:53
#: components/contracts/views/ContractServiceFees.yaml:91
msgctxt "Contracts"
msgid "Type"
msgstr "Típus"

#: components/contracts/Contracts.yaml:73
#: components/contracts/views/ContractServiceFees.yaml:118
msgctxt "Contracts"
msgid "Status"
msgstr "Státusz"

#: components/contracts/Contracts.yaml:95
msgctxt "Contracts"
msgid "Rental"
msgstr "Bérlemény"

#: components/contracts/Contracts.yaml:119
msgctxt "Contracts"
msgid "Lessor"
msgstr "Bérbeadó"

#: components/contracts/Contracts.yaml:129
msgctxt "Contracts"
msgid "Tenant"
msgstr "Bérlő"

#: components/contracts/Contracts.yaml:139
msgctxt "Contracts"
msgid "Version"
msgstr "Módosítás"

#: components/contracts/Contracts.yaml:142
msgctxt "Contracts"
msgid "Revision date"
msgstr "Módosítás dátuma"

#: components/contracts/Contracts.yaml:147
msgctxt "Contracts"
msgid "Contract date"
msgstr "Szerződés dátuma"

#: components/contracts/Contracts.yaml:152
#: components/contracts/views/ContractServiceFees.yaml:218
msgctxt "Contracts"
msgid "Valid From"
msgstr "Érvényesség kezdete"

#: components/contracts/Contracts.yaml:157
#: components/contracts/views/ContractServiceFees.yaml:223
msgctxt "Contracts"
msgid "Valid To"
msgstr "Érvényesség vége"

#: components/contracts/Contracts.yaml:162
msgctxt "Contracts"
msgid "Next indexation"
msgstr "Következő indexálás dátuma"

#: components/contracts/Contracts.yaml:167
msgctxt "Contracts"
msgid "Termination date"
msgstr "Felmondás napja"

#: components/contracts/Contracts.yaml:172
msgctxt "Contracts"
msgid "Termination effective date"
msgstr "Felmondás lejárata"

#: components/contracts/Contracts.yaml:177
msgctxt "Contracts"
msgid "Folder number"
msgstr "Mappaszám"

#: components/contracts/Contracts.yaml:180
msgctxt "Contracts"
msgid "Property units"
msgstr "Helyek"

#: components/contracts/Contracts.yaml:217
#: components/contracts/views/ContractServices.yaml:329
msgctxt "Contracts"
msgid "Skip archived contracts"
msgstr "Archivált szerződések elrejtése"

#: components/contracts/Contracts.yaml:227
msgctxt "Contracts"
msgid "Create contract..."
msgstr "Új szerződés..."

#: components/contracts/CreateContract.yaml:4
msgid "Create Contract"
msgstr "Új szerződés"

#: components/contracts/CreateContract.yaml:63
#: components/contracts/form/general/FieldsetContractCompanyData.yaml:19
#: components/contracts/form/general/UcContractGeneralInfo.yaml:97
msgctxt "Contract"
msgid "Lessor"
msgstr "Bérbeadó"

#: components/contracts/CreateContract.yaml:64
#: components/contracts/form/general/FieldsetContractCompanyData.yaml:24
#: components/contracts/views/ContractServiceFees.yaml:170
#: components/rental/views/RentalServices.yaml:153
msgctxt "Contract"
msgid "Company"
msgstr "Saját Cég"

#: components/contracts/CreateContract.yaml:71
#: components/contracts/form/general/FieldsetContractClientData.yaml:23
#: components/contracts/form/general/UcContractGeneralInfo.yaml:144
msgctxt "Contract"
msgid "Tenant"
msgstr "Bérlő"

#: components/contracts/CreateContract.yaml:72
#: components/contracts/views/ContractServiceFees.yaml:194
#: components/rental/views/RentalServices.yaml:177
msgctxt "Contract"
msgid "Counterparty"
msgstr "Szerződő partner"

#: components/contracts/CreateContract.yaml:114
#: components/contracts/form/general/FieldsetContractGeneralData.yaml:66
msgid "Contract type"
msgstr "Szerződés típusa"

#: components/contracts/CreateContract.yaml:160
#: components/contracts/form/general/FieldsetContractGeneralData.yaml:29
#: components/contracts/form/general/UcContractGeneralInfo.yaml:21
msgctxt "Contract"
msgid "General"
msgstr "Általános"

#: components/contracts/CreateContract.yaml:194
#: components/contracts/form/general/FieldsetContractRentalData.yaml:27
#: components/contracts/form/general/UcContractGeneralInfo.yaml:190
msgctxt "Contract"
msgid "Rental"
msgstr "Bérlemény"

#: components/contracts/CreateContract.yaml:204
#: components/contracts/form/invoicing/UcContractInvoicing.yaml:42
msgctxt "Contract"
msgid "Financial"
msgstr "Pénzügy"

#: components/contracts/CreateContract.yaml:247
msgid "Previous"
msgstr "Előző"

#: components/contracts/CreateContract.yaml:261
msgid "Next"
msgstr "Következő"

#: components/contracts/CreateContract.yaml:278
msgid "Create contract"
msgstr "Szerződés létrehozása"

#: components/contracts/CreateContractRevision.yaml:4
msgid "Create Contract Revision"
msgstr "Új szerződésmódosítás"

#: components/contracts/CreateContractRevision.yaml:94
msgctxt "Contract"
msgid "Revision Number"
msgstr "Módosítás"

#: components/contracts/CreateContractRevision.yaml:110
#: components/contracts/form/general/FieldsetContractGeneralData.yaml:84
#: components/contracts/form/general/UcContractGeneralInfo.yaml:64
msgctxt "Contract"
msgid "Status"
msgstr "Státusz"

#: components/contracts/CreateContractRevision.yaml:128
msgctxt "Contract"
msgid "Revision Date"
msgstr "Szerződésmódosítás dátuma"

#: components/contracts/CreateContractRevision.yaml:144
#: components/contracts/form/general/FieldsetContractValidityData.yaml:15
#: components/contracts/form/lifecycle/FieldsetContractLifecycle.yaml:70
msgctxt "Contract"
msgid "Validity"
msgstr "Érvényesség"

#: components/contracts/CreateContractRevision.yaml:184
msgctxt "CreateContractRevision"
msgid ""
"The new revision will be created based on the opened revision. Select the "
"following options to copy services and/or fees to the new revision."
msgstr ""
"Az új verzió az aktuálisan megnyitott verzió alapján készül. Az alábbi "
"opciók segítségével lehetőség van a szolgáltatások és az árak továbbvitelére."

#: components/contracts/CreateContractRevision.yaml:189
msgctxt "CreateContractRevision"
msgid "Options"
msgstr "Opciók"

#: components/contracts/CreateContractRevision.yaml:202
msgctxt "CreateContractRevision"
msgid "Copy services"
msgstr "Szolgáltatások másolása"

#: components/contracts/CreateContractRevision.yaml:209
msgctxt "CreateContractRevision"
msgid "Copy service fees"
msgstr "Szolgáltatási díjak másolása"

#: components/contracts/CreateContractRevision.yaml:216
msgctxt "CreateContractRevision"
msgid "Skip outdated services"
msgstr "Lejárt szolgáltatások másolásának kihagyása"

#: components/contracts/CreateContractRevision.yaml:223
msgctxt "CreateContractRevision"
msgid "Skip outdated service fees"
msgstr "Lejárt díjak másolásának kihagyása"

#: components/contracts/CreateContractRevision.yaml:263
msgctxt "Contract"
msgid "Create revision"
msgstr "Új szerződésmódosítás"

#: components/contracts/InflationIndexedPriceChange.yaml:4
msgid "Create new price"
msgstr "Új ár felvétele"

#: components/contracts/InflationIndexedPriceChange.yaml:84
msgid "Contract number"
msgstr "Szerződésszám"

#: components/contracts/InflationIndexedPriceChange.yaml:97
msgid "Tenant"
msgstr "Bérlő"

#: components/contracts/InflationIndexedPriceChange.yaml:111
#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:964
#: components/rental/Rental.yaml:6
msgid "Rental"
msgstr "Bérlemény"

#: components/contracts/InflationIndexedPriceChange.yaml:128
#: components/contracts/form/services/BulkContractServiceEditor.yaml:170
#: components/contracts/views/ContractServiceFees.yaml:233
#: components/rental/views/RentalServices.yaml:238
msgctxt "ContractService"
msgid "Name"
msgstr "Megnevezés"

#: components/contracts/InflationIndexedPriceChange.yaml:142
msgctxt "ContractServiceFee"
msgid "Current price"
msgstr "Aktuális ár"

#: components/contracts/InflationIndexedPriceChange.yaml:166
msgctxt "ContractServiceFee"
msgid "New price"
msgstr "Új ár"

#: components/contracts/InflationIndexedPriceChange.yaml:190
#: components/contracts/form/services/ContractServiceEditor.yaml:596
msgctxt "ContractServiceFee"
msgid "Valid from"
msgstr "Érvényesség kezdete"

#: components/contracts/InflationIndexedPriceChange.yaml:205
#: components/contracts/form/services/ContractServiceEditor.yaml:612
msgctxt "ContractServiceFee"
msgid "Valid to"
msgstr "Érvényesség vége"

#: components/contracts/InflationIndexedPriceChange.yaml:219
#: components/contracts/form/services/ContractServiceEditor.yaml:734
msgctxt "ContractServiceFee"
msgid "Notes"
msgstr "Megjegyzés"

#: components/contracts/UcExpiringContractNotificationCard.yaml:23
msgid "Expiring contract"
msgstr "Lejáró szerződés"

#: components/contracts/UcExpiringContractNotificationCard.yaml:60
msgid "End date"
msgstr "Záró dátum"

#: components/contracts/UcInflationIndexedPriceChangeNotificationCard.yaml:13
msgid "Inflation indexed price change"
msgstr "Inflációkövető ár változás"

#: components/contracts/UcInflationIndexedPriceChangeNotificationCard.yaml:48
msgid "current price"
msgstr "aktuális ár"

#: components/contracts/UcInflationIndexedPriceChangeNotificationCard.yaml:56
msgid "new price"
msgstr "új ár"

#: components/contracts/UcInflationIndexedPriceChangeNotificationCard.yaml:64
msgid "Add new price..."
msgstr "Új ár felvétele..."

#: components/contracts/form/events/FieldsetHandoverProtocol.yaml:26
msgctxt "RentalHandover"
msgid "Status"
msgstr "Státusz"

#: components/contracts/form/events/FieldsetHandoverProtocol.yaml:38
msgctxt "RentalHandover"
msgid "Handover date"
msgstr "Átadás/átvétel dátuma"

#: components/contracts/form/events/FieldsetHandoverProtocol.yaml:55
msgctxt "RentalHandover"
msgid "Paragraphs"
msgstr "Bekezdések"

#: components/contracts/form/events/FieldsetHandoverProtocol.yaml:78
msgctxt "RentalHandover"
msgid "Meter reading"
msgstr "Mérőóra leolvasások"

#: components/contracts/form/events/FieldsetHandoverProtocol.yaml:124
#: components/dashboard/Notifications.yaml:102
msgid "Remove"
msgstr "Eltávolítás"

#: components/contracts/form/events/HandoverProtocol.yaml:5
msgctxt "Contract"
msgid "Handover protocol"
msgstr "Átadási/visszavételi jegyzőkönyv"

#: components/contracts/form/events/HandoverProtocol.yaml:200
msgctxt "HandoverProtocol"
msgid "Cancel protocol"
msgstr "Jegyzőkönyv érvénytelenítése"

#: components/contracts/form/events/HandoverProtocol.yaml:213
#: components/payments/form/UcPaymentHeader.yaml:33
msgid "Complete"
msgstr "Véglegesítés"

#: components/contracts/form/events/UcContractEvents.yaml:34
msgctxt "Contract"
msgid "Protocols and events"
msgstr "Jegyzőkönyvek és események"

#: components/contracts/form/events/UcContractEvents.yaml:42
msgctxt "Contract"
msgid "New event"
msgstr "Új esemény"

#: components/contracts/form/events/UcContractEvents.yaml:49
msgctxt "Contract"
msgid "New handover protocol (moving in)..."
msgstr "Új átadás..."

#: components/contracts/form/events/UcContractEvents.yaml:70
msgctxt "Contract"
msgid "New handover protocol (moving out)..."
msgstr "Új visszavétel..."

#: components/contracts/form/events/UcContractEvents.yaml:94
msgctxt "Contract"
msgid "No events have been added yet."
msgstr "Nincsenek események."

#: components/contracts/form/events/UcContractEvents.yaml:120
msgctxt "HandoverType"
msgid "Sentence"
msgstr "Mondat"

#: components/contracts/form/events/UcContractEvents.yaml:152
msgctxt "Command"
msgid "Open"
msgstr "Megnyitás"

#: components/contracts/form/events/UcContractProtocolHeader.yaml:14
msgctxt "HandoverType"
msgid "Moving-in protocol"
msgstr "Átadási jegyzőkönyv"

#: components/contracts/form/events/UcContractProtocolHeader.yaml:15
msgctxt "HandoverType"
msgid "Moving-out protocol"
msgstr "Visszavételi jegyzőkönyv"

#: components/contracts/form/events/UcContractProtocolHeader.yaml:16
msgctxt "ContractProtocol"
msgid "New protocol"
msgstr "Új jegyzőkönyv"

#: components/contracts/form/events/UcContractProtocolHeader.yaml:17
msgctxt "ContractProtocol"
msgid "Edit protocol"
msgstr "Szerkesztés"

#: components/contracts/form/events/UcContractProtocolHeader.yaml:80
msgctxt "ContractProtocol"
msgid "Open preview"
msgstr "Előnézet megnyitása"

#: components/contracts/form/events/UcContractProtocolHeader.yaml:104
msgctxt "HandoverProtocol|Command"
msgid "Complete"
msgstr "Véglegesítés"

#: components/contracts/form/events/UcContractProtocolHeader.yaml:105
msgctxt "HandoverProtocol|CommandTooltip"
msgid "Complete"
msgstr "Véglegesítés"

#: components/contracts/form/events/UcContractProtocolHeader.yaml:138
msgctxt "HandoverProtocol|Command"
msgid "Cancel"
msgstr "Érvénytelenítés"

#: components/contracts/form/events/UcContractProtocolHeader.yaml:139
msgctxt "HandoverProtocol|CommandTooltip"
msgid "Cancel or invalidate the event."
msgstr "Az esemény érvénytelenítése."

#: components/contracts/form/events/UcContractProtocolHeader.yaml:232
msgctxt "Payment"
msgid "Delete protocol"
msgstr "Jegyzőkönyv törlése"

#: components/contracts/form/general/FieldsetContractClientData.yaml:28
msgctxt "Contract"
msgid "Client"
msgstr "Ügyfél"

#: components/contracts/form/general/FieldsetContractClientData.yaml:69
msgctxt "Company"
msgid "Head office"
msgstr "Székhely"

#: components/contracts/form/general/FieldsetContractClientData.yaml:83
msgctxt "Company"
msgid "Branch office"
msgstr "Fiók"

#: components/contracts/form/general/FieldsetContractClientData.yaml:97
msgctxt "Company"
msgid "Statistical code"
msgstr "Statisztikai kód"

#: components/contracts/form/general/FieldsetContractClientData.yaml:125
msgctxt "Company"
msgid "Account number"
msgstr "Számlaszám"

#: components/contracts/form/general/FieldsetContractClientData.yaml:139
msgctxt "Company"
msgid "Representative"
msgstr "Képviselő"

#: components/contracts/form/general/FieldsetContractGeneralData.yaml:35
msgid "Category"
msgstr "Kategória"

#: components/contracts/form/general/FieldsetContractGeneralData.yaml:50
msgctxt "Contract"
msgid "Revision number"
msgstr "Módosítás"

#: components/contracts/form/general/FieldsetContractGeneralData.yaml:102
msgctxt "Contract"
msgid "External key"
msgstr "Külső azonosító"

#: components/contracts/form/general/FieldsetContractNumbersData.yaml:17
#: components/contracts/form/general/UcContractGeneralInfo.yaml:51
#: components/contracts/views/ContractServiceFees.yaml:70
#: components/rental/views/RentalServices.yaml:53
msgctxt "Contract"
msgid "Contract number"
msgstr "Szerződésszám"

#: components/contracts/form/general/FieldsetContractNumbersData.yaml:33
#: components/contracts/form/general/UcContractGeneralInfo.yaml:80
msgctxt "Contract"
msgid "Description"
msgstr "Leírás"

#: components/contracts/form/general/FieldsetContractNumbersData.yaml:46
#: components/contracts/form/general/UcContractGeneralInfo.yaml:92
msgctxt "Contract"
msgid "Reference number"
msgstr "Hivatkozási szám"

#: components/contracts/form/general/FieldsetContractNumbersData.yaml:59
#: components/contracts/form/general/UcContractGeneralInfo.yaml:86
msgctxt "Contract"
msgid "Folder number"
msgstr "Mappaszám"

msgctxt "Contract"
msgid "Any format is allowed, but the contract number must be unique."
msgstr ""
"Bármilyen formátum megengedett, de a szerződésszámnak egyedinek kell kell "
"lennie."

#: components/contracts/form/general/FieldsetContractRentalData.yaml:32
#: components/rental/CreateRental.yaml:42
#: components/rental/primitives/UcRentalMiniCard.yaml:25
msgctxt "Rental"
msgid "Rental"
msgstr "Bérlemény"

#: components/contracts/form/general/FieldsetContractRentalData.yaml:81
#: components/rental/form/general/FieldsetRentalGeneralData.yaml:31
msgctxt "Rental"
msgid "Name"
msgstr "Név"

#: components/contracts/form/general/FieldsetContractRentalData.yaml:94
#: components/contracts/form/general/UcContractRentalCard.yaml:13
msgctxt "Rental"
msgid "Address"
msgstr "Cím"

#: components/contracts/form/general/FieldsetContractRentalData.yaml:107
#: components/contracts/form/general/UcContractRentalCard.yaml:18
#: components/rental/form/general/FieldsetRentalGeneralData.yaml:145
msgctxt "Rental"
msgid "Area"
msgstr "Alapterület"

#: components/contracts/form/general/FieldsetContractRentalData.yaml:120
#: components/contracts/form/general/UcContractRentalCard.yaml:23
msgctxt "Rental"
msgid "LOT number"
msgstr "Helyrajzi szám"

#: components/contracts/form/general/FieldsetContractRentalData.yaml:133
#: components/contracts/form/general/UcContractRentalCard.yaml:28
msgctxt "Rental"
msgid "House number"
msgstr "Épületszám"

#: components/contracts/form/general/FieldsetContractRentalData.yaml:146
#: components/contracts/form/general/UcContractRentalCard.yaml:33
#: components/rental/form/general/FieldsetRentalGeneralData.yaml:47
msgctxt "Rental"
msgid "Description"
msgstr "Megnevezés"

#: components/contracts/form/general/FieldsetContractValidityData.yaml:20
#: components/contracts/form/general/UcContractValidityCard.yaml:13
msgctxt "Contract"
msgid "Contract date"
msgstr "Szerződés dátuma"

#: components/contracts/form/general/FieldsetContractValidityData.yaml:33
#: components/contracts/form/statuses/ContractStatusTransition.yaml:49
msgctxt "Contract"
msgid "Valid from"
msgstr "Érvényesség kezdete"

#: components/contracts/form/general/FieldsetContractValidityData.yaml:46
msgctxt "Contract"
msgid "Valid to"
msgstr "Érvényesség vége"

#: components/contracts/form/general/FieldsetContractValidityData.yaml:59
#: components/contracts/form/general/UcContractValidityCard.yaml:37
msgctxt "Contract"
msgid "Auto renewal"
msgstr "Automatikus megújítás"

#: components/contracts/form/general/UcContractClientCard.yaml:13
msgctxt "Client"
msgid "Head Office"
msgstr "Székhely"

#: components/contracts/form/general/UcContractClientCard.yaml:18
msgctxt "Client"
msgid "Branch Office"
msgstr "Fiók"

#: components/contracts/form/general/UcContractClientCard.yaml:23
msgctxt "Client"
msgid "Statistical Code"
msgstr "Statisztikai kód"

#: components/contracts/form/general/UcContractClientCard.yaml:28
msgctxt "Client"
msgid "Registration Number"
msgstr "Nyilvántartási szám"

#: components/contracts/form/general/UcContractClientCard.yaml:33
msgctxt "Client"
msgid "Bank Account"
msgstr "Bankszámlaszám"

#: components/contracts/form/general/UcContractClientCard.yaml:38
msgctxt "Contract"
msgid "Representatives"
msgstr "Képviselő"

#: components/contracts/form/general/UcContractCompanyCard.yaml:13
msgctxt "Company"
msgid "Head Office"
msgstr "Székhely"

#: components/contracts/form/general/UcContractCompanyCard.yaml:18
msgctxt "Company"
msgid "Branch Office"
msgstr "Fiók"

#: components/contracts/form/general/UcContractCompanyCard.yaml:23
msgctxt "Company"
msgid "Statistical Code"
msgstr "Statisztikai kód"

#: components/contracts/form/general/UcContractCompanyCard.yaml:28
msgctxt "Company"
msgid "Registration Number"
msgstr "Nyilvántartási szám"

#: components/contracts/form/general/UcContractCompanyCard.yaml:33
msgctxt "Company"
msgid "Bank Account"
msgstr "Bankszámlaszám"

#: components/contracts/form/general/UcContractGeneralInfo.yaml:56
msgctxt "Contract"
msgid "Contract type"
msgstr "Szerződés típusa"

#: components/contracts/form/general/UcContractRentalServices.yaml:62
#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:772
#: components/meters/Meter.yaml:7
#: components/rental/form/services/UcRentalFormServicesTable.yaml:110
msgid "Meter"
msgstr "Mérőóra"

#: components/contracts/form/general/UcContractValidityCard.yaml:18
msgctxt "Contract"
msgid "From"
msgstr "Tól"

#: components/contracts/form/general/UcContractValidityCard.yaml:23
msgctxt "Contract"
msgid "To"
msgstr "Ig"

#: components/contracts/form/general/UcContractValidityCard.yaml:28
msgctxt "Contract"
msgid "Indefinite"
msgstr "Határozatlan"

#: components/contracts/form/general/UcContractValidityCard.yaml:33
msgctxt "Contract"
msgid "Notice Period"
msgstr "Felmondási idő"

#: components/contracts/form/general/UcContractValidityCard.yaml:37
msgid "On"
msgstr "Be"

#: components/contracts/form/general/UcContractValidityCard.yaml:37
msgid "Off"
msgstr "Ki"

#: components/contracts/form/invoicing/FieldsetContractInvoicing.yaml:35
msgid "day"
msgstr "nap"

#: components/contracts/form/invoicing/FieldsetContractInvoicing.yaml:37
msgid "month"
msgstr "hónap"

#: components/contracts/form/invoicing/FieldsetContractInvoicing.yaml:55
msgctxt "Contract"
msgid "Initial advances"
msgstr "Kezdeti előleg"

#: components/contracts/form/invoicing/FieldsetContractInvoicing.yaml:56
msgctxt "InputAddon"
msgid "months"
msgstr "hónap"

#: components/contracts/form/invoicing/FieldsetContractInvoicing.yaml:70
msgctxt "Contract"
msgid "Reserve advances"
msgstr "Fenntartott előleg"

#: components/contracts/form/invoicing/FieldsetContractInvoicing.yaml:85
msgctxt "Contract"
msgid "Indexing"
msgstr "Indexálás"

#: components/contracts/form/invoicing/FieldsetContractInvoicing.yaml:90
msgctxt "Contract"
msgid "Next indexation date"
msgstr "Következő indexálás dátuma"

#: components/contracts/form/invoicing/FieldsetContractInvoicing.yaml:105
msgctxt "Contract"
msgid "Billing currency"
msgstr "Számlázás pénzneme"

#: components/contracts/form/invoicing/FieldsetContractInvoicing.yaml:123
msgctxt "Contract"
msgid "Billing frequency"
msgstr "Számlázás gyakorisága"

#: components/contracts/form/invoicing/FieldsetContractInvoicing.yaml:163
msgctxt "Contract"
msgid "Payment period"
msgstr "Fizetési határidő"

#: components/contracts/form/invoicing/FieldsetContractInvoicing.yaml:191
msgctxt "Contract"
msgid "Notes on invoice"
msgstr "Számla megjegyzések"

#: components/contracts/form/invoicing/FieldsetContractInvoicing.yaml:205
msgctxt "Contract"
msgid "Contract in invoice notes"
msgstr "Szerződés a számla megjegyzésben"

#: components/contracts/form/invoicing/FieldsetContractInvoicing.yaml:206
msgctxt "Contract"
msgid ""
"Whether to include the contract number in the invoice notes when generating "
"invoices."
msgstr "A szerződésszám feltüntetése a számla megjegyzésben."

#: components/contracts/form/invoicing/FieldsetContractInvoicing.yaml:220
msgctxt "Contract"
msgid "Rental in invoice notes"
msgstr "Bérlemény a számla megjegyzésben"

#: components/contracts/form/invoicing/FieldsetContractInvoicing.yaml:221
msgctxt "Contract"
msgid ""
"Whether to include the rental name in the invoice notes when generating "
"invoices."
msgstr "A bérlemény feltüntetése a számla megjegyzésben."

#: components/contracts/form/invoicing/FieldsetContractInvoicing.yaml:235
msgctxt "Contract"
msgid "Period in invoice notes"
msgstr "Időszak a számla megjegyzésben"

#: components/contracts/form/invoicing/FieldsetContractInvoicing.yaml:236
msgctxt "Contract"
msgid ""
"Whether to include the billing period in the invoice notes when generating "
"invoices."
msgstr "A számlázási időszak felüntetése a számla megjegyzésben."

#: components/contracts/form/invoicing/UcContractInvoicing.yaml:2
msgctxt "ContractPaymentTerms"
msgid "days"
msgstr "Nap"

#: components/contracts/form/invoicing/UcContractInvoicing.yaml:3
msgctxt "ContractPaymentTerms"
msgid "day_of_month"
msgstr "A hónap napja"

#: components/contracts/form/invoicing/UcContractInvoicing.yaml:4
msgctxt "ContractPaymentTerms"
msgid "day_before_end_of_month"
msgstr "A hónap vége előtt"

#: components/contracts/form/invoicing/UcContractInvoicing.yaml:74
msgctxt "Contract"
msgid "Advances"
msgstr "Előlegek"

#: components/contracts/form/invoicing/UcContractInvoicing.yaml:79
msgctxt "ContractAdvances"
msgid "months initial"
msgstr "kezdeti hónapok"

#: components/contracts/form/invoicing/UcContractInvoicing.yaml:81
msgctxt "ContractAdvances"
msgid "months reserved"
msgstr "fenntartott hónapok"

#: components/contracts/form/invoicing/UcContractInvoicing.yaml:104
msgctxt "Contract"
msgid "Text to append to the invoices generated from this contract."
msgstr "A szerződésből generált számlákhoz csatolandó extra megjegyzés"

#: components/contracts/form/invoicing/UcContractInvoicing.yaml:112
msgctxt "Contract"
msgid "Payment terms"
msgstr "Fizetési feltételek"

#: components/contracts/form/lifecycle/FieldsetContractLifecycle.yaml:57
msgctxt "Contract"
msgid "Revision date"
msgstr "Szerződésmódosítás dátuma"

#: components/contracts/form/lifecycle/FieldsetContractLifecycle.yaml:95
msgctxt "Contract"
msgid "Date signed"
msgstr "Alárás dátuma"

#: components/contracts/form/lifecycle/FieldsetContractLifecycle.yaml:108
msgctxt "Contract"
msgid "Effective date"
msgstr "Hatálybalépés dátuma"

#: components/contracts/form/lifecycle/FieldsetContractLifecycle.yaml:121
msgctxt "Contract"
msgid "Date of occupancy"
msgstr "Átadás dátuma"

#: components/contracts/form/lifecycle/FieldsetContractLifecycle.yaml:147
msgctxt "Contract"
msgid "Notice period"
msgstr "Felmondási idő"

#: components/contracts/form/lifecycle/FieldsetContractLifecycle.yaml:169
msgctxt "Contract"
msgid "Indexing rule"
msgstr "Indexálási szabály"

#: components/contracts/form/lifecycle/FieldsetContractLifecycle.yaml:198
msgctxt "Contract"
msgid "Terminaton date"
msgstr "Felmondás napja"

#: components/contracts/form/lifecycle/FieldsetContractLifecycle.yaml:211
msgctxt "Contract"
msgid "Terminaton effective date"
msgstr "Felmondás lejárata"

#: components/contracts/form/lifecycle/UcContractLifecycle.yaml:41
msgctxt "Contract"
msgid "Lifecycle"
msgstr "Életciklus"

#: components/contracts/form/lifecycle/UcContractLifecycle.yaml:96
msgctxt "ContractValidity"
msgid "Indefinite"
msgstr "Határozatlan ideig"

#: components/contracts/form/lifecycle/UcContractLifecycle.yaml:145
msgctxt "Contract/NoticePeriod"
msgid "day(s)"
msgstr "nap"

#: components/contracts/form/lifecycle/UcContractLifecycle.yaml:152
msgctxt "IndexingRule"
msgid "Sentence"
msgstr "Mondat"

#: components/contracts/form/services/BulkContractServiceEditor.yaml:4
msgctxt "BulkContractServiceEditor"
msgid "Edit Service Properties"
msgstr "Szolgáltatás Jellemzők Szerkesztése"

#: components/contracts/form/services/BulkContractServiceEditor.yaml:68
msgctxt "ContractService"
msgid "Service"
msgstr "Szolgáltatás"

#: components/contracts/form/services/BulkContractServiceEditor.yaml:72
msgctxt "ContractService|Tooltip"
msgid "Select the product or service the invoice line refers to."
msgstr "A vonatkozó termék vagy szolgáltatás a terméktörzsből."

#: components/contracts/form/services/BulkContractServiceEditor.yaml:113
msgctxt "ContractService"
msgid "Invoice Group"
msgstr "Számlázási csoport"

#: components/contracts/form/services/BulkContractServiceEditor.yaml:115
msgctxt "ContractService|Tooltip"
msgid "The invoice group this service belongs to."
msgstr "A szolgáltatás a megadott számlázási csoporthoz fog tartozni."

#: components/contracts/form/services/BulkContractServiceEditor.yaml:135
#: components/contracts/views/ContractServiceFees.yaml:311
#: components/rental/views/RentalServices.yaml:242
msgctxt "ContractService"
msgid "Intermediated service"
msgstr "Közvetített szolgáltatás"

#: components/contracts/form/services/BulkContractServiceEditor.yaml:137
msgctxt "ContractService|Tooltip"
msgid ""
"Select this option if the service is provided via an intermediary party."
msgstr "Közvetített szolgáltatás esetén kötelezően ki kell választani."

#: components/contracts/form/services/BulkContractServiceEditor.yaml:147
#: components/contracts/views/ContractServiceFees.yaml:308
msgctxt "ContractService"
msgid "Description"
msgstr "Leírás"

#: components/contracts/form/services/BulkContractServiceEditor.yaml:151
msgctxt "ContractService|Tooltip"
msgid "Internal notes for reference only. Not visible externally."
msgstr "Belső megjegyzés. A számlákon nem jelenik meg."

#: components/contracts/form/services/BulkContractServiceEditor.yaml:165
msgctxt "ContractServiceEditor|Section"
msgid "Invoicing"
msgstr "Számlázás"

#: components/contracts/form/services/BulkContractServiceEditor.yaml:174
msgctxt "ContractService|Tooltip"
msgid "This text will appear on the invice line."
msgstr ""
"Számlázáskor az itt megadott szöveg kerül feltüntetésre a tételsor "
"megnevezéseként."

#: components/contracts/form/services/BulkContractServiceEditor.yaml:184
msgctxt "ContractServiceFee"
msgid "Invoice notes"
msgstr "Számlatétel megjegyzés"

#: components/contracts/form/services/BulkContractServiceEditor.yaml:188
msgctxt "ContractService|Tooltip"
msgid "Note to display on the invoice line."
msgstr "A számla tételsorához kapcsolódó megjegyzés."

#: components/contracts/form/services/BulkContractServiceEditor.yaml:198
#: components/contracts/views/ContractServices.yaml:238
msgctxt "ContractService"
msgid "Billing frequency"
msgstr "Számlázás gyakorisága"

#: components/contracts/form/services/BulkContractServiceEditor.yaml:202
msgctxt "ContractService|Tooltip"
msgid "The cycle length of issuing the invoices."
msgstr "A számlakiállítás ciklikusságának a meghatározása."

#: components/contracts/form/services/BulkContractServiceEditor.yaml:211
msgctxt "ContractService"
msgid "Billing date rule"
msgstr "Számlázás esedékesség szabály"

#: components/contracts/form/services/BulkContractServiceEditor.yaml:232
msgctxt "ContractService"
msgid "Due date rule"
msgstr "Fizetési határidő szabály"

#: components/contracts/form/services/BulkContractServiceEditor.yaml:236
msgctxt "ContractService|Tooltip"
msgid "The rule of calculating the payment dates."
msgstr "A fizetési határidő számolásának a szabálya."

#: components/contracts/form/services/BulkContractServiceEditor.yaml:253
#: components/contracts/views/ContractServices.yaml:241
msgctxt "ContractService"
msgid "Billing currency"
msgstr "A számlázás pénzneme"

#: components/contracts/form/services/BulkContractServiceEditor.yaml:257
msgctxt "ContractService|Tooltip"
msgid "The currency to use on the invoice."
msgstr "A számlakiállítás pénzneme."

#: components/contracts/form/services/BulkContractServiceEditor.yaml:266
msgctxt "ContractService"
msgid "Exchange rate source"
msgstr "A devizaárfolyam forrása"

#: components/contracts/form/services/BulkContractServiceEditor.yaml:270
msgctxt "ContractService|Tooltip"
msgid "The currency exchange rate's provider."
msgstr "A devizaárfolyam szolgáltatója."

#: components/contracts/form/services/BulkContractServiceEditor.yaml:279
msgctxt "ContractService"
msgid "Exchange rate date rule"
msgstr "Árfolyam dátum szabály"

#: components/contracts/form/services/BulkContractServiceEditor.yaml:283
msgctxt "ContractService|Tooltip"
msgid "The date used to determine the exchange rate for billing purposes."
msgstr "A használt devizaárfolyam dátumát meghatározó szabály."

#: components/contracts/form/services/BulkContractServiceFeeEditor.yaml:4
msgctxt "BulkContractServiceFeeEditor|Title"
msgid "Bulk Edit"
msgstr "Csoportos szerkesztés..."

#: components/contracts/form/services/BulkContractServiceFeeEditor.yaml:126
msgctxt "BulkContractServiceFeeEditor|ResourceTitle"
msgid "Contract Service Fees"
msgstr "Szerződött szolgáltatások"

#: components/contracts/form/services/BulkContractServiceFeeEditor.yaml:152
#: components/product/ProductPricesDataTable.yaml:58
#: components/rental/form/assets/UcRentalFormFixedAssets.yaml:66
#: components/rental/form/services/BulkRentalServiceEditor.yaml:213
msgid "Valid From"
msgstr "Érvényesség kezdete"

#: components/contracts/form/services/BulkContractServiceFeeEditor.yaml:179
#: components/product/ProductPricesDataTable.yaml:64
#: components/rental/form/assets/UcRentalFormFixedAssets.yaml:71
#: components/rental/form/services/BulkRentalServiceEditor.yaml:240
msgid "Valid To"
msgstr "Érvényesség vége"

#: components/contracts/form/services/BulkContractServiceFeeEditor.yaml:206
msgctxt "ContractServiceFee"
msgid "Amount"
msgstr "Összeg"

#: components/contracts/form/services/BulkContractServiceFeeEditor.yaml:246
#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:410
#: components/worksheets/form/UcWorksheetInvoiceLineAccountings.yaml:96
#: components/worksheets/form/UcWorksheetWorkItems.yaml:296
msgid "Quantity"
msgstr "Mennyiség"

#: components/contracts/form/services/BulkContractServiceFeeEditor.yaml:274
msgctxt "ContractServiceFee"
msgid "Unit of quantity"
msgstr "Mennyiségi egység"

#: components/contracts/form/services/BulkContractServiceFeeEditor.yaml:302
msgctxt "ContractServiceFee"
msgid "Inflation indexed"
msgstr "Inflációkövető"

#: components/contracts/form/services/BulkContractServiceFeeEditor.yaml:330
msgctxt "ContractServiceFee"
msgid "Transaction notes"
msgstr "Tranzakció megjegyzések"

#: components/contracts/form/services/BulkIndexContractServiceFee.yaml:4
msgctxt "BulkIndexContractServiceFee|Title"
msgid "Indexing"
msgstr "Indexálás"

#: components/contracts/form/services/BulkIndexContractServiceFee.yaml:62
msgctxt "BulkIndexContractServiceFee|ResourceTitle"
msgid "Contract Service Fees"
msgstr "Szerződött szolgáltatás díjak"

#: components/contracts/form/services/BulkIndexContractServiceFee.yaml:63
msgctxt "BulkIndexContractServiceFee|ResourceKey"
msgid "Indexing"
msgstr "Indexálás"

#: components/contracts/form/services/BulkIndexContractServiceFee.yaml:88
msgctxt "BulkIndexContractServiceFee"
msgid "Percentage"
msgstr "Százalék"

#: components/contracts/form/services/BulkIndexContractServiceFee.yaml:89
msgctxt "BulkIndexContractServiceFee"
msgid "The percentage used to calculate the indexed prices."
msgstr "Az indexelt árak kiszámításához használt százalék."

#: components/contracts/form/services/BulkIndexContractServiceFee.yaml:109
msgctxt "BulkIndexContractServiceFee"
msgid "Valid From"
msgstr "Érvényesség kezdete"

#: components/contracts/form/services/BulkIndexContractServiceFee.yaml:110
msgctxt "BulkIndexContractServiceFee"
msgid "The start date from which the new fee is valid."
msgstr "A kezdő dátum, amelytől az új díj érvényes."

#: components/contracts/form/services/BulkIndexContractServiceFee.yaml:125
msgctxt "BulkIndexContractServiceFee"
msgid "New Indexation Date"
msgstr "A következő indexálás dátuma"

#: components/contracts/form/services/BulkIndexContractServiceFee.yaml:126
msgctxt "BulkIndexContractServiceFee"
msgid "Sets the next indexation date for the related contracts."
msgstr "Beállítja a kapcsolódó szerződések következő indexálási dátumát."

#: components/contracts/form/services/BulkIndexContractServiceFee.yaml:160
msgctxt "Button"
msgid "Submit"
msgstr "Küldés"

#: components/contracts/form/services/ContractServiceEditor.yaml:327
msgctxt "ContractService"
msgid "Valid from"
msgstr "Érvényesség kezdete"

#: components/contracts/form/services/ContractServiceEditor.yaml:331
msgctxt "ContractService|Tooltip"
msgid "Specifies the start date of the service period."
msgstr "A szolgáltatás érvényességének a kezdete."

#: components/contracts/form/services/ContractServiceEditor.yaml:343
msgctxt "ContractService"
msgid "Valid to"
msgstr "Érvényesség vége"

#: components/contracts/form/services/ContractServiceEditor.yaml:347
msgctxt "ContractService|Tooltip"
msgid ""
"The service end date. Set only if it's different from the contract's end "
"date."
msgstr ""
"A szolgáltatás érvényességének a vége. Csak akkor kell beállítani, ha eltér "
"az aktuális szerződésmódosítás záró dátumától."

#: components/contracts/form/services/ContractServiceEditor.yaml:384
#: components/contracts/views/ContractServiceFees.yaml:302
msgctxt "ContractService"
msgid "Billing category"
msgstr "Számlázási kategória"

#: components/contracts/form/services/ContractServiceEditor.yaml:386
msgctxt "ContractService|Help|BillingCategory"
msgid ""
"The invoice category this service should be assigned to when billed. New "
"values entered will be saved for future use."
msgstr ""
"Számlázáskor a tétel a megadott kategóriának megfelelő számlára kerül. Az "
"itt megadott értékeket a rendszer megjegyzi."

#: components/contracts/form/services/ContractServiceEditor.yaml:418
msgctxt "ContractService"
msgid "Name(s)"
msgstr "Megnevezés(ek)"

#: components/contracts/form/services/ContractServiceEditor.yaml:456
msgctxt "ContractServiceFee"
msgid "Additional invoice notes"
msgstr "További számlamegjegyzések"

#: components/contracts/form/services/ContractServiceEditor.yaml:460
msgctxt "ContractService|Tooltip"
msgid "Note to display on the invoice line conditionally."
msgstr "A számlasoron feltételesen megjelenített megjegyzés."

#: components/contracts/form/services/ContractServiceEditor.yaml:556
msgctxt "ContractService"
msgid "Exchange rate source specification"
msgstr "Devizaárfolyam forrása"

#: components/contracts/form/services/ContractServiceEditor.yaml:560
msgctxt "ContractService|Tooltip"
msgid "The currency exchange rate configuration."
msgstr "A devizaárfolyam forrás beállítások"

#: components/contracts/form/services/ContractServiceEditor.yaml:590
msgctxt "ContractServiceEditor"
msgid "Fee"
msgstr "Díj"

#: components/contracts/form/services/ContractServiceEditor.yaml:600
msgctxt "ContractService|Tooltip"
msgid "The start date of the fee."
msgstr "Az ár érvényességének a kezdete."

#: components/contracts/form/services/ContractServiceEditor.yaml:616
msgctxt "ContractService|Tooltip"
msgid ""
"The end date of the fee. Set only if it's different from the service's end "
"date."
msgstr ""
"Az ár érvényességének a vége. Csak akkor kell beállítani, ha eltér a "
"szolgáltatás végétől vagy a következő ár érvényességének a kezdetétől."

#: components/contracts/form/services/ContractServiceEditor.yaml:632
msgctxt "ContractService|Tooltip"
msgid "The price per unit of the fee."
msgstr "A szolgáltatás egységára."

#: components/contracts/form/services/ContractServiceEditor.yaml:656
msgctxt "ContractServiceFee"
msgid "Invoice unit"
msgstr "Számlázási egység"

#: components/contracts/form/services/ContractServiceEditor.yaml:661
msgctxt "ContractService|Tooltip"
msgid "The unit used for billing."
msgstr "A számlázott mennyiségi egység."

#: components/contracts/form/services/ContractServiceEditor.yaml:673
msgctxt "ContractServiceFee"
msgid "Quantity"
msgstr "Mennyiség"

#: components/contracts/form/services/ContractServiceEditor.yaml:678
msgctxt "ContractService|Tooltip"
msgid "The quantity to bill for each period."
msgstr "Az időszakosan számlázott mennyiség, ha eltér 1-től."

#: components/contracts/form/services/ContractServiceEditor.yaml:695
msgctxt "ContractService|Tooltip"
msgid "The unit of quantity - if different from the billing quantity."
msgstr "A mennyiség mérőszáma - ha eltér a számlázási egységtől."

#: components/contracts/form/services/ContractServiceEditor.yaml:710
msgctxt "ContractService|Tooltip"
msgid ""
"Indicates if the unit price should be automatically adjusted based on "
"indexation rules."
msgstr "Automatikus indexálás alá vont ár."

#: components/contracts/form/services/ContractServiceEditor.yaml:738
msgctxt "ContractService|Tooltip"
msgid "Notes for internal use only."
msgstr "Belső használatra szánt megjegyzések."

#: components/contracts/form/services/FieldsetContractServiceFee.yaml:24
msgctxt "ContractServiceFee"
msgid "Validity"
msgstr "Érvényesség"

#: components/contracts/form/services/FieldsetContractServiceFee.yaml:28
msgctxt "ContractServiceFee|Tooltip"
msgid "The validity period of the fee."
msgstr "A szolgáltatás érvényességi ideje."

#: components/contracts/form/services/FieldsetContractServiceFee.yaml:52
msgctxt "ContractServiceFee|Tooltip"
msgid ""
"The start date is required. Set the end date only if different from the end "
"of the service."
msgstr ""
"Csak a kezdő dátum megadása kötelező. A záró dátumot csak akkor kell "
"beállítani, ha eltér a szolgáltatás érvényességének a végétől."

#: components/contracts/form/services/FieldsetContractServiceFee.yaml:62
msgctxt "ContractServiceFee|Tooltip"
msgid "The price per unit of the fee."
msgstr "A szolgáltatás egységára."

#: components/contracts/form/services/FieldsetContractServiceFee.yaml:92
msgctxt "ContractServiceFee|Tooltip"
msgid "The unit used for billing."
msgstr "A számlázott mennyiségi egység."

#: components/contracts/form/services/FieldsetContractServiceFee.yaml:108
msgctxt "ContractServiceFee|Tooltip"
msgid "The quantity to bill for each period."
msgstr "Az időszakosan számlázott mennyiség, ha eltér 1-től."

#: components/contracts/form/services/FieldsetContractServiceFee.yaml:124
msgctxt "ContractServiceFee|Tooltip"
msgid "The unit of quantity - if different from the billing quantity."
msgstr "A mennyiség mérőszáma - ha eltér a számlázási egységtől."

#: components/contracts/form/services/FieldsetContractServiceFee.yaml:138
msgctxt "ContractServiceFee|Tooltip"
msgid ""
"Indicates if the unit price should be automatically adjusted based on "
"indexation rules."
msgstr "Automatikus indexálás alá vont ár."

#: components/contracts/form/services/FieldsetContractServiceFee.yaml:152
msgctxt "ContractServiceFee|Tooltip"
msgid "Note to display on the invoice line."
msgstr "A számla tételsorához kapcsolódó megjegyzés."

#: components/contracts/form/services/FieldsetContractServiceFee.yaml:165
msgctxt "ContractServiceFee|Tooltip"
msgid "Notes for internal use only."
msgstr "Belső használatra szánt megjegyzések."

#: components/contracts/form/services/UCContractServiceFeesEditor.yaml:102
msgctxt "Button|Command"
msgid "Create copy"
msgstr "Másolás"

#: components/contracts/form/services/UCContractServiceFeesEditor.yaml:103
msgctxt "ContractServiceFeesEditor|CommandTooltip"
msgid "Copy the selected service fee."
msgstr "Másolat készítése a kiválasztott díj alapján."

#: components/contracts/form/services/UCContractServiceItemNameEditor.yaml:26
msgctxt "languages"
msgid "hungarian"
msgstr "magyar"

#: components/contracts/form/services/UCContractServiceItemNameEditor.yaml:29
msgctxt "languages"
msgid "italian"
msgstr "olasz"

#: components/contracts/form/services/UCContractServiceItemNameEditor.yaml:32
msgctxt "languages"
msgid "english"
msgstr "angol"

#: components/contracts/form/services/UCContractServiceItemNameEditor.yaml:122
msgctxt "ContractServiceItemNameEditor"
msgid "Include period"
msgstr "Időszak feltüntetése"

#: components/contracts/form/services/UCContractServiceItemNameEditor.yaml:165
msgctxt "ContractServiceItemNameEditor"
msgid "Remove name"
msgstr "Megnevezés törlése"

#: components/contracts/form/services/UCContractServiceItemNameEditor.yaml:185
msgctxt "ContractServiceItemNameEditor"
msgid "Add name"
msgstr "Új megnevezés"

#: components/contracts/form/services/UcContractServiceCard.yaml:112
#: components/rental/form/services/BulkRentalServiceEditor.yaml:268
msgid "Intermediated service"
msgstr "Közvetített szolgáltatás"

#: components/contracts/form/services/UcContractServiceFees.yaml:158
msgctxt "Contract"
msgid "Add service fee..."
msgstr "Szolgáltatási díj hozzáadása..."

#: components/contracts/form/services/UcContractServices.yaml:45
msgctxt "Contract"
msgid "Services and Fees"
msgstr "Szolgáltatások és díjak"

#: components/contracts/form/services/UcContractServices.yaml:51
msgid "Add service..."
msgstr "Szolgáltatás hozzáadása..."

#: components/contracts/form/services/UcContractServices.yaml:74
msgctxt "Contract"
msgid "No services have been added yet."
msgstr "Nincsenek szolgáltatások."

#: components/contracts/form/statuses/ContractStatusTransition.yaml:24
msgctxt "Contract"
msgid "Approve"
msgstr "Jóváhagyás"

#: components/contracts/form/statuses/ContractStatusTransition.yaml:25
msgctxt "Contract"
msgid "Approval date"
msgstr "Jóváhagyás dátuma"

#: components/contracts/form/statuses/ContractStatusTransition.yaml:32
msgctxt "Contract"
msgid "Sign"
msgstr "Aláírás"

#: components/contracts/form/statuses/ContractStatusTransition.yaml:33
msgctxt "Contract"
msgid "Signature date"
msgstr "Aláírás dátuma"

#: components/contracts/form/statuses/ContractStatusTransition.yaml:40
msgctxt "Contract"
msgid "Rescind"
msgstr "Meghiúsulás"

#: components/contracts/form/statuses/ContractStatusTransition.yaml:41
msgctxt "Contract"
msgid "Rescission date"
msgstr "Megszüntetés/elállás dátuma"

#: components/contracts/form/statuses/ContractStatusTransition.yaml:48
msgctxt "Contract"
msgid "Activate"
msgstr "Aktiválás"

#: components/contracts/form/statuses/ContractStatusTransition.yaml:56
msgctxt "Contract"
msgid "Terminate"
msgstr "Felmondás"

#: components/contracts/form/statuses/ContractStatusTransition.yaml:57
msgctxt "Contract"
msgid "Termination date"
msgstr "Felmondás napja"

#: components/contracts/form/statuses/ContractStatusTransition.yaml:58
msgctxt "Contract"
msgid "Termination effective date"
msgstr "Felmondás lejárata"

#: components/contracts/form/statuses/ContractStatusTransition.yaml:65
msgctxt "Contract"
msgid "End"
msgstr "Lejárt"

#: components/contracts/form/statuses/ContractStatusTransition.yaml:66
msgctxt "Contract"
msgid "Ending date"
msgstr "Záró dátum"

#: components/contracts/form/statuses/ContractStatusTransition.yaml:73
msgctxt "Contract"
msgid "Archive"
msgstr "Archív"

#: components/contracts/form/statuses/ContractStatusTransition.yaml:74
msgctxt "Contract"
msgid "Archive date"
msgstr "Archiválás dátuma"

#: components/contracts/form/statuses/ContractStatusTransition.yaml:81
msgctxt "Contract"
msgid "Unarchive"
msgstr "Archiválás feloldása"

#: components/contracts/form/statuses/ContractStatusTransition.yaml:84
msgctxt "Contract"
msgid "The reason for unarchiving must be justified."
msgstr "A feloldás okát kötelező megadni."

#: components/contracts/form/statuses/ContractStatusTransition.yaml:187
msgctxt "ContractStatusTransition"
msgid "Notes"
msgstr "Megjegyzés"

#: components/contracts/form/statuses/UcContractStatusCard.yaml:13
msgctxt "SetContractStatus"
msgid "Approve..."
msgstr "Jóváhagyás..."

#: components/contracts/form/statuses/UcContractStatusCard.yaml:17
msgctxt "SetContractStatus"
msgid "Sign..."
msgstr "Aláírás..."

#: components/contracts/form/statuses/UcContractStatusCard.yaml:21
msgctxt "SetContractStatus"
msgid "Rescind..."
msgstr "Meghiúsult..."

#: components/contracts/form/statuses/UcContractStatusCard.yaml:25
msgctxt "SetContractStatus"
msgid "Activate..."
msgstr "Aktiválás..."

#: components/contracts/form/statuses/UcContractStatusCard.yaml:29
msgctxt "SetContractStatus"
msgid "Terminate..."
msgstr "Felmondás..."

#: components/contracts/form/statuses/UcContractStatusCard.yaml:33
msgctxt "SetContractStatus"
msgid "End..."
msgstr "Lejárt..."

#: components/contracts/form/statuses/UcContractStatusCard.yaml:37
msgctxt "SetContractStatus"
msgid "Archive..."
msgstr "Archiválás..."

#: components/contracts/form/statuses/UcContractStatusCard.yaml:96
msgctxt "SetContractStatus"
msgid "Unarchive..."
msgstr "Archiválás feloldása..."

#: components/contracts/form/terms/ContractTermEditor.yaml:68
msgctxt "Contract|ModalHeader"
msgid "Add term"
msgstr "Feltétel hozzáadása"

#: components/contracts/form/terms/ContractTermEditor.yaml:70
msgctxt "Contract|ModalHeader"
msgid "Edit term"
msgstr "Feltétel szerkesztése"

#: components/contracts/form/terms/ContractTermEditor.yaml:154
msgctxt "ContractTerm"
msgid "Service"
msgstr "Szolgáltatás"

#: components/contracts/form/terms/ContractTermEditor.yaml:192
msgctxt "ContractTerm"
msgid "Name"
msgstr "Megnevezés"

#: components/contracts/form/terms/ContractTermEditor.yaml:207
msgctxt "ContractTerm"
msgid "Valid from"
msgstr "Érvényesség kezdete"

#: components/contracts/form/terms/ContractTermEditor.yaml:221
msgctxt "ContractTerm"
msgid "Valid to"
msgstr "Érvényesség vége"

#: components/contracts/form/terms/ContractTermEditor.yaml:236
msgctxt "ContractTerm"
msgid "Amount"
msgstr "Összeg"

#: components/contracts/form/terms/ContractTermEditor.yaml:260
msgctxt "ContractTerm"
msgid "Quantity"
msgstr "Mennyiség"

#: components/contracts/form/terms/ContractTermEditor.yaml:275
msgctxt "ContractTerm"
msgid "Unit"
msgstr "Mennyiségi egység"

#: components/contracts/form/terms/ContractTermEditor.yaml:290
msgctxt "ContractTerm"
msgid "Notes"
msgstr "Megjegyzés"

#: components/contracts/form/terms/ContractTermEditor.yaml:343
msgctxt "Button"
msgid "Delete Term"
msgstr "Feltétel törlése"

#: components/contracts/form/terms/UcContractTerms.yaml:45
msgctxt "Contract"
msgid "Terms"
msgstr "Feltételek"

#: components/contracts/form/terms/UcContractTerms.yaml:51
msgctxt "Contract"
msgid "Add term..."
msgstr "Feltétel felvétele..."

#: components/contracts/form/terms/UcContractTerms.yaml:74
msgctxt "Contract"
msgid "No terms have been added yet."
msgstr "Nincsenek feltételek rögzítve."

#: components/contracts/primitives/UcContractCard.yaml:32
#: components/contracts/primitives/UcContractMiniCard.yaml:26
msgctxt "Contract"
msgid "Contract"
msgstr "Szerződés"

#: components/contracts/primitives/UcContractRevisionDropdown.yaml:71
msgctxt "Contract"
msgid "Create revision..."
msgstr "Új szerződésmódosítás..."

#: components/contracts/primitives/UcContractRevisionDropdown.yaml:90
msgctxt "Contract"
msgid "Delete revision"
msgstr "Szerződésmódosítás törlése"

#: components/contracts/primitives/UcContractStatusBadge.yaml:15
msgctxt "ContractStatus"
msgid "Sentence"
msgstr "Mondat"

#: components/contracts/primitives/UcContractTypeBadge.yaml:14
msgctxt "ContractTypes"
msgid "Sentence"
msgstr "Mondat"

#: components/contracts/primitives/UcInflationIndexedSign.yaml:12
msgid "Inflation Indexed"
msgstr "Inflációkövető"

#: components/contracts/views/ContractAttachments.yaml:4
msgctxt "ContractAttachments|Title"
msgid "Contract Attachments"
msgstr "Szerződés csatolmányok"

#: components/contracts/views/ContractAttachments.yaml:31
msgctxt "ExportFilename"
msgid "contract-attachments"
msgstr "szerződéd-csatolmányok"

#: components/contracts/views/ContractAttachments.yaml:38
msgctxt "ContractAttachments"
msgid "Contract"
msgstr "Szerződés"

#: components/contracts/views/ContractAttachments.yaml:63
msgctxt "ContractAttachments"
msgid "File name"
msgstr "Filenév"

#: components/contracts/views/ContractAttachments.yaml:70
msgctxt "ContractAttachments"
msgid "File size"
msgstr "File méret"

#: components/contracts/views/ContractAttachments.yaml:75
msgctxt "ContractAttachments"
msgid "Description"
msgstr "Leírás"

#: components/contracts/views/ContractAttachments.yaml:82
msgctxt "ContractAttachments"
msgid "Created by"
msgstr "Készítette"

#: components/contracts/views/ContractAttachments.yaml:110
msgctxt "ContractAttachments"
msgid "New Attachment/Service..."
msgstr "Új csatolmány..."

#: components/contracts/views/ContractEvents.yaml:4
msgctxt "ContractEvents|Title"
msgid "Contract Events"
msgstr "Szerződés események"

#: components/contracts/views/ContractEvents.yaml:50
msgctxt "ContractEvents"
msgid "Name"
msgstr "Megnevezés"

#: components/contracts/views/ContractEvents.yaml:53
msgctxt "ContractEvents"
msgid "Description"
msgstr "Leírás"

#: components/contracts/views/ContractEvents.yaml:56
msgctxt "ContractEvents"
msgid "Contract"
msgstr "Szerződés"

#: components/contracts/views/ContractEvents.yaml:78
msgctxt "ContractEvents"
msgid "Timestamp"
msgstr "Időbélyeg"

#: components/contracts/views/ContractEvents.yaml:83
msgctxt "ContractEvents"
msgid "User"
msgstr "Felhasználó"

#: components/contracts/views/ContractServiceFees.yaml:9
msgid "Contract service fees"
msgstr "Szerződött szolgáltatás díjak"

#: components/contracts/views/ContractServiceFees.yaml:58
msgctxt "ContractServiceFees"
msgid "Contract service fees"
msgstr "Szerződött szolgáltatás díjak"

#: components/contracts/views/ContractServiceFees.yaml:62
msgctxt "filename"
msgid "contract-service-fees"
msgstr "szerződött-szolgáltatás-díjak"

#: components/contracts/views/ContractServiceFees.yaml:146
msgctxt "ContractServiceFees"
msgid "Rental"
msgstr "Bérlemény"

#: components/contracts/views/ContractServiceFees.yaml:228
msgctxt "Contracts"
msgid "Next Indexation Date"
msgstr "Következő indexálás dátuma"

#: components/contracts/views/ContractServiceFees.yaml:237
msgctxt "ContractService"
msgid "Amount"
msgstr "Összeg"

#: components/contracts/views/ContractServiceFees.yaml:254
msgctxt "ContractService"
msgid "Total"
msgstr "Végösszeg"

#: components/contracts/views/ContractServiceFees.yaml:275
msgctxt "ContractServiceFee"
msgid "Unit"
msgstr "Mennyiségi egység"

#: components/contracts/views/ContractServiceFees.yaml:278
msgctxt "ContractService"
msgid "Quantity"
msgstr "Mennyiség"

#: components/contracts/views/ContractServiceFees.yaml:292
msgctxt "ContractService"
msgid "Inflation indexed"
msgstr "Inflációkövető"

#: components/contracts/views/ContractServiceFees.yaml:296
msgctxt "ContractService"
msgid "Invoice notes"
msgstr "Számlatétel megjegyzés"

#: components/contracts/views/ContractServiceFees.yaml:305
msgctxt "ContractService"
msgid "Invoice group"
msgstr "Számlázási csoport"

#: components/contracts/views/ContractServiceFees.yaml:358
msgctxt "ContractServiceFees"
msgid "Skip archived items"
msgstr "Archivált elemek elrejtése"

#: components/contracts/views/ContractServiceFees.yaml:369
msgctxt "ContractServiceFees"
msgid "Bulk edit..."
msgstr "Csoportos szerkesztés..."

#: components/contracts/views/ContractServiceFees.yaml:389
msgctxt "ContractServiceFees"
msgid "Delete"
msgstr "Törlés"

#: components/contracts/views/ContractServiceFees.yaml:390
msgctxt "ContractServiceFees"
msgid "Delete the selected items"
msgstr "A kijelölt elemek törlése"

#: components/contracts/views/ContractServiceFees.yaml:403
msgctxt "ContractServiceFees"
msgid "Indexing..."
msgstr "Indexálás..."

#: components/contracts/views/ContractServices.yaml:9
msgid "Contract services"
msgstr "Szerződött szolgáltatások"

#: components/contracts/views/ContractServices.yaml:37
msgctxt "ContractServices"
msgid "Contract services"
msgstr "Szerződött szolgáltatások"

#: components/contracts/views/ContractServices.yaml:41
msgctxt "filename"
msgid "contract-services"
msgstr "szerződés-szolgáltatások"

#: components/contracts/views/ContractServices.yaml:126
msgctxt "ContractServices"
msgid "Rental"
msgstr "Bérlemény"

#: components/contracts/views/ContractServices.yaml:208
msgctxt "Contracts"
msgid "Next Bill"
msgstr "Következő számlázás"

#: components/contracts/views/ContractServices.yaml:244
msgctxt "ContractService"
msgid "Billing date"
msgstr "Számlázás"

#: components/contracts/views/ContractServices.yaml:263
msgctxt "ContractService"
msgid "Due date"
msgstr "Kiegyenlítés"

#: components/contracts/views/ContractServices.yaml:282
msgctxt "ContractService"
msgid "Exchange rate date"
msgstr "Árfolyam dátuma"

#: components/contracts/views/ContractServices.yaml:340
msgctxt "ContractServices"
msgid "Bulk edit..."
msgstr "Csoportos szerkesztés..."

#: components/contracts/views/ContractViewsOverlappingRevisions.yaml:4
msgctxt "Contracts"
msgid "Overlapping Revisions"
msgstr "Egymást átfedő szerződések"

#: components/contracts/views/ContractViewsOverlappingRevisions.yaml:35
msgctxt "ContractViewsOverlappingRevisions"
msgid "Contract 'A'"
msgstr "'A' Szerződés"

#: components/contracts/views/ContractViewsOverlappingRevisions.yaml:44
msgctxt "ContractViewsOverlappingRevisions"
msgid "'A' Status"
msgstr "'A' Státusz"

#: components/contracts/views/ContractViewsOverlappingRevisions.yaml:66
msgctxt "ContractViewsOverlappingRevisions"
msgid "Client 'A'"
msgstr "'A' Ügyfél"

#: components/contracts/views/ContractViewsOverlappingRevisions.yaml:75
msgctxt "ContractViewsOverlappingRevisions"
msgid "'A' Valid From"
msgstr "'A' Érv. kezdete"

#: components/contracts/views/ContractViewsOverlappingRevisions.yaml:80
msgctxt "ContractViewsOverlappingRevisions"
msgid "'A' Valid To"
msgstr "'A' Érv. vége"

#: components/contracts/views/ContractViewsOverlappingRevisions.yaml:86
msgctxt "ContractViewsOverlappingRevisions"
msgid "Contract 'B'"
msgstr "'B' Szerződés"

#: components/contracts/views/ContractViewsOverlappingRevisions.yaml:95
msgctxt "ContractViewsOverlappingRevisions"
msgid "'B' Status"
msgstr "'B' Státusz"

#: components/contracts/views/ContractViewsOverlappingRevisions.yaml:117
msgctxt "ContractViewsOverlappingRevisions"
msgid "Client 'B'"
msgstr "'B' Ügyfél"

#: components/contracts/views/ContractViewsOverlappingRevisions.yaml:126
msgctxt "ContractViewsOverlappingRevisions"
msgid "'B' Valid From"
msgstr "'B' Érv. kezdete"

#: components/contracts/views/ContractViewsOverlappingRevisions.yaml:131
msgctxt "ContractViewsOverlappingRevisions"
msgid "'B' Valid To"
msgstr "'B' Érv. vége"

#: components/contracts/views/ContractViewsOverlappingRevisions.yaml:136
msgctxt "ContractViewsOverlappingRevisions"
msgid "Rental"
msgstr "Bérlemény"

#: components/dashboard/Dashboard.yaml:4
msgid "Dashboard"
msgstr "Dashboard"

#: components/dashboard/Notifications.yaml:44
msgid "Notifications"
msgstr "Értesítések"

#: components/dashboard/Notifications.yaml:115
msgid "No new notifications."
msgstr "Nincsenek új értesítések."

#: components/finance/Claims.yaml:4
msgctxt "Claims"
msgid "Claims"
msgstr "Követelések"

#: components/finance/Claims.yaml:45
msgctxt "ExportFilename"
msgid "claims"
msgstr "követelések"

#: components/finance/Claims.yaml:53 components/invoice/InvoiceBrowser.yaml:273
msgctxt "InvoicesView"
msgid "Invoice nr"
msgstr "Számlaszám"

#: components/finance/Claims.yaml:72 components/invoice/InvoiceBrowser.yaml:293
msgctxt "InvoicesView"
msgid "Type"
msgstr "Típus"

#: components/finance/Claims.yaml:86
msgctxt "Claims"
msgid "Issuer"
msgstr "Kibocsátó"

#: components/finance/Claims.yaml:101
msgctxt "Claims"
msgid "Client"
msgstr "Ügyfél"

#: components/finance/Claims.yaml:110
msgctxt "Claims"
msgid "Dunning letters"
msgstr "Felszólítólevelek"

#: components/finance/Claims.yaml:118
msgctxt "Claims"
msgid "Uncollectible"
msgstr "Behajthatatlan"

#: components/finance/Claims.yaml:124
msgctxt "Claims"
msgid "Days past due"
msgstr "Napok száma"

#: components/finance/Claims.yaml:129
msgctxt "Claims"
msgid "Amount"
msgstr "Összeg"

#: components/finance/Claims.yaml:134
msgctxt "Claims"
msgid "Claim"
msgstr "Követelés"

#: components/finance/Claims.yaml:139
msgctxt "Claims"
msgid "Paid"
msgstr "Fizetve"

#: components/finance/Claims.yaml:144
msgctxt "Claims"
msgid "Date of last settlement"
msgstr "Utolsó kiegyenlítés"

#: components/finance/Claims.yaml:148
#: components/invoice/InvoiceBrowser.yaml:405
msgctxt "InvoicesView"
msgid "Currency"
msgstr "Pénznem"

#: components/finance/Claims.yaml:151
msgctxt "InvoicesView"
msgid "Invoice date"
msgstr "Számla dátuma"

#: components/finance/Claims.yaml:154
#: components/invoice/InvoiceBrowser.yaml:318
msgctxt "InvoicesView"
msgid "Fulfillment date"
msgstr "Teljesítés dátuma"

#: components/finance/Claims.yaml:157
#: components/invoice/InvoiceBrowser.yaml:322
msgctxt "InvoicesView"
msgid "Due date"
msgstr "Fizetési határidő"

#: components/finance/Claims.yaml:160
msgctxt "InvoicesView"
msgid "Payment method"
msgstr "Fizetési mód"

#: components/finance/Claims.yaml:205
msgid "Create dunning letters..."
msgstr "Felszólítólevelek generálása..."

#: components/finance/ExchangeRateFieldset.yaml:57
msgctxt "ExchangeRateFieldset"
msgid "Rate"
msgstr "Árfolyam"

#: components/finance/ExchangeRateFieldset.yaml:74
msgctxt "ExchangeRateFieldset"
msgid "Date"
msgstr "Dátum"

#: components/finance/ExchangeRateFieldset.yaml:92
msgctxt "ExchangeRateFieldset"
msgid "Provider"
msgstr "Adatszolgáltató"

#: components/finance/InvoiceClaimsDashboard.yaml:4
msgid "Invoice Claims"
msgstr "Vevőtartozások"

#: components/finance/SendMails.yaml:4
msgid "Send emails"
msgstr "Email küldés"

#: components/finance/SendMails.yaml:61
msgid "One email has been successfully enqueued."
msgid_plural "${n} emails have been successfully enqueued."
msgstr[0] "Egy e-mail sikeresen elküldve."
msgstr[1] "${n} email sikeresen elküldve."

#: components/finance/SendMails.yaml:107
#: components/finance/dunning-letter/DunningLetter.yaml:245
msgid "Template"
msgstr "Sablon"

#: components/finance/SendMails.yaml:108
msgid "The template to use to generate the emails."
msgstr "A levelek a kiválasztott sablonnal lesznek generálva."

#: components/finance/SendMails.yaml:130
#: components/finance/dunning-letter/DunningLetter.yaml:297
msgid "Send"
msgstr "Küldés"

#: components/finance/Tariffs.yaml:6
msgctxt "Tariffs|Header"
msgid "Configure tariffs"
msgstr "Tarifák beállítása"

#: components/finance/Tariffs.yaml:70
msgctxt "Tariff"
msgid "Code"
msgstr "Kód"

#: components/finance/Tariffs.yaml:75
msgctxt "Tariff"
msgid "Name"
msgstr "Megnevezés"

#: components/finance/Tariffs.yaml:80
msgctxt "Tariff"
msgid "Description"
msgstr "Leírás"

#: components/finance/dunning-letter/CreateDunningLetter.yaml:4
msgid "Create dunning letters"
msgstr "Felszólítólevelek generálása"

#: components/finance/dunning-letter/CreateDunningLetter.yaml:60
msgid "One dunning letter created."
msgid_plural "${n} dunning letters created."
msgstr[0] "Egy felszólítólevél elkészült."
msgstr[1] "${n} felszólítólevél elkészült."

#: components/finance/dunning-letter/CreateDunningLetter.yaml:107
msgid "Last reference number"
msgstr "Az utolsó iktatószám"

#: components/finance/dunning-letter/CreateDunningLetter.yaml:121
msgid "Next reference number"
msgstr "A következő iktatószám"

#: components/finance/dunning-letter/CreateDunningLetter.yaml:143
msgid ""
"Next reference numbers will be generated from the given value. It must be "
"higher than the current value."
msgstr ""
"A felszólítólevelek a megadott sorszámtól kezdve készülnek el. A megadott "
"érték nem lehet kisebb az utolsó iktatószám sorszámánál!"

#: components/finance/dunning-letter/CreateDunningLetter.yaml:156
msgctxt "DunningLetterCreatePage"
msgid "Generate"
msgstr "Generálás"

#: components/finance/dunning-letter/DunningLetter.yaml:4
#: translations-extra.yaml:8
msgid "Dunning Letter"
msgstr "Felszólítólevél"

#: components/finance/dunning-letter/DunningLetter.yaml:218
msgid "Send email"
msgstr "Email küldése"

#: components/finance/dunning-letter/DunningLetter.yaml:231
msgid "Recipient"
msgstr "Címzett"

#: components/finance/dunning-letter/DunningLetter.yaml:232
msgid "Use semicolon to separate multiple addresses."
msgstr "Pontosvesszővel elválasztva több címzett is megadható."

#: components/finance/dunning-letter/DunningLetter.yaml:238
msgid "Email address"
msgstr "Email cím"

#: components/finance/dunning-letter/DunningLetter.yaml:272
msgctxt "DunningLetter|Submit"
msgid "Send"
msgstr "Küldés"

#: components/finance/dunning-letter/DunningLetter.yaml:319
msgid "Generate document"
msgstr "Dokumentum generálása"

#: components/finance/dunning-letter/DunningLetter.yaml:349
msgctxt "DunningLetter|Submit"
msgid "Generate document"
msgstr "Dokumentum generálása"

#: components/finance/dunning-letter/DunningLetter.yaml:375
msgctxt "DunningLetter"
msgid "Create"
msgstr "Generálás"

#: components/finance/dunning-letter/DunningLetter.yaml:385
msgid "Dunning letter"
msgstr "Felszólítólevél"

#: components/finance/dunning-letter/DunningLetter.yaml:454
msgid "Status"
msgstr "Státusz"

#: components/finance/dunning-letter/DunningLetter.yaml:465
#: translations-openapi.yaml:38
msgctxt "DunningLetterStatus"
msgid "Sent"
msgstr "Elküldve"

#: components/finance/dunning-letter/DunningLetter.yaml:467
#: translations-openapi.yaml:36
msgctxt "DunningLetterStatus"
msgid "Delivered"
msgstr "Postázva"

#: components/finance/dunning-letter/DunningLetter.yaml:469
#: translations-openapi.yaml:37
msgctxt "DunningLetterStatus"
msgid "Error"
msgstr "Hiba"

#: components/finance/dunning-letter/DunningLetter.yaml:475
msgid "Severity"
msgstr "Kategória"

#: components/finance/dunning-letter/DunningLetter.yaml:489
#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:636
#: components/meters/form/readings/UcMeterReadings.yaml:87
#: components/rental/form/assets/UcRentalFormFixedAssets.yaml:86
#: components/rental/form/services/UcRentalFormServicesTable.yaml:151
#: components/worksheets/form/UcWorksheetInvoiceLineAccountings.yaml:127
#: components/worksheets/form/UcWorksheetWorkItems.yaml:290
msgid "Notes"
msgstr "Megjegyzés"

#: components/finance/dunning-letter/DunningLetter.yaml:500
#: components/invoice/form/FieldsetInvoiceHeader.yaml:258
msgid "Client"
msgstr "Ügyfél"

#: components/finance/dunning-letter/DunningLetter.yaml:512
msgid "Address"
msgstr "Cím"

#: components/finance/dunning-letter/DunningLetter.yaml:552
msgid "Invoices"
msgstr "Számlák"

#: components/finance/dunning-letter/DunningLetter.yaml:572
msgid "Invoice number"
msgstr "Számlaszám"

#: components/finance/dunning-letter/DunningLetter.yaml:575
msgid "Completion date"
msgstr "Tejlesítés ideje"

#: components/finance/dunning-letter/DunningLetter.yaml:580
msgid "Due date"
msgstr "Fizetési határidő"

#: components/finance/dunning-letter/DunningLetter.yaml:585
#: components/invoice/form/UcInvoiceExchangeRateEditor.yaml:79
#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:466
#: components/worksheets/form/UcWorksheetInvoiceLineAccountings.yaml:107
#: components/worksheets/form/UcWorksheetWorkItems.yaml:340
msgid "Amount"
msgstr "Összeg"

#: components/finance/dunning-letter/DunningLetter.yaml:590
msgid "Paid"
msgstr "Fizetve"

#: components/finance/dunning-letter/DunningLetter.yaml:595
msgid "Debt"
msgstr "Követelés"

#: components/finance/dunning-letter/DunningLetter.yaml:606
msgid "No events"
msgstr "Nincsenek események"

#: components/finance/dunning-letter/DunningLetter.yaml:667
msgctxt "email"
msgid "To"
msgstr "Címzett"

#: components/finance/dunning-letter/DunningLetter.yaml:678
msgctxt "email"
msgid "Subject"
msgstr "Tárgy"

#: components/finance/dunning-letter/DunningLetter.yaml:702
msgid "Error log"
msgstr "Hibanapló"

#: components/finance/dunning-letter/DunningLetter.yaml:781
msgctxt "DialogButton"
msgid "Close"
msgstr "Bezárás"

#: components/finance/dunning-letter/DunningLetters.yaml:4
msgctxt "DunningLetters"
msgid "Dunning Letters"
msgstr "Felszólítólevelek"

#: components/finance/dunning-letter/DunningLetters.yaml:46
msgctxt "DunningLetters"
msgid "Dunning letters"
msgstr "Felszólítólevelek"

#: components/finance/dunning-letter/DunningLetters.yaml:50
msgctxt "filename"
msgid "dunning-letters"
msgstr "felszólítólevelek"

#: components/finance/dunning-letter/DunningLetters.yaml:58
msgctxt "DunningLetters"
msgid "Reference Number"
msgstr "Hivatkozási szám"

#: components/finance/dunning-letter/DunningLetters.yaml:67
msgctxt "DunningLetters"
msgid "Status"
msgstr "Státusz"

#: components/finance/dunning-letter/DunningLetters.yaml:83
msgctxt "DunningLetters"
msgid "Owner company"
msgstr "Saját cég"

#: components/finance/dunning-letter/DunningLetters.yaml:92
msgctxt "DunningLetters"
msgid "Partner"
msgstr "Ügyfél"

#: components/finance/dunning-letter/DunningLetters.yaml:101
msgctxt "DunningLetters"
msgid "Client Email"
msgstr "Ügyfél email"

#: components/finance/dunning-letter/DunningLetters.yaml:107
msgctxt "DunningLetters"
msgid "Severity"
msgstr "Kategória"

#: components/finance/dunning-letter/DunningLetters.yaml:114
msgctxt "DunningLetters"
msgid "Created by"
msgstr "Készítette"

#: components/finance/dunning-letter/DunningLetters.yaml:155
msgctxt "DunningLetters"
msgid "Send emails..."
msgstr "Email küldése..."

#: components/finance/dunning-letter/DunningLetters.yaml:167
msgctxt "DunningLetters"
msgid "Delete"
msgstr "Törlés"

#: components/finance/primitives/UcInvoiceStatusBadge.yaml:11
msgctxt "InvoiceStatus"
msgid "StartCase"
msgstr "StartCase"

#: components/invoice/BatchInvoiceEditor.yaml:4
msgctxt "BatchInvoiceEditor|Title"
msgid "Batch Edit Invoices"
msgstr "Tömeges Számla Szerkesztés"

#: components/invoice/BatchInvoiceEditor.yaml:216
#: components/invoice/form/FieldsetInvoiceHeader.yaml:402
msgctxt "Invoice"
msgid "Payment Method"
msgstr "Fizetési mód"

#: components/invoice/BatchInvoiceEditor.yaml:244
#: components/invoice/form/FieldsetInvoiceHeader.yaml:442
msgctxt "Invoice"
msgid "Accounting Date"
msgstr "Számviteli teljesítés dátuma"

#: components/invoice/CreateInvoice.yaml:27
#: components/invoice/form/InvoiceLineGroup.yaml:49
msgctxt "Invoice"
msgid "Create Incoming Invoice"
msgstr "Szállítói számla létrehozása"

#: components/invoice/CreateInvoice.yaml:28
#: components/invoice/form/InvoiceLineGroup.yaml:50
msgctxt "Invoice"
msgid "Create Outgoing Invoice"
msgstr "Vevőszámla létrehozása"

#: components/invoice/CreateInvoice.yaml:145
msgctxt "CreateInvoice|Submit"
msgid "Create invoice"
msgstr "Számla létrehozása"

#: components/invoice/CreatePassThroughInvoice.yaml:5
msgctxt "Invoice"
msgid "Create Invoice"
msgstr "Számla létrehozása"

#: components/invoice/CreatePassThroughInvoice.yaml:64
msgctxt "Invoice"
msgid "Pass-through Invoice"
msgstr "Továbbszámlázás"

#: components/invoice/CreatePassThroughInvoice.yaml:90
msgctxt "Invoice"
msgid "Client"
msgstr "Ügyfél"

#: components/invoice/CreatePassThroughInvoice.yaml:94
msgctxt "CreatePassThroughInvoice|Tooltip"
msgid "Specify the client to be re-invoiced."
msgstr "A továbbszámlázás ügyfele"

#: components/invoice/CreatePassThroughInvoice.yaml:113
msgctxt "CreatePassThroughInvoice"
msgid "Multiplier"
msgstr "Szorzó"

#: components/invoice/CreatePassThroughInvoice.yaml:117
msgctxt "CreatePassThroughInvoice|Tooltip"
msgid "Line items will be generated with the given multiplier."
msgstr "A sortételek a megadott szorzóval lesznek létrehozva."

#: components/invoice/ImportInvoices.yaml:4
msgctxt "ImportInvoices|Title"
msgid "Import Invoices"
msgstr "Számlák importálása"

#: components/invoice/ImportInvoices.yaml:25
msgctxt "ImportInvoicesFormat"
msgid "Szamlazz.hu CSV"
msgstr "Számlázz.hu CSV"

#: components/invoice/ImportInvoices.yaml:29
msgctxt "ImportInvoicesFormat"
msgid "UBL XML"
msgstr "UBL XML"

#: components/invoice/ImportInvoices.yaml:104
msgctxt "ImportInvoices"
msgid "File format"
msgstr "Formátum"

#: components/invoice/ImportInvoices.yaml:119
msgctxt "ImportInvoices"
msgid "Export file"
msgstr "Export fájl"

#: components/invoice/ImportInvoices.yaml:121
msgctxt "ImportInvoices"
msgid "The file can be obtained from the respective providers's application."
msgstr ""
"Az állomány letölthető a kiválasztott formátumnak megelelő alkalmazásból."

#: components/invoice/ImportInvoices.yaml:160
msgctxt "ImportInvoices"
msgid "Submit file"
msgstr "Fájl feltöltése"

#: components/invoice/Invoice.yaml:4
msgid "Create Invoice"
msgstr "Számla létrehozása"

#: components/invoice/Invoice.yaml:99
#: components/invoice/form/FieldsetInvoiceHeader.yaml:17
#: components/invoice/primitives/UcInvoiceTypeBadge.yaml:30
#: translations-openapi.yaml:58
msgctxt "InvoiceType"
msgid "Correction"
msgstr "Helyesbítő"

#: components/invoice/Invoice.yaml:100
#: components/invoice/form/FieldsetInvoiceHeader.yaml:18
#: components/invoice/primitives/UcInvoiceTypeBadge.yaml:29
#: translations-openapi.yaml:61
msgctxt "InvoiceType"
msgid "Storno"
msgstr "Storno"

#: components/invoice/Invoice.yaml:101
#: components/invoice/form/FieldsetInvoiceHeader.yaml:19
#: components/invoice/primitives/UcInvoiceTypeBadge.yaml:31
msgctxt "InvoiceType"
msgid "Pro Forma"
msgstr "Pro Forma"

#: components/invoice/Invoice.yaml:159
msgctxt "Invoice"
msgid "Invoice data"
msgstr "Számla adatok"

#: components/invoice/InvoiceBrowser.yaml:4
msgctxt "InvoiceBrowser"
msgid "Browse Invoices"
msgstr "Számlák keresése"

#: components/invoice/InvoiceBrowser.yaml:62 translations-openapi.yaml:56
msgctxt "InvoiceKind"
msgid "Incoming"
msgstr "Szállítói számla"

#: components/invoice/InvoiceBrowser.yaml:64 translations-openapi.yaml:57
msgctxt "InvoiceKind"
msgid "Outgoing"
msgstr "Vevőszámla"

#: components/invoice/InvoiceBrowser.yaml:145
msgctxt "InvoiceBrowser"
msgid "Company"
msgstr "Saját Cég"

#: components/invoice/InvoiceBrowser.yaml:157
msgctxt "InvoiceBrowser"
msgid "Invoice kind"
msgstr "Számla fajtája"

#: components/invoice/InvoiceBrowser.yaml:173
msgctxt "InvoiceBrowser"
msgid "Select client"
msgstr "Ügyfél kiválasztása"

#: components/invoice/InvoiceBrowser.yaml:186
msgctxt "InvoiceBrowser"
msgid "Date From"
msgstr "Dátumtól"

#: components/invoice/InvoiceBrowser.yaml:194
msgctxt "InvoiceBrowser"
msgid "Date To"
msgstr "Dátumig"

#: components/invoice/InvoiceBrowser.yaml:204
msgctxt "InvoiceBrowser"
msgid "Unpaid"
msgstr "Fizetetlen"

#: components/invoice/InvoiceBrowser.yaml:211
msgid "Search"
msgstr "Keresés"

#: components/invoice/InvoiceBrowser.yaml:226
msgid "Add Selection"
msgstr "Kijelölés hozzáadása"

#: components/invoice/InvoiceBrowser.yaml:265
msgctxt "InvoicesView"
msgid "Kind"
msgstr "Jelleg"

#: components/invoice/InvoiceBrowser.yaml:269
msgctxt "InvoiceKind"
msgid "In"
msgstr "Szállítói számla"

#: components/invoice/InvoiceBrowser.yaml:270
msgctxt "InvoiceKind"
msgid "Out"
msgstr "Vevőszámla"

#: components/invoice/InvoiceBrowser.yaml:307
msgctxt "InvoicesView"
msgid "Status"
msgstr "Státusz"

#: components/invoice/InvoiceBrowser.yaml:315
msgctxt "InvoicesView"
msgid "Date"
msgstr "Dátum"

#: components/invoice/InvoiceBrowser.yaml:326
msgctxt "InvoicesView"
msgid "Register entry"
msgstr "Iktatás"

#: components/invoice/InvoiceBrowser.yaml:333
msgctxt "InvoicesView"
msgid "Client"
msgstr "Ügyfél"

#: components/invoice/InvoiceBrowser.yaml:342
msgctxt "InvoicesView"
msgid "Description"
msgstr "Leírás"

#: components/invoice/InvoiceBrowser.yaml:345
msgctxt "InvoicesView"
msgid "Net"
msgstr "Nettó"

#: components/invoice/InvoiceBrowser.yaml:350
msgctxt "InvoicesView"
msgid "Amount"
msgstr "Összeg"

#: components/invoice/InvoiceBrowser.yaml:355
#: components/invoice/Invoices.yaml:297
msgctxt "Invoices"
msgid "Outstanding Amounts"
msgstr "Nyitott összeg"

#: components/invoice/InvoiceBrowser.yaml:384
msgctxt "InvoicesView"
msgid "Paid"
msgstr "Fizetve"

#: components/invoice/InvoiceBrowser.yaml:401
#: components/invoice/Invoices.yaml:343
msgctxt "PaymentBrowserView"
msgid "Date of last settlement"
msgstr "Utolsó kiegyenlítés"

#: components/invoice/InvoiceBrowser.yaml:408
msgctxt "InvoicesView"
msgid "Tags"
msgstr "Címkék"

#: components/invoice/InvoiceBrowser.yaml:411
#: components/invoice/invoice-generation/UcInvoiceGenerationInvoices.yaml:220
msgctxt "InvoicesView"
msgid "Rentals"
msgstr "Bérlemények"

#: components/invoice/InvoiceBrowser.yaml:429
#: components/invoice/invoice-generation/UcInvoiceGenerationInvoices.yaml:238
msgctxt "InvoicesView"
msgid "Contracts"
msgstr "Szerződések"

#: components/invoice/InvoiceEditor.yaml:22
msgctxt "Invoice"
msgid "Edit Invoice"
msgstr "Számla szerkesztése"

#: components/invoice/InvoiceEditor.yaml:27
msgctxt "Invoice"
msgid "Edit Invoice Header"
msgstr "Számla adatok szerkesztése"

#: components/invoice/Invoices.yaml:37
msgctxt "Invoices"
msgid "Vendor invoices"
msgstr "Szállítói számlák"

#: components/invoice/Invoices.yaml:38
msgctxt "Invoices"
msgid "Customer invoices"
msgstr "Vevőszámlák"

#: components/invoice/Invoices.yaml:90
msgctxt "ExportFilename"
msgid "invoices"
msgstr "számlák"

#: components/invoice/Invoices.yaml:98
msgctxt "Invoices"
msgid "Company"
msgstr "Saját cég"

#: components/invoice/Invoices.yaml:116
msgctxt "Invoices"
msgid "Invoice nr"
msgstr "Számlaszám"

#: components/invoice/Invoices.yaml:142
msgctxt "Invoices"
msgid "NAV"
msgstr "NAV"

#: components/invoice/Invoices.yaml:168
msgctxt "Invoices"
msgid "Type"
msgstr "Típus"

#: components/invoice/Invoices.yaml:182
msgctxt "Invoices"
msgid "Status"
msgstr "Státusz"

#: components/invoice/Invoices.yaml:195
msgctxt "Invoices"
msgid "Printout"
msgstr "Nyomtatási kép"

#: components/invoice/Invoices.yaml:201
msgctxt "Invoices"
msgid "Attachments"
msgstr "Csatolmányok"

#: components/invoice/Invoices.yaml:207
msgctxt "Invoices"
msgid "Register entry"
msgstr "Iktatás"

#: components/invoice/Invoices.yaml:235
msgctxt "Invoices"
msgid "VAT period"
msgstr "ÁFA időszak"

#: components/invoice/Invoices.yaml:259
msgctxt "Invoices"
msgid "Date"
msgstr "Dátum"

#: components/invoice/Invoices.yaml:262
msgctxt "Invoices"
msgid "Fulfillment date"
msgstr "Teljesítés dátuma"

#: components/invoice/Invoices.yaml:266
msgctxt "Invoices"
msgid "Due date"
msgstr "Fizetési határidő"

#: components/invoice/Invoices.yaml:270
msgctxt "Invoices"
msgid "Client"
msgstr "Ügyfél"

#: components/invoice/Invoices.yaml:279
msgctxt "Invoices"
msgid "Description"
msgstr "Leírás"

#: components/invoice/Invoices.yaml:282
msgctxt "Invoices"
msgid "Net"
msgstr "Nettó"

#: components/invoice/Invoices.yaml:287
msgctxt "Invoices"
msgid "VAT"
msgstr "ÁFA"

#: components/invoice/Invoices.yaml:292
msgctxt "Invoices"
msgid "Total"
msgstr "Végösszeg"

#: components/invoice/Invoices.yaml:326
msgctxt "Invoices"
msgid "Paid"
msgstr "Fizetve"

#: components/invoice/Invoices.yaml:347
msgctxt "Invoices"
msgid "Currency"
msgstr "Pénznem"

#: components/invoice/Invoices.yaml:351
msgctxt "InvoicesView"
msgid "VAT deductible"
msgstr "Levonható ÁFA"

#: components/invoice/Invoices.yaml:356
msgctxt "Invoices"
msgid "Tags"
msgstr "Címkék"

#: components/invoice/Invoices.yaml:359
msgctxt "Invoices"
msgid "Rentals"
msgstr "Bérlemények"

#: components/invoice/Invoices.yaml:379
msgctxt "Invoices"
msgid "Contracts"
msgstr "Szerződések"

#: components/invoice/Invoices.yaml:428
#: components/payments/views/PaymentsFilters.yaml:114
msgid "Commands"
msgstr "Parancsok"

#: components/invoice/Invoices.yaml:439
msgctxt "Invoices"
msgid "New Invoice..."
msgstr "Új számla..."

#: components/invoice/Invoices.yaml:453
msgctxt "Invoices"
msgid "Import Invoices..."
msgstr "Számlák importálása..."

#: components/invoice/Invoices.yaml:466
msgctxt "Invoices"
msgid "Set VAT period..."
msgstr "ÁFA időszak beállítása..."

#: components/invoice/Invoices.yaml:501
msgctxt "Invoices"
msgid "Print invoices..."
msgstr "Számlák nyomtatása..."

#: components/invoice/PrintInvoices.yaml:4
msgctxt "PrintInvoices|Title"
msgid "Print Invoices"
msgstr "Számlák Nyomtatása"

#: components/invoice/PrintInvoices.yaml:71
#: components/invoice/form/ConfirmSyncInvoice.yaml:105
#: components/invoice/invoice-generation/CompleteInvoicesAlt.yaml:164
msgctxt "InvoiceSync"
msgid "Copies"
msgstr "Példányszám"

msgctxt "InvoiceSync"
msgid "After synchronization, the account can no longer be modified."
msgstr "Szinkronizálás után a számla már nem módosítható."

#: components/invoice/PrintInvoices.yaml:89
#: components/invoice/invoice-generation/CompleteInvoicesAlt.yaml:183
msgctxt "InvoiceSync"
msgid "Printer"
msgstr "Nyomtató"

#: components/invoice/PrintInvoices.yaml:109
msgctxt "PrintInvoices|Submit"
msgid "Print"
msgstr "Nyomtatás"

#: components/invoice/SetInvoiceVatPeriod.yaml:4
msgctxt "SetInvoiceVatPeriod"
msgid "Set VAT period"
msgstr "ÁFA időszak beállítása"

#: components/invoice/SetInvoiceVatPeriod.yaml:87
msgctxt "SetInvoiceVatPeriod"
msgid "VAT Period"
msgstr "ÁFA időszak"

#: components/invoice/SetInvoiceVatPeriod.yaml:101
msgctxt "SetInvoiceVatPeriod"
msgid "Lock invoices in order to prevent further modifications"
msgstr "A számlák zárolása a további módosítások megakadályozása érdekében"

#: components/invoice/SetInvoiceVatPeriod.yaml:110
msgctxt "SetInvoiceVatPeriod"
msgid "Lock invoices"
msgstr "Számlák zárolása"

#: components/invoice/SetInvoiceVatPeriod.yaml:122
msgctxt "SetInvoiceVatPeriod"
msgid "Submit"
msgstr "Küldés"

#: components/invoice/SetInvoiceVatPeriod.yaml:129
msgctxt "SetInvoiceVatPeriod"
msgid "Cancel"
msgstr "Mégsem"

#: components/invoice/UcInvoiceImportNotificationCard.yaml:26
msgctxt "Notification"
msgid "Invoice import"
msgstr "Számla import"

#: components/invoice/form/ConfirmSyncInvoice.yaml:4
msgctxt "ConfirmSyncInvoice.Title"
msgid "Create invoice"
msgstr "Számla kiállítása"

#: components/invoice/form/ConfirmSyncInvoice.yaml:90
#: components/invoice/invoice-generation/CompleteInvoicesAlt.yaml:149
msgctxt "InvoiceSync"
msgid "Print"
msgstr "Nyomtatás"

#: components/invoice/form/ConfirmSyncInvoice.yaml:128
msgctxt "Button"
msgid "Create invoice"
msgstr "Számla kiállítása"

#: components/invoice/form/FieldsetInvoiceHeader.yaml:22
msgctxt "Invoice|Reference|description"
msgid "Normal invoices can reference Pro Forma invoices."
msgstr "Normál számla csak Pro Forma számlára hivatkozhat."

#: components/invoice/form/FieldsetInvoiceHeader.yaml:23
msgctxt "Invoice|Reference|description"
msgid "A correction must reference the invoice being corrected."
msgstr ""
"A helyesbítő számlának hivatkoznia kell a helyesbített (normál) számlára."

#: components/invoice/form/FieldsetInvoiceHeader.yaml:24
msgctxt "Invoice|Reference|description"
msgid "The reversing invoice must reference the invoice being reversed."
msgstr "A stornó számlának hivatkoznia kell a törölt (normál) számlára."

#: components/invoice/form/FieldsetInvoiceHeader.yaml:25
msgctxt "Invoice|Reference|description"
msgid "Pro Forma invoices can reference former Pro Forma invoices."
msgstr "Pro Forma számla csak Pro Forma számlára hivatkozhat."

#: components/invoice/form/FieldsetInvoiceHeader.yaml:27
msgctxt "Invoice"
msgid "The given invoice number already exists."
msgstr "A megadott sorszámmal már létezik számla."

#: components/invoice/form/FieldsetInvoiceHeader.yaml:71 config.yaml:7
msgctxt "Language"
msgid "hungarian"
msgstr "magyar"

#: components/invoice/form/FieldsetInvoiceHeader.yaml:73 config.yaml:9
msgctxt "Language"
msgid "english"
msgstr "angol"

#: components/invoice/form/FieldsetInvoiceHeader.yaml:134
msgctxt "Invoice"
msgid "Type"
msgstr "Típus"

#: components/invoice/form/FieldsetInvoiceHeader.yaml:154
msgctxt "Invoice"
msgid "Reference Invoice"
msgstr "Hivatkozási számla"

#: components/invoice/form/FieldsetInvoiceHeader.yaml:202
msgctxt "Invoice"
msgid "Own company"
msgstr "Saját cég"

#: components/invoice/form/FieldsetInvoiceHeader.yaml:241
msgctxt "Invoice"
msgid "Toggle editor"
msgstr "Szerkesztő váltása"

#: components/invoice/form/FieldsetInvoiceHeader.yaml:318
#: components/worksheets/form/UcWorksheetInvoiceLineAccountings.yaml:73
msgid "Invoice Number"
msgstr "Számlaszám"

#: components/invoice/form/FieldsetInvoiceHeader.yaml:329
msgctxt "Invoice/invoice_number/placeholder"
msgid "Enter invoice number"
msgstr "Bizonylatszám megadása"

#: components/invoice/form/FieldsetInvoiceHeader.yaml:353
msgid "Invoice Date"
msgstr "Számla dátuma"

#: components/invoice/form/FieldsetInvoiceHeader.yaml:423
msgctxt "Invoice"
msgid "Status"
msgstr "Státusz"

#: components/invoice/form/FieldsetInvoiceHeader.yaml:540
msgctxt "Invoice"
msgid "Provider"
msgstr "Adatszolgáltató"

#: components/invoice/form/FieldsetInvoiceHeader.yaml:546
msgid "Language"
msgstr "Nyelv"

#: components/invoice/form/FieldsetInvoiceHeader.yaml:562
#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:943
#: components/worksheets/form/UcWorksheetInvoiceLineAccountings.yaml:111
msgid "Expense Type"
msgstr "Költségtípus"

#: components/invoice/form/FieldsetInvoiceHeader.yaml:582
msgctxt "Invoice"
msgid "Categories"
msgstr "Kategóriák"

#: components/invoice/form/FieldsetInvoiceHeader.yaml:599
msgctxt "Invoice"
msgid "VAT Period"
msgstr "ÁFA időszak"

#: components/invoice/form/FieldsetInvoiceHeader.yaml:618
msgctxt "Invoice"
msgid "Reference Number"
msgstr "Hivatkozási szám"

#: components/invoice/form/FieldsetInvoiceHeader.yaml:633
msgctxt "Invoice"
msgid "Order Number"
msgstr "Rendelésszám"

#: components/invoice/form/FieldsetInvoiceHeader.yaml:648
msgctxt "Invoice"
msgid "File Number"
msgstr "Mappaszám"

#: components/invoice/form/FieldsetInvoiceHeader.yaml:681
msgctxt "Invoice"
msgid "Internal Notes"
msgstr "Belső feljegyzés"

#: components/invoice/form/FieldsetInvoiceParty.yaml:60
msgctxt "InvoiceParty"
msgid "Name"
msgstr "Név"

#: components/invoice/form/FieldsetInvoiceParty.yaml:75
msgctxt "InvoiceParty"
msgid "Postal code"
msgstr "Irányítószám"

#: components/invoice/form/FieldsetInvoiceParty.yaml:85
msgctxt "InvoiceParty"
msgid "City"
msgstr "Város"

#: components/invoice/form/FieldsetInvoiceParty.yaml:96
msgctxt "InvoiceParty"
msgid "Address"
msgstr "Cím"

#: components/invoice/form/FieldsetInvoiceParty.yaml:106
msgctxt "InvoiceParty"
msgid "Tax number"
msgstr "Adószám"

#: components/invoice/form/FieldsetInvoiceParty.yaml:116
msgctxt "InvoiceParty"
msgid "Account number"
msgstr "Számlaszám"

#: components/invoice/form/FieldsetInvoiceParty.yaml:126
msgctxt "InvoiceParty"
msgid "Bank"
msgstr "Bank"

#: components/invoice/form/InvoiceLineGroup.yaml:5
msgctxt "InvoiceLineGroup"
msgid "New line group"
msgstr "Új tételsor csoport"

#: components/invoice/form/InvoiceLineGroup.yaml:6
msgctxt "InvoiceLineGroup"
msgid "Edit line group"
msgstr "Tételsor csoport szerkesztése"

#: components/invoice/form/InvoiceLineGroup.yaml:107
msgctxt "InvoiceLineGroup"
msgid "Description"
msgstr "Megnevezés"

#: components/invoice/form/InvoiceLineGroup.yaml:117
msgctxt "InvoiceLineGroup/description/placeholder"
msgid "Enter group description"
msgstr "A csoport megnevezése"

#: components/invoice/form/InvoiceLineGroup.yaml:122
msgctxt "InvoiceLineGroup"
msgid "Expense Type"
msgstr "Költségtípus"

#: components/invoice/form/InvoiceLineGroup.yaml:140
msgctxt "InvoiceLineGroup"
msgid "Rental"
msgstr "Bérlemény"

#: components/invoice/form/InvoiceLineGroup.yaml:168
msgctxt "InvoiceLineGroup"
msgid "Property"
msgstr "Ingatlan"

#: components/invoice/form/InvoiceLineGroup.yaml:190
msgctxt "InvoiceLineGroup"
msgid "Worksheet"
msgstr "Munkalap"

#: components/invoice/form/InvoiceLineGroup.yaml:212
msgctxt "InvoiceLineGroup"
msgid "Contractor"
msgstr "Alvállalkozó"

#: components/invoice/form/InvoiceLineMeterReadingSelector.yaml:5
msgctxt "InvoiceLineMeterReadingSelector|Title"
msgid "Choose readings"
msgstr "Mérőállás választása"

#: components/invoice/form/InvoiceLineMeterReadingSelector.yaml:151
msgctxt "MeterRentalServices"
msgid "No rental services."
msgstr "Nincsenek szolgáltatások"

#: components/invoice/form/InvoiceLineMeterReadingSelector.yaml:231
#: components/meters/form/consumptions/UcMeterConsumptions.yaml:144
#: components/rental/form/services/RentalService.yaml:367
msgctxt "RentalService"
msgid "Non billable"
msgstr "Nem továbbszámlázott"

#: components/invoice/form/InvoiceLineMeterReadingSelector.yaml:296
msgctxt "InvoiceLineMeterReadingSelector|ColHead"
msgid "Value"
msgstr "Óraállás"

#: components/invoice/form/InvoiceLineMeterReadingSelector.yaml:299
msgctxt "InvoiceLineMeterReadingSelector|ColHead"
msgid "Diff"
msgstr "Fogyasztás"

#: components/invoice/form/InvoiceLineMeterReadingSelector.yaml:302
msgctxt "InvoiceLineMeterReadingSelector|ColHead"
msgid "Date"
msgstr "Dátum"

#: components/invoice/form/InvoiceLineMeterReadingSelector.yaml:305
msgctxt "InvoiceLineMeterReadingSelector|ColHead"
msgid "Notes"
msgstr "Megjegyzés"

#: components/invoice/form/UcInvoiceData.yaml:82
msgctxt "Invoice"
msgid "Partner"
msgstr "Ügyfél"

#: components/invoice/form/UcInvoiceData.yaml:100
#: components/invoice/views/InvoiceLinesView.yaml:71
msgctxt "Invoice"
msgid "Invoice date"
msgstr "Számla dátuma"

#: components/invoice/form/UcInvoiceData.yaml:112
#: components/invoice/views/InvoiceLinesView.yaml:75
msgctxt "Invoice"
msgid "Fulfillment date"
msgstr "Teljesítés dátuma"

#: components/invoice/form/UcInvoiceData.yaml:124
msgctxt "Invoice"
msgid "Billing period"
msgstr "Számlázási időszak"

#: components/invoice/form/UcInvoiceData.yaml:288
#: components/invoice/views/InvoicesFilters.yaml:58
msgctxt "Invoice"
msgid "Due date"
msgstr "Fizetési határidő"

#: components/invoice/form/UcInvoiceData.yaml:304
msgctxt "PaymentMethod"
msgid "Sentence"
msgstr "Mondat"

#: components/invoice/form/UcInvoiceData.yaml:310
msgctxt "Invoice"
msgid "Expense Type"
msgstr "Költségtípus"

#: components/invoice/form/UcInvoiceData.yaml:315
#: components/worksheets/form/UcWorksheetInvoiceLineAccountings.yaml:116
msgctxt "ExpenseType"
msgid "Sentence"
msgstr "Mondat"

#: components/invoice/form/UcInvoiceData.yaml:321
msgctxt "Invoice"
msgid "Register entries"
msgstr "Iktatás"

#: components/invoice/form/UcInvoiceData.yaml:346
msgctxt "Invoice"
msgid "References"
msgstr "Hivatkozások"

#: components/invoice/form/UcInvoiceData.yaml:362
msgctxt "Invoice"
msgid "Attachments"
msgstr "Csatolmányok"

#: components/invoice/form/UcInvoiceData.yaml:381
#: components/payments/form/UcPaymentInvoices.yaml:27
msgctxt "Invoice"
msgid "Payments"
msgstr "Pénzforgalom"

#: components/invoice/form/UcInvoiceExchangeRateEditor.yaml:42
msgid "Exchange rate"
msgstr "Árfolyam"

#: components/invoice/form/UcInvoiceExchangeRateEditor.yaml:92
#: components/worksheets/form/UcWorksheetWorkItems.yaml:283
msgid "Date"
msgstr "Dátum"

#: components/invoice/form/UcInvoiceFooter.yaml:29
msgctxt "Invoice"
msgid "Taxable subtotal"
msgstr "Nettó összesen"

#: components/invoice/form/UcInvoiceFooter.yaml:54
msgid "Tax"
msgstr "Adó"

#: components/invoice/form/UcInvoiceFooter.yaml:86
msgid "Total"
msgstr "Végösszeg"

#: components/invoice/form/UcInvoiceHeader.yaml:24
msgctxt "Invoice"
msgid "New Invoice"
msgstr "Új számla"

#: components/invoice/form/UcInvoiceHeader.yaml:26
msgctxt "InvoiceKind"
msgid "Incoming Invoice"
msgstr "Szállítói számla"

#: components/invoice/form/UcInvoiceHeader.yaml:27
msgctxt "InvoiceKind"
msgid "Outgoing Invoice"
msgstr "Vevőszámla"

#: components/invoice/form/UcInvoiceHeader.yaml:28
msgctxt "Invoice"
msgid "Create corrector invoice"
msgstr "Számla helyesbítése"

#: components/invoice/form/UcInvoiceHeader.yaml:29
msgctxt "Invoice"
msgid "Create storno invoice"
msgstr "Számla stornózása"

#: components/invoice/form/UcInvoiceHeader.yaml:30
msgctxt "Invoice|Tooltip"
msgid "Rebilling the line items to a designated client."
msgstr "A sortételek továbbszámlázása egy ügyfélnek"

#: components/invoice/form/UcInvoiceHeader.yaml:31
msgctxt "Invoice|Tooltip"
msgid "Create advance invoice from a Pro Forma invoice."
msgstr "Előlegszámla létrehozása proforma számlából"

#: components/invoice/form/UcInvoiceHeader.yaml:32
msgctxt "Invoice|Tooltip"
msgid "Create final invoice from a Pro Forma or advance invoice."
msgstr "Végszámla létrehozása proforma- vagy előlegszámlából"

#: components/invoice/form/UcInvoiceHeader.yaml:243
#: components/worksheets/form/UcWorksheetHeader.yaml:57
msgid "Closed"
msgstr "Lezárt"

#: components/invoice/form/UcInvoiceHeader.yaml:278
msgctxt "Invoice"
msgid "Reference invoice"
msgstr "Hivatkozott számla"

#: components/invoice/form/UcInvoiceHeader.yaml:294
msgctxt "Invoice"
msgid "Referencing invoices"
msgstr "Hivatkozó számlák"

#: components/invoice/form/UcInvoiceHeader.yaml:310
msgctxt "Invoice"
msgid "Invoice Language"
msgstr "Nyelv"

#: components/invoice/form/UcInvoiceHeader.yaml:427
msgctxt "Invoice"
msgid "Open preview"
msgstr "Előnézet megnyitása"

#: components/invoice/form/UcInvoiceHeader.yaml:438
msgctxt "Invoice"
msgid "Show log messages"
msgstr "Naplófile megtekintése"

#: components/invoice/form/UcInvoiceHeader.yaml:468
msgctxt "Invoice"
msgid "Register invoice"
msgstr "Iktatás"

#: components/invoice/form/UcInvoiceHeader.yaml:469
msgctxt "Invoice"
msgid "Add this invoice to the invoice register"
msgstr "Iktatókönyv bejegyzés létrehozása"

#: components/invoice/form/UcInvoiceHeader.yaml:478
#: components/worksheets/form/UcWorksheetHeader.yaml:136
msgctxt "BtnCopyResource"
msgid "Copy"
msgstr "Másolás"

#: components/invoice/form/UcInvoiceHeader.yaml:479
msgctxt "Invoice"
msgid "Create new invoice from this one"
msgstr "Új számla készítése a jelenlegi alapján"

#: components/invoice/form/UcInvoiceHeader.yaml:489
msgctxt "Invoice"
msgid "Create pass-through"
msgstr "Továbbszámlázás"

#: components/invoice/form/UcInvoiceHeader.yaml:501
msgctxt "Invoice"
msgid "Create advance"
msgstr "Előlegszámla"

#: components/invoice/form/UcInvoiceHeader.yaml:513
msgctxt "Invoice"
msgid "Create final"
msgstr "Végszámla"

#: components/invoice/form/UcInvoiceHeader.yaml:527
msgctxt "Invoice"
msgid "Create storno"
msgstr "Stornózás"

#: components/invoice/form/UcInvoiceHeader.yaml:540
msgctxt "Invoice"
msgid "Create corrector"
msgstr "Helyesbítés"

#: components/invoice/form/UcInvoiceHeader.yaml:553
msgctxt "Invoice"
msgid "Lock invoice"
msgstr "Számla zárolása"

#: components/invoice/form/UcInvoiceHeader.yaml:567
msgctxt "Invoice"
msgid "Delete invoice"
msgstr "Számla törlése"

#: components/invoice/form/UcInvoiceHeader.yaml:580
#: components/worksheets/form/UcWorksheetHeader.yaml:159
msgctxt "BtnResourceHistory"
msgid "History"
msgstr "Előzmények"

#: components/invoice/form/UcInvoiceHeader.yaml:581
#: components/meters/Meter.yaml:85
msgctxt "Invoice"
msgid "Invoice history"
msgstr "Számla előzmények"

#: components/invoice/form/UcInvoiceLineGroup.yaml:87
msgctxt "InvoiceLineGroup"
msgid "Edit group..."
msgstr "Csoport szerkesztése..."

#: components/invoice/form/UcInvoiceTotals.yaml:23
#: components/worksheets/form/UcWorksheetWorkItems.yaml:331
msgid "Net"
msgstr "Nettó"

#: components/invoice/form/UcInvoiceTotals.yaml:40
#: components/worksheets/form/UcWorksheetWorkItems.yaml:347
msgid "VAT"
msgstr "ÁFA"

#: components/invoice/form/UcInvoiceViewDocumentDropdown.yaml:73
msgctxt "Invoice"
msgid "Open print document"
msgstr "Nyomtatási kép"

#: components/invoice/form/UcInvoiceViewDocumentDropdown.yaml:85
msgctxt "Invoice"
msgid "Open print document in a new browser tab."
msgstr "Számlakép megnyitása új lapon."

#: components/invoice/form/UcInvoiceViewDocumentDropdown.yaml:96
msgctxt "Invoice|Command"
msgid "Upload print document"
msgstr "Számlakép feltöltése"

#: components/invoice/form/UcInvoiceViewDocumentDropdown.yaml:112
msgctxt "Invoice|Command"
msgid "Delete print document"
msgstr "Számlakép törlése"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:43
msgctxt "InvoiceLines"
msgid "Search product/service..."
msgstr "Termék/szolgáltatás keresése..."

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:44
msgctxt "invoiceLines"
msgid "search..."
msgstr "keresés..."

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:45
msgctxt "InvoiceLines"
msgid "Description"
msgstr "Megnevezés"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:141
msgctxt "Invoice"
msgid "Invoice Lines"
msgstr "Tételsorok"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:154
msgctxt "Invoice|InvoiceLines"
msgid "Upload..."
msgstr "Feltöltés..."

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:155
msgctxt "Invoice|InvoiceLines|Tooltip"
msgid "Upload invoice lines from file."
msgstr "Számlasorok feltöltése fájlból."

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:171
msgctxt "Invoice|InvoiceLines|Command"
msgid "Delete"
msgstr "Törlés"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:172
msgctxt "Invoice|InvoiceLines|Tooltip"
msgid "Remove the selected lines."
msgstr "A kijelölt tételek törlése."

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:295
msgctxt "InvoiceLines"
msgid "Add line"
msgstr "Új sortétel"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:296
msgctxt "InvoiceLines"
msgid "Add new product..."
msgstr "Új termék felvétele..."

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:297
msgctxt "InvoiceLines"
msgid "Search for product/service..."
msgstr "Termék/szolgáltatás keresése..."

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:298
msgctxt "InvoiceLines"
msgid "search..."
msgstr "keresés..."

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:302
#: components/product/Product.yaml:6
msgid "Product"
msgstr "Termék"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:390
msgctxt "InvoiceLine|ColHeader"
msgid "Adv."
msgstr "Előleg"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:391
msgctxt "invoiceLine|ColHeader|Tooltip"
msgid "Advance"
msgstr "Előleg"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:398
#: components/worksheets/form/UcWorksheetWorkItems.yaml:357
msgctxt "AbbrIntermediatedService"
msgid "IMS"
msgstr "Közv."

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:399
#: components/worksheets/form/UcWorksheetWorkItems.yaml:358
msgid "Intermediated Service"
msgstr "Közvetített szolgáltatás"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:409
#: components/worksheets/form/UcWorksheetWorkItems.yaml:295
msgctxt "Quantity Abbr"
msgid "Qty"
msgstr "Menny."

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:418
#: components/worksheets/form/UcWorksheetWorkItems.yaml:303
msgctxt "Unit Abbr"
msgid "Unit"
msgstr "M.e."

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:419
#: components/meters/form/readings/UcMeterReadings.yaml:63
#: components/settings/StatData.yaml:92
#: components/worksheets/form/UcWorksheetWorkItems.yaml:304
msgid "Unit"
msgstr "Mennyiségi egység"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:430
#: components/product/ProductPricesDataTable.yaml:76
#: components/worksheets/form/UcWorksheetWorkItems.yaml:313
msgid "Price"
msgstr "Ár"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:442
#: components/worksheets/form/UcWorksheetWorkItems.yaml:322
msgctxt "AbbrDiscount"
msgid "Disc"
msgstr "Kedv."

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:443
#: components/worksheets/form/UcWorksheetWorkItems.yaml:323
msgid "Discount"
msgstr "Kedvezmény"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:475
#: components/worksheets/form/UcWorksheetWorkItems.yaml:348
msgid "VAT Code"
msgstr "ÁFA kód"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:488
msgid "D-VAT"
msgstr "L-ÁFA"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:489
msgid "Deductible VAT amount"
msgstr "Levonható ÁFA"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:499
msgctxt "InvoiceLine|ColHeader"
msgid "Expense Type"
msgstr "Költségtípus"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:506
#: components/worksheets/form/UcWorksheetInvoiceLineAccountings.yaml:120
msgid "Cost Center"
msgstr "Költséghely"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:592
msgctxt "InvoiceLineGroup"
msgid "Add group..."
msgstr "Új csoport..."

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:644
msgctxt "InvoiceLine"
msgid "Reference invoice"
msgstr "Hivatkozott számla"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:675
msgctxt "InvoiceLines"
msgid "Select readings..."
msgstr "Óraállások kiválasztása..."

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:754
msgctxt "invoiceLines"
msgid "New meter row"
msgstr "Új mérőóra"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:786
msgid "Previous reading"
msgstr "Előző"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:829
msgid "Current reading"
msgstr "Aktuális"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:872
msgid "Consumption"
msgstr "Fogyasztás"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:880
msgid "Multiplier"
msgstr "Szorzó"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:939
msgctxt "invoiceLines"
msgid "New accounting row"
msgstr "Új elszámolás"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:955
#: components/worksheets/Worksheet.yaml:6
msgid "Worksheet"
msgstr "Munkalap"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:975
#: components/property/Property.yaml:7
msgid "Property"
msgstr "Ingatlan"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:986
msgid "Contractor"
msgstr "Alvállalkozó"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:1000
#: components/worksheets/form/UcWorksheetInvoiceLineAccountings.yaml:123
msgid "Handover Date"
msgstr "Átadás dátuma"

#: components/invoice/form/invoice-lines/UcInvoiceLines.yaml:1021
msgctxt "invoiceLineAccounting"
msgid "Quantity mismatch."
msgstr "Mennyiségi eltérés."

#: components/invoice/form/invoice-lines/UploadInvoiceLines.yaml:4
msgctxt "UploadInvoiceLines|Title"
msgid "Upload invoice lines"
msgstr "Számlasorok feltöltése"

#: components/invoice/form/invoice-lines/UploadInvoiceLines.yaml:55
msgid "One line has been imported."
msgid_plural "${n} lines have been imported."
msgstr[0] "Egy tételsor importálása megtörtént."
msgstr[1] "Nem történt változás."

#: components/invoice/form/invoice-lines/UploadInvoiceLines.yaml:63
msgid "No lines have been imported."
msgstr "Nem importáltunk egy tételsort sem."

#: components/invoice/form/invoice-lines/UploadInvoiceLines.yaml:71
msgid "One line imported."
msgid_plural "${n} lines imported."
msgstr[0] "Importálva egy tételsor."
msgstr[1] "Importálva ${n} tételsor."

#: components/invoice/form/invoice-lines/UploadInvoiceLines.yaml:122
msgctxt "UploadInvoiceLines"
msgid "Download template"
msgstr "Sablon letöltése"

#: components/invoice/form/invoice-lines/UploadInvoiceLines.yaml:147
msgctxt "UploadInvoiceLines"
msgid "Invoice lines file"
msgstr "Számla tételsorok fájl"

#: components/invoice/form/invoice-lines/UploadInvoiceLines.yaml:149
msgctxt "UploadInvoiceLines"
msgid "Please select a filled-in template file."
msgstr "Válassza ki a kitöltött sablon fájlt."

#: components/invoice/form/invoice-lines/UploadInvoiceLines.yaml:179
msgctxt "UploadInvoiceLines"
msgid "Upload lines"
msgstr "Tételsorok feltöltése"

#: components/invoice/form/invoice-references/InvoiceReferenceSearch.yaml:4
msgctxt "Invoice"
msgid "Search Reference"
msgstr "Hivatkozások keresése"

#: components/invoice/form/invoice-references/InvoiceReferenceSearch.yaml:44
#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:110
#: components/rental/Rental.yaml:55
msgid "Rentals"
msgstr "Bérlemények"

#: components/invoice/form/invoice-references/InvoiceReferenceSearch.yaml:53
#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:81
msgid "Clients"
msgstr "Ügyfelek"

#: components/invoice/form/invoice-references/InvoiceReferenceSearch.yaml:64
#: components/property/Property.yaml:45
msgid "Properties"
msgstr "Ingatlanok"

#: components/invoice/form/invoice-references/InvoiceReferenceSearch.yaml:219
msgctxt "Search Placeholder"
msgid "Search..."
msgstr "Keresés..."

#: components/invoice/form/invoice-references/InvoiceReferenceSearch.yaml:291
msgctxt "InvoiceReferenceSearch/Submit"
msgid "Add references"
msgstr "Hivatkozás(ok) hozzáadása"

#: components/invoice/form/invoice-references/UcInvoiceReferences.yaml:22
msgctxt "InvoiceReferences"
msgid "No references added."
msgstr "Nincsenek hivatkozások."

#: components/invoice/form/invoice-references/UcInvoiceReferences.yaml:49
msgid "Please confirm deleting the reference."
msgstr "Kérem, erősítse meg a hivatkozás törlését."

#: components/invoice/form/invoice-references/UcInvoiceReferences.yaml:50
msgid "Delete reference"
msgstr "Hivatkozás törlése"

#: components/invoice/form/invoice-references/UcInvoiceReferences.yaml:71
msgid "Add reference"
msgstr "Hivatkozás hozzáadása"

#: components/invoice/invoice-generation/CompleteInvoicesAlt.yaml:4
msgctxt "CompleteInvoices|Title"
msgid "Complete Invoices"
msgstr "Számlák kiállítása"

#: components/invoice/invoice-generation/CompleteInvoicesAlt.yaml:101
msgctxt "InvoiceSync"
msgid "Filing"
msgstr "Iktatás"

#: components/invoice/invoice-generation/CompleteInvoicesAlt.yaml:102
msgctxt "InvoiceSync"
msgid "Create a register entry after issuing the invoice."
msgstr "Iktatás létrehozása a számla kiállítása után"

#: components/invoice/invoice-generation/CompleteInvoicesAlt.yaml:121
msgctxt "InvoiceSync"
msgid "Filing subject"
msgstr "Iktatás tárgya"

#: components/invoice/invoice-generation/CompleteInvoicesAlt.yaml:122
msgctxt "InvoiceSync"
msgid "Use the given subject for the register entries."
msgstr "A megadott tárgy használata az iktatások létrehozása során."

#: components/invoice/invoice-generation/CompleteInvoicesAlt.yaml:204
msgctxt "CompleteInvoices|Submit"
msgid "Complete invoices"
msgstr "Számlák kiállítása"

msgctxt "CompleteInvoices|Submit"
msgid "It cannot be modified after synchronization."
msgstr "Szinkronizálás után már nem módosítható."

#: components/invoice/invoice-generation/InvoiceGeneration.yaml:5
msgctxt "InvoiceGeneration/title"
msgid "Invoice generation"
msgstr "Számlagenerálás"

#: components/invoice/invoice-generation/InvoiceGeneration.yaml:61
msgctxt "InvoiceGeneration|TabHeader"
msgid "Invoices"
msgstr "Számlák"

#: components/invoice/invoice-generation/InvoiceGeneration.yaml:72
msgctxt "InvoiceGeneration|TabHeader"
msgid "Controlling"
msgstr "Controlling"

#: components/invoice/invoice-generation/InvoiceGeneration.yaml:83
msgctxt "InvoiceGeneration|TabHeader"
msgid "Invoice lines"
msgstr "Soradatok"

#: components/invoice/invoice-generation/UcInvoiceGenerationControlling.yaml:394
msgid "Reload data from the server"
msgstr "Az adatok újratöltése a szerverről"

#: components/invoice/invoice-generation/UcInvoiceGenerationControlling.yaml:397
msgctxt "InvoiceGenerationControlling"
msgid "Reload data"
msgstr "Adatok betöltése"

#: components/invoice/invoice-generation/UcInvoiceGenerationControlling.yaml:406
msgctxt "InvoiceGenerationControlling"
msgid "Invoice groups"
msgstr "Számlázási csoportok"

#: components/invoice/invoice-generation/UcInvoiceGenerationInvoiceLines.yaml:18
msgctxt "InvoiceGeneration|ColumnHeader"
msgid "Partner"
msgstr "Ügyfél"

#: components/invoice/invoice-generation/UcInvoiceGenerationInvoiceLines.yaml:28
msgctxt "InvoiceGeneration|ColumnHeader"
msgid "Rental"
msgstr "Bérlemény"

#: components/invoice/invoice-generation/UcInvoiceGenerationInvoiceLines.yaml:38
msgctxt "InvoiceGeneration|ColumnHeader"
msgid "Site"
msgstr "Telephely"

#: components/invoice/invoice-generation/UcInvoiceGenerationInvoiceLines.yaml:42
msgctxt "InvoiceGeneration|ColumnHeader"
msgid "Item"
msgstr "Tétel"

#: components/invoice/invoice-generation/UcInvoiceGenerationInvoiceLines.yaml:52
msgctxt "InvoiceGeneration|ColumnHeader"
msgid "Serial"
msgstr "Sorozatszám"

#: components/invoice/invoice-generation/UcInvoiceGenerationInvoiceLines.yaml:144
msgid "Draft invoice lines"
msgstr "Számlatervezetek"

#: components/invoice/invoice-generation/UcInvoiceGenerationInvoiceLines.yaml:149
msgctxt "ExportFilename"
msgid "draft-invoice-lines"
msgstr "számlatervezetek"

#: components/invoice/invoice-generation/UcInvoiceGenerationInvoices.yaml:137
msgid "Draft Invoices"
msgstr "Számlatervezetek"

#: components/invoice/invoice-generation/UcInvoiceGenerationInvoices.yaml:142
msgctxt "ExportFilename"
msgid "draft-invoices"
msgstr "számlatervezetek"

#: components/invoice/invoice-generation/UcInvoiceGenerationInvoices.yaml:255
msgctxt "Invoices"
msgid "Period start"
msgstr "Időszak kezdete"

#: components/invoice/invoice-generation/UcInvoiceGenerationInvoices.yaml:265
msgctxt "Invoices"
msgid "Period end"
msgstr "Időszak vége"

#: components/invoice/invoice-generation/UcInvoiceGenerationInvoices.yaml:276
msgctxt "InvoiceBrowserView"
msgid "Billing category"
msgstr "Számlázási kategória"

#: components/invoice/invoice-generation/UcInvoiceGenerationInvoices.yaml:279
msgctxt "InvoiceBrowserView"
msgid "Net"
msgstr "Nettó"

#: components/invoice/invoice-generation/UcInvoiceGenerationInvoices.yaml:285
msgctxt "InvoiceBrowserView"
msgid "VAT"
msgstr "ÁFA"

#: components/invoice/invoice-generation/UcInvoiceGenerationInvoices.yaml:291
msgctxt "InvoiceBrowserView"
msgid "Amount"
msgstr "Összeg"

#: components/invoice/invoice-generation/UcInvoiceGenerationInvoices.yaml:297
msgctxt "InvoiceBrowserView"
msgid "Currency"
msgstr "Deviza"

#: components/invoice/invoice-generation/UcInvoiceGenerationInvoices.yaml:300
msgctxt "InvoiceBrowserView"
msgid "Invoice date"
msgstr "Számla dátuma"

#: components/invoice/invoice-generation/UcInvoiceGenerationInvoices.yaml:304
msgctxt "InvoiceBrowserView"
msgid "Fulfillment date"
msgstr "Teljesítés dátuma"

#: components/invoice/invoice-generation/UcInvoiceGenerationInvoices.yaml:308
msgctxt "InvoiceBrowserView"
msgid "Due date"
msgstr "Fizetési határidő"

#: components/invoice/invoice-generation/UcInvoiceGenerationInvoices.yaml:312
msgctxt "InvoiceBrowserView"
msgid "Accounting date"
msgstr "Számviteli telj."

#: components/invoice/invoice-generation/UcInvoiceGenerationInvoices.yaml:320
msgctxt "InvoiceBrowserView"
msgid "Status"
msgstr "Státusz"

#: components/invoice/invoice-generation/UcInvoiceGenerationInvoices.yaml:369
msgctxt "Invoices"
msgid "Bulk edit..."
msgstr "Csoportos szerkesztés..."

#: components/invoice/invoice-generation/UcInvoiceGenerationInvoices.yaml:421
msgctxt "DraftInvoices|Submit"
msgid "Issue Invoices"
msgstr "Számlák kiállítása"

#: components/invoice/invoice-generation/UcInvoiceGenerationInvoices.yaml:428
msgctxt "InvoiceGeneration"
msgid "Download invoice lines"
msgstr "Számlasorok letöltése"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:68
msgid "Companies"
msgstr "Saját cégek"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:94
msgid "Client Groups"
msgstr "Ügyfélcsoportok"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:122
msgid "Product Groups"
msgstr "Termékcsoportok"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:128
msgid "Meter Groups"
msgstr "Mérőóra csoportok"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:133
msgid "Contract types"
msgstr "Szerződés típusok"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:173
msgctxt "InvoiceGenerator"
msgid "Include"
msgstr "Tartalmaz"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:176
msgctxt "InvoiceGenerator"
msgid "Exclude"
msgstr "Nem tartalmaz"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:281
msgid "One invoice created."
msgid_plural "${n}invoices created."
msgstr[0] "Egy számla elkészült."
msgstr[1] "${n} számla elkészült."

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:313
msgctxt "InvoiceGenerator"
msgid "Filters"
msgstr "Szűrőfeltételek"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:326
msgctxt "InvoiceGenerator"
msgid "Product Invoice Groups"
msgstr "Számlázási csoportok"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:340
msgctxt "InvoiceGenerator"
msgid "Include works from worksheets"
msgstr "Munkák számlázása"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:355
msgctxt "InvoiceGenerator"
msgid "Other Filters"
msgstr "Egyéb szűrőfeltételek"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:403
msgctxt "InvoiceGenerator"
msgid "Add Filter"
msgstr "Szűrőfeltétel hozzáadása"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:439
msgctxt "InvoiceGenerator"
msgid "No filters"
msgstr "Nincsenek szűrőfeltételek"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:468
msgctxt "InvoiceGenerator"
msgid "Remove"
msgstr "Eltávolítás"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:493
msgctxt "InvoiceGenerator"
msgid "Parameters"
msgstr "Paraméterek"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:498
msgctxt "InvoiceGenerator"
msgid "Billing Period Start"
msgstr "Számlázási időszak kezdete"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:508
msgctxt "InvoiceGenerator"
msgid "Start of Period"
msgstr "Az időszak kezdete"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:514
msgctxt "InvoiceGenerator"
msgid "Billing Period End"
msgstr "Számlázási időszak vége"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:524
msgctxt "InvoiceGenerator"
msgid "End of Period"
msgstr "Időszak vége"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:530
msgctxt "InvoiceGenerator"
msgid "Invoice Date"
msgstr "Számla dátuma"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:545
msgctxt "InvoiceGenerator"
msgid "Fulfillment Date"
msgstr "Teljesítés dátuma"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:560
msgctxt "InvoiceGenerator"
msgid "Due Date"
msgstr "Esedékesség dátuma"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:576
msgctxt "InvoiceGenerator"
msgid "Meter Readings From"
msgstr "Leolvasások induló dátuma"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:590
msgctxt "InvoiceGenerator"
msgid "Invoice Tags"
msgstr "Számla címkék"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:615
msgctxt "InvoiceGenerator"
msgid "Options"
msgstr "Opciók"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:620
msgctxt "InvoiceGenerator"
msgid "Do not charge past periods, even if no invoice has been issued."
msgstr ""
"Megelőző időszakok kihagyása abban az esetben is, ha nem lett számla "
"kiállítva."

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:626
msgctxt "InvoiceGenerator"
msgid "Exclude past periods."
msgstr "Előző időszakok kihagyása."

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:636
msgctxt "InvoiceGenerator"
msgid "Include zero consumptions"
msgstr "Nulla fogyasztásokat is tartalmazzon"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:642
msgid "Charge all consumptions, even minimal ones."
msgstr "Mennyiségtől függetlenül tartalmazza az összes fogyasztást."

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:648
msgctxt "InvoiceGenerator"
msgid "Ignore meter billing thresholds."
msgstr "Hagyja figyelmen kívül a számlázási küszöbértékeket."

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:658
msgctxt "InvoiceGenerator"
msgid "Generate Invoices"
msgstr "Számlák generálása"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:698
msgctxt "InvoiceGeneratorPanel"
msgid "Last task"
msgstr "Utolsó feladat"

#: components/invoice/invoice-generation/UcInvoiceGeneratorControls.yaml:718
msgctxt "InvoiceGeneratorPanel"
msgid "Reload"
msgstr "Frissítés"

#: components/invoice/payments/UcInvoicePayments.yaml:160
msgctxt "InvoicePayments"
msgid "Total"
msgstr "Végösszeg"

#: components/invoice/payments/UcInvoicePayments.yaml:183
#: components/payments/form/UcPaymentInvoices.yaml:28
msgctxt "Invoice"
msgid "No payment required"
msgstr "Pénzügyi teljesítést nem igényel"

#: components/invoice/payments/UcInvoicePayments.yaml:200
msgctxt "Invoice"
msgid "Uncollectible"
msgstr "Behajthatatlan"

#: components/invoice/payments/UcInvoicePayments.yaml:227
msgctxt "InvoicePayments"
msgid "New payment"
msgstr "Új kiegyenlítés"

#: components/invoice/payments/UcInvoicePayments.yaml:233
msgctxt "InvoicePayments"
msgid "New cash payment..."
msgstr "Pénztári be/kifizetés..."

#: components/invoice/payments/UcInvoicePayments.yaml:242
msgctxt "InvoicePayments"
msgid "New banking payment..."
msgstr "Banki tranzakció..."

#: components/invoice/payments/UcInvoicePayments.yaml:253
msgctxt "InvoicePayments"
msgid "New reconciliation..."
msgstr "Összevezetés..."

#: components/invoice/payments/UcInvoicePayments.yaml:262
msgctxt "InvoicePayments"
msgid "Bad debt..."
msgstr "Behajthatatlan követelés..."

#: components/invoice/primitives/UcInvoiceKindBadge.yaml:14
msgctxt "InvoiceKind"
msgid "Sentence"
msgstr "Mondat"

#: components/invoice/primitives/UcInvoiceMiniCard.yaml:25
msgctxt "Invoice"
msgid "Invoice"
msgstr "Számla"

#: components/invoice/primitives/UcInvoiceStatusBadge.yaml:15
msgctxt "Status"
msgid "Sentence"
msgstr "Mondat"

#: components/invoice/primitives/UcInvoiceTypeBadge.yaml:23
msgctxt "InvoiceType|Abbrev"
msgid "N"
msgstr "N"

#: components/invoice/primitives/UcInvoiceTypeBadge.yaml:24
msgctxt "InvoiceType|Abbrev"
msgid "S"
msgstr "S"

#: components/invoice/primitives/UcInvoiceTypeBadge.yaml:25
msgctxt "InvoiceType|Abbrev"
msgid "C"
msgstr "K"

#: components/invoice/primitives/UcInvoiceTypeBadge.yaml:26
msgctxt "InvoiceType|Abbrev"
msgid "PF"
msgstr "PF"

#: components/invoice/primitives/UcInvoiceTypeBadge.yaml:28
#: translations-openapi.yaml:59
msgctxt "InvoiceType"
msgid "Normal"
msgstr "Normál"

#: components/invoice/primitives/UcInvoiceTypeBadge.yaml:32
msgctxt "InvoiceType|Tooltip"
msgid "Advance"
msgstr "Előleg"

#: components/invoice/primitives/UcInvoiceTypeBadge.yaml:33
msgctxt "InvoiceType|Tooltip"
msgid "Advance invoice"
msgstr "Előlegszámla"

#: components/invoice/views/InvoiceLinesView.yaml:44
msgctxt "InvoiceLines"
msgid "Invoices"
msgstr "Számlák"

#: components/invoice/views/InvoiceLinesView.yaml:49
msgctxt "filename"
msgid "company-invoices"
msgstr "saját-cég-számlák"

#: components/invoice/views/InvoiceLinesView.yaml:56
msgctxt "Invoice"
msgid "Invoice kind"
msgstr "Jelleg"

#: components/invoice/views/InvoiceLinesView.yaml:59
msgctxt "Invoice"
msgid "Invoice type"
msgstr "Típus"

#: components/invoice/views/InvoiceLinesView.yaml:62
msgctxt "Invoice"
msgid "Invoice number"
msgstr "Számlaszám"

#: components/invoice/views/InvoiceLinesView.yaml:79
msgctxt "InvoiceLine"
msgid "Description"
msgstr "Megnevezés"

#: components/invoice/views/InvoiceLinesView.yaml:82
msgctxt "InvoiceLine"
msgid "Quantity"
msgstr "Mennyiség"

#: components/invoice/views/InvoiceLinesView.yaml:87
msgctxt "InvoiceLine"
msgid "Unit"
msgstr "M.e."

#: components/invoice/views/InvoiceLinesView.yaml:90
msgctxt "InvoiceLine"
msgid "Price"
msgstr "Egységár"

#: components/invoice/views/InvoiceLinesView.yaml:95
msgctxt "InvoiceLine"
msgid "Discount"
msgstr "Kedvezmény"

#: components/invoice/views/InvoiceLinesView.yaml:100
msgctxt "InvoiceLine"
msgid "Net"
msgstr "Nettó"

#: components/invoice/views/InvoiceLinesView.yaml:105
msgctxt "InvoiceLine"
msgid "VAT"
msgstr "ÁFA"

#: components/invoice/views/InvoiceLinesView.yaml:110
msgctxt "InvoiceLine"
msgid "Amount"
msgstr "Bruttó"

#: components/invoice/views/InvoiceLinesView.yaml:115
msgctxt "InvoiceLine"
msgid "Tax Code"
msgstr "ÁFA kód"

#: components/invoice/views/InvoiceLinesView.yaml:121
msgctxt "Invoice"
msgid "Period start"
msgstr "Számlázási időszak kezdete"

#: components/invoice/views/InvoiceLinesView.yaml:125
msgctxt "Invoice"
msgid "Period end"
msgstr "Számlázási időszak vége"

#: components/invoice/views/InvoicesFilters.yaml:49
msgctxt "Invoices"
msgid "date filter type"
msgstr "dátumszűrő típusa"

#: components/invoice/views/InvoicesFilters.yaml:82
msgctxt "Invoices"
msgid "Unpaid"
msgstr "Kiegyenlítetlen"

#: components/invoice/views/InvoicesFilters.yaml:99
msgid "Load"
msgstr "Betöltés"

#: components/jobs/JobModal.yaml:4
msgid "Job"
msgstr "Munka"

#: components/jobs/JobModal.yaml:94
msgctxt "Job"
msgid "Status"
msgstr "Státusz"

#: components/jobs/JobModal.yaml:107
msgctxt "Job"
msgid "Job type"
msgstr "Folyamat típusa"

#: components/jobs/JobModal.yaml:120 templates.yaml:138
msgid "Created at"
msgstr "Készült"

#: components/jobs/JobModal.yaml:133 templates.yaml:120
msgid "Created by"
msgstr "Készítette"

#: components/jobs/JobModal.yaml:154
msgid "Job data"
msgstr "Folyamat adatok"

#: components/jobs/JobModal.yaml:166
msgid "Job result"
msgstr "Eredmény"

#: components/jobs/JobModal.yaml:178
msgid "Restart"
msgstr "Újraindítás"

#: components/jobs/Jobs.yaml:4
msgid "Jobs"
msgstr "Folyamatok"

#: components/jobs/Jobs.yaml:23
msgctxt "Jobs"
msgid "Jobs"
msgstr "Folyamatok"

#: components/jobs/Jobs.yaml:33
msgctxt "Jobs"
msgid "Number"
msgstr "Sorszám"

#: components/jobs/Jobs.yaml:42
msgctxt "Jobs"
msgid "Status"
msgstr "Státusz"

#: components/jobs/Jobs.yaml:58
msgctxt "Jobs"
msgid "Job type"
msgstr "Folyamat típusa"

#: components/jobs/Jobs.yaml:61
msgctxt "Jobs"
msgid "User"
msgstr "Felhasználó"

#: components/jobs/Jobs.yaml:66
msgctxt "Jobs"
msgid "Submit time"
msgstr "Küldés"

#: components/jobs/JobsV2.yaml:4
msgctxt "Jobs|Title"
msgid "Jobs"
msgstr "Folyamatok"

#: components/jobs/JobsV2.yaml:42
msgctxt "Jobs"
msgid "Parent"
msgstr "Forrás"

#: components/jobs/JobsV2.yaml:65
msgctxt "Jobs"
msgid "Bulk"
msgstr "Tömeges műv."

#: components/jobs/JobsV2.yaml:70
msgctxt "Jobs"
msgid "Key"
msgstr "Kulcs"

#: components/jobs/JobsV2.yaml:73
msgctxt "Jobs"
msgid "Queue"
msgstr "Feldolgozási sor"

#: components/jobs/JobsV2.yaml:81
msgctxt "Jobs"
msgid "Submitter"
msgstr "Felhasználó"

#: components/jobs/job/Job.yaml:5
msgctxt "Job|Title"
msgid "Job"
msgstr "Folyamat"

#: components/jobs/job/JobHandlerControl.yaml:54
msgctxt "JobHandler|Command"
msgid "Open job details"
msgstr "Részletek"

#: components/jobs/job/JobHandlerControl.yaml:55
msgctxt "JobHandler|Command"
msgid "Reload job status"
msgstr "Az adatok újratöltése"

#: components/jobs/job/JobHeader.yaml:14
msgctxt "Job|ModalHeader"
msgid "Job"
msgstr "Feladat"

#: components/jobs/job/JobHeader.yaml:133
msgctxt "Job"
msgid "Retry"
msgstr "Újrakezdés"

#: components/jobs/job/JobHeader.yaml:144
msgctxt "Job"
msgid "Cancel"
msgstr "Megszakítás"

#: components/jobs/job/JobHeader.yaml:159
msgctxt "LetterRegister"
msgid "Lock entry"
msgstr "Bejegyzés zárolása"

#: components/jobs/job/JobHeader.yaml:173
msgctxt "LetterRegister"
msgid "Delete entry"
msgstr "Bejegyzés törlése"

#: components/jobs/job/JobRunView.yaml:50
msgctxt "Job"
msgid "Start time"
msgstr "Kezdés ideje"

#: components/jobs/job/JobRunView.yaml:65
msgctxt "Job"
msgid "End time"
msgstr "Befejezés ideje"

#: components/jobs/job/JobView.yaml:34
msgctxt "Job"
msgid "Job ID"
msgstr "Feladat AZ"

#: components/jobs/job/JobView.yaml:42
msgctxt "Job"
msgid "Job name"
msgstr "Folyamat neve"

#: components/jobs/job/JobView.yaml:50
msgctxt "Job"
msgid "Submitter"
msgstr "Felhasználó"

#: components/jobs/job/JobView.yaml:58
msgctxt "Job"
msgid "Submit time"
msgstr "Létrehozás ideje"

#: components/jobs/job/JobView.yaml:67
msgctxt "Job"
msgid "Execution time"
msgstr "Futtatás időpontja"

#: components/jobs/job/JobView.yaml:76
msgctxt "Job"
msgid "Message"
msgstr "Eredmény"

#: components/jobs/job/UcJobNameBadge.yaml:14
msgctxt "JobName"
msgid "Sentence"
msgstr "Mondat"

#: components/meters/CreateMeter.yaml:4
msgid "Create Meter"
msgstr "Új mérőóra felvétele"

#: components/meters/CreateMeter.yaml:155
msgctxt "LetterRegisterEntry/Command"
msgid "Save and create another"
msgstr "Mentés és új bejegyzés létrehozása"

#: components/meters/GenerateMeterConsumptions.yaml:4
msgctxt "GenerateMeterConsumptions|Title"
msgid "Generate Consumptions"
msgstr "Fogyasztások Generálása"

#: components/meters/GenerateMeterConsumptions.yaml:110
msgctxt "GenerateMeterConsumptions"
msgid ""
"Create consumption records from the readings available in the system between "
"the start and end dates."
msgstr ""
"Fogyasztások létrehozása a rendszerben a kezdő és záró dátumok között "
"található leolvasásokból."

#: components/meters/GenerateMeterConsumptions.yaml:124
msgctxt "GenerateMeterConsumptions"
msgid "Start date"
msgstr "Kezdő dátum"

#: components/meters/GenerateMeterConsumptions.yaml:140
msgctxt "GenerateMeterConsumptions"
msgid "End date"
msgstr "Záró dátum"

#: components/meters/GenerateMeterConsumptions.yaml:156
msgctxt "GenerateMeterConsumptions"
msgid "Exact period"
msgstr "Pontos időszak"

#: components/meters/GenerateMeterConsumptions.yaml:157
msgctxt "GenerateMeterConsumptions"
msgid ""
"Assign the specified dates as the consumption periods, even if they differ "
"from the reading dates."
msgstr ""
"Állítsa be a megadott dátumokat fogyasztási időszaknak, még akkor is, ha "
"eltérnek a leolvasási dátumoktól."

#: components/meters/GenerateMeterConsumptions.yaml:176
msgctxt "GenerateMeterConsumptions"
msgid "Contracts"
msgstr "Szerződések"

#: components/meters/GenerateMeterConsumptions.yaml:177
msgctxt "GenerateMeterConsumptions"
msgid "Search consumption data for rentals under the selected contract."
msgstr ""
"A kiválasztott szerződésekhez tartozó bérlő fogyasztásainak a keresése."

#: components/meters/GenerateMeterConsumptions.yaml:193
msgctxt "GenerateMeterConsumptions"
msgid "Companies"
msgstr "Saját cégek"

#: components/meters/GenerateMeterConsumptions.yaml:194
msgctxt "GenerateMeterConsumptions"
msgid "Search consumption data related to the selected companies' rentals."
msgstr "A kiválasztott cégekhez tartozó fogyasztások keresése."

#: components/meters/GenerateMeterConsumptions.yaml:210
msgctxt "GenerateMeterConsumptions"
msgid "Tenants"
msgstr "Bérlők"

#: components/meters/GenerateMeterConsumptions.yaml:211
msgctxt "GenerateMeterConsumptions"
msgid "Include only the selected tenant's consumptions."
msgstr "Csak a kiválasztott bérlő fogyasztásainak a keresése."

#: components/meters/GenerateMeterConsumptions.yaml:227
msgctxt "GenerateMeterConsumptions"
msgid "Rentals"
msgstr "Bérlemények"

#: components/meters/GenerateMeterConsumptions.yaml:228
msgctxt "GenerateMeterConsumptions"
msgid "Search consumption data related to the selected rentals."
msgstr "A kiválasztott bérleményekhez tartozó fogyasztások keresése."

#: components/meters/GenerateMeterConsumptions.yaml:244
msgctxt "GenerateMeterConsumptions"
msgid "Meter types"
msgstr "Típus"

#: components/meters/GenerateMeterConsumptions.yaml:245
msgctxt "GenerateMeterConsumptions"
msgid "Search consumptions only for the selecter meter tyes."
msgstr "Csak a megadott mérőóra típusok fogyasztásai között keressen."

#: components/meters/GenerateMeterConsumptions.yaml:261
msgctxt "GenerateMeterConsumptions"
msgid "Meters"
msgstr "Mérőórák"

#: components/meters/GenerateMeterConsumptions.yaml:262
msgctxt "GenerateMeterConsumptions"
msgid "Search consumption data measured by the selected meters."
msgstr "A kiválasztott mérőórákhoz tartozó fogyasztások keresése."

#: components/meters/GenerateMeterConsumptions.yaml:281
msgctxt "GenerateMeterConsumptions|Submit"
msgid "Generate"
msgstr "Generálás"

#: components/meters/Meter.yaml:49
msgid "Meters"
msgstr "Mérőórák"

#: components/meters/Meter.yaml:154
msgctxt "Meter"
msgid "Readings"
msgstr "Leolvasások"

#: components/meters/Meter.yaml:166
msgctxt "Meter"
msgid "Consumptions"
msgstr "Fogyasztások"

#: components/meters/Meter.yaml:183
msgctxt "Meter"
msgid "Auto Readings"
msgstr "Automata adatszolgáltatás"

#: components/meters/Meter.yaml:195
msgctxt "Meter"
msgid "Invoices"
msgstr "Számlák"

#: components/meters/MeterBrowser.yaml:4
msgctxt "MeterBrowser"
msgid "Meters"
msgstr "Mérőórák"

#: components/meters/MeterBrowser.yaml:42
msgctxt "ExportFilename"
msgid "meters"
msgstr "mérőórák"

#: components/meters/MeterBrowser.yaml:49
msgctxt "MeterBrowser"
msgid "Serial Number"
msgstr "Sorozatszám"

#: components/meters/MeterBrowser.yaml:58
msgctxt "MeterBrowser"
msgid "Main Meter"
msgstr "Főmérő"

#: components/meters/MeterBrowser.yaml:73
#: components/meters/MeterConsumptionBrowser.yaml:150
msgctxt "MeterBrowser"
msgid "Meter type"
msgstr "Típus"

#: components/meters/MeterBrowser.yaml:81
#: components/meters/MeterConsumptionBrowser.yaml:172
msgctxt "MeterBrowser"
msgid "Tag ID"
msgstr "Fogyasztási hely"

#: components/meters/MeterBrowser.yaml:84
msgctxt "MeterBrowser"
msgid "DevEUI"
msgstr "DevEUI"

#: components/meters/MeterBrowser.yaml:87
msgctxt "MeterBrowser"
msgid "Unit"
msgstr "Egység"

#: components/meters/MeterBrowser.yaml:90
msgctxt "MeterBrowser"
msgid "Mt."
msgstr "Szorzó"

#: components/meters/MeterBrowser.yaml:94
msgctxt "MeterBrowser"
msgid "Site"
msgstr "Telephely"

#: components/meters/MeterBrowser.yaml:103
#: components/meters/MeterConsumptionBrowser.yaml:163
msgctxt "MeterBrowser"
msgid "Description"
msgstr "Leírás"

#: components/meters/MeterBrowser.yaml:106
msgctxt "MeterBrowser"
msgid "Model"
msgstr "Modell/Típus"

#: components/meters/MeterBrowser.yaml:109
msgctxt "MeterBrowser"
msgid "Valid From"
msgstr "Érvényesség kezdete"

#: components/meters/MeterBrowser.yaml:113
msgctxt "MeterBrowser"
msgid "Valid To"
msgstr "Érvényesség vége"

#: components/meters/MeterBrowser.yaml:117
msgctxt "MeterBrowser"
msgid "Groups"
msgstr "Csoportok"

#: components/meters/MeterBrowser.yaml:123
msgctxt "MeterBrowser"
msgid "Rentals"
msgstr "Bérlemények"

#: components/meters/MeterBrowser.yaml:124
msgctxt "MeterBrowser"
msgid "Current rentals"
msgstr "Aktuális bérlemények"

#: components/meters/MeterBrowser.yaml:153
msgctxt "MeterBrowser"
msgid "Tenants"
msgstr "Bérlők"

#: components/meters/MeterBrowser.yaml:154
msgctxt "MeterBrowser"
msgid "Current tenants"
msgstr "Aktuális bérlők"

#: components/meters/MeterBrowser.yaml:172
msgctxt "MeterBrowser"
msgid "Lr. date"
msgstr "Ul dátum"

#: components/meters/MeterBrowser.yaml:173
msgctxt "MeterBrowser"
msgid "Latest reading date"
msgstr "Utolsó leolvasás dátuma"

#: components/meters/MeterBrowser.yaml:177
msgctxt "MeterBrowser"
msgid "Lr."
msgstr "Ul állás"

#: components/meters/MeterBrowser.yaml:178
msgctxt "MeterBrowser"
msgid "Latest reading"
msgstr "Utolsó leolvasás állása"

#: components/meters/MeterBrowser.yaml:188
msgctxt "MeterBrowser"
msgid "L inv. date"
msgstr "Usz dátum"

#: components/meters/MeterBrowser.yaml:189
msgctxt "MeterBrowser"
msgid "Latest invoiced reading date"
msgstr "Az utolsó számlázott leolvasás dátuma"

#: components/meters/MeterBrowser.yaml:193
msgctxt "MeterBrowser"
msgid "L inv. r."
msgstr "Usz állás"

#: components/meters/MeterBrowser.yaml:194
msgctxt "MeterBrowser"
msgid "Latest invoiced reading"
msgstr "Az utolsó számlázott leolvasás állása"

#: components/meters/MeterBrowser.yaml:219
msgctxt "MeterBrowser"
msgid "Hide inactive meters"
msgstr "Inaktív órák  elrejtése"

#: components/meters/MeterBrowser.yaml:227
msgctxt "MeterBrowser"
msgid "New meter"
msgstr "Új mérőóra"

#: components/meters/MeterConsumptionBrowser.yaml:9
msgid "Meter Consumptions"
msgstr "Mérőóra Fogyasztások"

#: components/meters/MeterConsumptionBrowser.yaml:87
msgctxt "MeterConsumptionBrowser"
msgid "Meter Consumptions"
msgstr "Mérőóra Fogyasztások"

#: components/meters/MeterConsumptionBrowser.yaml:91
msgctxt "MeterConsumptionBrowser|ExportFilename"
msgid "meter-consumptions"
msgstr "mérőóra-fogyasztások"

#: components/meters/MeterConsumptionBrowser.yaml:100
msgctxt "MeterConsumptionBrowser"
msgid "Commands"
msgstr "Parancsok"

#: components/meters/MeterConsumptionBrowser.yaml:108
msgctxt "MeterConsumptionBrowser"
msgid "Invoice"
msgstr "Számla"

#: components/meters/MeterConsumptionBrowser.yaml:128
#: components/rental/views/RentalServices.yaml:201
msgctxt "MeterConsumptionBrowser"
msgid "Meter"
msgstr "Mérőóra"

#: components/meters/MeterConsumptionBrowser.yaml:182
msgctxt "MeterConsumptionBrowser"
msgid "Start date"
msgstr "Kezdés dátuma"

#: components/meters/MeterConsumptionBrowser.yaml:192
msgctxt "MeterConsumptionBrowser"
msgid "Start reading"
msgstr "Kezdő állás"

#: components/meters/MeterConsumptionBrowser.yaml:203
msgctxt "MeterConsumptionBrowser"
msgid "End date"
msgstr "Záró dátum"

#: components/meters/MeterConsumptionBrowser.yaml:213
msgctxt "MeterConsumptionBrowser"
msgid "End reading"
msgstr "Záró állás"

#: components/meters/MeterConsumptionBrowser.yaml:223
msgctxt "MeterConsumptionBrowser"
msgid "Total"
msgstr "Végösszeg"

#: components/meters/MeterConsumptionBrowser.yaml:230
msgctxt "MeterConsumptionBrowser"
msgid "Unit"
msgstr "Mennyiségi egység"

#: components/meters/MeterConsumptionBrowser.yaml:234
msgctxt "MeterConsumptionBrowser"
msgid "Billing multiplier"
msgstr "Számlázási szorzó"

#: components/meters/MeterConsumptionBrowser.yaml:237
msgctxt "MeterConsumptionBrowser"
msgid "Billing category"
msgstr "Számlázási kategória"

#: components/meters/MeterConsumptionBrowser.yaml:240
msgctxt "MeterConsumptionBrowser"
msgid "Non-billable"
msgstr "Nem továbbszámlázott"

#: components/meters/MeterConsumptionBrowser.yaml:244
msgctxt "MeterConsumptionBrowser"
msgid "Tariff"
msgstr "Tarifa"

#: components/meters/MeterConsumptionBrowser.yaml:247
msgctxt "MeterConsumptionBrowser"
msgid "Rental"
msgstr "Bérlemény"

#: components/meters/MeterConsumptionBrowser.yaml:269
msgctxt "MeterConsumptionBrowser"
msgid "Consumer"
msgstr "Fogyasztó"

#: components/meters/MeterConsumptionBrowser.yaml:337
msgctxt "MeterConsumptionBrowser"
msgid "Unbilled only"
msgstr "Nem számlázott"

#: components/meters/MeterConsumptionBrowser.yaml:348
msgctxt "MeterConsumptionBrowser"
msgid "Upload readings..."
msgstr "Óraállások fetöltése..."

#: components/meters/MeterConsumptionBrowser.yaml:365
msgctxt "GenerateMeterConsumptions|Submit"
msgid "Generate Consumptions"
msgstr "Fogyasztások generálása"

#: components/meters/MeterConsumptionBrowser.yaml:372
msgctxt "MeterConsumptionBrowser"
msgid "Add consumption..."
msgstr "Új fogyasztás..."

#: components/meters/MeterConsumptionBrowser.yaml:390
msgctxt "MeterConsumptionBrowser"
msgid "Delete consumption"
msgstr "Fogyasztás törlése"

#: components/meters/MeterConsumptionBrowser.yaml:407
msgctxt "MeterConsumptions|Submit"
msgid "Generate Invoices"
msgstr "Számlák generálása"

#: components/meters/MeterDataExchange.yaml:4
msgid "Meter Data Exchange"
msgstr "Mérőóra-adatcsere"

#: components/meters/MeterDataExchange.yaml:48
msgid "One event has been imported."
msgid_plural "${n} events have been imported."
msgstr[0] "Egy esemény importálása megtörtént."
msgstr[1] "Nem történt változás."

#: components/meters/MeterDataExchange.yaml:56
msgid "No events have been imported."
msgstr "Nem importáltunk egy eseményt sem."

#: components/meters/MeterDataExchange.yaml:116
msgctxt "MeterDataExchange"
msgid "Download events"
msgstr "Események letöltése"

#: components/meters/MeterDataExchange.yaml:147
msgctxt "MeterDataExchange"
msgid "Events file"
msgstr "Események állomány"

msgctxt "MeterDataExchange"
msgid ""
"The sensor-meter settings are exchanged using an Excel spreadsheet. The "
"current sensor events can be downloaded from here."
msgstr ""
"A szenzor-mérőóra beállítások adatcseréje Excel táblázat segítségével "
"történik. A mindenkor aktuális szenzor események innen tölthetőek le."

msgctxt "MeterDataExchange"
msgid "New events can be uploaded to the system using the form below."
msgstr "Új események az alábbi űrlap segítségével tölthetőek fel a rendszerbe."

#: components/meters/MeterDataExchange.yaml:149
msgid ""
"Only XLSX files are allowed. It must contain at least serial_number and "
"meter_type columns."
msgstr ""
"Csak XLSX állományt lehet feltölteni. Minimálisan tartalmaznia kell "
"sorozatszám és fajta oszlopokat."

#: components/meters/MeterDataExchange.yaml:179
msgctxt "MeterDataExchange"
msgid "Upload events"
msgstr "Események feltöltése"

#: components/meters/ReplaceMeter.yaml:4
msgctxt "ReplaceMeterModal.Title"
msgid "Replace Meter"
msgstr "Mérőóra csere"

#: components/meters/ReplaceMeter.yaml:119
msgctxt "ReplaceMeterModal"
msgid "Replacement time"
msgstr "Csere időpontja"

#: components/meters/ReplaceMeter.yaml:139
msgctxt "ReplaceMeterModal"
msgid "Old device"
msgstr "Leszerelt eszköz"

#: components/meters/ReplaceMeter.yaml:147
msgctxt "ReplaceMeterModal"
msgid "Meter"
msgstr "Mérőóra"

#: components/meters/ReplaceMeter.yaml:186
msgctxt "ReplaceMeterModal"
msgid "Reading value"
msgstr "Mérőállás"

#: components/meters/ReplaceMeter.yaml:213
msgctxt "ReplaceMeter"
msgid "Photo"
msgstr "Fénykép"

#: components/meters/ReplaceMeter.yaml:221
msgctxt "ReplaceMeter"
msgid "The photo of the gauge if available."
msgstr "A leolvasásról készült fotó"

#: components/meters/ReplaceMeter.yaml:236
msgctxt "ReplaceMeterModal"
msgid "Notes"
msgstr "Megjegyzés"

#: components/meters/ReplaceMeter.yaml:255
msgctxt "ReplaceMeterModal"
msgid "New device"
msgstr "Felszerelt eszköz"

#: components/meters/ReplaceMeter.yaml:264
msgctxt "ReplaceMeterModal"
msgid "Device"
msgstr "Eszköz"

#: components/meters/ReplaceMeter.yaml:313
msgctxt "ReplaceMeterModal"
msgid "Serial number"
msgstr "Sorozatszám"

#: components/meters/ReplaceMeter.yaml:329
msgctxt "ReplaceMeterModal"
msgid "DevEUI"
msgstr "DevEUI"

#: components/meters/ReplaceMeter.yaml:343
msgctxt "ReplaceMeterModal"
msgid "Location Code"
msgstr "Hely"

#: components/meters/ReplaceMeter.yaml:420
msgctxt "ReplaceMeterModal"
msgid "Replace Meter"
msgstr "Mérőóra cseréje"

#: components/meters/UploadMeterReadings.yaml:4
msgctxt "UploadMeterReadings|Title"
msgid "Upload Meter Readings"
msgstr "Mérőleolvasások feltöltése"

#: components/meters/UploadMeterReadings.yaml:33
msgctxt "UploadMeterReadings"
msgid "No records have been imported."
msgstr "Nem importáltunk egy rekordot sem."

#: components/meters/UploadMeterReadings.yaml:34
msgctxt "UploadMeterReadings"
msgid ""
"%(readings)s readings and %(consumptions)s consumptions have been imported."
msgstr "%(readings)s leolvasás és %(consumptions)s fogyasztás lett importálva."

#: components/meters/UploadMeterReadings.yaml:92
msgid "One record has been imported."
msgid_plural "${n} records have been imported."
msgstr[0] "Egy rekord importálása megtörtént."
msgstr[1] "Nem történt változás."

#: components/meters/UploadMeterReadings.yaml:100
msgid "No records have been imported."
msgstr "Nem importáltunk egy rekordot sem."

#: components/meters/UploadMeterReadings.yaml:152
msgctxt "UploadMeterReadings"
msgid ""
"Upload meter readings from a template file and optionally generate "
"consumption data."
msgstr ""
"Mérőóra-állások feltöltése sablonfájlból, és opcionálisan fogyasztási adatok "
"generálása."

#: components/meters/UploadMeterReadings.yaml:172
msgctxt "UploadMeterReadings"
msgid "Events file"
msgstr "Események állomány"

#: components/meters/UploadMeterReadings.yaml:192
msgctxt "UploadMeterReadings"
msgid "Only XLSX files are allowed."
msgstr "Csak XLSX fájlok engedélyezettek."

#: components/meters/UploadMeterReadings.yaml:196
msgctxt "UploadMeterReadings"
msgid "Download template"
msgstr "Sablon letöltése"

#: components/meters/UploadMeterReadings.yaml:211
msgctxt "UploadMeterReadings"
msgid "Create consumptions"
msgstr "Fogyasztások létrehozása"

#: components/meters/UploadMeterReadings.yaml:236
msgctxt "UploadMeterReadings"
msgid "Upload"
msgstr "Feltöltés"

#: components/meters/form/charts/UcMeterCharts.yaml:67
msgctxt "MeterChartsAlert"
msgid "No data is available for the selected device."
msgstr "Az eszközhöz nem állnak rendelkezésre adatok."

#: components/meters/form/charts/UcMeterCharts.yaml:91
msgctxt "MeterCharts"
msgid "Values"
msgstr "Mérőállások"

#: components/meters/form/charts/UcMeterCharts.yaml:97
msgctxt "MeterCharts"
msgid "Time"
msgstr "Időpont"

#: components/meters/form/charts/UcMeterCharts.yaml:99
msgctxt "MeterCharts"
msgid "Raw"
msgstr "Szenzor adat"

#: components/meters/form/charts/UcMeterCharts.yaml:103
msgctxt "MeterCharts"
msgid "Calculated"
msgstr "Mérőállás"

#: components/meters/form/charts/UcMeterCharts.yaml:115
msgctxt "MeterCharts"
msgid "Consumption"
msgstr "Fogyasztás"

#: components/meters/form/charts/UcMeterCharts.yaml:138
msgctxt "MeterCharts"
msgid "Date"
msgstr "Dátum"

#: components/meters/form/charts/UcMeterCharts.yaml:151
msgctxt "MeterCharts"
msgid "Raw Value"
msgstr "Szenzor adat"

#: components/meters/form/charts/UcMeterCharts.yaml:161
msgctxt "MeterCharts"
msgid "Offset"
msgstr "Korrekció"

#: components/meters/form/charts/UcMeterCharts.yaml:167
msgctxt "MeterCharts"
msgid "Offset Value"
msgstr "Mérőállás"

#: components/meters/form/consumptions/MeterConsumption.yaml:4
msgid "Edit Meter Consumption"
msgstr "Fogyasztás szerkesztése"

#: components/meters/form/consumptions/MeterConsumption.yaml:4
msgid "Add Meter Consumption"
msgstr "Fogyasztás rögzítése"

#: components/meters/form/consumptions/MeterConsumption.yaml:117
msgctxt "MeterConsumption"
msgid "Meter"
msgstr "Mérőóra"

#: components/meters/form/consumptions/MeterConsumption.yaml:118
msgctxt "MeterConsumption"
msgid "The consuming meter"
msgstr "A fogyasztó eszköz"

#: components/meters/form/consumptions/MeterConsumption.yaml:141
msgctxt "MeterConsumption"
msgid "Consumer"
msgstr "Fogyasztó"

#: components/meters/form/consumptions/MeterConsumption.yaml:142
msgctxt "MeterConsumption"
msgid "The consumer of the resources"
msgstr "A felhasználó cég"

#: components/meters/form/consumptions/MeterConsumption.yaml:158
msgctxt "MeterConsumption"
msgid "Unit"
msgstr "Mennyiségi egység"

#: components/meters/form/consumptions/MeterConsumption.yaml:159
msgctxt "MeterConsumption"
msgid "Unit of measurement"
msgstr "Az elhasznált energia mértékegysége"

#: components/meters/form/consumptions/MeterConsumption.yaml:178
msgctxt "MeterConsumption"
msgid "Start"
msgstr "Kezdés"

#: components/meters/form/consumptions/MeterConsumption.yaml:179
msgctxt "MeterConsumption"
msgid "Start reading and it's date"
msgstr "A kezdő állás és annak dátuma"

#: components/meters/form/consumptions/MeterConsumption.yaml:193
msgctxt "MeterConsumption|InputPlaceholder"
msgid "Start reading"
msgstr "Kezdő állás"

#: components/meters/form/consumptions/MeterConsumption.yaml:203
msgctxt "MeterConsumption|InputPlaceholder"
msgid "Start date"
msgstr "Kezdés dátuma"

#: components/meters/form/consumptions/MeterConsumption.yaml:210
msgctxt "MeterConsumption"
msgid "End"
msgstr "Zárás"

#: components/meters/form/consumptions/MeterConsumption.yaml:211
msgctxt "MeterConsumption"
msgid "End reading and it's date"
msgstr "A záró állás és annak dátuma"

#: components/meters/form/consumptions/MeterConsumption.yaml:225
msgctxt "MeterConsumption|InputPlaceholder"
msgid "End reading"
msgstr "Záró állás"

#: components/meters/form/consumptions/MeterConsumption.yaml:235
msgctxt "MeterConsumption|InputPlaceholder"
msgid "End date"
msgstr "Záró dátum"

#: components/meters/form/consumptions/MeterConsumption.yaml:244
msgctxt "MeterConsumption"
msgid "Rental"
msgstr "Bérlemény"

#: components/meters/form/consumptions/MeterConsumption.yaml:245
msgctxt "MeterConsumption"
msgid "The rental the consumption belongs to"
msgstr "A kapcsolodó bérlemény"

#: components/meters/form/consumptions/MeterConsumption.yaml:266
msgctxt "MeterConsumption"
msgid "Non billable"
msgstr "Nem továbbszámlázott"

#: components/meters/form/consumptions/MeterConsumption.yaml:267
msgctxt "MeterConsumption"
msgid "Optional flag to exclude this consumption from billing processes"
msgstr "Opcionális kapcsoló arra az esetre, ha a fogyasztást nem számlázzuk"

#: components/meters/form/consumptions/MeterConsumption.yaml:282
msgctxt "MeterConsumption"
msgid "Billing factor"
msgstr "Szorzó"

#: components/meters/form/consumptions/MeterConsumption.yaml:283
msgctxt "MeterConsumption"
msgid "Optional multiplier applied to consumption"
msgstr "Az elfogyasztott érték szorzója"

#: components/meters/form/consumptions/MeterConsumption.yaml:298
msgctxt "MeterConsumption"
msgid "Billing tariff"
msgstr "Tarifa"

#: components/meters/form/consumptions/MeterConsumption.yaml:299
msgctxt "MeterConsumption"
msgid "Tariff plan to use for billing"
msgstr "A számlázáskor használandó tarifa"

#: components/meters/form/consumptions/MeterConsumption.yaml:317
msgctxt "MeterConsumption"
msgid "Unit price"
msgstr "Egységár"

#: components/meters/form/consumptions/MeterConsumption.yaml:318
msgctxt "MeterConsumption"
msgid "Price per unit for billing"
msgstr "A számlázáskor használandó ár"

#: components/meters/form/consumptions/MeterConsumption.yaml:327
msgctxt "MeterConsumption|InputPlaceholder"
msgid "Amount"
msgstr "Összeg"

#: components/meters/form/consumptions/MeterConsumption.yaml:335
msgctxt "MeterConsumption|InputPlaceholder"
msgid "Currency"
msgstr "Pénznem"

#: components/meters/form/consumptions/MeterConsumption.yaml:349
msgctxt "MeterConsumption"
msgid "Note"
msgstr "Megjegyzés"

#: components/meters/form/consumptions/MeterConsumption.yaml:350
msgctxt "MeterConsumption"
msgid "Optional note or comment about this meter period"
msgstr "A fogyasztáshoz kapcsolódó opcionális megjegyzés"

#: components/meters/form/consumptions/MeterConsumption.yaml:402
#: components/product/ProductPrice.yaml:348
#: components/rental/form/services/RentalService.yaml:481
msgctxt "ModalButton"
msgid "Save"
msgstr "Mentés"

#: components/meters/form/consumptions/MeterConsumption.yaml:412
#: components/product/ProductPrice.yaml:358
#: components/rental/form/services/RentalService.yaml:491
msgctxt "ModalButton"
msgid "Close"
msgstr "Bezárás"

#: components/meters/form/consumptions/UcMeterConsumptions.yaml:39
msgctxt "MeterConsumptions"
msgid "Meter Consumptions"
msgstr "Mérőóra Fogyasztások"

#: components/meters/form/consumptions/UcMeterConsumptions.yaml:44
msgctxt "MeterConsumptions"
msgid "Add consumption..."
msgstr "Új fogyasztás..."

#: components/meters/form/consumptions/UcMeterConsumptions.yaml:67
msgctxt "MeterConsumptions"
msgid "No consumptions."
msgstr "Nincsenek fogyasztások"

#: components/meters/form/consumptions/UcMeterConsumptions.yaml:127
msgid "Billing factor"
msgstr "Számlázási szorzó"

#: components/meters/form/general/FieldsetMeterGeneralData.yaml:30
msgctxt "Meter"
msgid "General"
msgstr "Általános"

#: components/meters/form/general/FieldsetMeterGeneralData.yaml:37
msgctxt "Meter"
msgid "Meter type"
msgstr "Mérőóra típusa"

#: components/meters/form/general/FieldsetMeterGeneralData.yaml:50
msgctxt "Meter"
msgid "Main meter"
msgstr "Főmérő"

#: components/meters/form/general/FieldsetMeterGeneralData.yaml:75
msgctxt "Meter"
msgid "Unit and multiplier"
msgstr "Számlázási egység és szorzó"

#: components/meters/form/general/FieldsetMeterGeneralData.yaml:79
msgctxt "Meter"
msgid "The multiplier converts the readings into the given units."
msgstr "A szorzó a leolvasásokat a beállított mértékegységgé konvertálja."

#: components/meters/form/general/FieldsetMeterGeneralData.yaml:101
msgctxt "Meter"
msgid "Multiplier"
msgstr "Szorzó"

#: components/meters/form/general/FieldsetMeterGeneralData.yaml:109
msgctxt "Meter"
msgid "Model name"
msgstr "Modell/Típus"

#: components/meters/form/general/FieldsetMeterGeneralData.yaml:122
msgctxt "Meter"
msgid "Smart Device"
msgstr "Okos eszköz"

#: components/meters/form/general/FieldsetMeterGeneralData.yaml:136
msgctxt "Meter"
msgid "Groups"
msgstr "Csoportok"

#: components/meters/form/general/FieldsetMeterGeneralData.yaml:151
msgctxt "Meter"
msgid "Site"
msgstr "Telephely"

#: components/meters/form/general/FieldsetMeterGeneralData.yaml:166
msgctxt "Meter"
msgid "Description"
msgstr "Leírás"

#: components/meters/form/general/FieldsetMeterGeneralData.yaml:178
msgctxt "Meter"
msgid "Numbers"
msgstr "Sorszámok"

#: components/meters/form/general/FieldsetMeterGeneralData.yaml:185
msgctxt "Meter"
msgid "Serial number"
msgstr "Sorozatszám"

#: components/meters/form/general/FieldsetMeterGeneralData.yaml:187
msgctxt "Meter"
msgid "The device's unique serial number."
msgstr "Az eszköz egyedi sorozatszáma."

#: components/meters/form/general/FieldsetMeterGeneralData.yaml:200
msgctxt "Meter"
msgid "DevEUI"
msgstr "DevEUI"

#: components/meters/form/general/FieldsetMeterGeneralData.yaml:202
msgctxt "Meter"
msgid ""
"64-bit globally-unique Extended Unique Identifier (EUI-64) assigned by the "
"manufacturer, or the owner, of the end-device."
msgstr ""
"64 bites egyedi kód, amely az IEEE EUI64 címtartományban azonosítja a "
"konkrét eszközt, jellemzően a szenzor gyártója generálja."

#: components/meters/form/general/FieldsetMeterGeneralData.yaml:214
msgctxt "Meter"
msgid "Tag ID"
msgstr "Címke"

#: components/meters/form/general/FieldsetMeterGeneralData.yaml:216
msgctxt "Meter"
msgid "Locally-unique tag ID to be used within the company."
msgstr "Helyben használatos egyedi azonosító."

#: components/meters/form/general/FieldsetMeterGeneralData.yaml:228
msgctxt "Meter"
msgid "Barcode"
msgstr "Vonalkód"

#: components/meters/form/general/FieldsetMeterGeneralData.yaml:230
msgctxt "Meter"
msgid "Globally-unique barcode."
msgstr "Egyedi vonalkód."

#: components/meters/form/general/FieldsetMeterValidityData.yaml:15
msgctxt "Meter"
msgid "Validity"
msgstr "Érvényesség"

#: components/meters/form/general/FieldsetMeterValidityData.yaml:20
msgctxt "Meter"
msgid "Valid from"
msgstr "Érvényesség kezdete"

#: components/meters/form/general/FieldsetMeterValidityData.yaml:33
msgctxt "Meter"
msgid "Valid to"
msgstr "Érvényesség vége"

#: components/meters/form/general/MeterEditor.yaml:4
msgctxt "Meter"
msgid "Edit General Information"
msgstr "Általános információk szerkesztése"

#: components/meters/form/general/UcMeterGeneralPanel.yaml:54
msgctxt "Meter"
msgid "Type"
msgstr "Típus"

#: components/meters/form/general/UcMeterGeneralPanel.yaml:73
msgctxt "MeterTypes"
msgid "Sentence"
msgstr "Mondat"

#: components/meters/form/general/UcMeterGeneralPanel.yaml:78
msgctxt "Meter"
msgid "Unit"
msgstr "Egység"

#: components/meters/form/general/UcMeterGeneralPanel.yaml:116
msgid "The device's unique serial number."
msgstr "Az eszköz egyedi sorozatszáma."

#: components/meters/form/general/UcMeterGeneralPanel.yaml:121
msgctxt "Meter"
msgid "Smart device"
msgstr "Okos eszköz"

#: components/meters/form/general/UcMeterGeneralPanel.yaml:158
msgid ""
"64-bit globally-unique Extended Unique Identifier (EUI-64) assigned by the "
"manufacturer, or the owner, of the end-device."
msgstr ""
"64 bites egyedi kód, amely az IEEE EUI64 címtartományban azonosítja a "
"konkrét eszközt, jellemzően a szenzor gyártója generálja."

#: components/meters/form/general/UcMeterGeneralPanel.yaml:163
msgctxt "Meter"
msgid "Location Code"
msgstr "Fogyasztási hely"

#: components/meters/form/general/UcMeterGeneralPanel.yaml:165
msgid "Locally-unique tag ID to be used within the company."
msgstr "Helyben használatos egyedi azonosító."

#: components/meters/form/general/UcMeterValidityCard.yaml:13
msgctxt "Meter"
msgid "From"
msgstr "Tól"

#: components/meters/form/general/UcMeterValidityCard.yaml:13
msgctxt "Meter"
msgid "N/A"
msgstr "N/A"

#: components/meters/form/general/UcMeterValidityCard.yaml:23
msgctxt "Meter"
msgid "To"
msgstr "Ig"

#: components/meters/form/general/UcMeterValidityCard.yaml:28
msgctxt "Meter"
msgid "Indefinite"
msgstr "Határozatlan"

#: components/meters/form/invoices/UcMeterInvoices.yaml:26
msgctxt "Meter"
msgid "This meter has no related invoices."
msgstr "Nincsenek kapcsolódó számlák."

#: components/meters/form/invoices/UcMeterInvoices.yaml:38
msgctxt "MeterInvoices"
msgid "Invoice"
msgstr "Számla"

#: components/meters/form/invoices/UcMeterInvoices.yaml:53
msgctxt "MeterInvoices"
msgid "Contract / Rental"
msgstr "Szerződés / Bérlemény"

#: components/meters/form/invoices/UcMeterInvoices.yaml:66
msgctxt "MeterInvoices"
msgid "From"
msgstr "Induló állás"

#: components/meters/form/invoices/UcMeterInvoices.yaml:76
msgctxt "MeterInvoices"
msgid "To"
msgstr "Záró állás"

#: components/meters/form/invoices/UcMeterInvoices.yaml:86
msgctxt "MeterInvoices"
msgid "Consumption"
msgstr "Fogyasztás"

#: components/meters/form/invoices/UcMeterInvoices.yaml:95
msgctxt "MeterInvoices"
msgid "Mp."
msgstr "Szorzó"

#: components/meters/form/invoices/UcMeterInvoices.yaml:96
msgctxt "MeterInvoices"
msgid "Multiplier"
msgstr "Szorzó"

#: components/meters/form/invoices/UcMeterInvoices.yaml:101
msgctxt "MeterInvoices"
msgid "Quantity"
msgstr "Mennyiség"

#: components/meters/form/invoices/UcMeterInvoices.yaml:107
msgctxt "MeterInvoices"
msgid "Price"
msgstr "Egységár"

#: components/meters/form/invoices/UcMeterInvoices.yaml:112
msgctxt "MeterInvoices"
msgid "Net"
msgstr "Nettó"

#: components/meters/form/invoices/UcMeterInvoices.yaml:117
msgctxt "MeterInvoices"
msgid "Amount"
msgstr "Bruttó"

#: components/meters/form/invoices/UcMeterInvoices.yaml:122
msgctxt "MeterInvoices"
msgid "Currency"
msgstr "Pénznem"

#: components/meters/form/readings/UcMeterReadings.yaml:56
#: components/settings/StatData.yaml:87
msgid "Value"
msgstr "Érték"

#: components/meters/form/readings/UcMeterReadings.yaml:68
msgid "Reading Type"
msgstr "Leolvasás típusa"

#: components/meters/form/readings/UcMeterReadings.yaml:75
msgid "Reading Date"
msgstr "Leolvasás dátuma"

#: components/meters/form/readings/UcMeterReadings.yaml:81
msgid "Reading Time"
msgstr "Leolvasás ideje"

#: components/meters/form/relations/MeterRelations.yaml:61
msgctxt "MeterRelationTypes"
msgid "Parent"
msgstr "Főmérő"

#: components/meters/form/relations/MeterRelations.yaml:64
msgctxt "MeterRelationTypes"
msgid "Submeter"
msgstr "Almérő"

#: components/meters/form/relations/MeterRelations.yaml:67
msgctxt "MeterRelationTypes"
msgid "Data Provider"
msgstr "Adatszolgáltató"

#: components/meters/form/relations/MeterRelations.yaml:115
msgid "Relation type"
msgstr "Kapcsolattípus"

#: components/meters/form/relations/MeterRelations.yaml:121
msgid "Device"
msgstr "Eszköz"

#: components/meters/form/relations/MeterRelations.yaml:157
msgid "Slot Number"
msgstr "Foglalat száma"

#: components/meters/form/relations/MeterRelations.yaml:162
msgid "Offset"
msgstr "Korrekció"

#: components/meters/primitives/UcCompactMeterDisplay.yaml:47
msgid "DevEUI"
msgstr "DevEUI"

#: components/meters/sensor-data/CreateMeterReadings.yaml:4
msgctxt "CreateMeterReadings"
msgid "Create Meter Readings"
msgstr "Mérőleolvasások generálása"

#: components/meters/sensor-data/CreateMeterReadings.yaml:67
msgid "One meter reading created."
msgid_plural "${n} meter readings created."
msgstr[0] "Egy leolvasás lett generálva."
msgstr[1] "${n} leolvasás lett generálva."

#: components/meters/sensor-data/CreateMeterReadings.yaml:113
msgctxt "CreateMeterReadings"
msgid "Notes"
msgstr "Megjegyzés"

#: components/meters/sensor-data/CreateMeterReadings.yaml:123
msgctxt "CreateMeterReadings"
msgid "Save values to the legacy database, too."
msgstr "Az adatok mentése az IntegroRent adatbázisba is."

#: components/meters/sensor-data/CreateMeterReadings.yaml:132
msgctxt "CreateMeterReadings"
msgid "IntegroRent writeback"
msgstr "IntegroRent visszaírás"

#: components/meters/sensor-data/CreateMeterReadings.yaml:137
msgctxt "GenerateMeterReading"
msgid ""
"Skip writeback to the legacy database if the serial number is not found in "
"the legacy database."
msgstr ""
"Hibajelzés helyett ugorja át a rendszer az IntegroRent adatbázisában nem "
"talált mérőórákat."

#: components/meters/sensor-data/CreateMeterReadings.yaml:146
msgctxt "CreateMeterReadings"
msgid "IntegroRent writeback - skip not found"
msgstr "IntegroRent visszaírás - ismeretlen mérőórák kihagyása"

#: components/meters/sensor-data/CreateMeterReadings.yaml:151
msgctxt "CreateMeterReadings"
msgid "Skip meters not found in the database."
msgstr ""
"Hibajelzés helyett ugorja át a rendszer az adatbázisban nem szereplő "
"mérőórákat."

#: components/meters/sensor-data/CreateMeterReadings.yaml:160
msgctxt "CreateMeterReadings"
msgid "Skip not found"
msgstr "Ismeretlen mérőórák kihagyása"

#: components/meters/sensor-data/CreateMeterReadings.yaml:172
msgctxt "MeterMeasurementGenerateButton"
msgid "Create Readings"
msgstr "Leolvasások létrehozása"

#: components/meters/sensor-data/CreateMeterReadings.yaml:179
msgctxt "CreateMeterReadings"
msgid "Cancel"
msgstr "Mégsem"

#: components/meters/sensor-data/CreateMeterReadingsParameters.yaml:77
msgctxt "CreateMeterReadings"
msgid "Reading date"
msgstr "Leolvasás dátuma"

#: components/meters/sensor-data/CreateMeterReadingsParameters.yaml:78
msgctxt "CreateMeterReadings"
msgid "Use this date as reading date instead."
msgstr "A leolvasás dátuma helyett a megadott dátumot állítsa be."

#: components/meters/sensor-data/SensorDataBrowser.yaml:4
msgctxt "MeterSensorDataBrowser"
msgid "Auto Readings"
msgstr "Automata adatszolgáltatás"

#: components/meters/sensor-data/SensorDataBrowser.yaml:63
msgctxt "ExportFilename"
msgid "meter-sensor-data"
msgstr "AutomataAdatszolgáltatás"

#: components/meters/sensor-data/SensorDataBrowser.yaml:72
msgctxt "MeterSensorDataBrowser"
msgid "Meter Type"
msgstr "Mérőóra típusa"

#: components/meters/sensor-data/SensorDataBrowser.yaml:83
msgctxt "MeterSensorDataBrowser"
msgid "Meter"
msgstr "Mérőóra"

#: components/meters/sensor-data/SensorDataBrowser.yaml:92
msgctxt "MeterSensorDataBrowser"
msgid "Meter Tag"
msgstr "Belső azonosító"

#: components/meters/sensor-data/SensorDataBrowser.yaml:101
msgctxt "MeterSensorDataBrowser"
msgid "Sensor Key"
msgstr "Szenzor azonosító"

#: components/meters/sensor-data/SensorDataBrowser.yaml:104
msgctxt "MeterSensorDataBrowser"
msgid "Raw"
msgstr "Szenzor adat"

#: components/meters/sensor-data/SensorDataBrowser.yaml:111
msgctxt "MeterSensorDataBrowser"
msgid "Offset"
msgstr "Korrekció"

#: components/meters/sensor-data/SensorDataBrowser.yaml:118
msgctxt "MeterSensorDataBrowser"
msgid "Value"
msgstr "Mérőállás"

#: components/meters/sensor-data/SensorDataBrowser.yaml:125
msgctxt "MeterSensorDataBrowser"
msgid "Unit"
msgstr "Egység"

#: components/meters/sensor-data/SensorDataBrowser.yaml:129
msgctxt "MeterSensorDataBrowser"
msgid "Timestamp"
msgstr "Időpont"

#: components/meters/sensor-data/SensorDataBrowser.yaml:134
msgctxt "MeterSensorDataBrowser"
msgid "Rentals"
msgstr "Bérlemények"

#: components/meters/sensor-data/SensorDataBrowser.yaml:152
msgctxt "MeterSensorDataBrowser"
msgid "Tenants"
msgstr "Bérlők"

#: components/meters/sensor-data/SensorDataBrowser.yaml:190
msgctxt "SensorDataBrowser|Button"
msgid "Create readings"
msgstr "Leolvasások létrehozása"

#: components/meters/sensor-data/SensorDataBrowser.yaml:204
msgctxt "MeterSensorDataBrowser"
msgid "Generate Readings..."
msgstr "Leolvasások generálása..."

#: components/multilineNotes/MultilineNotes.yaml:142
msgctxt "MultilineNotes"
msgid "Edit text templates..."
msgstr "Sablonok kezelése..."

#: components/multilineNotes/TextTemplate.yaml:12
msgctxt "TextTemplate|Type"
msgid "Invoice"
msgstr "Számla"

#: components/multilineNotes/TextTemplate.yaml:14
msgctxt "TextTemplate|Type"
msgid "Invoice line"
msgstr "Számlasor"

#: components/multilineNotes/TextTemplate.yaml:85
msgctxt "TextTemplate"
msgid "Object type"
msgstr "Objektum típusa"

#: components/multilineNotes/TextTemplate.yaml:103
msgctxt "TextTemplate"
msgid "Name"
msgstr "Megnevezés"

#: components/multilineNotes/TextTemplate.yaml:118
msgctxt "TextTemplate"
msgid "Description"
msgstr "Leírás"

#: components/multilineNotes/TextTemplate.yaml:131
msgctxt "TextTemplate"
msgid "Condition"
msgstr "Feltétel"

#: components/multilineNotes/TextTemplate.yaml:144
msgctxt "TextTemplate"
msgid "Template"
msgstr "Sablon"

#: components/multilineNotes/TextTemplates.yaml:50
msgctxt "TextTemplates|header"
msgid "Edit Text Templates"
msgstr "Sablonok kezelése"

#: components/multilineNotes/TextTemplates.yaml:80
msgctxt "TextTemplates"
msgid "Add new text template"
msgstr "Új sablon hozzáadása"

#: components/numberings/InvoiceNumbering.yaml:5
msgid "New Numbering"
msgstr "Új sorszámozás"

msgid "Edit Numbering"
msgstr "Sorszámozás szerkesztése"

#: components/numberings/InvoiceNumbering.yaml:54
msgctxt "Numbering|ResourceTitle"
msgid "Invoice Numbering"
msgstr "Számla Sorszámozás"

#: components/numberings/InvoiceNumbering.yaml:84
#: components/numberings/Numberings.yaml:93
msgctxt "Numbering"
msgid "Format"
msgstr "Formátum"

#: components/numberings/InvoiceNumbering.yaml:98
msgctxt "Numbering"
msgid "Start"
msgstr "Induló érték"

#: components/numberings/InvoiceNumbering.yaml:113
#: components/numberings/Numberings.yaml:98
msgctxt "Numbering"
msgid "Increment"
msgstr "Lépésköz"

#: components/numberings/InvoiceNumbering.yaml:134
msgctxt "Numbering"
msgid "ID"
msgstr "AZ"

#: components/numberings/InvoiceNumbering.yaml:139
msgctxt "Numbering"
msgid "Name"
msgstr "Megnevezés"

#: components/numberings/InvoiceNumbering.yaml:144
msgctxt "Numbering"
msgid "Data type"
msgstr "Adattípus"

#: components/numberings/InvoiceNumbering.yaml:149
msgctxt "Numbering"
msgid "Value"
msgstr "Érték"

#: components/numberings/InvoiceNumbering.yaml:163
msgctxt "Numbering"
msgid "Save"
msgstr "Mentés"

#: components/numberings/InvoiceNumbering.yaml:172
msgctxt "Numbering"
msgid "Close"
msgstr "Bezárás"

#: components/numberings/Numbering.yaml:85
msgctxt "Numbering|ResourceTitle"
msgid "Numbering"
msgstr "Sorszámozás"

#: components/numberings/Numbering.yaml:117
msgctxt "Numbering"
msgid "Resource type"
msgstr "Objektum típusa"

#: components/numberings/Numbering.yaml:126
msgctxt "Numbering"
msgid "The type of the resource."
msgstr "Objektum típusa."

#: components/numberings/Numbering.yaml:134
#: components/numberings/Numberings.yaml:80
msgctxt "Numbering"
msgid "Key"
msgstr "Kulcs"

#: components/numberings/Numbering.yaml:142
msgctxt "Numbering"
msgid "The unique key of the sequence."
msgstr "A sorozat egyedi kulcsa."

#: components/numberings/Numbering.yaml:147
#: components/numberings/Numberings.yaml:89
msgctxt "Numbering"
msgid "Description"
msgstr "Megnevezés"

#: components/numberings/Numbering.yaml:158
msgctxt "Numbering"
msgid "Short name/description."
msgstr "Rövid név/leírás."

#: components/numberings/NumberingSelector.yaml:35
msgid "Manual"
msgstr "Manuális"

#: components/numberings/NumberingSelector.yaml:66
msgid "Add new..."
msgstr "Új hozzáadása..."

#: components/numberings/Numberings.yaml:24
msgctxt "Numberings"
msgid "Add numbering..."
msgstr "Új sorszámozás..."

#: components/numberings/Numberings.yaml:33
msgctxt "Numberings"
msgid "Reload"
msgstr "Frissítés"

#: components/numberings/Numberings.yaml:85
msgctxt "Numbering"
msgid "Resource Type"
msgstr "Objektum típusa"

#: components/numberings/Numberings.yaml:103
msgctxt "Numbering"
msgid "Next value"
msgstr "Következő érték"

#: components/numberings/Numberings.yaml:108
msgctxt "Numbering"
msgid "Next Number"
msgstr "A következő szám"

#: components/payments/AccountStatementReport.yaml:4
msgctxt "AccountStatementReport/title"
msgid "Account Statement Report"
msgstr "Pénztári elszámolás"

#: components/payments/AccountStatementReport.yaml:143
msgctxt "Button"
msgid "Display..."
msgstr "Megnyitás..."

#: components/payments/ImportBankStatement.yaml:4
msgctxt "ImportBankStatement|Title"
msgid "Import Bank Statement"
msgstr "Banki Kivonat Importálása"

#: components/payments/ImportBankStatement.yaml:26
msgctxt "BankStatementFormat"
msgid "UniCredit XLSX"
msgstr "UniCredit XLSX"

#: components/payments/ImportBankStatement.yaml:30
msgctxt "BankStatementFormat"
msgid "CIB csv"
msgstr "CIB csv"

#: components/payments/ImportBankStatement.yaml:34
msgctxt "BankStatementFormat"
msgid "Text (TXT)"
msgstr "Szöveg (TXT)"

#: components/payments/ImportBankStatement.yaml:74
msgid "One transaction has been imported."
msgid_plural "${n} transactions have been imported."
msgstr[0] "Egy tranzakció importálása megtörtént."
msgstr[1] "Nem történt változás."

#: components/payments/ImportBankStatement.yaml:82
msgid "No transactions have been imported."
msgstr "Nem importáltunk egy tranzakciót sem."

#: components/payments/ImportBankStatement.yaml:89
msgctxt "ImportBankStatement"
msgid "Successful import."
msgstr "Sikeres importálás."

#: components/payments/ImportBankStatement.yaml:162
msgctxt "ImportBankStatement"
msgid "Statement format"
msgstr "Banki kivonat formátuma"

#: components/payments/ImportBankStatement.yaml:176
msgctxt "ImportBankStatement"
msgid "Payment number"
msgstr "Bizonylat sorszáma"

#: components/payments/ImportBankStatement.yaml:187
msgctxt "ImportBankStatement"
msgid "Statement file"
msgstr "Banki kivonat fájl"

#: components/payments/ImportBankStatement.yaml:189
msgctxt "ImportBankStatement"
msgid "The file must be downloaded from the respective bank's application."
msgstr ""
"A kiválasztott formátumnak megelelő kivonat letölthető a banki "
"alkamazásokból."

#: components/payments/ImportBankStatement.yaml:219
msgctxt "ImportBankStatement"
msgid "Submit file"
msgstr "Fájl feltöltése"

#: components/payments/Payment.yaml:11 translations-extra.yaml:20
msgctxt "PaymentMethod"
msgid "Card"
msgstr "Bankkártya"

#: components/payments/Payment.yaml:12 translations-extra.yaml:21
msgctxt "PaymentMethod"
msgid "Debit card"
msgstr "Debit kártya"

#: components/payments/Payment.yaml:13 translations-extra.yaml:22
msgctxt "PaymentMethod"
msgid "Credit card"
msgstr "Hitelkártya"

#: components/payments/Payment.yaml:14 translations-extra.yaml:18
msgctxt "PaymentMethod"
msgid "Bank transfer"
msgstr "Átutalás"

#: components/payments/Payment.yaml:15 translations-extra.yaml:23
msgctxt "PaymentMethod"
msgid "Gift card"
msgstr "Ajándékkártya"

#: components/payments/Payment.yaml:16 translations-extra.yaml:24
msgctxt "PaymentMethod"
msgid "Check"
msgstr "Csekk"

#: components/payments/Payment.yaml:17 translations-extra.yaml:25
msgctxt "PaymentMethod"
msgid "Paypal"
msgstr "PayPal"

#: components/payments/Payment.yaml:18
msgctxt "PaymentMethod"
msgid "Inter account transfer"
msgstr "Átvezetés"

#: components/payments/Payment.yaml:19
msgctxt "PaymentMethod"
msgid "IAT"
msgstr "Átvezetés"

#: components/payments/Payment.yaml:20
msgctxt "PaymentMethod"
msgid "Other"
msgstr "Egyéb"

#: components/payments/Payment.yaml:21
msgctxt "PaymentMethod"
msgid "Voucher"
msgstr "Kupon"

#: components/payments/Payment.yaml:54
msgctxt "Button"
msgid "Create payment"
msgstr "Bizonylat mentése"

#: components/payments/Payment.yaml:87
msgctxt "TransactionType"
msgid "credit"
msgstr "jóváírás"

#: components/payments/Payment.yaml:88
msgctxt "TransactionType"
msgid "debit"
msgstr "terhelés"

#: components/payments/Payment.yaml:90
msgctxt "TransactionType"
msgid "deposit"
msgstr "befizetés"

#: components/payments/Payment.yaml:91
msgctxt "TransactionType"
msgid "payment"
msgstr "kifizetés"

#: components/payments/Payment.yaml:93
msgctxt "TransactionType"
msgid "invoice reconciliation"
msgstr "összevezetés"

#: components/payments/Payment.yaml:94
msgctxt "TransactionType"
msgid "write off"
msgstr "kivezetés"

#: components/payments/Payment.yaml:99
msgctxt "Payment|Header"
msgid "Bank credit"
msgstr "Banki jóváírás"

#: components/payments/Payment.yaml:100
msgctxt "Payment|Header"
msgid "New transaction"
msgstr "Új tranzakció"

#: components/payments/Payment.yaml:103
msgctxt "Payment|Header"
msgid "Bank debit"
msgstr "Banki terhelés"

#: components/payments/Payment.yaml:114
msgctxt "Payment|Header"
msgid "Cash-In"
msgstr "Pénztári befizetés"

#: components/payments/Payment.yaml:122
msgctxt "Payment|Header"
msgid "Cash-Out"
msgstr "Pénztári kifizetés"

#: components/payments/Payment.yaml:135
msgctxt "Payment|Header"
msgid "Invoice reconciliation"
msgstr "Összevezetés"

#: components/payments/Payment.yaml:147
msgctxt "Payment|Header"
msgid "Write off"
msgstr "Kivezetés"

#: components/payments/Payment.yaml:333
msgctxt "Button"
msgid "Create another payment"
msgstr "Új kiegyenlítés létrehozása"

#: components/payments/Payments.yaml:14
#: components/payments/form/UcPaymentInvoices.yaml:123
msgctxt "payment"
msgid "Mismatch between the amount of payment and invoices."
msgstr "Eltérés a fizetett összeg és a számla kiegyenlítések összege között."

#: components/payments/Payments.yaml:104
#: components/payments/views/PaymentsView.yaml:83
msgctxt "PaymentBrowserView"
msgid "Method"
msgstr "Fizetési mód"

#: components/payments/Payments.yaml:112
#: components/payments/views/PaymentsView.yaml:91
msgctxt "PaymentBrowserView"
msgid "Number"
msgstr "Sorszám"

#: components/payments/Payments.yaml:130
#: components/payments/views/PaymentsView.yaml:109
msgctxt "PaymentBrowserView"
msgid "Type"
msgstr "Típus"

#: components/payments/Payments.yaml:138
#: components/payments/views/PaymentsView.yaml:117
msgctxt "PaymentBrowserView"
msgid "Date"
msgstr "Dátum"

#: components/payments/Payments.yaml:142
#: components/payments/views/PaymentsView.yaml:121
msgctxt "PaymentBrowserView"
msgid "Title"
msgstr "Jogcím"

#: components/payments/Payments.yaml:145
msgctxt "PaymentBrowserView"
msgid "Transaction code"
msgstr "Tranzakció kód"

#: components/payments/Payments.yaml:148
msgctxt "PaymentBrowserView"
msgid "Statement number"
msgstr "Kivonat sorszáma"

#: components/payments/Payments.yaml:151
#: components/payments/views/PaymentsView.yaml:124
msgctxt "PaymentBrowserView"
msgid "Description"
msgstr "Leírás"

#: components/payments/Payments.yaml:154
msgctxt "PaymentBrowserView"
msgid "Message"
msgstr "Közlemény"

#: components/payments/Payments.yaml:157
#: components/payments/views/PaymentsView.yaml:130
msgctxt "PaymentBrowserView"
msgid "Opening balance"
msgstr "Nyitó egyenleg"

#: components/payments/Payments.yaml:163
#: components/payments/views/PaymentsView.yaml:136
msgctxt "PaymentBrowserView"
msgid "In"
msgstr "Befizetés"

#: components/payments/Payments.yaml:168
#: components/payments/views/PaymentsView.yaml:141
msgctxt "PaymentBrowserView"
msgid "Out"
msgstr "Kifizetés"

#: components/payments/Payments.yaml:173
#: components/payments/views/PaymentsView.yaml:146
msgctxt "PaymentBrowserView"
msgid "Closing balance"
msgstr "Záró egyenleg"

#: components/payments/Payments.yaml:179
#: components/payments/views/PaymentsView.yaml:152
msgctxt "PaymentBrowserView"
msgid "Currency"
msgstr "Pénznem"

#: components/payments/Payments.yaml:182
#: components/payments/views/PaymentsView.yaml:155
msgctxt "PaymentBrowserView"
msgid "Exchange Rate"
msgstr "Árfolyam"

#: components/payments/Payments.yaml:188
#: components/payments/views/PaymentsView.yaml:161
msgctxt "PaymentBrowserView"
msgid "Ref Nr."
msgstr "Hivatkozási szám"

#: components/payments/Payments.yaml:191
#: components/payments/views/PaymentsView.yaml:164
msgctxt "PaymentBrowserView"
msgid "File Nr."
msgstr "Mappaszám"

#: components/payments/Payments.yaml:194
#: components/payments/views/PaymentsView.yaml:176
msgctxt "PaymentBrowserView"
msgid "Client"
msgstr "Ügyfél"

#: components/payments/Payments.yaml:203
msgctxt "PaymentBrowserView"
msgid "Settlement Diff."
msgstr "Számlakiegyenlítés eltérés"

#: components/payments/Payments.yaml:209
#: components/payments/views/PaymentsView.yaml:185
msgctxt "PaymentBrowserView"
msgid "Invoices"
msgstr "Számlák"

#: components/payments/Payments.yaml:257
#: components/worksheets/views/WorkSummaryView.yaml:130
msgid "Create Payment"
msgstr "Új kiegyenlítés"

#: components/payments/form/FieldsetPaymentGeneral.yaml:101
msgctxt "Payment"
msgid "Account"
msgstr "Számla"

#: components/payments/form/FieldsetPaymentGeneral.yaml:140
msgctxt "Payment"
msgid "Title"
msgstr "Jogcím"

#: components/payments/form/FieldsetPaymentGeneral.yaml:160
msgctxt "Payment"
msgid "Client"
msgstr "Ügyfél"

#: components/payments/form/FieldsetPaymentGeneral.yaml:184
msgctxt "Payment"
msgid "Employee"
msgstr "Dolgozó"

#: components/payments/form/FieldsetPaymentGeneral.yaml:215
msgctxt "Payment"
msgid "Number"
msgstr "Bizonylatszám"

#: components/payments/form/FieldsetPaymentGeneral.yaml:224
msgctxt "Payment|transaction_number|placeholder"
msgid "Enter payment number"
msgstr "A bizonylat sorszáma"

#: components/payments/form/FieldsetPaymentGeneral.yaml:233
msgctxt "Payment"
msgid "Payment Date"
msgstr "Dátum"

#: components/payments/form/FieldsetPaymentGeneral.yaml:250
msgctxt "Payment"
msgid "Method"
msgstr "Fizetési mód"

#: components/payments/form/FieldsetPaymentGeneral.yaml:268
msgctxt "Payment"
msgid "Payment type"
msgstr "Tranz. típusa"

#: components/payments/form/FieldsetPaymentGeneral.yaml:286
msgctxt "Payment"
msgid "Amount"
msgstr "Összeg"

#: components/payments/form/FieldsetPaymentGeneral.yaml:318
msgctxt "Payment"
msgid "Automatically recalculates payment when the invoice settlement changes."
msgstr ""
"Automatikusan újraszámolja az összeget számla kiegyenlítés változtatásakor."

#: components/payments/form/FieldsetPaymentGeneral.yaml:329
msgctxt "PaymentInvoices"
msgid "Autocalc total amount."
msgstr "Automatikus végösszeg kalkuláció"

#: components/payments/form/FieldsetPaymentGeneral.yaml:341
msgctxt "Payment"
msgid "Description"
msgstr "Leírás"

#: components/payments/form/FieldsetPaymentGeneral.yaml:354
msgctxt "Payment"
msgid "Reference number"
msgstr "Hivatkozási szám"

#: components/payments/form/FieldsetPaymentGeneral.yaml:368
msgctxt "Payment"
msgid "Statement number"
msgstr "Kivonat sorszáma"

#: components/payments/form/FieldsetPaymentGeneral.yaml:383
msgctxt "Payment"
msgid "Transaction code"
msgstr "Tranzakció kód"

#: components/payments/form/FieldsetPaymentGeneral.yaml:396
msgctxt "Payment"
msgid "File number"
msgstr "Mappaszám"

#: components/payments/form/FieldsetPaymentGeneral.yaml:420
msgctxt "Payment"
msgid "Message"
msgstr "Közlemény"

#: components/payments/form/UcPaymentHeader.yaml:32
msgid ""
"Completing prevents further modifications. Please confirm this operation."
msgstr "Figyelem, véglegesítés után módosítás már nem lehetséges!"

#: components/payments/form/UcPaymentHeader.yaml:141
msgctxt "Payment"
msgid "Open preview"
msgstr "Előnézet megnyitása"

#: components/payments/form/UcPaymentHeader.yaml:163
msgctxt "Command"
msgid "Complete"
msgstr "Véglegesítés"

#: components/payments/form/UcPaymentHeader.yaml:178
msgctxt "Payment"
msgid "Delete payment"
msgstr "Bizonylat törlése"

#: components/payments/form/UcPaymentInvoices.yaml:26
msgctxt "Invoice"
msgid "Gross amount"
msgstr "Bruttó összeg"

#: components/payments/form/UcPaymentInvoices.yaml:96
msgctxt "Payment"
msgid "Invoices"
msgstr "Számla kiegyenlítések"

#: components/payments/form/UcPaymentInvoices.yaml:103
msgctxt "Payment"
msgid "Add invoice..."
msgstr "Számla hozzáadása..."

#: components/payments/form/UcPaymentInvoices.yaml:114
msgctxt "Payment"
msgid "Invoice amount mismatch"
msgstr "Eltérő összegek"

#: components/payments/form/UcPaymentInvoices.yaml:166
msgctxt "InvoicePayment"
msgid "Invoice"
msgstr "Számla"

#: components/payments/form/UcPaymentInvoices.yaml:191
msgctxt "InvoicePayment"
msgid "Amount"
msgstr "Összeg"

#: components/payments/form/UcPaymentInvoices.yaml:199
msgctxt "InvoicePayment"
msgid "Exch. Rate"
msgstr "Árfolyam"

#: components/payments/form/UcPaymentInvoices.yaml:207
msgctxt "InvoicePayment"
msgid "Notes"
msgstr "Megjegyzés"

#: components/payments/primitives/UcPaymentTransactionTypeSymbol.yaml:16
msgctxt "PaymentType"
msgid "credit"
msgstr "jóváírás"

#: components/payments/primitives/UcPaymentTransactionTypeSymbol.yaml:20
msgctxt "PaymentType"
msgid "debit"
msgstr "terhelés"

#: components/payments/primitives/UcPaymentTransactionTypeSymbol.yaml:24
msgctxt "PaymentType"
msgid "deposit"
msgstr "befizetés"

#: components/payments/primitives/UcPaymentTransactionTypeSymbol.yaml:28
msgctxt "PaymentType"
msgid "payment"
msgstr "kifizetés"

#: components/payments/views/AccountsDailyFlowView.yaml:4
msgctxt "AccountsDailyFlowView"
msgid "Daily Flow"
msgstr "Napi forgalom"

#: components/payments/views/AccountsDailyFlowView.yaml:53
msgctxt "ExportFilename"
msgid "accounts-daily-flow"
msgstr "napi-szamlaforgalom"

#: components/payments/views/AccountsDailyFlowView.yaml:61
msgctxt "AccountsDailyFlowView"
msgid "Date"
msgstr "Dátum"

#: components/payments/views/AccountsDailyFlowView.yaml:64
msgctxt "AccountsDailyFlowView"
msgid "Opening balance"
msgstr "Nyitó egyenleg"

#: components/payments/views/AccountsDailyFlowView.yaml:70
msgctxt "AccountsDailyFlowView"
msgid "Pay in"
msgstr "Befizetés"

#: components/payments/views/AccountsDailyFlowView.yaml:75
msgctxt "AccountsDailyFlowView"
msgid "Pay out"
msgstr "Kifizetés"

#: components/payments/views/AccountsDailyFlowView.yaml:80
msgctxt "AccountsDailyFlowView"
msgid "Closing balance"
msgstr "Záró egyenleg"

#: components/payments/views/InvoicePaymentsDashboard.yaml:4
msgid "Invoice Payments"
msgstr "Számla kiegyenlítések"

#: components/payments/views/PaymentsFilters.yaml:126
msgctxt "Payments"
msgid "Add deposit"
msgstr "Új befizetés"

#: components/payments/views/PaymentsFilters.yaml:143
msgctxt "Payments"
msgid "New payment"
msgstr "Új kifizetés"

#: components/payments/views/PaymentsFilters.yaml:161
msgctxt "Payments"
msgid "New transaction..."
msgstr "Új bizonylat..."

#: components/payments/views/PaymentsFilters.yaml:178
msgctxt "Payments"
msgid "Import Bank Statement..."
msgstr "Banki kivonat importálása..."

#: components/payments/views/PaymentsView.yaml:127
msgctxt "PaymentBrowserView"
msgid "Notes"
msgstr "Megjegyzés"

#: components/payments/views/PaymentsView.yaml:167
msgctxt "PaymentBrowserView"
msgid "Own company"
msgstr "Saját cég"

#: components/product/CreateProduct.yaml:4
msgctxt "Product"
msgid "New product"
msgstr "Új termék"

#: components/product/CreateProduct.yaml:45
msgctxt "Product"
msgid "Product"
msgstr "Termék"

#: components/product/CreateProduct.yaml:141
msgctxt "Product"
msgid "IntegroRent sync"
msgstr "IntegroRent szinkronizálás"

#: components/product/Product.yaml:41
msgid "Products"
msgstr "Termékek"

#: components/product/Product.yaml:68
msgctxt "Modal|Header"
msgid "Delete product"
msgstr "Termék törlése"

#: components/product/Product.yaml:125 components/projects/Project.yaml:114
msgid "Prices"
msgstr "Árak"

#: components/product/ProductBrowser.yaml:4
msgctxt "ProductsView"
msgid "Products"
msgstr "Termékek"

#: components/product/ProductBrowser.yaml:28
msgctxt "ExportFilename"
msgid "products"
msgstr "termékek"

#: components/product/ProductBrowser.yaml:36
msgctxt "ProductsView"
msgid "Code"
msgstr "Azonosító"

#: components/product/ProductBrowser.yaml:45
msgctxt "ProductsView"
msgid "Name"
msgstr "Megnevezés"

#: components/product/ProductBrowser.yaml:54
msgctxt "ProductsView"
msgid "Product type"
msgstr "Típus"

#: components/product/ProductBrowser.yaml:62
msgctxt "ProductsView"
msgid "Invoice group"
msgstr "Számlázási csoport"

#: components/product/ProductBrowser.yaml:65
msgctxt "ProductsView"
msgid "Unit"
msgstr "Egység"

#: components/product/ProductBrowser.yaml:68
msgctxt "ProductsView"
msgid "Sales VAT code"
msgstr "Eladási ÁFA"

#: components/product/ProductBrowser.yaml:71
msgctxt "ProductsView"
msgid "Purchase VAT code"
msgstr "Vételi ÁFA"

#: components/product/ProductBrowser.yaml:74
msgctxt "ProductsView"
msgid "Groups"
msgstr "Csoportok"

#: components/product/ProductBrowser.yaml:77
msgctxt "ProductsView"
msgid "External key"
msgstr "Külső azonosító"

#: components/product/ProductBrowser.yaml:107
msgctxt "ProductsView"
msgid "New Product/Service..."
msgstr "Új termék/szolgáltatás..."

#: components/product/ProductEditor.yaml:24
msgctxt "Product"
msgid "Edit General Information"
msgstr "Általános információk szerkesztése"

#: components/product/ProductEditor.yaml:29
msgctxt "Product"
msgid "Edit general data"
msgstr "Általános információk szerkesztése"

#: components/product/ProductPrice.yaml:4
msgid "Edit Price"
msgstr "Ár Szerkesztése"

#: components/product/ProductPrice.yaml:4
msgid "Add Price"
msgstr "Új ár hozzáadása"

#: components/product/ProductPrice.yaml:127
msgctxt "ProductPrice"
msgid "Price"
msgstr "Ár"

#: components/product/ProductPrice.yaml:155
msgctxt "ProductPrice"
msgid "Tariff"
msgstr "Tarifa"

#: components/product/ProductPrice.yaml:172
msgctxt "ProductPrice"
msgid "From quantity"
msgstr "Mennyiség -től"

#: components/product/ProductPrice.yaml:195
msgctxt "ProductPrice"
msgid "Validity"
msgstr "Érvényesség"

#: components/product/ProductPrice.yaml:208
#: components/rental/form/services/RentalService.yaml:397
msgctxt "InputPlaceholder"
msgid "Valid from"
msgstr "Érvényesség kezdete"

#: components/product/ProductPrice.yaml:219
#: components/rental/form/services/RentalService.yaml:407
msgctxt "InputPlaceholder"
msgid "Valid to"
msgstr "Érvényesség vége"

#: components/product/ProductPrice.yaml:226
msgctxt "ProductPrice"
msgid "Client"
msgstr "Ügyfél"

#: components/product/ProductPrice.yaml:266
msgctxt "ProductPrice"
msgid "Discount price"
msgstr "Kedvezményes ár"

#: components/product/ProductPrice.yaml:281
msgctxt "ProductPrice"
msgid "Inactive"
msgstr "Inaktív"

#: components/product/ProductPrice.yaml:298
msgctxt "ProductPrice"
msgid "Notes"
msgstr "Megjegyzés"

#: components/product/ProductPricesDataTable.yaml:69
msgid "Quantity from"
msgstr "Mennyiség -től"

#: components/product/ProductPricesDataTable.yaml:91
msgid "Discount price"
msgstr "Kedvezményes ár"

#: components/product/ProductPricesDataTable.yaml:95
msgid "Purchase price"
msgstr "Beszerzési ár"

#: components/product/ProductPricesDataTable.yaml:99
msgid "Note"
msgstr "Megjegyzés"

#: components/product/form/FieldsetProductGeneral.yaml:31
msgctxt "Product"
msgid "Type"
msgstr "Típus"

#: components/product/form/FieldsetProductGeneral.yaml:48
msgctxt "Product"
msgid "Item number"
msgstr "Cikkszám"

#: components/product/form/FieldsetProductGeneral.yaml:63
msgctxt "Product"
msgid "Name"
msgstr "Megnevezés"

#: components/product/form/FieldsetProductGeneral.yaml:78
msgctxt "Product"
msgid "Description"
msgstr "Leírás"

#: components/product/form/FieldsetProductGeneral.yaml:91
msgctxt "Product"
msgid "Unit"
msgstr "Egység"

#: components/product/form/FieldsetProductGeneral.yaml:107
msgctxt "Product"
msgid "Sales tax code"
msgstr "Eladási ÁFA"

#: components/product/form/FieldsetProductGeneral.yaml:122
msgctxt "Product"
msgid "Purchase tax code"
msgstr "Vételi ÁFA"

#: components/product/form/FieldsetProductGeneral.yaml:137
msgctxt "Product"
msgid "Intermediated service"
msgstr "Közvetített szolgáltatás"

#: components/product/form/FieldsetProductGeneral.yaml:150
msgctxt "Product"
msgid "Invoice Group"
msgstr "Számlázási csoport"

#: components/product/form/FieldsetProductGeneral.yaml:170
msgctxt "Product"
msgid "Groups"
msgstr "Csoportok"

#: components/product/form/FieldsetProductGeneral.yaml:185
msgctxt "Product"
msgid "Customs tariff no."
msgstr "Vámtarifaszám"

#: components/product/form/FieldsetProductGeneral.yaml:198
msgctxt "Product"
msgid "TESZOR code (HU)"
msgstr "TESZOR kód"

#: components/product/form/FieldsetProductGeneral.yaml:211
msgctxt "Product"
msgid "EWC code (EU)"
msgstr "EWC-kód"

#: components/product/form/FieldsetProductGeneral.yaml:224
msgctxt "Product"
msgid "External key"
msgstr "Külső azonosító"

#: components/product/form/UcProductGeneral.yaml:18
msgctxt "Product"
msgid "General"
msgstr "Általános"

#: components/product/form/UcProductGeneral.yaml:51
msgctxt "ProductTypes"
msgid "Sentence"
msgstr "Mondat"

#: components/product/form/UcProductGeneral.yaml:55
msgctxt "Product"
msgid "Number"
msgstr "Cikkszám"

#: components/product/form/UcProductGeneral.yaml:79
msgctxt "Product"
msgid "VAT codes"
msgstr "ÁFA kód"

#: components/product/form/UcProductGeneral.yaml:83
msgctxt "Product"
msgid "Sales VAT"
msgstr "Eladási ÁFA"

#: components/product/form/UcProductGeneral.yaml:87
msgctxt "Product"
msgid "Purchase VAT"
msgstr "Vételi ÁFA"

#: components/product/form/UcProductGeneral.yaml:92
msgctxt "Product"
msgid "Invoice group"
msgstr "Számlázási csoport"

#: components/product/form/UcProductPrices.yaml:251
msgctxt "ProductPrices"
msgid "Selling prices"
msgstr "Eladási árak"

#: components/product/form/UcProductPrices.yaml:256
msgctxt "ProductPrices"
msgid "Add price..."
msgstr "Új ár hozzáadása..."

#: components/product/form/UcProductPrices.yaml:281
msgctxt "ProductPrices"
msgid "No prices."
msgstr "Nincsenek árak"

#: components/product/form/UcProductPrices.yaml:300
msgctxt "ProductPrices"
msgid "Purchase prices"
msgstr "Beszerzési árak"

#: components/projects/CreateProject.yaml:4
msgctxt "Project"
msgid "New project"
msgstr "Új projekt"

#: components/projects/CreateProject.yaml:42
msgctxt "Project"
msgid "Project"
msgstr "Projekt"

#: components/projects/CreateProject.yaml:128
msgctxt "Button"
msgid "Create"
msgstr "Létrehozás"

#: components/projects/Project.yaml:6
msgid "Project"
msgstr "Projekt"

#: components/projects/Project.yaml:41
msgid "Projects"
msgstr "Projektek"

#: components/projects/Project.yaml:68
msgctxt "Modal|Header"
msgid "Delete project"
msgstr "Projekt törlése"

#: components/projects/ProjectEditor.yaml:24
msgctxt "Project"
msgid "Edit General Information"
msgstr "Általános adatok szerkesztése"

#: components/projects/ProjectEditor.yaml:29
msgctxt "Project"
msgid "Edit general data"
msgstr "Általános adatok  szerkesztése"

#: components/projects/Projects.yaml:4
msgctxt "ProjectsView"
msgid "Projects"
msgstr "Projektek"

#: components/projects/Projects.yaml:28
msgctxt "ExportFilename"
msgid "projects"
msgstr "projektek"

#: components/projects/Projects.yaml:36
msgctxt "ProjectsView"
msgid "Code"
msgstr "Azonosító"

#: components/projects/Projects.yaml:45
msgctxt "ProjectsView"
msgid "Name"
msgstr "Megnevezés"

#: components/projects/Projects.yaml:67
msgctxt "ProjectsView"
msgid "New project..."
msgstr "Új projekt..."

#: components/projects/form/FieldsetProjectGeneral.yaml:19
#: components/projects/form/UcProjectGeneral.yaml:54
msgctxt "Project"
msgid "Name"
msgstr "Megnevezés"

#: components/projects/form/FieldsetProjectGeneral.yaml:34
#: components/projects/form/UcProjectGeneral.yaml:49
msgctxt "Project"
msgid "Code"
msgstr "Kód"

#: components/projects/form/UcProjectGeneral.yaml:18
msgctxt "Project"
msgid "General"
msgstr "Általános"

#: components/projects/primitives/UcProjectSelector.yaml:11
msgctxt "Project"
msgid "Search for invoice"
msgstr "Számla keresése"

#: components/property/CreateProperty.yaml:4
msgctxt "Property"
msgid "New property"
msgstr "Új ingatlan"

#: components/property/CreateProperty.yaml:39
msgctxt "Property"
msgid "Property"
msgstr "Ingatlan"

#: components/property/Property.yaml:59
msgctxt "Contract/DialogTitle"
msgid "Delete property"
msgstr "Hely törlése"

#: components/property/PropertyBrowser.yaml:4
msgid "Locations"
msgstr "Helyek"

#: components/property/PropertyBrowser.yaml:33
msgctxt "PropertyBrowser"
msgid "Type"
msgstr "Típus"

#: components/property/PropertyBrowser.yaml:36
msgctxt "PropertyBrowser"
msgid "Name"
msgstr "Név"

#: components/property/PropertyBrowser.yaml:45
msgctxt "PropertyBrowser"
msgid "Description"
msgstr "Leírás"

#: components/property/PropertyBrowser.yaml:48
msgctxt "PropertyBrowser"
msgid "Area"
msgstr "Alapterület"

#: components/property/PropertyBrowser.yaml:51
msgctxt "PropertyBrowser"
msgid "Unit"
msgstr "Egység"

#: components/property/PropertyBrowser.yaml:54
msgctxt "PropertyBrowser"
msgid "Location code"
msgstr "Hely"

#: components/property/PropertyBrowser.yaml:82
msgid "New location..."
msgstr "Új hely..."

#: components/property/PropertyEditor.yaml:21
msgctxt "Property"
msgid "Edit General Information"
msgstr "Általános információk szerkesztése"

#: components/property/PropertyEditor.yaml:26
msgctxt "Property"
msgid "Edit general data"
msgstr "Általános információk szerkesztése"

#: components/property/form/FieldsetPropertyGeneralData.yaml:32
msgctxt "Property"
msgid "General"
msgstr "Általános"

#: components/property/form/FieldsetPropertyGeneralData.yaml:39
msgctxt "Property"
msgid "Own company"
msgstr "Saját cég"

#: components/property/form/FieldsetPropertyGeneralData.yaml:58
msgctxt "Property"
msgid "Name"
msgstr "Név"

#: components/property/form/FieldsetPropertyGeneralData.yaml:75
msgctxt "Property"
msgid "Code"
msgstr "Kód"

#: components/property/form/FieldsetPropertyGeneralData.yaml:91
msgctxt "Property"
msgid "Description"
msgstr "Leírás"

#: components/property/form/FieldsetPropertyGeneralData.yaml:104
msgctxt "Property"
msgid "Type"
msgstr "Típus"

#: components/property/form/FieldsetPropertyGeneralData.yaml:120
msgctxt "Property"
msgid "Location"
msgstr "Helykód"

#: components/property/form/FieldsetPropertyGeneralData.yaml:132
msgctxt "Property"
msgid "Lot number"
msgstr "Helyrajzi szám"

#: components/property/form/FieldsetPropertyGeneralData.yaml:144
msgctxt "Property"
msgid "Building number"
msgstr "Épületszám"

#: components/property/form/FieldsetPropertyGeneralData.yaml:155
msgctxt "Property"
msgid "Area"
msgstr "Alapterület"

#: components/property/form/UcPropertyGeneralData.yaml:53
msgctxt "Property"
msgid "Owner"
msgstr "Tulajdonos"

#: components/property/form/UcPropertyGeneralData.yaml:102
msgctxt "Property"
msgid "Validity"
msgstr "Érvényesség"

#: components/property/form/UcPropertyUnits.yaml:18
msgctxt "Property"
msgid "Units"
msgstr "Helyek"

#: components/property/form/UcPropertyUnits.yaml:24
msgid "Add unit..."
msgstr "Hely hozzáadása..."

#: components/property/form/UcPropertyUnits.yaml:47
msgctxt "Property"
msgid "No units have been added yet."
msgstr "Nincsenek helyek rögzítve."

#: components/property/form/UcPropertyValidityCard.yaml:13
msgctxt "Property"
msgid "From"
msgstr "Tól"

#: components/property/form/UcPropertyValidityCard.yaml:13
msgctxt "Property"
msgid "N/A"
msgstr "N/A"

#: components/property/form/UcPropertyValidityCard.yaml:23
msgctxt "Property"
msgid "To"
msgstr "Ig"

#: components/property/form/UcPropertyValidityCard.yaml:28
msgctxt "Property"
msgid "Indefinite"
msgstr "Határozatlan"

#: components/property/primitives/UcPropertyMiniCard.yaml:25
msgctxt "Property"
msgid "Property/Unit"
msgstr "Ingatlan/hely"

#: components/registers/RegisterEntry.yaml:26
msgctxt "RegisterEntry"
msgid "Create new entry"
msgstr "Új iktatás"

#: components/registers/RegisterEntry.yaml:39
msgctxt "RegisterEntry"
msgid "New Registry Entry"
msgstr "Új iktatás"

#: components/registers/RegisterEntry.yaml:42
msgctxt "RegisterEntry"
msgid "Edit Entry"
msgstr "Iktatás szerkesztése"

#: components/registers/RegisterEntry.yaml:296
msgctxt "RegisterEntry|Command"
msgid "Create another entry"
msgstr "Új iktatás"

#: components/registers/RegisterEntry.yaml:315
msgctxt "RegisterEntry/Button"
msgid "Create entry"
msgstr "Iktatás létrehozása"

#: components/registers/RegisterView.yaml:4
msgctxt "Register"
msgid "Registers"
msgstr "Iktatókönyvek"

#: components/registers/RegisterView.yaml:161
msgctxt "filename"
msgid "register-entries"
msgstr "iktatások"

#: components/registers/RegisterView.yaml:170
msgctxt "Register"
msgid "No."
msgstr "Sorszám"

#: components/registers/RegisterView.yaml:190
msgctxt "Register"
msgid "Date"
msgstr "Dátum"

#: components/registers/RegisterView.yaml:194
msgctxt "Register"
msgid "Direction"
msgstr "Irány"

#: components/registers/RegisterView.yaml:204
msgctxt "Register"
msgid "Document type"
msgstr "Dokumentum típus"

#: components/registers/RegisterView.yaml:214
msgctxt "Register"
msgid "Attachments"
msgstr "Csatolmányok"

#: components/registers/RegisterView.yaml:220
msgctxt "Register"
msgid "Delivery mode"
msgstr "Kézbesítés módja"

#: components/registers/RegisterView.yaml:226
msgctxt "Register"
msgid "Clerk"
msgstr "Ügyintéző"

#: components/registers/RegisterView.yaml:229
msgctxt "Register"
msgid "Project"
msgstr "Projekt"

#: components/registers/RegisterView.yaml:248
msgctxt "Register"
msgid "Priority"
msgstr "Fontosság"

#: components/registers/RegisterView.yaml:255
msgctxt "Priority"
msgid "normal"
msgstr "normál"

#: components/registers/RegisterView.yaml:256
msgctxt "Priority"
msgid "important"
msgstr "fontos"

#: components/registers/RegisterView.yaml:257
msgctxt "Priority"
msgid "urgent"
msgstr "sürgős"

#: components/registers/RegisterView.yaml:264
msgctxt "Register"
msgid "Document"
msgstr "Dokumentum"

#: components/registers/RegisterView.yaml:269
msgctxt "Register"
msgid "Partner"
msgstr "Ügyfél"

#: components/registers/RegisterView.yaml:287
msgctxt "Register"
msgid "Subject"
msgstr "Tárgy"

#: components/registers/RegisterView.yaml:290
msgctxt "Register"
msgid "Ref."
msgstr "Hiv."

#: components/registers/RegisterView.yaml:299
msgctxt "Register"
msgid "Status"
msgstr "Státusz"

#: components/registers/RegisterView.yaml:302
msgctxt "Register"
msgid "Category"
msgstr "Kategória"

#: components/registers/RegisterView.yaml:305
msgctxt "Register"
msgid "Delivery date"
msgstr "Kézbesítés dátuma"

#: components/registers/RegisterView.yaml:309
msgctxt "Register"
msgid "Notes"
msgstr "Megjegyzés"

#: components/registers/RegisterView.yaml:401
msgctxt "Register"
msgid "Add entry..."
msgstr "Új iktatás..."

#: components/registers/RegisterView.yaml:428
msgctxt "Register"
msgid "Set status to selected items"
msgstr "Státusz beállítása a kijelült elemekre"

#: components/registers/RegisterView.yaml:450
msgctxt "Register"
msgid "Set status"
msgstr "Státusz beállítása"

#: components/registers/RegisterView.yaml:480
msgctxt "Register"
msgid "Clear status"
msgstr "Státusz törlése"

#: components/registers/Registers.yaml:4
msgctxt "Registers|Title"
msgid "Configure registers"
msgstr "Iktatókönyvek beállítása"

#: components/registers/Registers.yaml:83
msgctxt "Registers"
msgid "Add register..."
msgstr "Új iktatókönyv..."

#: components/registers/Registers.yaml:145
msgctxt "Registers"
msgid "No registers have been added yet."
msgstr "Nincsenek létrehozva iktatókönyvek."

#: components/registers/Registers.yaml:150
msgctxt "Registers"
msgid "Create register..."
msgstr "Új iktatókönyv..."

#: components/registers/form/FieldsetRegisterEntry.yaml:148
msgctxt "RegisterEntry"
msgid "Date"
msgstr "Dátum"

#: components/registers/form/FieldsetRegisterEntry.yaml:164
msgctxt "RegisterEntry"
msgid "Document type"
msgstr "Dokumentum típusa"

#: components/registers/form/FieldsetRegisterEntry.yaml:204
msgctxt "RegisterEntry"
msgid "Subject"
msgstr "Tárgy"

#: components/registers/form/FieldsetRegisterEntry.yaml:221
msgctxt "RegisterEntry"
msgid "Reference number"
msgstr "Hivatkozási szám"

#: components/registers/form/FieldsetRegisterEntry.yaml:223
msgctxt "RegisterEntry|Help|Reference number"
msgid ""
"The invoice number, contract number or other number identifying the "
"registered document."
msgstr "Dokumentum azonosító - számlaszám, szerződésszám vagy egyéb iratszám."

#: components/registers/form/FieldsetRegisterEntry.yaml:247
msgctxt "RegisterEntry"
msgid ""
"An invoice exists with the given number. Click to assign it to the current "
"entry."
msgstr ""
"A megadott számmal már létezik számla a rendszerben. A számla "
"hozzárendelhető ehhez az iktatáshoz."

#: components/registers/form/FieldsetRegisterEntry.yaml:252
msgctxt "RegisterEntry"
msgid "Assign invoice"
msgstr "Számla hozzárendelése."

#: components/registers/form/FieldsetRegisterEntry.yaml:269
msgctxt "RegisterEntry"
msgid "An invoice exists with the given number but it's already registered."
msgstr ""
"A megadott számmal már létezik számla a rendszerben, de már iktatva van."

#: components/registers/form/FieldsetRegisterEntry.yaml:282
msgctxt "RegisterEntry"
msgid "Clerk"
msgstr "Ügyintéző"

#: components/registers/form/FieldsetRegisterEntry.yaml:284
msgctxt "RegisterEntry|Help|Clerk"
msgid "New values entered are memorized and saved to the database."
msgstr "Az újonnan megadott értékeket a rendszer megjegyzi."

#: components/registers/form/FieldsetRegisterEntry.yaml:302
msgctxt "RegisterEntry"
msgid "Partner"
msgstr "Ügyfél"

#: components/registers/form/FieldsetRegisterEntry.yaml:303
msgctxt "RegisterEntry|Help|Partner"
msgid ""
"Search and select a company or enter it's name if the database does not "
"contain its data. Type ENTER after typing in a new value."
msgstr ""
"A cég kikeresése, vagy ha nem létezik a rendszerben akkor a nevének a "
"megadása. A név megadása után ENTER-t kell nyomni."

#: components/registers/form/FieldsetRegisterEntry.yaml:317
msgctxt "RegisterEntry"
msgid "Invoice"
msgstr "Számla"

#: components/registers/form/FieldsetRegisterEntry.yaml:328
msgctxt "RegisterEntry"
msgid "Create invoice..."
msgstr "Számla rögzítése..."

#: components/registers/form/FieldsetRegisterEntry.yaml:331
msgctxt "RegisterEntry"
msgid "Create invoice with the given reference number."
msgstr "Számla rögzítése a megadott hivatkozási számmal."

#: components/registers/form/FieldsetRegisterEntry.yaml:351
msgctxt "RegisterEntry"
msgid "Reference entry"
msgstr "Hivatkozott iktatás"

#: components/registers/form/FieldsetRegisterEntry.yaml:355
msgctxt "RegisterEntry|Help|Clerk"
msgid "Reference of an other entry in any version of the current register."
msgstr ""
"Hivatkozás egy másik iktatásra a jelen iktatókönyv bármely verziójából."

#: components/registers/form/FieldsetRegisterEntry.yaml:385
msgctxt "RegisterEntry"
msgid "Status"
msgstr "Státusz"

#: components/registers/form/FieldsetRegisterEntry.yaml:387
msgctxt "RegisterEntry|Help|Status"
msgid ""
"Type in arbitrary values to assign a status. The values are memorized. Press "
"ENTER after typing in a new value."
msgstr ""
"Tetszőleges értékek megadhatók. A megadott értékeket a rendszer megjegyzi. "
"Új érték megadása után ENTER-t kell nyomni."

#: components/registers/form/FieldsetRegisterEntry.yaml:404
msgctxt "RegisterEntry"
msgid "Categories"
msgstr "Kategóriák"

#: components/registers/form/FieldsetRegisterEntry.yaml:406
msgctxt "RegisterEntry|Help|Categories"
msgid ""
"Assign multiple arbitrary values. The values are memorized. Press ENTER "
"after typing in a new value."
msgstr ""
"Több érték is kiválasztható/megadható. Az új értékeket a rendszer megjegyzi. "
"Új érték megadása után ENTER-t kell nyomni."

#: components/registers/form/FieldsetRegisterEntry.yaml:424
msgctxt "RegisterEntry"
msgid "Project"
msgstr "Projekt"

#: components/registers/form/FieldsetRegisterEntry.yaml:437
msgctxt "RegisterEntry"
msgid "Delivery date"
msgstr "Kézbesítés dátuma"

#: components/registers/form/FieldsetRegisterEntry.yaml:439
msgctxt "RegisterEntry|Help|Delivery date"
msgid "Receive or delivery date."
msgstr "A beérkezés vagy a feladás dátuma."

#: components/registers/form/FieldsetRegisterEntry.yaml:452
msgctxt "RegisterEntry"
msgid "Delivery modes"
msgstr "Kézbesítés módja"

#: components/registers/form/FieldsetRegisterEntry.yaml:454
msgctxt "RegisterEntry|Help|Delivery modes"
msgid "Receive or delivery date."
msgstr "A beérkezés vagy a feladás dátuma."

#: components/registers/form/FieldsetRegisterEntry.yaml:470
msgctxt "RegisterEntry"
msgid "Due date"
msgstr "Határidő"

#: components/registers/form/FieldsetRegisterEntry.yaml:484
msgctxt "RegisterEntry"
msgid "Priority"
msgstr "Fontosság"

#: components/registers/form/FieldsetRegisterEntry.yaml:499
msgctxt "RegisterEntry"
msgid "Storage location"
msgstr "Tárolási hely"

#: components/registers/form/FieldsetRegisterEntry.yaml:501
msgctxt "RegisterEntry|Help|Storage location"
msgid "The description or number of the document's storage location."
msgstr "A tárolás helyének a kódja, megnevezése vagy leírása."

#: components/registers/form/FieldsetRegisterEntry.yaml:515
msgctxt "RegisterEntry"
msgid "Contract number"
msgstr "Szerződésszám"

#: components/registers/form/FieldsetRegisterEntry.yaml:563
msgctxt "RegisterEntry"
msgid "Contract number mismatch"
msgstr "Szerződésszám eltérés."

#: components/registers/form/FieldsetRegisterEntry.yaml:574
msgctxt "RegisterEntry"
msgid "Assign..."
msgstr "Hozzárendelés..."

#: components/registers/form/FieldsetRegisterEntry.yaml:577
msgctxt "RegisterEntry"
msgid "Assign contract."
msgstr "Szerződés hozzérendelése."

#: components/registers/form/FieldsetRegisterEntry.yaml:597
msgctxt "RegisterEntry"
msgid "Record..."
msgstr "Rögzítés..."

#: components/registers/form/FieldsetRegisterEntry.yaml:600
msgctxt "RegisterEntry"
msgid "Record a new invoice."
msgstr "Új számla rögzítése."

#: components/registers/form/FieldsetRegisterEntry.yaml:623
msgctxt "RegisterEntry"
msgid "Notes"
msgstr "Megjegyzés"

#: components/registers/form/UcRegister.yaml:11
msgctxt "Register|Command"
msgid "Create register"
msgstr "Iktatókönyv létrehozása"

#: components/registers/form/UcRegister.yaml:12
msgctxt "Register|Command"
msgid "Save changes"
msgstr "Változtatások mentése"

#: components/registers/form/UcRegister.yaml:70
msgctxt "Register|Header"
msgid "Please confirm deleting this register."
msgstr "Kérem, erősítse meg az iktatókönyv törlését!"

#: components/registers/form/UcRegister.yaml:71
msgctxt "Register"
msgid "This action cannot be undone."
msgstr "A művelet nem visszavonható."

#: components/registers/form/UcRegister.yaml:112
msgctxt "Register"
msgid "Name"
msgstr "Megnevezés"

#: components/registers/form/UcRegister.yaml:120
msgctxt "Register"
msgid "The name of the register."
msgstr "Az iktatókönyv rövid megnevezése."

#: components/registers/form/UcRegister.yaml:128
msgctxt "Register"
msgid "Company"
msgstr "Saját cég"

#: components/registers/form/UcRegister.yaml:172
msgctxt "Register"
msgid "Delete"
msgstr "Törlés"

#: components/registers/form/UcRegister.yaml:180
msgctxt "Register"
msgid "Cancel"
msgstr "Mégsem"

#: components/registers/form/UcRegisterEntryHeader.yaml:16
msgctxt "Register"
msgid "New entry"
msgstr "Új iktatás"

#: components/registers/form/UcRegisterEntryHeader.yaml:73
msgctxt "RegisterEntryHeader"
msgid "Invoice number"
msgstr "Számlaszám"

#: components/registers/form/UcRegisterEntryHeader.yaml:312
msgctxt "Register"
msgid "Delete entry"
msgstr "Iktatás törlése"

#: components/registers/form/UcRegisterEntryInvoiceSelector.yaml:7
msgctxt "Register"
msgid "Search for invoice"
msgstr "Számla keresése"

#: components/registers/form/UcRegisterEntryInvoiceSelector.yaml:149
msgctxt "RegisterEntry"
msgid "Invoice number mismatch"
msgstr "Eltérő számlaszámok"

#: components/registers/form/UcRegisterEntryInvoiceSelector.yaml:165
msgctxt "RegisterEntry"
msgid "Assign invoice."
msgstr "Számla hozzárendelése."

#: components/registers/form/UcRegisterEntryPartnerSelector.yaml:7
msgctxt "Register"
msgid "Search for partner"
msgstr "Ügyfél keresése"

#: components/registers/form/UcRegisterVersions.yaml:16
msgctxt "Register"
msgid "Versions"
msgstr "Példányok"

#: components/registers/form/UcRegisterVersions.yaml:78
msgctxt "RegisterVersion"
msgid "Name"
msgstr "Megnevezés"

#: components/registers/form/UcRegisterVersions.yaml:84
msgctxt "RegisterVersion"
msgid "Financial year"
msgstr "Pénzügyi év"

#: components/registers/form/UcRegisterVersions.yaml:91
msgctxt "RegisterVersion"
msgid "Number format"
msgstr "Sorszámozás formátuma"

#: components/registers/form/UcRegisterVersions.yaml:97
msgctxt "RegisterVersion"
msgid "Current value"
msgstr "Számláló állása"

#: components/registers/form/UcRegisterVersions.yaml:104
msgctxt "RegisterVersion"
msgid "Increment"
msgstr "Lépésköz"

#: components/registers/primitives/UcRegisterEntryMiniCard.yaml:26
msgctxt "Register"
msgid "Register"
msgstr "Iktatókönyv"

#: components/registers/primitives/UcRegisterSelector.yaml:127
msgctxt "RegisterSelector"
msgid "No register have been defined yet."
msgstr "Nincsenek létrehozva iktatókönyvek."

#: components/registers/primitives/UcRegisterSelector.yaml:132
msgctxt "RegisterSelector"
msgid "Select register"
msgstr "Iktatókönyv kiválasztása"

#: components/registers/primitives/UcRegisterSelector.yaml:174
msgctxt "RegisterSelector"
msgid "Configure registers..."
msgstr "Iktatókönyvek beállítása..."

#: components/rental/CreateRental.yaml:4
msgctxt "Rental"
msgid "Create Rental"
msgstr "Új bérlemény"

#: components/rental/Rental.yaml:33
msgctxt "Rental|Header"
msgid "Delete rental"
msgstr "Bérlemény törlése"

#: components/rental/Rental.yaml:170
msgid "Services"
msgstr "Szolgáltatások"

#: components/rental/Rental.yaml:202
msgctxt "Rental"
msgid "Billing list"
msgstr "Számlázandók"

#: components/rental/Rental.yaml:214
msgctxt "Rental"
msgid "Invoices"
msgstr "Számlák"

#: components/rental/RentalBrowser.yaml:45
msgctxt "filename"
msgid "rentals"
msgstr "bérlemények"

#: components/rental/RentalBrowser.yaml:49
msgctxt "Rentals"
msgid "Inactive"
msgstr "Inaktív"

#: components/rental/RentalBrowser.yaml:55
msgctxt "Rentals"
msgid "Name"
msgstr "Megnevezés"

#: components/rental/RentalBrowser.yaml:64
msgctxt "Rentals"
msgid "Description"
msgstr "Leírás"

#: components/rental/RentalBrowser.yaml:73
msgctxt "Rentals"
msgid "Category"
msgstr "Kategória"

#: components/rental/RentalBrowser.yaml:76
msgctxt "Rentals"
msgid "Valid From"
msgstr "Érvényesség kezdete"

#: components/rental/RentalBrowser.yaml:80
msgctxt "Rentals"
msgid "Valid To"
msgstr "Érvényesség vége"

#: components/rental/RentalBrowser.yaml:84
msgctxt "Rentals"
msgid "Site"
msgstr "Telephely"

#: components/rental/RentalBrowser.yaml:94
msgctxt "Rentals"
msgid "Property units"
msgstr "Helyek"

#: components/rental/RentalBrowser.yaml:113
msgctxt "Rentals"
msgid "Location Code"
msgstr "Hely"

#: components/rental/RentalBrowser.yaml:116
msgctxt "Rentals"
msgid "Lot Number"
msgstr "Helyrajzi szám"

#: components/rental/RentalBrowser.yaml:119
msgctxt "Rentals"
msgid "House Number"
msgstr "Épületszám"

#: components/rental/RentalBrowser.yaml:122
msgctxt "Rentals"
msgid "Area"
msgstr "Alapterület"

#: components/rental/RentalBrowser.yaml:126
msgctxt "Rentals"
msgid "Company"
msgstr "Saját Cég"

#: components/rental/RentalBrowser.yaml:136
msgctxt "Rentals"
msgid "Tenant"
msgstr "Bérlő"

#: components/rental/RentalBrowser.yaml:146
msgctxt "Rentals"
msgid "Contract"
msgstr "Szerződés"

#: components/rental/RentalBrowser.yaml:189
msgctxt "RentalBrowser"
msgid "Display active rentals only"
msgstr "Inaktív bérlemények elrejtése"

#: components/rental/RentalBrowser.yaml:197
msgctxt "RentalBrowser"
msgid "Add rental..."
msgstr "Új bérlemény..."

#: components/rental/form/contracts/UcRentalFormContracts.yaml:47
msgctxt "RentalFormContracts"
msgid "Contracts"
msgstr "Szerződések"

#: components/rental/form/contracts/UcRentalFormContracts.yaml:67
msgctxt "RentalFormContracts"
msgid "No rental contracts."
msgstr "Nincsenek bérleti szerződések."

#: components/rental/form/general/FieldsetRentalGeneralData.yaml:24
msgctxt "Rental"
msgid "General"
msgstr "Általános"

#: components/rental/form/general/FieldsetRentalGeneralData.yaml:60
msgctxt "Rental"
msgid "Company"
msgstr "Saját Cég"

#: components/rental/form/general/FieldsetRentalGeneralData.yaml:77
msgctxt "Rental"
msgid "Site"
msgstr "Telephely"

#: components/rental/form/general/FieldsetRentalGeneralData.yaml:93
msgctxt "Rental"
msgid "Categories"
msgstr "Kategóriák"

#: components/rental/form/general/FieldsetRentalGeneralData.yaml:110
msgctxt "Rental"
msgid "Location"
msgstr "Helykód"

#: components/rental/form/general/FieldsetRentalGeneralData.yaml:122
msgctxt "Rental"
msgid "Lot number"
msgstr "Helyrajzi szám"

#: components/rental/form/general/FieldsetRentalGeneralData.yaml:134
msgctxt "Rental"
msgid "Building number"
msgstr "Épület száma"

#: components/rental/form/general/FieldsetRentalGeneralData.yaml:166
msgctxt "Rental"
msgid "Net floor area"
msgstr "Nettó alapterület"

#: components/rental/form/general/FieldsetRentalGeneralData.yaml:180
msgctxt "Rental"
msgid "Net floor area factor"
msgstr "Alapterület szorzó"

#: components/rental/form/general/FieldsetRentalValidityData.yaml:15
msgctxt "Rental"
msgid "Validity"
msgstr "Érvényesség"

#: components/rental/form/general/FieldsetRentalValidityData.yaml:20
msgctxt "Rental"
msgid "Valid from"
msgstr "Érvényesség kezdete"

#: components/rental/form/general/FieldsetRentalValidityData.yaml:33
msgctxt "Rental"
msgid "Valid to"
msgstr "Érvényesség vége"

#: components/rental/form/general/MRentalGeneralDataEditor.yaml:4
msgctxt "Rental"
msgid "Edit General Information"
msgstr "Általános információk szerkesztése"

#: components/rental/form/general/UcRentalGeneralPanel.yaml:60
msgctxt "Rental"
msgid "Owner company"
msgstr "Saját cég"

#: components/rental/form/general/UcRentalValidityCard.yaml:13
msgctxt "Rental"
msgid "From"
msgstr "Tól"

#: components/rental/form/general/UcRentalValidityCard.yaml:13
msgctxt "Rental"
msgid "N/A"
msgstr "N/A"

#: components/rental/form/general/UcRentalValidityCard.yaml:23
msgctxt "Rental"
msgid "To"
msgstr "Ig"

#: components/rental/form/general/UcRentalValidityCard.yaml:28
msgctxt "Rental"
msgid "Indefinite"
msgstr "Határozatlan"

#: components/rental/form/properties/RentalProperty.yaml:4
msgid "Edit Rental Property"
msgstr "Bérlemény ingatlan módosítása"

#: components/rental/form/properties/RentalProperty.yaml:4
msgid "Add Rental Property"
msgstr "Új bérlemény ingatlan"

#: components/rental/form/properties/RentalProperty.yaml:105
msgid "Real Property"
msgstr "Ingatlan"

#: components/rental/form/properties/RentalProperty.yaml:116
msgid "Valid from"
msgstr "Érvényesség kezdete"

#: components/rental/form/properties/RentalProperty.yaml:130
msgid "Valid to"
msgstr "Érvényesség vége"

#: components/rental/form/properties/UcRentalFormProperties.yaml:71
msgctxt "RentalFormProperties"
msgid "Properties"
msgstr "Ingatlanok"

#: components/rental/form/properties/UcRentalFormProperties.yaml:76
msgid "Add property..."
msgstr "Új ingatlan..."

#: components/rental/form/properties/UcRentalFormProperties.yaml:91
msgctxt "RentalFormProperties"
msgid "No properties."
msgstr "Nincsenek ingatlanok"

#: components/rental/form/services/BulkRentalServiceEditor.yaml:4
msgctxt "BulkRentalServiceEditor"
msgid "Edit Service Properties"
msgstr "Szolgáltatás Jellemzők Szerkesztése"

#: components/rental/form/services/BulkRentalServiceEditor.yaml:138
msgctxt "BulkRentalServiceEditor|ResourceTitle"
msgid "Rental Services"
msgstr "Bérlemény Szolgáltatások"

#: components/rental/form/services/BulkRentalServiceEditor.yaml:165
msgctxt "RentalService"
msgid "Service"
msgstr "Szolgáltatás"

#: components/rental/form/services/BulkRentalServiceEditor.yaml:296
msgid "Inflation indexed"
msgstr "Inflációkövető"

#: components/rental/form/services/BulkRentalServiceEditor.yaml:325
msgctxt "RentalService"
msgid "Tariff"
msgstr "Tarifák..."

#: components/rental/form/services/BulkRentalServiceEditor.yaml:355
msgctxt "RentalService"
msgid "Billing unit"
msgstr "Számlázási egység"

#: components/rental/form/services/BulkRentalServiceEditor.yaml:389
msgctxt "RentalService"
msgid "Notes"
msgstr "Megjegyzés"

#: components/rental/form/services/RentalService.yaml:4
msgid "Edit Rental Service"
msgstr "Szolgáltatás szerkesztése"

#: components/rental/form/services/RentalService.yaml:4
msgid "Add Rental Service"
msgstr "Szolgáltatás hozzáadása"

#: components/rental/form/services/RentalService.yaml:172
msgctxt "RentalService"
msgid "Rental"
msgstr "Bérlemény"

#: components/rental/form/services/RentalService.yaml:188
msgctxt "RentalService"
msgid "Meter"
msgstr "Mérőóra"

#: components/rental/form/services/RentalService.yaml:215
msgctxt "RentalService"
msgid "Meter factor"
msgstr "Szorzó"

#: components/rental/form/services/RentalService.yaml:268
msgctxt "RentalService"
msgid "Name"
msgstr "Név"

#: components/rental/form/services/RentalService.yaml:272
msgctxt "RentalService|Tooltip"
msgid "This text will appear on the invice line."
msgstr ""
"Számlázáskor az itt megadott szöveg kerül feltüntetésre a tételsor "
"megnevezéseként."

#: components/rental/form/services/RentalService.yaml:285
msgctxt "RentalService"
msgid "Name(s)"
msgstr "Megnevezés(ek)"

#: components/rental/form/services/RentalService.yaml:300
msgctxt "RentalService"
msgid "Invoice notes"
msgstr "Számlatétel megjegyzés"

#: components/rental/form/services/RentalService.yaml:304
msgctxt "RentalService|Tooltip"
msgid "Note to display on the invoice line."
msgstr "A számla tételsorához kapcsolódó megjegyzés."

#: components/rental/form/services/RentalService.yaml:352
msgctxt "RentalService"
msgid "Intermediated service"
msgstr "Közvetített szolgáltatás"

#: components/rental/form/services/RentalService.yaml:384
msgctxt "RentalService"
msgid "Validity"
msgstr "Érvényesség"

#: components/rental/form/services/RentalService.yaml:414
msgctxt "RentalService"
msgid "Inactive"
msgstr "Inaktív"

#: components/rental/form/services/RentalServiceCostAllocator.yaml:45
msgctxt "RentalServiceCostAllocator"
msgid "New cost allocator"
msgstr "Új költségmegosztó"

#: components/rental/form/services/RentalServiceCostAllocator.yaml:48
msgctxt "RentalServiceCostAllocator/header"
msgid "Cost allocator"
msgstr "Költségmegosztó"

#: components/rental/form/services/RentalServiceCostAllocator.yaml:99
msgctxt "RentalServiceCostAllocator"
msgid "Meter"
msgstr "Költségmegosztó"

#: components/rental/form/services/RentalServiceCostAllocator.yaml:124
msgctxt "RentalServiceCostAllocator"
msgid "Factor"
msgstr "Faktor"

#: components/rental/form/services/RentalServiceCostAllocator.yaml:141
msgctxt "RentalServiceCostAllocator"
msgid "Notes"
msgstr "Megjegyzés"

#: components/rental/form/services/UcRentalFormServicesTable.yaml:100
msgid "Service"
msgstr "Szolgáltatás"

#: components/rental/form/services/UcRentalFormServicesTable.yaml:132
msgid "Billing Frequency"
msgstr "Számlázási gyakoriság"

#: components/rental/form/services/UcRentalFormServicesTable.yaml:137
msgid "Billing Unit"
msgstr "Számlázási egység"

#: components/rental/form/services/UcRentalFormServicesTable.yaml:147
msgid "Factor"
msgstr "Szorzó"

#: components/rental/form/services/UcRentalServiceCostAllocators.yaml:24
msgctxt "RentalServiceCostAllocators"
msgid "Cost allocators"
msgstr "Költségmegosztók"

#: components/rental/form/services/UcRentalServiceCostAllocators.yaml:117
msgctxt "RentalServiceCostAllocators"
msgid "Add cost allocator..."
msgstr "Költségmegosztó hozzáadása..."

#: components/rental/form/services/UcRentalServices.yaml:60
msgctxt "RentalServices"
msgid "Rental Services"
msgstr "Bérlemény Szolgáltatások"

#: components/rental/form/services/UcRentalServices.yaml:65
msgctxt "RentalServices"
msgid "Add rental service..."
msgstr "Szolgáltatás hozzáadása..."

#: components/rental/form/services/UcRentalServices.yaml:95
msgctxt "RentalServices"
msgid "No services."
msgstr "Nincsenek szolgáltatások"

#: components/rental/form/services/UcRentalServices.yaml:270
msgctxt "RentalServiceCostAllocators"
msgid "Add cost allocator"
msgstr "Költségmegosztó hozzáadása"

#: components/rental/views/RentalServices.yaml:9
msgid "Rental services"
msgstr "Bérlemény Szolgáltatások"

#: components/rental/views/RentalServices.yaml:40
msgctxt "RentalServices"
msgid "Rental services"
msgstr "Bérlemény Szolgáltatások"

#: components/rental/views/RentalServices.yaml:44
msgctxt "filename"
msgid "rental-services"
msgstr "bérlemény-szolgáltatások"

#: components/rental/views/RentalServices.yaml:74
msgctxt "RentalServices"
msgid "Type"
msgstr "Típus"

#: components/rental/views/RentalServices.yaml:101
msgctxt "RentalServices"
msgid "Status"
msgstr "Státusz"

#: components/rental/views/RentalServices.yaml:129
msgctxt "RentalServices"
msgid "Rental"
msgstr "Bérlemény"

#: components/rental/views/RentalServices.yaml:223
msgctxt "RentalServices"
msgid "Valid From"
msgstr "Érvényesség kezdete"

#: components/rental/views/RentalServices.yaml:228
msgctxt "RentalServices"
msgid "Valid To"
msgstr "Érvényesség vége"

#: components/rental/views/RentalServices.yaml:233
msgctxt "RentalServices"
msgid "Meter factor"
msgstr "Szorzó"

#: components/rental/views/RentalServices.yaml:246
msgctxt "ContractService"
msgid "Non-billable"
msgstr "Nem továbbszámlázott"

#: components/rental/views/RentalServices.yaml:250
msgctxt "ContractService"
msgid "Billing unit"
msgstr "Számlázási egység"

#: components/rental/views/RentalServices.yaml:253
msgctxt "ContractService"
msgid "Taridd code"
msgstr "Tarifa"

#: components/rental/views/RentalServices.yaml:296
msgctxt "RentalServices"
msgid "Skip archived items"
msgstr "Archivált elemek elrejtése"

#: components/rental/views/RentalServices.yaml:307
msgctxt "RentalServices"
msgid "Bulk edit..."
msgstr "Csoportos szerkesztés..."

#: components/settings/ExpenseTypes.yaml:45
msgid "Code"
msgstr "Kód"

#: components/settings/GeneralSettings.yaml:42
msgctxt "Settings"
msgid "Email settings"
msgstr "Email beállítások"

#: components/settings/GeneralSettings.yaml:46
msgid "Send a test email to the current user's email address."
msgstr "Teszt e-mail küldése a jelenlegi felhasználó e-mail címére."

#: components/settings/GeneralSettings.yaml:55
msgctxt "Tasks|Command"
msgid "Send test email"
msgstr "Teszt e-mail küldése"

#: components/settings/GeneralSettings.yaml:77
msgctxt "Settings"
msgid "Email has been successfully sent."
msgstr "Az e-mailt sikeresen elküldtük."

#: components/settings/Groups.yaml:17
msgctxt "GroupType"
msgid "Meter"
msgstr "Mérőóra"

#: components/settings/Groups.yaml:20
msgctxt "GroupType"
msgid "Company"
msgstr "Saját cég"

#: components/settings/Groups.yaml:53
msgid "Group Type"
msgstr "Csoporttípus"

#: components/settings/InvoicingProviderSettings.yaml:5
msgctxt "InvoicingProviderSettings|Title"
msgid "Invoicing provider configuration"
msgstr "Számlázási szolgáltató beállítások"

#: components/settings/InvoicingProviderSettings.yaml:86
msgctxt "InvoicingProviderSettings"
msgid "Name"
msgstr "Megnevezés"

#: components/settings/InvoicingProviderSettings.yaml:100
msgctxt "InvoicingProviderSettings"
msgid "URL"
msgstr "URL"

#: components/settings/InvoicingProviderSettings.yaml:101
msgctxt "InvoicingProviderSettings"
msgid "The root URL of the service."
msgstr "A szerviz API elérési útja."

#: components/settings/InvoicingProviderSettings.yaml:115
msgctxt "InvoicingProviderSettings"
msgid "Invoice prefix"
msgstr "Számlaszám előtag"

#: components/settings/InvoicingProviderSettings.yaml:117
msgctxt "InvoicingProviderSettings"
msgid "The invoice prefix set up by the provider."
msgstr "A szolgáltatónál beállított számlazám elótag."

#: components/settings/InvoicingProviderSettings.yaml:130
msgctxt "InvoicingProviderSettings"
msgid "Username"
msgstr "Felhasználónév"

#: components/settings/InvoicingProviderSettings.yaml:131
msgctxt "InvoicingProviderSettings"
msgid "The technical user's name."
msgstr "A technikai felhasználó megnevezése."

#: components/settings/InvoicingProviderSettings.yaml:145
msgctxt "InvoicingProviderSettings"
msgid "Agent key"
msgstr "Aláírókulcs"

#: components/settings/InvoicingProviderSettings.yaml:146
msgctxt "InvoicingProviderSettings"
msgid "The technical user's agent key."
msgstr "A kapott XML aláírókulcs."

#: components/settings/InvoicingProviderSettings.yaml:160
msgctxt "InvoicingProviderSettings"
msgid "Invoice template"
msgstr "Számlasablon"

#: components/settings/InvoicingProviderSettings.yaml:161
msgctxt "InvoicingProviderSettings"
msgid "The ID/key of the invoice template."
msgstr "A számlasablon számlázó szolgáltatónál használatos azonosítója."

#: components/settings/InvoicingProviderSettings.yaml:173
msgctxt "InvoicingProviderSettings"
msgid "Invoice notes"
msgstr "Számla megjegyzés"

#: components/settings/InvoicingProviderSettings.yaml:174
msgctxt "InvoicingProviderSettings"
msgid "General notes to append to all invoices."
msgstr "Általános megjegyzés, amely minden számlán fel lesz tüntetve."

#: components/settings/InvoicingProviderSettings.yaml:186
msgctxt "InvoicingProviderSettings"
msgid "Send email notifications"
msgstr "Email értesítés küldése"

#: components/settings/InvoicingProviderSettings.yaml:187
msgctxt "InvoicingProviderSettings"
msgid "Send email notifications from the provider service."
msgstr "Email értesítés küldése a szolgáltatótól."

#: components/settings/InvoicingProviderSettings.yaml:213
#: components/settings/JobSchedulerConfig.yaml:255
msgctxt "Button"
msgid "Close"
msgstr "Bezárás"

#: components/settings/JobSchedulerConfig.yaml:5
msgctxt "JobSchedulerConfig|Title"
msgid "Job scheduler configuration"
msgstr "Feladatütemező beállításai"

#: components/settings/JobSchedulerConfig.yaml:115
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "Name"
msgstr "Megnevezés"

#: components/settings/JobSchedulerConfig.yaml:129
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "Suspended"
msgstr "Felfüggesztve"

#: components/settings/JobSchedulerConfig.yaml:141
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "Notes"
msgstr "Megjegyzés"

#: components/settings/JobSchedulerConfig.yaml:153
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "Function"
msgstr "Metódus"

#: components/settings/JobSchedulerConfig.yaml:185
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "Cron Tab Entry"
msgstr "Cron Tab bejegyzés"

#: components/settings/JobSchedulerConfig.yaml:197
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "Jitter"
msgstr "Véletlenszerű késleltetés"

#: components/settings/JobSchedulerConfig.yaml:210
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "Parameters"
msgstr "Paraméterek"

#: components/settings/JobSchedulerConfig.yaml:235
msgctxt "Button"
msgid "Delete"
msgstr "Törlés"

#: components/settings/JobSchedulerConfigurations.yaml:45
msgctxt "JobSchedulerConfigurations"
msgid "Job scheduler configurations"
msgstr "Feladatütemező beállítások"

#: components/settings/JobSchedulerConfigurations.yaml:64
msgctxt "JobSchedulerConfigurations"
msgid "Add schedule..."
msgstr "Ütemezés hozzáadása…"

#: components/settings/JobSchedulerConfigurations.yaml:79
msgctxt "JobSchedulerConfigurations"
msgid "Export"
msgstr "Exportálás"

#: components/settings/JobSchedulerConfigurations.yaml:92
msgctxt "JobSchedulerConfigurations"
msgid "Import"
msgstr "Importálás"

#: components/settings/JobSchedulerConfigurations.yaml:129
msgctxt "JobSchedulerConfig"
msgid "Suspended"
msgstr "Felfüggesztve"

#: components/settings/JobSchedulerConfigurations.yaml:134
msgctxt "JobSchedulerConfig"
msgid "ID"
msgstr "AZ"

#: components/settings/JobSchedulerConfigurations.yaml:149
msgctxt "JobSchedulerConfig"
msgid "Name"
msgstr "Megnevezés"

#: components/settings/JobSchedulerConfigurations.yaml:153
msgctxt "JobSchedulerConfig"
msgid "Function"
msgstr "Metódus"

#: components/settings/JobSchedulerConfigurations.yaml:157
msgctxt "JobSchedulerConfig"
msgid "Trigger"
msgstr "Kiváltó"

#: components/settings/MailAccountConfig.yaml:5
msgctxt "MailAccountConfig|Title"
msgid "Mail account configuration"
msgstr "Email fiók beállítások"

#: components/settings/MailAccountConfig.yaml:43
msgctxt "MailAccount"
msgid "Use TLS"
msgstr "TLS használata"

#: components/settings/MailAccountConfig.yaml:44
msgctxt "MailAccount"
msgid "Enable TLS encryption for the connection."
msgstr "TLS titkosítás használata"

#: components/settings/MailAccountConfig.yaml:47
msgctxt "MailAccount"
msgid "SSL"
msgstr "SSL"

#: components/settings/MailAccountConfig.yaml:48
msgctxt "MailAccount"
msgid "Use SSL to secure the connection."
msgstr "SSL használata"

#: components/settings/MailAccountConfig.yaml:51
msgctxt "MailAccount"
msgid "Use Credentials"
msgstr "Hitelesítés használata"

#: components/settings/MailAccountConfig.yaml:52
msgctxt "MailAccount"
msgid "Require username and password to authenticate."
msgstr "Felhasználónév és jelszó megadása a hitelesítéshez."

#: components/settings/MailAccountConfig.yaml:55
msgctxt "MailAccount"
msgid "Validate Certificates"
msgstr "Tanúsítványok érvényesítése"

#: components/settings/MailAccountConfig.yaml:56
msgctxt "MailAccount"
msgid "Check that server certificates are valid."
msgstr "Ellenőrizze, hogy a kiszolgáló tanúsítványai érvényesek-e."

#: components/settings/MailAccountConfig.yaml:59
msgctxt "MailAccount"
msgid "Mail From Name"
msgstr "Feladó neve"

#: components/settings/MailAccountConfig.yaml:60
msgctxt "MailAccount"
msgid "Name displayed as the sender of the email."
msgstr "A feladóként megjelenő név az e-mailben."

#: components/settings/MailAccountConfig.yaml:62
msgctxt "MailAccount"
msgid "Server"
msgstr "Szerver"

#: components/settings/MailAccountConfig.yaml:63
msgctxt "MailAccount"
msgid "Address of the mail server."
msgstr "A levelezőszerver címe."

#: components/settings/MailAccountConfig.yaml:66
msgctxt "MailAccount"
msgid "Port"
msgstr "Port"

#: components/settings/MailAccountConfig.yaml:67
msgctxt "MailAccount"
msgid "Port number for the mail server connection."
msgstr "A levelezőszerverhez való csatlakozáshoz használt portszám."

#: components/settings/MailAccountConfig.yaml:70
msgctxt "MailAccount"
msgid "Debug"
msgstr "Debug"

#: components/settings/MailAccountConfig.yaml:71
msgctxt "MailAccount"
msgid "Show detailed connection and sending logs."
msgstr "Részletes kapcsolódási és küldési naplók megjelenítése."

#: components/settings/MailAccountConfig.yaml:74
msgctxt "MailAccount"
msgid "Username"
msgstr "Felhasználónév"

#: components/settings/MailAccountConfig.yaml:75
msgctxt "MailAccount"
msgid "Your login name for authentication."
msgstr "A hitelesítéshez használt bejelentkezési név."

#: components/settings/MailAccountConfig.yaml:77
msgctxt "MailAccount"
msgid "Password"
msgstr "Jelszó"

#: components/settings/MailAccountConfig.yaml:78
msgctxt "MailAccount"
msgid "Your account password."
msgstr "A fiók jelszava."

#: components/settings/MailAccountConfig.yaml:80
msgctxt "MailAccount"
msgid "Confirm Password"
msgstr "Jelszó megerősítése"

#: components/settings/MailAccountConfig.yaml:81
msgctxt "MailAccount"
msgid "Re-enter password to verify."
msgstr "A jelszó újbóli megadása ellenőrzéshez."

#: components/settings/MailAccountConfig.yaml:83
msgctxt "MailAccount"
msgid "Timeout"
msgstr "Időtúllépés"

#: components/settings/MailAccountConfig.yaml:84
msgctxt "MailAccount"
msgid "Time to wait before giving up."
msgstr "Várakozási idő a kapcsolat megszakítása előtt."

#: components/settings/MailAccountConfig.yaml:87
msgctxt "MailAccount"
msgid "Description"
msgstr "Leírás"

#: components/settings/MailAccountConfig.yaml:88
msgctxt "MailAccount"
msgid "Short note or label for this entry."
msgstr "Rövid megjegyzés vagy címke."

#: components/settings/MailAccountConfig.yaml:90
msgctxt "MailAccount"
msgid "Address"
msgstr "Cím"

#: components/settings/MailAccountConfig.yaml:91
msgctxt "MailAccount"
msgid "Email or server address to use."
msgstr "Használandó e-mail cím vagy szervercím."

#: components/settings/MailAccountConfig.yaml:412
msgctxt "MailAccountConfig"
msgid "Send test email"
msgstr "Teszt e-mail küldése"

#: components/settings/MailAccountConfig.yaml:430
msgctxt "MailAccountConfig|Button"
msgid "Send"
msgstr "Küldés"

#: components/settings/MailAccountConfig.yaml:450
msgctxt "MailAccountConfig"
msgid "Email has been successfully sent."
msgstr "Az e-mail sikeresen elküldve."

#: components/settings/MailAccountConfigurations.yaml:45
msgctxt "MailAccountConfigurations"
msgid "Email account configurations"
msgstr "E-mail fiók beállításai"

#: components/settings/MailAccountConfigurations.yaml:64
msgctxt "MailAccountConfigurations"
msgid "Add account..."
msgstr "Új email fiók..."

#: components/settings/MailAccountConfigurations.yaml:79
msgctxt "MailAccountConfigurations"
msgid "Export"
msgstr "Exportálás"

#: components/settings/MailAccountConfigurations.yaml:92
msgctxt "MailAccountConfigurations"
msgid "Import"
msgstr "Importálás"

#: components/settings/MailAccountConfigurations.yaml:116
msgctxt "MailAccountConfig"
msgid "ID"
msgstr "AZ"

#: components/settings/MailAccountConfigurations.yaml:131
msgctxt "MailAccountConfig"
msgid "Address"
msgstr "Cím"

#: components/settings/MailAccountConfigurations.yaml:135
msgctxt "MailAccountConfig"
msgid "Description"
msgstr "Leírás"

#: components/settings/NAVOnlineInvoiceInterfacePanel.yaml:4
msgctxt "NAVOnlineInvoiceInterfaceSettings|Title"
msgid "NAV online invoice interface configuration"
msgstr "NAV online számla interfész konfiguráció"

#: components/settings/NAVOnlineInvoiceInterfacePanel.yaml:33
msgid "NAV online invoice interface"
msgstr "NAV online számla interfész"

#: components/settings/NAVOnlineInvoiceInterfacePanel.yaml:37
msgctxt "Tasks"
msgid "Import invoices from NAV online invoices service."
msgstr "Számlák importálása a NAV online számla alkalmazásból."

#: components/settings/NAVOnlineInvoiceInterfacePanel.yaml:74
msgctxt "NAVOnlineInvoiceInterface"
msgid "Not configured"
msgstr "Nincs beállítva"

#: components/settings/NAVOnlineInvoiceInterfacePanel.yaml:84
msgctxt "Tasks|Command"
msgid "Configure"
msgstr "Beállítások"

#: components/settings/NAVOnlineInvoiceInterfacePanel.yaml:108
msgctxt "Tasks|Command"
msgid "Pull new invoices from NAV services."
msgstr "Új számlák letöltése"

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:109
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "Company name"
msgstr "Saját cég"

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:123
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "Base URL"
msgstr "Szerviz URL"

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:124
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "The root URL of the service."
msgstr "A szerviz API elérési útja."

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:138
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "Tax number"
msgstr "Adószám"

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:140
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "The first 8 digits of the tax number."
msgstr "A cég adószámának az első 8 karaktere."

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:153
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "Login"
msgstr "Felhasználónév"

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:154
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "The technical user's login name."
msgstr "A technikai felhasználó megnevezése."

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:170
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "Password hash"
msgstr "Jelszó hash"

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:171
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "The generated password's SHA-512 hash."
msgstr "A generált jelszó tárolt, SHA-512 algoritmussal kódolt hash-e."

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:184
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "Password"
msgstr "Jelszó"

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:185
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "The generated password."
msgstr "A felhasználó jelszava."

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:198
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "Confirm password"
msgstr "Jelszó megerősítése"

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:214
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "XML sign key"
msgstr "XML aláírókulcs."

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:215
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "The technical user's XML sign key."
msgstr "A kapott XML aláírókulcs."

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:229
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "XML exchange key"
msgstr "XML cserekulcs"

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:230
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "The technical user's XML exchange key."
msgstr "A kapott XML cserekulcs."

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:244
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "Save unknown clients."
msgstr "Új ügyfelek mentése"

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:245
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "Add unknown client to the database."
msgstr "Az új (ismeretlen) ügyfelek mentése az adatbázisba."

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:258
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "Lookback period"
msgstr "Visszatekintési időszak"

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:259
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "The number of days to be used to look back for invoices."
msgstr "A számlák lekérdezése a megadott időszakra visszamenőlegesen."

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:280
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "Request timeout"
msgstr "Időtúllépés"

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:281
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "Stop waiting for a response once the specified timeout has expired."
msgstr "Az interface a megadott ideig vár választ a szervertől."

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:302
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "Auto sync"
msgstr "Automata szinkronizálás"

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:303
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "Check to include this company to the automated sync job."
msgstr "Az automata szinkronizálás be- vagy kikapcsolása"

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:315
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "Pull incoming invoices"
msgstr "Szállítói számlák letöltése"

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:316
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "Enable pulling of incoming invoices from the agency."
msgstr "A szállítói számlák letöltésének engedélyezése."

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:329
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "Pull outgoing invoices"
msgstr "Vevőszámlák letöltése."

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:330
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "Enable pulling of outgoing invoices from the agency."
msgstr "A vevőszámlák letöltésének engedélyezése."

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:342
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "Invoice tag"
msgstr "Számla címke"

#: components/settings/NAVOnlineInvoiceInterfaceSettings.yaml:343
msgctxt "NAVOnlineInvoiceInterfaceSettings"
msgid "The tag to set on the imported invoices."
msgstr "A megadott szöveggel lesznek az importált számlák felcímkézve."

#: components/settings/PrinterConfig.yaml:5
msgctxt "PrinterConfig|Title"
msgid "Printer configuration"
msgstr "Nyomtató beállítások"

#: components/settings/PrinterConfig.yaml:35
msgctxt "PrinterConfig"
msgid "Printer Name"
msgstr "Nyomtató neve"

#: components/settings/PrinterConfig.yaml:36
msgctxt "PrinterConfig"
msgid "A friendly name for the printer to help identify it easily."
msgstr "Könnyen felismerhető, beszédes név a nyomtató egyszerű azonosításához."

#: components/settings/PrinterConfig.yaml:39
msgctxt "PrinterConfig"
msgid "Printer URI"
msgstr "Nyomtató URI"

#: components/settings/PrinterConfig.yaml:44
msgctxt "PrinterConfig"
msgid "Proxy"
msgstr "Proxy szerver"

#: components/settings/PrinterConfig.yaml:45
msgctxt "PrinterConfig"
msgid "The URL of the proxy server, if any."
msgstr "A proxy szerver URL-je."

#: components/settings/PrinterConfig.yaml:48
msgctxt "PrinterConfig"
msgid "IPP User Name"
msgstr "IPP felhasználónév"

#: components/settings/PrinterConfig.yaml:49
msgctxt "PrinterConfig"
msgid "The username used for IPP (Internet Printing Protocol) authentication."
msgstr ""
"Az IPP (Internet Printing Protocol) hitelesítéshez használt felhasználónév."

#: components/settings/PrinterConfig.yaml:53
msgctxt "PrinterConfig"
msgid "IPP Version"
msgstr "IPP Verzió"

#: components/settings/PrinterConfig.yaml:54
msgctxt "PrinterConfig"
msgid ""
"Specifies the IPP protocol version used for communication (default is 2.0)."
msgstr ""
"Meghatározza a kommunikációhoz használt IPP protokoll verzióját "
"(alapértelmezés: 2.0)."

#: components/settings/PrinterConfig.yaml:59
msgctxt "PrinterConfig"
msgid "Set as Default Printer"
msgstr "Alapértelmezett nyomtató"

#: components/settings/PrinterConfig.yaml:60
msgctxt "PrinterConfig"
msgid "Mark this printer as the default option for print jobs."
msgstr ""
"A nyomtatási feladatokhoz alapértelmezetten ez a nyomtató less használva."

#: components/settings/PrinterTester.yaml:72
msgctxt "Button"
msgid "Get printer attributes..."
msgstr "Nyomtató tulajdonságok lekérdezése..."

#: components/settings/PrinterTester.yaml:82
msgctxt "PrinterConfig"
msgid "Print file"
msgstr "File nyomtatása"

#: components/settings/PrinterTester.yaml:83
msgctxt "PrinterConfig"
msgid "Select a file to send to the network printer for testing purposes."
msgstr ""
"Válasszon ki egy fájlt, amelyet tesztelés céljából a hálózati nyomtatóra "
"szeretne küldeni."

#: components/settings/PrinterTester.yaml:89
msgctxt "PrinterConfig"
msgid "Choose a file or drop it here"
msgstr "Válasszon ki egy fájlt, vagy húzza ide."

#: components/settings/PrinterTester.yaml:90
msgctxt "PrinterConfig"
msgid "Drop file here"
msgstr "Húzza a file-t ide"

#: components/settings/PrinterTester.yaml:98
msgid "Print"
msgstr "Nyomtatás"

#: components/settings/PrinterTester.yaml:116
msgctxt "PrinterTester|ColHead"
msgid "ID"
msgstr "AZ"

#: components/settings/PrinterTester.yaml:119
msgctxt "PrinterTester|ColHead"
msgid "State"
msgstr "Állapot"

#: components/settings/PrinterTester.yaml:122
msgctxt "PrinterTester|ColHead"
msgid "State reasons"
msgstr "Állapot leírása"

#: components/settings/Printers.yaml:45
msgctxt "Printers"
msgid "Printer configurations"
msgstr "Nyomtatóbeállítások"

#: components/settings/Printers.yaml:64
msgctxt "Printers"
msgid "Add printer..."
msgstr "Új nyomtató felvétele..."

#: components/settings/Printers.yaml:78
msgctxt "Printers"
msgid "Export"
msgstr "Exportálás"

#: components/settings/Printers.yaml:91
msgctxt "Printers"
msgid "Import"
msgstr "Importálás"

#: components/settings/Printers.yaml:115
msgctxt "Printer"
msgid "ID"
msgstr "AZ"

#: components/settings/Printers.yaml:130
msgctxt "Printer"
msgid "Name"
msgstr "Megnevezés"

#: components/settings/Printers.yaml:135
msgctxt "Printer"
msgid "URI"
msgstr "URL"

#: components/settings/Settings.yaml:4
msgid "Settings"
msgstr "Beállítások"

#: components/settings/Settings.yaml:20
msgid "Mail accounts"
msgstr "Email fiókok"

#: components/settings/Settings.yaml:25
msgctxt "Settings"
msgid "Printers"
msgstr "Nyomtatók"

#: components/settings/Settings.yaml:30
msgid "Groups"
msgstr "Csoportok"

#: components/settings/Settings.yaml:35
msgid "Tags"
msgstr "Címkék"

#: components/settings/Settings.yaml:40
msgid "Numberings"
msgstr "Sorszámozások"

#: components/settings/Settings.yaml:45
msgid "External stat data"
msgstr "Külső statisztikai adat"

#: components/settings/Settings.yaml:50
msgid "Tasks"
msgstr "Feladatok"

#: components/settings/Settings.yaml:55
msgctxt "Settings"
msgid "Job scheduler"
msgstr "Feladatütemező beállítások"

#: components/settings/Settings.yaml:60
msgid "Expense types"
msgstr "Költségtípus"

#: components/settings/Settings.yaml:65
msgctxt "Settings"
msgid "Invoicing"
msgstr "Számlázás"

#: components/settings/Settings.yaml:70
msgctxt "Settings"
msgid "VAT periods"
msgstr "ÁFA időszakok"

#: components/settings/Settings.yaml:75
msgctxt "Settings"
msgid "Units"
msgstr "Mértékegységek"

#: components/settings/SettingsInvoicing.yaml:129
msgctxt "Settings"
msgid "Invoicing configuration"
msgstr "Számlázás beállítások"

#: components/settings/SettingsInvoicing.yaml:130
msgctxt "Tasks"
msgid "Configure invoicing modes for own companies."
msgstr "A saját cégek számlázási beállításai."

#: components/settings/SettingsInvoicing.yaml:167
msgctxt "Settings|TableHeader"
msgid "Company"
msgstr "Saját cég"

#: components/settings/SettingsInvoicing.yaml:172
msgctxt "Settings|TableHeader"
msgid "Invoicing mode"
msgstr "Számlázási mód"

#: components/settings/SettingsInvoicing.yaml:180
msgctxt "Settings|TableHeader"
msgid "Draft numbering"
msgstr "Vázlat sorszámozás"

#: components/settings/SettingsInvoicing.yaml:190
msgctxt "Settings|TableHeader"
msgid "Numbering"
msgstr "Sorszámozás"

#: components/settings/SettingsInvoicing.yaml:244
msgctxt "Settings|TableHeader"
msgid "Provider settings"
msgstr "Szolgáltatói beállítások"

#: components/settings/SettingsInvoicing.yaml:260
msgctxt "Settings|TableHeader"
msgid "Template"
msgstr "Sablon"

#: components/settings/StatData.yaml:14
msgctxt "StatDataCategory"
msgid "Exchange rate"
msgstr "Árfolyam"

#: components/settings/StatData.yaml:17
msgctxt "StatDataCategory"
msgid "Base rate"
msgstr "Alapkamat"

#: components/settings/StatData.yaml:20
msgctxt "StatDataCategory"
msgid "Inflation index"
msgstr "Infláció index"

#: components/settings/StatData.yaml:65
msgctxt "StatData"
msgid "Category"
msgstr "Kategória"

#: components/settings/StatData.yaml:71
msgctxt "StatData"
msgid "Name"
msgstr "Megnevezés"

#: components/settings/StatData.yaml:76
msgctxt "StatData"
msgid "Source"
msgstr "Adatforrás"

#: components/settings/StatData.yaml:81
msgctxt "StatData"
msgid "Date"
msgstr "Dátum"

#: components/settings/TagsEditor.yaml:51
msgctxt "Tag"
msgid "Type"
msgstr "Típus"

#: components/settings/TagsEditor.yaml:59
msgctxt "Tag"
msgid "Name"
msgstr "Megnevezés"

#: components/settings/Tasks.yaml:60
msgid "Expired contracts"
msgstr "Lejárt szerződések"

#: components/settings/Tasks.yaml:64
msgid ""
"This task searches for contracts expired within X days and creates "
"notifications if founds any."
msgstr ""
"A feladat 30 napon belül lejáró szerződéseket keres, a találatokból "
"értesítéseket készít."

#: components/settings/Tasks.yaml:71
msgctxt "Tasks|Command"
msgid "Check expiring contracts"
msgstr "Lejáró szerződések ellenőrzése"

#: components/settings/Tasks.yaml:81
msgid "Inflation indexed fees"
msgstr "Inflációkövető díjak"

#: components/settings/Tasks.yaml:85
msgid ""
"This task searches for fees subject to inflation indexed price change and "
"creates notifications if founds any."
msgstr ""
"A feladat az indexkövető díjakból készít értesítéseket abban az esetben, ha "
"a KSH adat alapján az árat emelni kell."

#: components/settings/Tasks.yaml:92
msgctxt "Tasks|Command"
msgid "Check inflation indexed fees."
msgstr "Inflációkövető díjak ellenőrzése"

#: components/settings/Tasks.yaml:105
msgid "Import rental contracts"
msgstr "Bérleti szerződés import"

#: components/settings/Tasks.yaml:109
msgid "This task imports rental contracts from the legacy Irent."
msgstr "Bérleti szerződések importálása az IntegroRent rendszerből."

#: components/settings/Tasks.yaml:114
msgid "Run task"
msgstr "Feladat futtatása"

#: components/settings/Tasks.yaml:128
msgid "Export customer invoice data"
msgstr "Vevőszámlák exportálása"

#: components/settings/Tasks.yaml:132
msgid "Download customer invoice data."
msgstr "Vevőszámla adatok letöltése."

#: components/settings/Tasks.yaml:136
msgid "Download file"
msgstr "Fájl letöltése"

#: components/settings/UnitsEditor.yaml:27
msgctxt "UnitsEditor"
msgid "Units"
msgstr "Mértékegységek"

#: components/settings/UnitsEditor.yaml:66
msgctxt "Unit"
msgid "Type"
msgstr "Típus"

#: components/settings/UnitsEditor.yaml:74
msgctxt "Unit"
msgid "Symbol"
msgstr "Szimbólum"

#: components/settings/UnitsEditor.yaml:79
msgctxt "Unit"
msgid "Name"
msgstr "Megnevezés"

#: components/settings/UnitsEditor.yaml:84
msgctxt "Unit"
msgid "Description"
msgstr "Leírás"

#: components/settings/VATPeriods.yaml:46
msgctxt "VATPeriod"
msgid "Name"
msgstr "Megnevezés"

#: components/settings/VATPeriods.yaml:51
msgctxt "VATPeriod"
msgid "Frequency"
msgstr "Gyakoriság"

#: components/settings/VATPeriods.yaml:60
msgctxt "VATPeriod"
msgid "Start"
msgstr "Kezdő dátum"

#: components/settings/VATPeriods.yaml:66
msgctxt "VATPeriod"
msgid "End"
msgstr "Záró dátum"

#: components/settings/VATPeriods.yaml:72
msgctxt "VATPeriod"
msgid "Due date"
msgstr "Határidő"

#: components/settings/VATPeriods.yaml:78
msgctxt "VATPeriod"
msgid "Closed"
msgstr "Lezárt"

#: components/tasks/TaskViewModal.yaml:4
#: components/worksheets/form/UcWorksheetWorkItems.yaml:247
msgid "Task"
msgstr "Feladat"

#: components/templates/CreateTemplate.yaml:4
msgctxt "Templates"
msgid "Create Template"
msgstr "Új sablon"

#: components/templates/CreateTemplate.yaml:75
msgctxt "Templates"
msgid "Name"
msgstr "Megnevezés"

#: components/templates/CreateTemplate.yaml:84
msgctxt "Templates"
msgid "Name of template"
msgstr "A sablon megnevezése"

#: components/templates/CreateTemplate.yaml:89
msgctxt "Templates"
msgid "Object type"
msgstr "Objektum típusa"

#: components/templates/CreateTemplate.yaml:103
msgctxt "Templates"
msgid "Template type"
msgstr "Típus"

#: components/templates/CreateTemplate.yaml:104
msgctxt "Templates"
msgid ""
"Emails are generated from MJML templates, PDF documents are generated from "
"HTML templates."
msgstr ""
"Az MJML sablonokból generáljuk az emaileket, a HTML sablonokból pedig a PDF "
"dokumentumokat."

#: components/templates/CreateTemplate.yaml:125
msgctxt "Templates"
msgid "Save"
msgstr "Mentés"

#: components/templates/CreateTemplate.yaml:133
msgctxt "Templates"
msgid "Close"
msgstr "Bezárás"

#: components/templates/TemplatePreview.yaml:4
msgctxt "TemplatePreview"
msgid "Preview"
msgstr "Előnézet"

#: components/templates/TemplatePreview.yaml:109
msgctxt "Templates"
msgid "Generate HTML previews using the data loaded/entered at the Data tab."
msgstr ""
"HTML előnézet generálása az Adatok fül alatt betöltött/megadott adatokkal "
"lehetséges."

#: components/templates/Templates.yaml:4
msgctxt "Templates"
msgid "Templates"
msgstr "Sablonok"

#: components/templates/Templates.yaml:7
msgid "Create template"
msgstr "Új sablon"

#: components/templates/Templates.yaml:8
msgid "Edit template"
msgstr "Sablon szerkesztése"

#: components/templates/Templates.yaml:117
msgctxt "Templates"
msgid "Please confirm deleting the template."
msgstr "Biztosan törölni szeretné a sablont?"

#: components/templates/Templates.yaml:118
msgctxt "Templates"
msgid "Delete"
msgstr "Törlés"

#: components/templates/Templates.yaml:119
msgctxt "Templates"
msgid "Cancel"
msgstr "Mégsem"

#: components/templates/Templates.yaml:180
msgctxt "Templates"
msgid "Preview"
msgstr "Előnézet"

#: components/templates/Templates.yaml:197
msgctxt "Templates"
msgid "Export"
msgstr "Exportálás"

#: components/templates/UcTemplate.yaml:53
msgctxt "Templates"
msgid "Email has been sent."
msgstr "Az email elküldve."

#: components/templates/UcTemplate.yaml:105
msgctxt "Templates"
msgid "Send email"
msgstr "Email küldése"

#: components/templates/UcTemplate.yaml:122
msgctxt "Template"
msgid "Name"
msgstr "Megnevezés"

#: components/templates/UcTemplate.yaml:136
msgctxt "Template"
msgid "Object Type"
msgstr "Objektum típusa"

msgctxt "Template"
msgid "Enter a valid JSON object, e.g. {}"
msgstr "Adjon meg egy érvényes JSON objektumot, pl. {}"

#: components/templates/UcTemplate.yaml:151
msgctxt "Template"
msgid "Template Type"
msgstr "Sablon típus"

#: components/templates/UcTemplate.yaml:167
msgctxt "Template"
msgid "Subject"
msgstr "Tárgy"

#: components/templates/UcTemplate.yaml:189
msgctxt "Template"
msgid "Header"
msgstr "Fejléc"

#: components/templates/UcTemplate.yaml:211
msgctxt "Template"
msgid "Content"
msgstr "Tartalom"

#: components/templates/UcTemplate.yaml:233
msgctxt "Template"
msgid "Footer"
msgstr "Lábléc"

#: components/templates/UcTemplate.yaml:255
msgctxt "Template"
msgid "CSS"
msgstr "CSS"

#: components/templates/UcTemplate.yaml:277
msgctxt "Template"
msgid "Sample data"
msgstr "Teszt adat"

#: components/templates/UcTemplateSelector.yaml:22
msgctxt "TemplateSelector"
msgid "No template have been defined yet"
msgstr "Nincsenek sablonok létrehozva."

#: components/templates/UcTemplateSelector.yaml:23
msgctxt "TemplateSelector"
msgid "Select template"
msgstr "Sablon kiválasztása"

#: components/templates/UcTemplateSelector.yaml:24
msgctxt "TemplateSelector"
msgid "Create template..."
msgstr "Új sablon..."

#: components/worksheets/Worksheet.yaml:155
msgctxt "Worksheet"
msgid "Worksheet data"
msgstr "Munkalap adatok"

#: components/worksheets/Worksheet.yaml:218
msgctxt "Button"
msgid "Create worksheet"
msgstr "Munkalap létrehozása"

#: components/worksheets/WorksheetEditor.yaml:24
msgctxt "Worksheet"
msgid "Edit Worksheet"
msgstr "Munkalap szerkesztése"

#: components/worksheets/WorksheetEditor.yaml:29
msgctxt "Worksheet"
msgid "Edit Worksheet Header"
msgstr "Munkalap szerkesztése"

#: components/worksheets/WorksheetList.yaml:4
msgid "Worksheets"
msgstr "Munkalapok"

#: components/worksheets/WorksheetList.yaml:48
msgctxt "Worksheets"
msgid "Number"
msgstr "Azonosító"

#: components/worksheets/WorksheetList.yaml:58
msgctxt "Worksheets"
msgid "Status"
msgstr "Státusz"

#: components/worksheets/WorksheetList.yaml:71
msgctxt "Worksheets"
msgid "Date"
msgstr "Dátum"

#: components/worksheets/WorksheetList.yaml:76
msgctxt "Worksheets"
msgid "Description"
msgstr "Leírás"

#: components/worksheets/WorksheetList.yaml:79
msgctxt "Worksheets"
msgid "Rental"
msgstr "Bérlemény"

#: components/worksheets/WorksheetList.yaml:89
msgctxt "Worksheets"
msgid "Company"
msgstr "Saját Cég"

#: components/worksheets/WorksheetList.yaml:99
msgctxt "Worksheets"
msgid "Client"
msgstr "Ügyfél"

#: components/worksheets/WorksheetList.yaml:109
msgctxt "Worksheets"
msgid "Contractor"
msgstr "Alvállalkozó"

#: components/worksheets/WorksheetList.yaml:139
msgid "New worksheet..."
msgstr "Új munkalap..."

#: components/worksheets/form/UcWorksheetData.yaml:31
msgctxt "Worksheet"
msgid "Status"
msgstr "Státusz"

#: components/worksheets/form/UcWorksheetData.yaml:47
msgctxt "Worksheet"
msgid "Own company"
msgstr "Saját cég"

#: components/worksheets/form/UcWorksheetData.yaml:63
msgctxt "Worksheet"
msgid "Partner"
msgstr "Ügyfél"

#: components/worksheets/form/UcWorksheetData.yaml:95
msgctxt "Worksheet"
msgid "Rental"
msgstr "Bérlemény"

#: components/worksheets/form/UcWorksheetData.yaml:115
msgctxt "Worksheet"
msgid "Description"
msgstr "Leírás"

#: components/worksheets/form/UcWorksheetData.yaml:131
msgctxt "Worksheet"
msgid "Date"
msgstr "Dátum"

#: components/worksheets/form/UcWorksheetData.yaml:147
msgctxt "Worksheet"
msgid "Start/End"
msgstr "Kezdés/Befejezés"

#: components/worksheets/form/UcWorksheetData.yaml:175
msgctxt "Worksheet"
msgid "GL Account Number"
msgstr "Főkönyvi szám"

#: components/worksheets/form/UcWorksheetData.yaml:192
msgctxt "Worksheet"
msgid "Notes"
msgstr "Megjegyzés"

#: components/worksheets/form/UcWorksheetEditorFieldset.yaml:77
msgctxt "Worksheet"
msgid "Worksheet Number"
msgstr "Munkalap száma"

#: components/worksheets/form/UcWorksheetEditorFieldset.yaml:126
msgctxt "Worksheet"
msgid "Worksheet Date"
msgstr "Munkalap dátuma"

#: components/worksheets/form/UcWorksheetEditorFieldset.yaml:142
msgctxt "Worksheet"
msgid "Period"
msgstr "Időszak"

#: components/worksheets/form/UcWorksheetEditorFieldset.yaml:153
msgctxt "Worksheet/StartDate/placeholder"
msgid "Start"
msgstr "Kezdés"

#: components/worksheets/form/UcWorksheetEditorFieldset.yaml:160
msgctxt "Worksheet/EndDate/placeholder"
msgid "End"
msgstr "Befejezés"

#: components/worksheets/form/UcWorksheetHeader.yaml:13
#: components/worksheets/primitives/UcWorksheetMiniCard.yaml:24
msgctxt "Worksheet"
msgid "Worksheet"
msgstr "Munkalap"

#: components/worksheets/form/UcWorksheetHeader.yaml:14
msgctxt "Worksheet"
msgid "New Worksheet"
msgstr "Új munkalap"

#: components/worksheets/form/UcWorksheetHeader.yaml:117
msgid "Preview"
msgstr "Előnézet"

#: components/worksheets/form/UcWorksheetHeader.yaml:137
msgctxt "Worksheet"
msgid "Copy worksheet"
msgstr "Munkalap másolása"

#: components/worksheets/form/UcWorksheetHeader.yaml:146
msgctxt "Worksheet"
msgid "Delete worksheet"
msgstr "Munkalap törlése"

#: components/worksheets/form/UcWorksheetHeader.yaml:160
msgctxt "Worksheet"
msgid "Worksheet history"
msgstr "Munkalap előzmények"

#: components/worksheets/form/UcWorksheetInvoiceLineAccountings.yaml:32
msgctxt "Worksheet"
msgid "Invoices"
msgstr "Számlák"

#: components/worksheets/form/UcWorksheetInvoiceLineAccountings.yaml:100
msgctxt "abbreviated"
msgid "Unit"
msgstr "Egység"

#: components/worksheets/form/UcWorksheetInvoiceLineAccountings.yaml:103
msgid "Unit Price"
msgstr "Egységár"

#: components/worksheets/form/UcWorksheetWorkItems.yaml:127
msgctxt "Worksheet"
msgid "Works"
msgstr "Munkák"

#: components/worksheets/form/UcWorksheetWorkItems.yaml:224
msgid "Worker"
msgstr "Munkavállaló"

#: components/worksheets/form/UcWorksheetWorkItems.yaml:266
msgid "Asset"
msgstr "Tárgyi eszköz"

#: components/worksheets/primitives/UcWorksheetStatus.yaml:24
msgctxt "WorksheetStatus"
msgid "Sentence"
msgstr "Mondat"

#: components/worksheets/views/WorkSummaryView.yaml:4
msgctxt "WorkSummaryView"
msgid "Work summary"
msgstr "Munkák összesítése"

#: components/worksheets/views/WorkSummaryView.yaml:43
msgctxt "ExportFilename"
msgid "work-summary"
msgstr "munkak-osszesitese"

#: components/worksheets/views/WorkSummaryView.yaml:50
msgctxt "WorkSummaryView"
msgid "Service name"
msgstr "Szolgáltatás"

#: components/worksheets/views/WorkSummaryView.yaml:60
msgctxt "WorkSummaryView"
msgid "unit"
msgstr "Egység"

#: components/worksheets/views/WorkSummaryView.yaml:63
msgctxt "WorkSummaryView"
msgid "Quantity"
msgstr "Mennyiség"

#: components/worksheets/views/WorkSummaryView.yaml:68
msgctxt "WorkSummaryView"
msgid "Net"
msgstr "Nettó"

#: components/worksheets/views/WorkSummaryView.yaml:73
msgctxt "WorkSummaryView"
msgid "VAT"
msgstr "ÁFA"

#: components/worksheets/views/WorkSummaryView.yaml:78
msgctxt "WorkSummaryView"
msgid "Amount"
msgstr "Összeg"

#: components/worksheets/views/WorkSummaryView.yaml:83
msgctxt "WorkSummaryView"
msgid "Rental"
msgstr "Bérlemény"

#: components/worksheets/views/WorkSummaryView.yaml:93
msgctxt "WorkSummaryView"
msgid "Company"
msgstr "Saját Cég"

#: components/worksheets/views/WorkSummaryView.yaml:113
msgctxt "WorkSummaryView"
msgid "Contractor"
msgstr "Alvállalkozó"

#: components/worksheets/views/WorkSummaryView.yaml:168
msgctxt "WorkSummaryViewFilters"
msgid "Load data"
msgstr "Adatok betöltése"

#: config.yaml:237
msgctxt "MeterTypes"
msgid "Pulse meter"
msgstr "Impulzusmérő"

#: config.yaml:240
msgctxt "MeterTypes"
msgid "Water meter"
msgstr "Vízóra"

#: config.yaml:243
msgctxt "MeterTypes"
msgid "Heat meter"
msgstr "Hőmennyiségmérő"

#: config.yaml:246
msgctxt "MeterTypes"
msgid "Electric meter"
msgstr "Elektromos fogyasztásmérő"

#: config.yaml:249
msgctxt "MeterTypes"
msgid "Gas meter"
msgstr "Gázmérő"

#: config.yaml:252
msgctxt "MeterTypes"
msgid "Cost allocator"
msgstr "Költségmegosztó"

#: templates.yaml:102
msgid "No"
msgstr "Nem"

#: templates.yaml:129
msgid "Updated by"
msgstr "Módosította"

#: templates.yaml:147
msgid "Updated at"
msgstr "Utolsó módosítás ideje"

#: translations-extra.yaml:1
msgid "Add item"
msgstr "Új elem"

#: translations-extra.yaml:3
msgctxt "my context"
msgid "Add item"
msgstr "Új elem"

#: translations-extra.yaml:5
msgid "Add single item"
msgid_plural "Add ${n} items."
msgstr[0] "Új elem"
msgstr[1] "${n} új elem."

#: translations-extra.yaml:7
msgid "Created"
msgstr "Készült"

#: translations-extra.yaml:10
msgctxt "ItpResourceMeta"
msgid "Created"
msgstr "Készült"

#: translations-extra.yaml:11
msgctxt "ItpResourceMeta"
msgid "Last modified"
msgstr "Utolsó módosítás"

#: translations-extra.yaml:13
msgctxt "NumberingID"
msgid "Dunning Letter"
msgstr "Felszólítólevél"

#: translations-extra.yaml:14
msgctxt "NumberingID"
msgid "Rental Contract"
msgstr "Bérleti szerződés"

#: translations-extra.yaml:16
msgctxt "PaymentMethod"
msgid "Cash"
msgstr "készpénz"

#: translations-extra.yaml:17
msgctxt "PaymentMethod"
msgid "Cash on delivery"
msgstr "utánvét"

#: translations-extra.yaml:19
msgctxt "PaymentMethod"
msgid "POS"
msgstr "POS"

#: translations-extra.yaml:26
msgctxt "PaymentMethod"
msgid "Inter Account Transfer"
msgstr "Átvezetés"

#: translations-extra.yaml:31
msgctxt "Status"
msgid "Approved"
msgstr "Jóváhagyva"

#: translations-extra.yaml:32
msgctxt "Status"
msgid "Enqueued"
msgstr "Sorban áll"

#: translations-extra.yaml:34
msgctxt "Status"
msgid "Received"
msgstr "Érkezett"

#: translations-extra.yaml:35
msgctxt "Status"
msgid "Filed"
msgstr "Iktatva"

#: translations-extra.yaml:36
msgctxt "Status"
msgid "Accounting"
msgstr "Könyvelés"

#: translations-extra.yaml:37
msgctxt "Status"
msgid "Accounted"
msgstr "Elszámolva"

#: translations-extra.yaml:38
msgctxt "Status"
msgid "Recorded"
msgstr "Rögzítve"

#: translations-extra.yaml:39
msgctxt "Status"
msgid "Open"
msgstr "Nyitott"

#: translations-extra.yaml:40
msgctxt "Status"
msgid "OK"
msgstr "OK"

#: translations-extra.yaml:41
msgctxt "Status"
msgid "Ok"
msgstr "OK"

#: translations-extra.yaml:42
msgctxt "Status"
msgid "Paid"
msgstr "Fizetve"

#: translations-extra.yaml:43
msgctxt "Status"
msgid "Processing"
msgstr "Feldolgozás alatt"

#: translations-extra.yaml:44
msgctxt "Status"
msgid "Void"
msgstr "Érvénytelen"

#: translations-extra.yaml:45
msgctxt "Status"
msgid "Error"
msgstr "Hiba"

#: translations-openapi.yaml:1
msgctxt "AccountTypes"
msgid "Bank account"
msgstr "Bankszámla"

#: translations-openapi.yaml:2
msgctxt "AccountTypes"
msgid "Cash book"
msgstr "Pénztár"

#: translations-openapi.yaml:3
msgctxt "AccountTypes"
msgid "Technical"
msgstr "Technikai"

#: translations-openapi.yaml:4
msgctxt "AddressType"
msgid "Billing"
msgstr "Számlázási cím"

#: translations-openapi.yaml:5
msgctxt "AddressType"
msgid "Branch"
msgstr "Fióktelep"

#: translations-openapi.yaml:6
msgctxt "AddressType"
msgid "Hq"
msgstr "Központ"

#: translations-openapi.yaml:7
msgctxt "AddressType"
msgid "Mailing"
msgstr "Levelezési cím"

#: translations-openapi.yaml:8
msgctxt "AddressType"
msgid "Premise"
msgstr "Telephely (iroda)"

#: translations-openapi.yaml:9
msgctxt "AddressType"
msgid "Registered office"
msgstr "Székhely"

#: translations-openapi.yaml:10
msgctxt "AddressType"
msgid "Seat"
msgstr "Székhely (seat)"

#: translations-openapi.yaml:11
msgctxt "AddressType"
msgid "Site"
msgstr "Telephely"

#: translations-openapi.yaml:12
msgctxt "BarcodeTypes"
msgid "Code128 A"
msgstr "Code128A"

#: translations-openapi.yaml:13
msgctxt "CheckOp"
msgid "Exists"
msgstr "Létező"

#: translations-openapi.yaml:14
msgctxt "CheckOp"
msgid "Unique"
msgstr "Egyedi"

#: translations-openapi.yaml:15
msgctxt "CompanyRelation"
msgid "Both"
msgstr "Mindkettő"

#: translations-openapi.yaml:16
msgctxt "CompanyRelation"
msgid "Customer"
msgstr "Vevő"

#: translations-openapi.yaml:17
msgctxt "CompanyRelation"
msgid "Na"
msgstr "n/a"

#: translations-openapi.yaml:18
msgctxt "CompanyRelation"
msgid "Vendor"
msgstr "Szállító"

#: translations-openapi.yaml:19
msgctxt "ContractPaymentTermTypes"
msgid "Day before end of month"
msgstr "Hónap vége előtt"

#: translations-openapi.yaml:20
msgctxt "ContractPaymentTermTypes"
msgid "Day of month"
msgstr "A hónap napja"

#: translations-openapi.yaml:21
msgctxt "ContractPaymentTermTypes"
msgid "Days"
msgstr "Napok"

#: translations-openapi.yaml:22
msgctxt "ContractStatus"
msgid "Active"
msgstr "Aktív"

#: translations-openapi.yaml:23
msgctxt "ContractStatus"
msgid "Approved"
msgstr "Jóváhagyva"

#: translations-openapi.yaml:24
msgctxt "ContractStatus"
msgid "Archived"
msgstr "Archiválva"

#: translations-openapi.yaml:25
msgctxt "ContractStatus"
msgid "Draft"
msgstr "Tervezet"

#: translations-openapi.yaml:26
msgctxt "ContractStatus"
msgid "Ended"
msgstr "Lejárt"

#: translations-openapi.yaml:27
msgctxt "ContractStatus"
msgid "Rescinded"
msgstr "Visszavonva"

#: translations-openapi.yaml:28
msgctxt "ContractStatus"
msgid "Signed"
msgstr "Aláírva"

#: translations-openapi.yaml:29
msgctxt "ContractStatus"
msgid "Terminated"
msgstr "Megszűnt"

#: translations-openapi.yaml:30
msgctxt "ContractTypes"
msgid "Parking"
msgstr "Parkoló bérleti"

#: translations-openapi.yaml:31
msgctxt "ContractTypes"
msgid "Rental"
msgstr "Bérleti"

#: translations-openapi.yaml:32
msgctxt "ContractTypes"
msgid "Rental agreement"
msgstr "Bérleti megállapodás"

#: translations-openapi.yaml:33
msgctxt "ContractTypes"
msgid "Service"
msgstr "Szolgáltatási"

#: translations-openapi.yaml:34
msgctxt "ContractTypes"
msgid "Unknown"
msgstr "Egyéb"

#: translations-openapi.yaml:35
msgctxt "ContractTypes"
msgid "Vendor"
msgstr "Beszállítói"

#: translations-openapi.yaml:39
msgctxt "HandoverType"
msgid "Moving in"
msgstr "Átadás"

#: translations-openapi.yaml:40
msgctxt "HandoverType"
msgid "Moving out"
msgstr "Visszavétel"

#: translations-openapi.yaml:41
msgctxt "IncomingInvoiceStatus"
msgid "Accounted"
msgstr "Elszámolva"

#: translations-openapi.yaml:42
msgctxt "IncomingInvoiceStatus"
msgid "Completed"
msgstr "Kész"

#: translations-openapi.yaml:43
msgctxt "IncomingInvoiceStatus"
msgid "Draft"
msgstr "Vázlat"

#: translations-openapi.yaml:44
msgctxt "IncomingInvoiceStatus"
msgid "Filed"
msgstr "Iktatva"

#: translations-openapi.yaml:45
msgctxt "IncomingInvoiceStatus"
msgid "Received"
msgstr "Érkezett"

#: translations-openapi.yaml:46
msgctxt "IncomingInvoiceStatus"
msgid "Recorded"
msgstr "Rögzítve"

#: translations-openapi.yaml:47
msgctxt "IndexingRule"
msgid "First day of the year"
msgstr "az év első napján"

#: translations-openapi.yaml:48
msgctxt "IndexingRule"
msgid "Period end"
msgstr "fordulónapon"

#: translations-openapi.yaml:49
msgctxt "InvoiceAppearance"
msgid "Edi"
msgstr "EDI"

#: translations-openapi.yaml:50
msgctxt "InvoiceAppearance"
msgid "Electronic"
msgstr "Elektronikus"

#: translations-openapi.yaml:51
msgctxt "InvoiceAppearance"
msgid "Paper"
msgstr "Papír"

#: translations-openapi.yaml:52
msgctxt "InvoiceAppearance"
msgid "Unknown"
msgstr "Ismeretlen"

#: translations-openapi.yaml:53
msgctxt "InvoiceCategory"
msgid "Aggregate"
msgstr "Gyűjtő"

#: translations-openapi.yaml:54
msgctxt "InvoiceCategory"
msgid "Normal"
msgstr "Normál"

#: translations-openapi.yaml:55
msgctxt "InvoiceCategory"
msgid "Simplified"
msgstr "Egyszerűsített"

#: translations-openapi.yaml:60
msgctxt "InvoiceType"
msgid "Proforma"
msgstr "Pro Forma"

#: translations-openapi.yaml:62
msgctxt "InvoicingMode"
msgid "Default"
msgstr "Alapértelmezett"

#: translations-openapi.yaml:63
msgctxt "InvoicingMode"
msgid "Szamlazz hu"
msgstr "Számlázz.hu"

#: translations-openapi.yaml:64
msgctxt "JobStatus"
msgid "Cancelled"
msgstr "Megszakítva"

#: translations-openapi.yaml:65
msgctxt "JobStatus"
msgid "Completed"
msgstr "Kész"

#: translations-openapi.yaml:66
msgctxt "JobStatus"
msgid "Deleted"
msgstr "Törölt"

#: translations-openapi.yaml:67
msgctxt "JobStatus"
msgid "Failed"
msgstr "Hiba"

#: translations-openapi.yaml:68
msgctxt "JobStatus"
msgid "Invalid"
msgstr "Érvénytelen"

#: translations-openapi.yaml:69
msgctxt "JobStatus"
msgid "Pending"
msgstr "Várakozik"

#: translations-openapi.yaml:70
msgctxt "JobStatus"
msgid "Retry"
msgstr "Újrakezdés"

#: translations-openapi.yaml:71
msgctxt "JobStatus"
msgid "Running"
msgstr "Folyamatban"

#: translations-openapi.yaml:72
msgctxt "MeterOperationTypes"
msgid "Replacement"
msgstr "Csere"

#: translations-openapi.yaml:74
msgctxt "MeterTypes"
msgid "Electricity"
msgstr "Villany"

#: translations-openapi.yaml:75
msgctxt "MeterTypes"
msgid "Gas"
msgstr "Gáz"

#: translations-openapi.yaml:76
msgctxt "MeterTypes"
msgid "Heat"
msgstr "Hőmennyiség"

#: translations-openapi.yaml:77
msgctxt "MeterTypes"
msgid "Pulse"
msgstr "Impulzusmérő"

#: translations-openapi.yaml:78
msgctxt "MeterTypes"
msgid "Water"
msgstr "Víz"

#: translations-openapi.yaml:79
msgctxt "NotificationState"
msgid "Deleted"
msgstr "Törölve"

#: translations-openapi.yaml:80
msgctxt "NotificationState"
msgid "Handled"
msgstr "Kezelt"

#: translations-openapi.yaml:81
msgctxt "NotificationState"
msgid "New"
msgstr "Új"

#: translations-openapi.yaml:82
msgctxt "ObjectTypes"
msgid "Account statement"
msgstr "Pénztári elszámolás"

#: translations-openapi.yaml:83
msgctxt "ObjectTypes"
msgid "Dunning letter"
msgstr "Felszólítólevél"

#: translations-openapi.yaml:84
msgctxt "ObjectTypes"
msgid "Invoice"
msgstr "Számla"

#: translations-openapi.yaml:85
msgctxt "ObjectTypes"
msgid "Invoice line notes"
msgstr "Számlatétel megjegyzés"

#: translations-openapi.yaml:86
msgctxt "ObjectTypes"
msgid "Invoice notes"
msgstr "Számla megjegyzés"

#: translations-openapi.yaml:87
msgctxt "ObjectTypes"
msgid "Invoice notification"
msgstr "Számlaértesítés"

#: translations-openapi.yaml:88
msgctxt "ObjectTypes"
msgid "Na"
msgstr "n/a"

#: translations-openapi.yaml:89
msgctxt "ObjectTypes"
msgid "Payment"
msgstr "Pénzforgalom"

#: translations-openapi.yaml:90
msgctxt "ObjectTypes"
msgid "Rental handover protocol"
msgstr "Bérlemény átadás/átvételi jegyzőkönyv"

#: translations-openapi.yaml:91
msgctxt "ObjectTypes"
msgid "Worksheet"
msgstr "Munkalap"

#: translations-openapi.yaml:92
msgctxt "OutgoingInvoiceStatus"
msgid "Completed"
msgstr "Kész"

#: translations-openapi.yaml:93
msgctxt "OutgoingInvoiceStatus"
msgid "Draft"
msgstr "Tervezet"

#: translations-openapi.yaml:94
msgctxt "PaymentTransactionKind"
msgid "Bank"
msgstr "Bank"

#: translations-openapi.yaml:95
msgctxt "PaymentTransactionKind"
msgid "Cash book"
msgstr "Pénztár"

#: translations-openapi.yaml:96
msgctxt "PaymentTransactionKind"
msgid "Technical"
msgstr "Technikai"

#: translations-openapi.yaml:97
msgctxt "ProductTypes"
msgid "Article"
msgstr "Cikk"

#: translations-openapi.yaml:98
msgctxt "ProductTypes"
msgid "Product"
msgstr "Termék"

#: translations-openapi.yaml:99
msgctxt "ProductTypes"
msgid "Raw material"
msgstr "Alapanyag"

#: translations-openapi.yaml:100
msgctxt "ProductTypes"
msgid "Service"
msgstr "Szolgáltatás"

#: translations-openapi.yaml:101
msgctxt "ProductTypes"
msgid "Tool"
msgstr "Eszköz"

#: translations-openapi.yaml:102
msgctxt "ProtocolStatus"
msgid "Cancelled"
msgstr "Érvénytelenítve"

#: translations-openapi.yaml:103
msgctxt "ProtocolStatus"
msgid "Completed"
msgstr "Kész"

#: translations-openapi.yaml:104
msgctxt "ProtocolStatus"
msgid "Draft"
msgstr "Tervezet"

#: translations-openapi.yaml:105
msgctxt "RegisterDocumentType"
msgid "Bank statement"
msgstr "Banki kivonat"

#: translations-openapi.yaml:106
msgctxt "RegisterDocumentType"
msgid "Contract"
msgstr "Szerződés"

#: translations-openapi.yaml:107
msgctxt "RegisterDocumentType"
msgid "Invoice"
msgstr "Számla"

#: translations-openapi.yaml:108
msgctxt "RegisterDocumentType"
msgid "Letter"
msgstr "Levél"

#: translations-openapi.yaml:109
msgctxt "RegisterDocumentType"
msgid "Other"
msgstr "Egyéb"

#: translations-openapi.yaml:110
msgctxt "RegisterEntryDirection"
msgid "Inbound"
msgstr "Bejövő"

#: translations-openapi.yaml:111
msgctxt "RegisterEntryDirection"
msgid "Outbound"
msgstr "Kimenő"

#: translations-openapi.yaml:112
msgctxt "SyncTargetTypes"
msgid "Szamlazz hu"
msgstr "Számlázz.hu"

#: translations-openapi.yaml:113
msgctxt "TemplateTypes"
msgid "Html"
msgstr "HTML"

#: translations-openapi.yaml:114
msgctxt "TemplateTypes"
msgid "Mjml"
msgstr "MJML"

#: translations-openapi.yaml:115
msgctxt "TemplateTypes"
msgid "Text"
msgstr "Szöveg"

#: translations-openapi.yaml:116
msgctxt "UnitTypes"
msgid "Area"
msgstr "Terület"

#: translations-openapi.yaml:117
msgctxt "UnitTypes"
msgid "Energy"
msgstr "Energia"

#: translations-openapi.yaml:118
msgctxt "UnitTypes"
msgid "Length"
msgstr "Hosszúság"

#: translations-openapi.yaml:119
msgctxt "UnitTypes"
msgid "Mass"
msgstr "Tömeg"

#: translations-openapi.yaml:120
msgctxt "UnitTypes"
msgid "Temperature"
msgstr "Hőmérséklet"

#: translations-openapi.yaml:121
msgctxt "UnitTypes"
msgid "Time"
msgstr "Idő"

#: translations-openapi.yaml:122
msgctxt "UnitTypes"
msgid "Volume"
msgstr "Térfogat"

#: translations-openapi.yaml:123
msgctxt "VATFrequency"
msgid "Monthly"
msgstr "havi"

#: translations-openapi.yaml:124
msgctxt "VATFrequency"
msgid "Quarterly"
msgstr "negyedéves"

#: translations-openapi.yaml:125
msgctxt "VATFrequency"
msgid "Yearly"
msgstr "éves"

#: translations-openapi.yaml:126
msgctxt "WorksheetStatus"
msgid "Approved"
msgstr "Jóváhagyott"

#: translations-openapi.yaml:127
msgctxt "WorksheetStatus"
msgid "Completed"
msgstr "Elkészült"

#: translations-openapi.yaml:128
msgctxt "WorksheetStatus"
msgid "Invalid"
msgstr "Érvénytelen"

#: translations-openapi.yaml:129
msgctxt "WorksheetStatus"
msgid "New"
msgstr "Új"

#: translations-openapi.yaml:130
msgctxt "WorksheetStatus"
msgid "Pending"
msgstr "Várakozik"

#: translations-openapi.yaml:131
msgctxt "WorksheetStatus"
msgid "Started"
msgstr "Megkezdett"

msgid "No data available"
msgstr "Nincs megjeleníthető adat"

msgctxt "ItpDataTable"
msgid "Create"
msgstr "Létrehozás"

msgctxt "ItpDataTable"
msgid "Delete"
msgstr "Törlés"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/numberings/Numberings.yaml:36
msgctxt "Numberings"
msgid "Numberings"
msgstr "Számozások"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/rental/form/services/UcRentalServices.yaml:269
msgctxt "RentalServices"
msgid "Order"
msgstr "Rendezés"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/rental/form/services/UcRentalServices.yaml:306
msgctxt "RentalServices"
msgid "No services match the current filters."
msgstr "Egyik szolgáltatás sem felel meg a jelenlegi szűrőknek."

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/common/BtnSyncResource.yaml:37
msgctxt "BtnSyncResource"
msgid "Sync to IntegroRent"
msgstr "Szinkronizálás az IntegroRent-be"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/common/BtnSyncResource.yaml:52
msgctxt "BtnSyncResource"
msgid "IntegroRent synchronization"
msgstr "IntegroRent szinkronizáció"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/common/BtnSyncResource.yaml:54
msgctxt "BtnSyncResource"
msgid "Write data back to the IntegroRent system"
msgstr "Adat visszaírása az IntegroRent rendszerbe"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/common/BtnSyncResource.yaml:56
msgctxt "BtnSyncResource"
msgid "Synchronization"
msgstr "Szinkronizáció"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/common/BtnSyncResource.yaml:57
msgctxt "BtnSyncResource"
msgid "Cancel"
msgstr "Mégsem"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/common/BtnSyncResource.yaml:68
msgctxt "BtnSyncResource"
msgid "Synchronized"
msgstr "Szinkronizálva"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/meters/form/consumptions/MeterConsumption.yaml:118
msgctxt "MeterConsumption"
msgid "The meter this consumption belongs to"
msgstr "A fogyasztáshoz tartozó mérőóra"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/AppDropdownMainMenu.yaml:49
msgctxt "SidebarHeader"
msgid "Toggle sidebar"
msgstr "Oldalsáv váltása"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/AppDropdownMainMenu.yaml:64
msgctxt "MainMenu"
msgid "Apps"
msgstr "Alkalmazások"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/form/ConfirmSyncInvoice.yaml:78
msgctxt "InvoiceSync"
msgid "After synchronization, the invoice can no longer be modified."
msgstr "Szinkronizáció után a számla már nem módosítható."

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/form/BtnIssueInvoice.yaml:45
msgctxt "BtnIssueInvoice"
msgid "Issue invoice"
msgstr "Számla kiállítása"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/form/BtnIssueInvoice.yaml:46
msgctxt "BtnIssueInvoice"
msgid "Finalize and issue the invoice."
msgstr "Véglegesítés és számla kiállítása"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/form/BtnIssueInvoice.yaml:49
msgctxt "BtnIssueInvoice"
msgid ""
"Please confirm issuing the invoice. The issued invoice can no longer be "
"modified."
msgstr ""
"Erősítse meg a számla kiállítását. A kiállított számla már nem módosítható."

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/form/BtnIssueInvoice.yaml:52
msgctxt "BtnIssueInvoice"
msgid "Cancel"
msgstr "Mégsem"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/form/BtnSyncInvoice.yaml:21
msgctxt "BtnSyncInvoice"
msgid "Issue Invoice"
msgstr "Számla kiállítása"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/form/BtnSyncInvoice.yaml:22
msgctxt "BtnSyncInvoice"
msgid "Issuance of the invoice by the billing service provider"
msgstr "A számla kiállítása a számlázó szolgáltatónál"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/form/BtnSyncInvoice.yaml:24
msgctxt "BtnSyncInvoice"
msgid "Synchronization"
msgstr "Szinkronizáció"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/form/BtnSyncInvoice.yaml:27
msgctxt "BtnSyncInvoice"
msgid "Synchronize invoice"
msgstr "Számla szinkronizálása"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/form/BtnSyncInvoice.yaml:29
msgctxt "BtnSyncInvoice"
msgid ""
"The invoice can  only be uploaded once in the szamlazz.hu system, after "
"uploading the invoice cannot be modified"
msgstr ""
"A számlát csak egyszer lehet feltölteni a szamlazz.hu rendszerébe, feltöltés "
"után a számlát már nem lehet módosítani."

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/form/BtnSyncInvoice.yaml:32
msgctxt "BtnSyncInvoice"
msgid "Cancel"
msgstr "Mégsem"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/form/BtnSyncInvoice.yaml:35
msgctxt "BtnSyncInvoice"
msgid "Cancel synchronization"
msgstr "Szinkronizáció megszakítása"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/form/BtnSyncInvoice.yaml:37
msgctxt "BtnSyncInvoice"
msgid ""
"If interrupted, the invoice will not be synchronized. Its content can be "
"edited and re-synchronized with the new data afterwards. Queue processing is "
"paused at the interrupted item."
msgstr ""
"Megszakítás esetén a számla nem lesz szinkronizálva. Tartalma módosítható, "
"szerkesztés után az új adattartalommal újra szinkronizálható. A sor "
"feldolgozása a megaszakított elemnél szünetel."

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/form/BtnSyncInvoice.yaml:41
msgctxt "BtnSyncInvoice"
msgid "Interrupt"
msgstr "Megszakítás"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/form/BtnSyncInvoice.yaml:44
msgctxt "BtnSyncInvoice"
msgid "View log file"
msgstr "Naplózási fájl megtekintése"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/form/BtnSyncInvoice.yaml:57
msgctxt "BtnSyncInvoice"
msgid "Invoice issuance in progress"
msgstr "Számla kiállítása folyamatban"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/form/BtnSyncInvoice.yaml:59
msgctxt "BtnSyncInvoice"
msgid ""
"The invoice is waiting for synchronization and cannot be modified in this "
"state."
msgstr "A számla szinkronizálásra vár, ebben az állapotában nem módosítható."

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/form/BtnSyncInvoice.yaml:68
msgctxt "BtnSyncInvoice"
msgid "The invoice is being synchronized."
msgstr "A számla éppen szinkronizálás alatt van."

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/form/BtnSyncInvoice.yaml:81
msgctxt "BtnSyncInvoice"
msgid "Invoice issuance error"
msgstr "Számla kiállítási hiba"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/form/BtnSyncInvoice.yaml:82
msgctxt "BtnSyncInvoice"
msgid "An error occurred during synchronization."
msgstr "Hiba lépett fel a szinkronizáció során."

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/form/BtnSyncInvoice.yaml:88
msgctxt "BtnSyncInvoice"
msgid "Invoice issuance cancelled"
msgstr "Számla kiállítás megszakítva"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/form/BtnSyncInvoice.yaml:90
msgctxt "BtnSyncInvoice"
msgid "The invoice was removed from the synchronization queue."
msgstr "A számla törölve lett a szinkronizálási sorból."

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/form/BtnReportInvoiceData.yaml:27
msgctxt "BtnReportInvoiceData"
msgid "NAV electric data service"
msgstr "NAV elektronikus adatszolgáltatás"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/form/BtnReportInvoiceData.yaml:41
msgctxt "BtnReportInvoiceData"
msgid "NAV data submission"
msgstr "NAV adatszolgáltatás"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/form/BtnReportInvoiceData.yaml:45
msgctxt "BtnReportInvoiceData"
msgid "Please confirm starting the data submission."
msgstr "Erősítse meg az adatküldés megkezdését."

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/form/BtnReportInvoiceData.yaml:47
msgctxt "BtnReportInvoiceData"
msgid "Start data submission"
msgstr "Adatszolgáltatás elindítása"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/form/BtnReportInvoiceData.yaml:48
msgctxt "BtnReportInvoiceData"
msgid "Cancel"
msgstr "Mégsem"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/components/invoice/CreatePassThroughInvoice.yaml:4
msgctxt "Invoice"
msgid "Create Pass-through Invoice"
msgstr "Átmenő számla létrehozása"

#: /Users/Shared/files_from_C/MUNKA/INTEGRO/integro-appbuilder/packages/integro/src/translations-extra.yaml:49
msgctxt "Done"
msgid "Kész"
msgstr "Kész"

#~ msgctxt "Invoices"
#~ msgid "Claim"
#~ msgstr "Követelés"

#~ msgctxt "InvoicesView"
#~ msgid "Overpayment"
#~ msgstr "Túlfizetés"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Contract"
#~ msgstr "Szerződés"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Invoice Number"
#~ msgstr "Számlaszám"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Company"
#~ msgstr "Saját cég"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Client"
#~ msgstr "Ügyfél"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Rental"
#~ msgstr "Bérlemény"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Site"
#~ msgstr "Telephely"

#~ msgctxt "DraftInvoices|Submit"
#~ msgid "Create Invoices"
#~ msgstr "Számla kiállítása"

#~ msgctxt "RentalService|Tooltip"
#~ msgid "Select the product or service the invoice line refers to."
#~ msgstr "A vonatkozó termék vagy szolgáltatás a terméktörzsből."

#~ msgctxt "RentalService"
#~ msgid "Invoice Group"
#~ msgstr "Számlázási csoport"

#~ msgctxt "RentalService|Tooltip"
#~ msgid "The invoice group this service belongs to."
#~ msgstr "A szolgáltatás a megadott számlázási csoporthoz fog tartozni."

#~ msgctxt "RentalService|Tooltip"
#~ msgid ""
#~ "Select this option if the service is provided via an intermediary party."
#~ msgstr "Közvetített szolgáltatás esetén kötelezően ki kell választani."

#~ msgctxt "RentalService|Tooltip"
#~ msgid "Internal notes for reference only. Not visible externally."
#~ msgstr "Belső megjegyzés. A számlákon nem jelenik meg."

#~ msgctxt "RentalServiceEditor|Section"
#~ msgid "Invoicing"
#~ msgstr "Számlázás"

#~ msgctxt "RentalServiceFee"
#~ msgid "Invoice notes"
#~ msgstr "Számlatétel megjegyzés"

#~ msgctxt "RentalService"
#~ msgid "Billing currency"
#~ msgstr "Számlázás pénzneme"

#~ msgctxt "RentalService|Tooltip"
#~ msgid "The currency to use on the invoice."
#~ msgstr "A számlakiállítás pénzneme."

#, fuzzy
#~| msgid "Intermediated service"
#~ msgctxt "ContractServiceFee"
#~ msgid "Intermediated service"
#~ msgstr "Közvetített szolgáltatás"

#~ msgctxt "AttachmentsView"
#~ msgid "Create time"
#~ msgstr "Kelt"

#~ msgctxt "DunningLetters"
#~ msgid "Created at"
#~ msgstr "Készült"

#~ msgctxt "ContractService"
#~ msgid "Create time"
#~ msgstr "Kelt"

#~ msgctxt "InvoicesView"
#~ msgid "Claim"
#~ msgstr "Követelés"

#~ msgctxt "MeterConsumptionBrowser"
#~ msgid "Invoices"
#~ msgstr "Számlák"

#~ msgctxt "PaymentsFilters"
#~ msgid "Load data"
#~ msgstr "Adatok betöltése"

#~ msgctxt "BillingListItem"
#~ msgid "Currency"
#~ msgstr "Pénznem"

#~ msgctxt "CopyBillingListItems"
#~ msgid "Specify the unit of measurement to use when creating new items."
#~ msgstr "Az új tételek létrehozásához használt mértékegység megadása."

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Contract valid from"
#~ msgstr "Érvényesség kezdete"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Contract valid to"
#~ msgstr "Érvényesség vége"

#~ msgid "Sync"
#~ msgstr "Szinkronizálás"

#~ msgctxt "MeterConsumptions|Submit"
#~ msgid "Create Invoices"
#~ msgstr "Számlák elkészítése"

#~ msgctxt "BillingList"
#~ msgid "Commands"
#~ msgstr "Parancsok"

#~ msgctxt "ContractEvents"
#~ msgid "Contract Number"
#~ msgstr "Szerződésszám"

#~ msgctxt "JobHandler"
#~ msgid "Reload"
#~ msgstr "Frissítés"

#~ msgctxt "BillingListItem"
#~ msgid "Due date"
#~ msgstr "Esedékesség"

#~ msgctxt "BillingList"
#~ msgid "Invoice due date"
#~ msgstr "Számla fizetési határideje"

#~ msgctxt "BillingList"
#~ msgid "Due date"
#~ msgstr "Fizetési határidő"

#~ msgctxt "MeterConsumptionBrowser"
#~ msgid "Lessor"
#~ msgstr "Bérbeadó"

#~ msgctxt "MeterRentalServices"
#~ msgid "Rental Services"
#~ msgstr "Bérlemény Szolgáltatások"

#~ msgctxt "UcRentalServices"
#~ msgid "Add rental service..."
#~ msgstr "Szolgáltatás hozzáadása..."

#~ msgctxt "Payment"
#~ msgid "Exchange Rate"
#~ msgstr "Árfolyam"

#~ msgctxt "Invoice"
#~ msgid "Exchange rate provider"
#~ msgstr "Árfolyam szolgáltatója"

#~ msgctxt "PaymentsViewFilters"
#~ msgid "Load data"
#~ msgstr "Adatok betöltése"

#~ msgctxt "Register"
#~ msgid "Amount"
#~ msgstr "Összeg"

#~ msgctxt "Register"
#~ msgid "Currency"
#~ msgstr "Pénznem"

#~ msgctxt "ContractService|Badge|Abbr"
#~ msgid "I"
#~ msgstr "K"

#~ msgctxt "ContractService|Badge|Tooltip"
#~ msgid "Intermediated service"
#~ msgstr "Közvetített szolgáltatás"

#~ msgctxt "StatDataType"
#~ msgid "Ksh domestic industrial sales price index"
#~ msgstr "KSH belföldi értékesítési árak ipari indexe"

#~ msgctxt "StatDataType"
#~ msgid "Other"
#~ msgstr "Egyéb"

#~ msgctxt "RegisterSelector"
#~ msgid "No register defined"
#~ msgstr "Nincs iktatókönyv létrehozva"

#~ msgctxt "TemplateSelector"
#~ msgid "No template defined"
#~ msgstr "Nincs sablon létrehozva"

#~ msgctxt "StatDataType"
#~ msgid "KSH domestic industrial sales price index"
#~ msgstr "KSH belföldi értékesítési árak ipari indexe"

#~ msgid "Data type"
#~ msgstr "Adattípus"

#~ msgctxt "Contract"
#~ msgid "Reserve"
#~ msgstr "Fenntartott"

#~ msgctxt "Contract"
#~ msgid "Billing"
#~ msgstr "Számlázás"

#~ msgctxt "Invoice"
#~ msgid "Reference Date"
#~ msgstr "Vonatkozó dátum"

#~ msgctxt "Invoice"
#~ msgid "Reference date"
#~ msgstr "Vonatkozó dátum"

#~ msgctxt "Templates"
#~ msgid "Template"
#~ msgstr "Sablon"

#~ msgctxt "Templates"
#~ msgid "General"
#~ msgstr "Általános"

#~ msgctxt "Templates"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "Templates"
#~ msgid ""
#~ "The subject of the email sent to the client. This is a template "
#~ "definition, interpolate expressions can be used here."
#~ msgstr ""
#~ "Az ügyfélnek küldött email tárgya. Mező behelyettesítések (\\{{ ... }}) "
#~ "itt is használhatóak."

#~ msgctxt "Templates"
#~ msgid "Body template"
#~ msgstr "Sablon"

#~ msgctxt "Templates"
#~ msgid "Render"
#~ msgstr "Előnézet generálása"

#~ msgctxt "Templates"
#~ msgid "Data"
#~ msgstr "Adatok"

#~ msgctxt "Templates"
#~ msgid "Search data"
#~ msgstr "Adatok keresése"

#~ msgctxt "BillingList"
#~ msgid "Client"
#~ msgstr "Ügyfél"

#~ msgctxt "PropertyBrowser"
#~ msgid "Location number"
#~ msgstr "Helykód"

#~ msgctxt "InvoicesView"
#~ msgid "Vendor invoices"
#~ msgstr "Szállítói számlák"

#~ msgctxt "InvoicesView"
#~ msgid "Customer invoices"
#~ msgstr "Vevőszámlák"

#~ msgctxt "InvoicesView"
#~ msgid "VAT"
#~ msgstr "ÁFA"

#~ msgctxt "InvoicesView"
#~ msgid "Total"
#~ msgstr "Végösszeg"

#~ msgctxt "InvoicesView"
#~ msgid "New Invoice..."
#~ msgstr "Új számla..."

#~ msgctxt "InvoicesView"
#~ msgid "Import Invoices..."
#~ msgstr "Számlák importálása..."

#~ msgctxt "InvoicesView"
#~ msgid "Print invoices..."
#~ msgstr "Számlák nyomtatása..."

#~ msgctxt "filename"
#~ msgid "client-invoices"
#~ msgstr "ügyfélszámlák"

#~ msgctxt "Rental"
#~ msgid "No related invoices."
#~ msgstr "Nincsenek kapcsolódó számlák."

#~ msgctxt "InvoiceRental"
#~ msgid "Net"
#~ msgstr "Nettó"

#~ msgctxt "InvoiceRental"
#~ msgid "Total"
#~ msgstr "Végösszeg"

#~ msgctxt "InvoiceRental"
#~ msgid "Billing Period"
#~ msgstr "Számlázási időszak"

#~ msgctxt "BillingListView"
#~ msgid "Due date"
#~ msgstr "Esedékesség"

#~ msgctxt "BillingListView"
#~ msgid "Description"
#~ msgstr "Megnevezés"

#~ msgctxt "InvoiceGenerator"
#~ msgid "Description"
#~ msgstr "Megnevezés"

#~ msgid "Approve"
#~ msgstr "Jóváhagy"

#~ msgid "New session..."
#~ msgstr "Új munkamenet..."

#~ msgctxt "DraftInvoices"
#~ msgid "Totals"
#~ msgstr "Végösszeg"

#~ msgctxt "DraftInvoices.Totals"
#~ msgid "Currency"
#~ msgstr "Pénznem"

#~ msgctxt "DraftInvoices.Totals"
#~ msgid "Net"
#~ msgstr "Nettó"

#~ msgctxt "DraftInvoices.Totals"
#~ msgid "VAT"
#~ msgstr "ÁFA"

#~ msgctxt "DraftInvoices.Totals"
#~ msgid "Amount"
#~ msgstr "Összeg"

#~ msgctxt "InvoiceGenerator"
#~ msgid "Worksheets"
#~ msgstr "Munkalapok"

#~ msgid "Registers"
#~ msgstr "Iktatókönyvek"

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Entry date"
#~ msgstr "Érkezett"

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Subject"
#~ msgstr "Tárgy"

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Reference entry"
#~ msgstr "Hivatkozott bejegyzés"

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Invoice number"
#~ msgstr "Számlaszám"

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Invoice number mismatch"
#~ msgstr "Eltérő számlaszámok"

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Assign..."
#~ msgstr "Hozzárendelés..."

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Assign invoice."
#~ msgstr "Számla hozzárendelése."

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Record..."
#~ msgstr "Rögzítés..."

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Record a new invoice."
#~ msgstr "Számla rögzítése."

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Invoice type"
#~ msgstr "Típus"

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Status"
#~ msgstr "Státusz"

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Categories"
#~ msgstr "Kategóriák"

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Client"
#~ msgstr "Ügyfél"

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Fulfillment date"
#~ msgstr "Teljesítés dátuma"

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Due date"
#~ msgstr "Fizetési határidő"

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Payment method"
#~ msgstr "Fizetési mód"

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Amount"
#~ msgstr "Összeg"

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "InvoiceRegisterEntry/Button"
#~ msgid "Create entry"
#~ msgstr "Bejegyzés mentése"

#~ msgctxt "Invoice register"
#~ msgid "Invoice register"
#~ msgstr "Számlák iktatása"

#~ msgctxt "filename"
#~ msgid "invoice-register"
#~ msgstr "szállítói-számlák-iktatókönyv"

#~ msgctxt "Invoice register"
#~ msgid "No."
#~ msgstr "Sorszám"

#~ msgctxt "Invoice register"
#~ msgid "Ref."
#~ msgstr "Hiv."

#~ msgctxt "Invoice register"
#~ msgid "Invoice number"
#~ msgstr "Számlaszám"

#~ msgctxt "Invoice register"
#~ msgid "Invoice assigned"
#~ msgstr "Hozzárendelve"

#~ msgctxt "Invoice register"
#~ msgid "Invoice type"
#~ msgstr "Típus"

#~ msgctxt "Invoice register"
#~ msgid "Status"
#~ msgstr "Státusz"

#~ msgctxt "Invoice register"
#~ msgid "Category"
#~ msgstr "Kategória"

#~ msgctxt "Invoice register"
#~ msgid "Vendor"
#~ msgstr "Szállító"

#~ msgctxt "Invoice register"
#~ msgid "Subject"
#~ msgstr "Tárgy"

#~ msgctxt "Invoice register"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "Invoice register"
#~ msgid "Amount"
#~ msgstr "Összeg"

#~ msgctxt "Invoice register"
#~ msgid "Currency"
#~ msgstr "Pénznem"

#~ msgctxt "Invoice register"
#~ msgid "Fulfillment date"
#~ msgstr "Teljesítés dátuma"

#~ msgctxt "Invoice register"
#~ msgid "Due date"
#~ msgstr "Fizetési határidő"

#~ msgctxt "InvoiceRegister"
#~ msgid "Add entry..."
#~ msgstr "Új bejegyzés..."

#~ msgctxt "InvoiceRegister"
#~ msgid "Set status to selected items"
#~ msgstr "Státusz beállítása a kijelült elemekre"

#~ msgctxt "InvoiceRegister"
#~ msgid "Set status"
#~ msgstr "Státusz beállítása"

#~ msgctxt "InvoiceRegister"
#~ msgid "Clear status"
#~ msgstr "Státusz törlése"

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Create new entry"
#~ msgstr "Új bejegyzés"

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "New Registry Entry"
#~ msgstr "Új bejegyzés"

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Edit Invoice Registry Information"
#~ msgstr "Bejegyzés szerkesztése"

#~ msgctxt "InvoiceRegisterEntry/Command"
#~ msgid "Create another entry"
#~ msgstr "Új bejegyzés létrehozása"

#~ msgctxt "InvoiceRegister"
#~ msgid "New entry"
#~ msgstr "Új bejegyzés"

#~ msgctxt "InvoiceRegisterEntryHeader"
#~ msgid "Invoice number"
#~ msgstr "Számlaszám"

#~ msgctxt "InvoiceRegister"
#~ msgid "Lock entry"
#~ msgstr "Bejegyzés zárolása"

#~ msgctxt "InvoiceRegister"
#~ msgid "Delete entry"
#~ msgstr "Bejegyzés törlése"

#~ msgctxt "InvoiceRegister"
#~ msgid "Invoice register"
#~ msgstr "Számlák iktatása"

#~ msgctxt "LetterRegisterEntry"
#~ msgid "Entry date"
#~ msgstr "Bejegyzés dátuma"

#~ msgctxt "LetterRegisterEntry"
#~ msgid "Categories"
#~ msgstr "Kategóriák"

#~ msgctxt "LetterRegisterEntry"
#~ msgid "Client"
#~ msgstr "Ügyfél"

# TODO
#~ msgctxt "LetterRegisterEntry"
#~ msgid "Subject"
#~ msgstr "Tárgy"

#~ msgctxt "LetterRegisterEntry"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "LetterRegisterEntry"
#~ msgid "Delivery date"
#~ msgstr "Kézbesítés dátuma"

#~ msgctxt "LetterRegisterEntry"
#~ msgid "Undelivered"
#~ msgstr "Kézbesítetlen"

#~ msgctxt "LetterRegisterEntry/Button"
#~ msgid "Create entry"
#~ msgstr "Bejegyzés mentése"

#~ msgctxt "Letter register"
#~ msgid "Letter register"
#~ msgstr "Iktatókönyv (levelek)"

#~ msgctxt "filename"
#~ msgid "letter-register"
#~ msgstr "iktatóköny-levelek"

#~ msgctxt "Letter register"
#~ msgid "No."
#~ msgstr "Sorszám"

#~ msgctxt "Letter register"
#~ msgid "Date"
#~ msgstr "Dátum"

#~ msgctxt "Letter register"
#~ msgid "Category"
#~ msgstr "Kategória"

#~ msgctxt "Letter register"
#~ msgid "Client"
#~ msgstr "Ügyfél"

# TODO
#~ msgctxt "Letter register"
#~ msgid "Subject"
#~ msgstr "Tárgy"

#~ msgctxt "Letter register"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "Letter register"
#~ msgid "Delivery date"
#~ msgstr "Kézbesítés dátuma"

#~ msgctxt "Letter register"
#~ msgid "Undelivered"
#~ msgstr "Kézbesíthetetlen"

#~ msgctxt "LetterRegister"
#~ msgid "Add entry..."
#~ msgstr "Új bejegyzés..."

#~ msgctxt "LetterRegisterEntry"
#~ msgid "Create new entry"
#~ msgstr "Új bejegyzés"

#~ msgctxt "LetterRegisterEntry/Command"
#~ msgid "Create another entry"
#~ msgstr "Új bejegyzés létrehozása"

#~ msgctxt "LetterRegister"
#~ msgid "New entry"
#~ msgstr "Új bejegyzés"

#~ msgctxt "Register"
#~ msgid "Invoice number"
#~ msgstr "Számlaszám"

#~ msgctxt "Register"
#~ msgid "Invoice assigned"
#~ msgstr "Hozzárendelve"

#~ msgctxt "Register"
#~ msgid "Invoice type"
#~ msgstr "Számlatípus"

#~ msgctxt "Register"
#~ msgid "Lock entry"
#~ msgstr "Iktatás zárolása"

#~ msgctxt "RegisterEntry"
#~ msgid "Click to assign it to the current entry."
#~ msgstr "A számla hozzárendelhető ehhez az iktatáshoz."

#~ msgctxt "Charts|Title"
#~ msgid "Reports"
#~ msgstr "Kimutatások"

#~ msgctxt "RegisterDocumentType"
#~ msgid "Email"
#~ msgstr "Email"

#~ msgctxt "RegisterEntry"
#~ msgid "Direction"
#~ msgstr "Irány"

#~ msgctxt "RegisterEntry"
#~ msgid "Entry date"
#~ msgstr "Iktatás dátuma"

#~ msgctxt "RegisterEntry"
#~ msgid "Client"
#~ msgstr "Ügyfél"

#~ msgctxt "RegisterEntry"
#~ msgid "Invoice number"
#~ msgstr "Számlaszám"

#~ msgid "New Register"
#~ msgstr "Új iktatókönyv"

#~ msgctxt "Register"
#~ msgid "Register type"
#~ msgstr "Típus"

#~ msgctxt "Register"
#~ msgid "The type of the register."
#~ msgstr "Az iktatókönyv típusa."

#~ msgctxt "Register"
#~ msgid "Save"
#~ msgstr "Mentés"

#~ msgctxt "Register"
#~ msgid "Close"
#~ msgstr "Bezárás"

#~ msgctxt "Registers"
#~ msgid "Reload"
#~ msgstr "Frissítés"

#~ msgctxt "Register"
#~ msgid "Type"
#~ msgstr "Típus"

#~ msgctxt "RegisterType"
#~ msgid "Incoming invoice"
#~ msgstr "Szállítói számla"

#~ msgctxt "RegisterType"
#~ msgid "Outgoing letters"
#~ msgstr "Kimenő levelek"

#~ msgctxt "Company"
#~ msgid "Tax Number"
#~ msgstr "Adószám"

#~ msgctxt "Company"
#~ msgid "EU Tax Number"
#~ msgstr "EU adószám"

#~ msgctxt "Company"
#~ msgid "Natural Person"
#~ msgstr "Magánszemély"

#~ msgctxt "Payment"
#~ msgid "Reference Number"
#~ msgstr "Hivatkozási szám"

#~ msgctxt "Payment"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "MainMenu"
#~ msgid "Jobs (v2)"
#~ msgstr "Folyamatok (v2)"

#~ msgctxt "Invoice"
#~ msgid "Invoice From"
#~ msgstr "Saját cég"

#~ msgctxt "MainMenu"
#~ msgid "Cash and Bank Accounts"
#~ msgstr "Készpénz- és bankszámlák"

#~ msgctxt "MainMenu"
#~ msgid "Add Property..."
#~ msgstr "Új hely..."

#~ msgctxt "MainMenu"
#~ msgid "Clients"
#~ msgstr "Ügyfelek"

#~ msgctxt "MainMenu"
#~ msgid "New client..."
#~ msgstr "Új ügyfél..."

#~ msgctxt "Client"
#~ msgid "Invoices"
#~ msgstr "Számlák"

#~ msgctxt "Client"
#~ msgid "Payments"
#~ msgstr "Pénzforgalom"

#~ msgctxt "ClientBrowser"
#~ msgid "Clients"
#~ msgstr "Ügyfelek"

#~ msgctxt "filename"
#~ msgid "clients"
#~ msgstr "ügyfelek"

#~ msgctxt "ClientsView"
#~ msgid "Code"
#~ msgstr "Azonosító"

#~ msgctxt "ClientsView"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#~ msgctxt "ClientsView"
#~ msgid "Owned"
#~ msgstr "Saját cég"

#~ msgctxt "ClientsView"
#~ msgid "Contractor"
#~ msgstr "Alvállalkozó"

#~ msgctxt "ClientBrowser"
#~ msgid "Dataimport..."
#~ msgstr "Adatimport..."

#~ msgctxt "ClientBrowser"
#~ msgid "New client..."
#~ msgstr "Új ügyfél..."

#~ msgctxt "Client"
#~ msgid "Client"
#~ msgstr "Ügyfél"

#~ msgctxt "Button"
#~ msgid "Create client"
#~ msgstr "Ügyfél felvétele"

#~ msgctxt "Client"
#~ msgid "Edit General Information"
#~ msgstr "Általános adatok szerkesztése"

#~ msgctxt "Client"
#~ msgid "Edit general data"
#~ msgstr "Általános adatok  szerkesztése"

#~ msgctxt "Client"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#~ msgctxt "Client"
#~ msgid "Code"
#~ msgstr "Azonosító"

#~ msgctxt "Client"
#~ msgid "Type"
#~ msgstr "Típus"

#~ msgctxt "Client"
#~ msgid "Groups"
#~ msgstr "Csoportok"

#~ msgctxt "Client"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "Client"
#~ msgid "Tax Number"
#~ msgstr "Adószám"

#~ msgctxt "Client"
#~ msgid "Discount"
#~ msgstr "Kedvezmény"

#~ msgctxt "Client"
#~ msgid "Contractor"
#~ msgstr "Alvállalkozó"

#~ msgctxt "Client"
#~ msgid "General"
#~ msgstr "Általános"

#~ msgctxt "Client"
#~ msgid "Number"
#~ msgstr "Kód"

#~ msgctxt "Client"
#~ msgid "Client type"
#~ msgstr "Ügyféltípus"

#~ msgctxt "Client"
#~ msgid "Registration number"
#~ msgstr "Cégjegyzékszám"

#~ msgctxt "Client"
#~ msgid "Natural person"
#~ msgstr "Magánszemély"

#~ msgctxt "Client"
#~ msgid "External key"
#~ msgstr "Külső azonosító"

#~ msgctxt "ClientInvoices"
#~ msgid "Client invoices"
#~ msgstr "Ügyfélszámlák"

#~ msgctxt "Client"
#~ msgid "No related invoices."
#~ msgstr "Nincsenek kapcsolódó számlák."

#~ msgctxt "ClientPayments"
#~ msgid "Payments"
#~ msgstr "Pénzforgalom"

#~ msgctxt "filename"
#~ msgid "client-payments"
#~ msgstr "ügyfél-pénzforgalom"

#~ msgctxt "PaymentBrowserView"
#~ msgid "Account"
#~ msgstr "Folyószámla"

#~ msgctxt "ClientStatement"
#~ msgid "Date"
#~ msgstr "Dátum"

#~ msgctxt "ClientStatement"
#~ msgid "Type"
#~ msgstr "Típus"

#~ msgctxt "ClientStatement"
#~ msgid "Number"
#~ msgstr "Azonosító"

#~ msgctxt "ClientStatement"
#~ msgid "Amount"
#~ msgstr "Összeg"

#~ msgctxt "ClientStatement"
#~ msgid "Currency"
#~ msgstr "Pénznem"

#~ msgctxt "ClientBankAccount"
#~ msgid "Account Number"
#~ msgstr "Számlaszám"

#~ msgctxt "ClientBankAccount"
#~ msgid "Description"
#~ msgstr "Leírás"

#~ msgctxt "ClientBankAccount"
#~ msgid "IBAN"
#~ msgstr "IBAN"

#~ msgctxt "Client"
#~ msgid "Default"
#~ msgstr "Alapértelmezett"

#~ msgctxt "ClientBankAccounts"
#~ msgid "Bank Accounts"
#~ msgstr "Bankszámlaszám"

#~ msgctxt "ClientRelations"
#~ msgid "Sentence"
#~ msgstr "Mondat"

#~ msgctxt "Client"
#~ msgid "Head office"
#~ msgstr "Székhely"

#~ msgctxt "Client"
#~ msgid "Branch office"
#~ msgstr "Fiók"

#~ msgctxt "Client"
#~ msgid "Statistical code"
#~ msgstr "Statisztikai kód"

#~ msgctxt "Client"
#~ msgid "Account number"
#~ msgstr "Számlaszám"

#~ msgctxt "Client"
#~ msgid "Representative"
#~ msgstr "Képviselő"

#~ msgctxt "DunningLettersView"
#~ msgid "Dunning letters"
#~ msgstr "Felszólítólevelek"

#~ msgctxt "DunningLettersView"
#~ msgid "Status"
#~ msgstr "Státusz"

#~ msgctxt "DunningLettersView"
#~ msgid "Customer Name"
#~ msgstr "Vevőnév"

#~ msgctxt "DunningLettersView"
#~ msgid "Severity"
#~ msgstr "Kategória"

#~ msgctxt "DunningLettersView"
#~ msgid "Created at"
#~ msgstr "Készült"

#~ msgctxt "DunningLettersView"
#~ msgid "Created by"
#~ msgstr "Készítette"

#~ msgctxt "DunningLettersView"
#~ msgid "Delete"
#~ msgstr "Törlés"

#~ msgctxt "Command"
#~ msgid "Load"
#~ msgstr "Betöltés"

#~ msgctxt "Payments"
#~ msgid "New transaction"
#~ msgstr "Új bizonylat"

#~ msgctxt "GroupType"
#~ msgid "Client"
#~ msgstr "Ügyfél"

#~ msgctxt "Worksheet"
#~ msgid "Company"
#~ msgstr "Saját Cég"

#~ msgctxt "Worksheet"
#~ msgid "Client"
#~ msgstr "Ügyfél"

#~ msgctxt "WorkSummaryView"
#~ msgid "Client"
#~ msgstr "Ügyfél"

#~ msgctxt "ClientRelations"
#~ msgid "Vendor"
#~ msgstr "Szállító"

#~ msgid "Draft Invoice Summary"
#~ msgstr "Számlatervezet összesítő"

#~ msgctxt "InvoiceGeneration/title"
#~ msgid "Invoice generation session"
#~ msgstr "Számlagenerálás munkamenet"

#~ msgctxt "AccountTypes"
#~ msgid "Bad debt journal"
#~ msgstr "Behajthatatlan követelések"

#~ msgctxt "AccountTypes"
#~ msgid "Reconciliation of invoices"
#~ msgstr "Számlák összevezetése"

#~ msgctxt "AccountTypes"
#~ msgid "Rounding adjustment"
#~ msgstr "Kerekítési különbözet"

#~ msgctxt "PaymentTransactionKind"
#~ msgid "Bad debt"
#~ msgstr "Behajthatatlan követelés"

#~ msgctxt "PaymentTransactionKind"
#~ msgid "Invoice reconciliation"
#~ msgstr "Számlák összevezetése"

#~ msgctxt "Payment"
#~ msgid "Bank transaction"
#~ msgstr "Banki tétel"

#~ msgctxt "Payment"
#~ msgid "Internal Notes"
#~ msgstr "Belső feljegyzés"

#~ msgctxt "CreatePaymentTransactionTypes"
#~ msgid "Bad debt journal"
#~ msgstr "Behajthatatlan követelések"

#~ msgctxt "CreatePaymentTransactionTypes"
#~ msgid "Banking"
#~ msgstr "Bank"

#~ msgctxt "CreatePaymentTransactionTypes"
#~ msgid "Credit"
#~ msgstr "Jóváírás"

#~ msgctxt "CreatePaymentTransactionTypes"
#~ msgid "Debit"
#~ msgstr "Terhelés"

#~ msgctxt "CreatePaymentTransactionTypes"
#~ msgid "Deposit"
#~ msgstr "Befizetés"

#~ msgctxt "CreatePaymentTransactionTypes"
#~ msgid "Payment"
#~ msgstr "Kifizetés"

#~ msgctxt "CreatePaymentTransactionTypes"
#~ msgid "Reconciliation of invoices"
#~ msgstr "Számlák összevezetése"

#~ msgctxt "PaymentType"
#~ msgid "Credit"
#~ msgstr "Jóváírás"

#~ msgctxt "PaymentType"
#~ msgid "Debit"
#~ msgstr "Terhelés"

#~ msgctxt "PaymentType"
#~ msgid "Deposit"
#~ msgstr "befizetés"

#~ msgctxt "PaymentType"
#~ msgid "Payment"
#~ msgstr "kifizetés"

#~ msgctxt "Contract"
#~ msgid "Generate invoice..."
#~ msgstr "Számla generálása..."

#~ msgctxt "Contract"
#~ msgid "No related invoices."
#~ msgstr "Nincsenek kapcsolódó számlák."

#~ msgctxt "InvoiceContract"
#~ msgid "Net"
#~ msgstr "Nettó"

#~ msgctxt "InvoiceContract"
#~ msgid "Total"
#~ msgstr "Végösszeg"

#~ msgctxt "Invoice"
#~ msgid "Log messages"
#~ msgstr "Napló tartalma"

#~ msgctxt "Invoice"
#~ msgid "View log messages"
#~ msgstr "Naplófile megtekintése"

#~ msgctxt "InvoiceContract"
#~ msgid "Billing Period"
#~ msgstr "Számlázási időszak"

#~ msgid "One invoice has been imported."
#~ msgid_plural "${n} invoices have been imported."
#~ msgstr[0] "Egy számla importálása megtörtént."
#~ msgstr[1] "${n} számla imporálása megtörtént."

#~ msgid "No invoice have been imported."
#~ msgstr "Nem importáltunk egyetlen számlát sem."

#~ msgctxt "ClientStatementType"
#~ msgid "invoice"
#~ msgstr "Számla"

#~ msgctxt "ClientStatementType"
#~ msgid "payment"
#~ msgstr "Kiegyenlítés"

#~ msgctxt "IncomingInvoiceStatus"
#~ msgid "Accounting"
#~ msgstr "Könyvelés"

#~ msgctxt "IncomingInvoiceStatus"
#~ msgid "Open"
#~ msgstr "Nyitott"

#~ msgctxt "IncomingInvoiceStatus"
#~ msgid "Paid"
#~ msgstr "Fizetve"

#~ msgctxt "IncomingInvoiceStatus"
#~ msgid "Void"
#~ msgstr "Érvénytelen"

#~ msgctxt "TaskStates"
#~ msgid "FAILURE"
#~ msgstr "Hiba"

#~ msgctxt "TaskStates"
#~ msgid "IGNORED"
#~ msgstr "Kihagyva"

#~ msgctxt "TaskStates"
#~ msgid "PENDING"
#~ msgstr "Várakozik"

#~ msgctxt "TaskStates"
#~ msgid "RETRY"
#~ msgstr "Újra próbálkozik"

#~ msgctxt "TaskStates"
#~ msgid "REVOKED"
#~ msgstr "Visszavont"

#~ msgctxt "TaskStates"
#~ msgid "STARTED"
#~ msgstr "Folyamatban"

#~ msgctxt "TaskStates"
#~ msgid "SUCCESS"
#~ msgstr "Sikeres"

#~ msgctxt "JobStatus"
#~ msgid "Disabled"
#~ msgstr "Kikapcsolva"

#~ msgctxt "JobStatus"
#~ msgid "Errored"
#~ msgstr "Hiba"

#~ msgctxt "JobStatus"
#~ msgid "Errored/ Rerunning"
#~ msgstr "Újra futtatva"

#~ msgctxt "JobStatus"
#~ msgid "Not Started"
#~ msgstr "Várakozik"

#~ msgctxt "Payments"
#~ msgid "New cash in"
#~ msgstr "Új befizetés"

#~ msgctxt "Payments"
#~ msgid "New cash out"
#~ msgstr "Új kifizetés"

#~ msgctxt "CreatePaymentTransactionTypes"
#~ msgid "Cash in"
#~ msgstr "Pénztári befizetés"

#~ msgctxt "CreatePaymentTransactionTypes"
#~ msgid "Cash out"
#~ msgstr "Pénztári kifizetés"

#~ msgctxt "PaymentStatuses"
#~ msgid "Unpaid"
#~ msgstr "Rendezetlen"

#~ msgctxt "PaymentStatuses"
#~ msgid "Paid"
#~ msgstr "Fizetve"

#~ msgctxt "PaymentStatuses"
#~ msgid "Uncollectible"
#~ msgstr "Behajthatatlan"

#~ msgctxt "PaymentStatuses"
#~ msgid "No payment required"
#~ msgstr "Pénzügyi teljesítést nem igényel"

#~ msgctxt "InvoicePayment"
#~ msgid "Status"
#~ msgstr "Státusz"

#~ msgid "Order Number"
#~ msgstr "Rendelésszám"

#~ msgid "File Number"
#~ msgstr "Mappaszám"

#~ msgctxt "Invoice"
#~ msgid "Payment Status"
#~ msgstr "Fizetés állapota"

#~ msgctxt "PaymentStatus"
#~ msgid "Sentence"
#~ msgstr "Mondat"

#~ msgctxt "IncomingInvoiceStatus"
#~ msgid "Pending"
#~ msgstr "Függő"

#~ msgctxt "PaymentStatus"
#~ msgid "No payment required"
#~ msgstr "Pénzügyi teljesítést nem igényel"

#~ msgctxt "PaymentStatus"
#~ msgid "Paid"
#~ msgstr "Fizetve"

#~ msgctxt "PaymentStatus"
#~ msgid "Uncollectible"
#~ msgstr "Behajthatatlan"

#~ msgctxt "PaymentStatus"
#~ msgid "Unpaid"
#~ msgstr "Rendezetlen"

#~ msgctxt "InvoiceReferences"
#~ msgid "No payments."
#~ msgstr "Nincsenek kiegyenlítések."

#~ msgctxt "Invoice"
#~ msgid "Corrective Invoices"
#~ msgstr "Módosító számlák"

#~ msgctxt "InvoiceType"
#~ msgid "Sentence"
#~ msgstr "Mondat"

#~ msgctxt "InvoiceStatus"
#~ msgid "Sentence"
#~ msgstr "Mondat"

#~ msgctxt "OutgoingInvoiceStatus"
#~ msgid "Accounting"
#~ msgstr "Könyvelésnek elküldve"

#~ msgctxt "OutgoingInvoiceStatus"
#~ msgid "Approved"
#~ msgstr "Jóváhagyott"

#~ msgctxt "OutgoingInvoiceStatus"
#~ msgid "Enqueued"
#~ msgstr "Várakozik"

#~ msgctxt "OutgoingInvoiceStatus"
#~ msgid "Error"
#~ msgstr "Hiba"

#~ msgctxt "OutgoingInvoiceStatus"
#~ msgid "Filed"
#~ msgstr "Iktatott"

#~ msgctxt "OutgoingInvoiceStatus"
#~ msgid "Ok"
#~ msgstr "OK"

#~ msgctxt "OutgoingInvoiceStatus"
#~ msgid "Open"
#~ msgstr "Nyitott"

#~ msgctxt "OutgoingInvoiceStatus"
#~ msgid "Paid"
#~ msgstr "Fizetve"

#~ msgctxt "OutgoingInvoiceStatus"
#~ msgid "Pending"
#~ msgstr "Függő"

#~ msgctxt "OutgoingInvoiceStatus"
#~ msgid "Processing"
#~ msgstr "Feldolgozás alatt"

#~ msgctxt "OutgoingInvoiceStatus"
#~ msgid "Received"
#~ msgstr "Érkeztetve"

#~ msgctxt "OutgoingInvoiceStatus"
#~ msgid "Sync error"
#~ msgstr "Szinkronizálási hiba"

#~ msgctxt "OutgoingInvoiceStatus"
#~ msgid "Sync in progress"
#~ msgstr "Szinkronizálás folyamatban"

#~ msgctxt "OutgoingInvoiceStatus"
#~ msgid "Sync job created"
#~ msgstr "Szinkronizálási feladat létrehozva"

#~ msgctxt "OutgoingInvoiceStatus"
#~ msgid "Sync pending"
#~ msgstr "Szinkronizálás függőben"

#~ msgctxt "OutgoingInvoiceStatus"
#~ msgid "Void"
#~ msgstr "Érvénytelen"

#~ msgctxt "Invoice"
#~ msgid "Corrections"
#~ msgstr "Helyesbítő számla"

#~ msgctxt "RentalService"
#~ msgid "Inflation indexed"
#~ msgstr "Inflációkövető"

#~ msgctxt "Payments"
#~ msgid "Create"
#~ msgstr "Új bizonylat"

#~ msgctxt "Create Payment"
#~ msgid "New bank payment"
#~ msgstr "Új banki tranzakció"

#~ msgctxt "Payment"
#~ msgid "Cash-In payment"
#~ msgstr "Pénztári befizetés"

#~ msgctxt "Payment"
#~ msgid "Cash-Out payment"
#~ msgstr "Pénztári kifizetés"

#~ msgctxt "UcInvoicePayments"
#~ msgid "Total"
#~ msgstr "Összesen"

#~ msgctxt "UcInvoicePayments"
#~ msgid "Add banking payment"
#~ msgstr "Új banki tranzakció"

#~ msgid "Add cash payment"
#~ msgstr "Új pénztári tranzakció"

#~ msgctxt "Invoice"
#~ msgid "Mark paid"
#~ msgstr "Fizetve"

#~ msgctxt "Invoice"
#~ msgid "Unpaid"
#~ msgstr "Rendezetlen"

#~ msgctxt "AccountTypes"
#~ msgid "Bank"
#~ msgstr "Bank"

#~ msgctxt "AccountTypes"
#~ msgid "Petty cash"
#~ msgstr "Pénztár"

#~ msgctxt "Invoice"
#~ msgid "Reversing invoice"
#~ msgstr "Stornó számla"

#~ msgctxt "SyncJobState"
#~ msgid "Completed"
#~ msgstr "Befejezett"

#~ msgctxt "SyncJobState"
#~ msgid "Failed"
#~ msgstr "Hiba"

#~ msgctxt "SyncJobState"
#~ msgid "Pending"
#~ msgstr "Függő"

#~ msgctxt "SyncJobState"
#~ msgid "Processing"
#~ msgstr "Folyamatban"

#~ msgctxt "MainMenu"
#~ msgid "Debts"
#~ msgstr "Követelések"

#~ msgid "Debts"
#~ msgstr "Követelések"

#~ msgctxt "ExportFilename"
#~ msgid "debts"
#~ msgstr "követelések"

#~ msgctxt "DebtsView"
#~ msgid "Client"
#~ msgstr "Ügyfél"

#~ msgctxt "DebtsView"
#~ msgid "Dunning letters"
#~ msgstr "Felszólítólevelek"

#~ msgctxt "DebtsView"
#~ msgid "Amount"
#~ msgstr "Összeg"

#~ msgctxt "DebtsView"
#~ msgid "Debt"
#~ msgstr "Követelés"

#~ msgctxt "DebtsView"
#~ msgid "Paid"
#~ msgstr "Fizetve"

#~ msgctxt "DebtStatus"
#~ msgid "Claim"
#~ msgstr "Érvényes"

#~ msgctxt "DebtStatus"
#~ msgid "Invalid"
#~ msgstr "Érvénytelen"

#~ msgctxt "DebtStatus"
#~ msgid "Settled"
#~ msgstr "Kiegyenlítve"

#~ msgid "Context"
#~ msgstr "Kontextus"

#~ msgctxt "DebtsView"
#~ msgid "Status"
#~ msgstr "Státusz"

#~ msgctxt "DebtsView"
#~ msgid "Customer"
#~ msgstr "Ügyfél"

#~ msgctxt "DebtsView"
#~ msgid "Invoice nr"
#~ msgstr "Számlaszám"

#~ msgctxt "DebtsView"
#~ msgid "Currency"
#~ msgstr "Pénznem"

#~ msgctxt "DebtsView"
#~ msgid "Invoice type"
#~ msgstr "Típus"

#~ msgctxt "InvoiceType"
#~ msgid "Corrector"
#~ msgstr "Helyesbítő"

#~ msgctxt "DebtsView"
#~ msgid "Invoice date"
#~ msgstr "Számla dátuma"

#~ msgctxt "DebtsView"
#~ msgid "Completion date"
#~ msgstr "Tejlesítés ideje"

#~ msgctxt "DebtsView"
#~ msgid "Due date"
#~ msgstr "Fizetési határidő"

#~ msgctxt "DebtsView"
#~ msgid "Payment agreements"
#~ msgstr "Fizetési megállapodások"

#~ msgctxt "DebtsView"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "ClientAddressTypes"
#~ msgid "Billing"
#~ msgstr "Számlázási cím"

#~ msgctxt "CompanyAddressTypes"
#~ msgid "Billing"
#~ msgstr "Számlázási cím"

#~ msgctxt "CompanyAddressTypes"
#~ msgid "Mailing"
#~ msgstr "Levelezési cím"

#~ msgctxt "CompanyAddressTypes"
#~ msgid "Premise"
#~ msgstr "Telephely"

#~ msgctxt "CompanyAddressTypes"
#~ msgid "Seat"
#~ msgstr "Székhely"

#~ msgctxt "AccountsDailyFlowView"
#~ msgid "Owner"
#~ msgstr "Tulajdonos"

#~ msgctxt "AccountsDailyFlowView"
#~ msgid "Account"
#~ msgstr "Folyószámla"

#~ msgctxt "AccountsDailyFlowView"
#~ msgid "Account type"
#~ msgstr "Számla típusa"

#~ msgctxt "Create Payment"
#~ msgid "New Banking"
#~ msgstr "Új Banki tétel"

#~ msgctxt "Account"
#~ msgid "Numbering (Payment OUT)"
#~ msgstr "Sorszámozás (Kifizetés)"

#~ msgctxt "AccountsDailyFlowView"
#~ msgid "Payment in"
#~ msgstr "Befizetés"

#~ msgctxt "InvoiceBrowser"
#~ msgid "Invoice Number"
#~ msgstr "Számlaszám"

#~ msgctxt "InvoiceBrowser"
#~ msgid "Invoice Date"
#~ msgstr "Számla dátuma"

#~ msgctxt "InvoiceBrowser"
#~ msgid "Status"
#~ msgstr "Státusz"

#~ msgctxt "InvoiceBrowser"
#~ msgid "Kind"
#~ msgstr "Számla fajtája"

#~ msgctxt "InvoiceBrowser"
#~ msgid "Type"
#~ msgstr "Típus"

#~ msgctxt "InvoiceBrowser"
#~ msgid "Client"
#~ msgstr "Ügyfél"

#~ msgctxt "InvoiceBrowser"
#~ msgid "Amount"
#~ msgstr "Összeg"

#~ msgctxt "InvoiceBrowser"
#~ msgid "Currency"
#~ msgstr "Pénznem"

#~ msgctxt "InvoiceBrowser"
#~ msgid "Paid"
#~ msgstr "Fizetve"

#~ msgid "Select Invoice"
#~ msgstr "Számla kiválasztása"

#~ msgid "Filters"
#~ msgstr "Szűrők"

#~ msgctxt "Invoice"
#~ msgid "Kind"
#~ msgstr "Fajta"

#~ msgctxt "Invoice"
#~ msgid "Company"
#~ msgstr "Saját Cég"

#~ msgid "Date To"
#~ msgstr "Dátumig"

#~ msgctxt "Invoice"
#~ msgid "Number"
#~ msgstr "Azonosító"

#~ msgctxt "Invoice"
#~ msgid "Amount"
#~ msgstr "Összeg"

#~ msgctxt "Invoice"
#~ msgid "Paid"
#~ msgstr "Fizetve"

#~ msgctxt "RentalServices"
#~ msgid "Service"
#~ msgstr "Szolgáltatás"

#~ msgctxt "RentalServices"
#~ msgid "Meter"
#~ msgstr "Mérőóra"

#~ msgctxt "RentalServices"
#~ msgid "Billing multiplier"
#~ msgstr "Számlázási szorzó"

#~ msgctxt "RentalServices"
#~ msgid "Validity"
#~ msgstr "Érvényesség"

#~ msgctxt "InvoicePaymentMethod"
#~ msgid "Sentence"
#~ msgstr "Mondat"

#~ msgctxt "InvoicePaymentMethod"
#~ msgid "Bank transfer"
#~ msgstr "Átutalás"

#~ msgctxt "InvoicePaymentMethod"
#~ msgid "Cash"
#~ msgstr "Készpénz"

#~ msgctxt "PaymentMethod"
#~ msgid "Account"
#~ msgstr "Folyószámla"

#~ msgctxt "PaymentMethod"
#~ msgid "Cod"
#~ msgstr "Utánvét"

#~ msgctxt "PaymentMethod"
#~ msgid "Pos"
#~ msgstr "POS"

#~ msgctxt "PaymentMethod"
#~ msgid "Square gift card"
#~ msgstr "Kupon"

#~ msgid "Rental Contract"
#~ msgstr "Bérleti szerződés"

#~ msgid "Serial number"
#~ msgstr "Sorozatszám"

#~ msgid "Sync to IntegroRent"
#~ msgstr "IntegroRent szinkronizálás"

#~ msgctxt "InvoicePayment"
#~ msgid "Invoice Number"
#~ msgstr "Számlaszám"

#~ msgctxt "PaymentBrowserView"
#~ msgid "Category"
#~ msgstr "Kategória"

#~ msgctxt "Payment"
#~ msgid "Category"
#~ msgstr "Kategória"

#~ msgctxt "ExpenseType"
#~ msgid "Investment"
#~ msgstr "Beruházás"

#~ msgctxt "ExpenseType"
#~ msgid "Maintenance"
#~ msgstr "Karbantartás"

#~ msgctxt "InvoiceRegister"
#~ msgid "Invoice Entry"
#~ msgstr "Számla"

#~ msgctxt "Button"
#~ msgid "Create meter"
#~ msgstr "Mérőóra felvétele"

#~ msgctxt "MeterTypes"
#~ msgid "StartCase"
#~ msgstr "StartCase"

#~ msgctxt "ResourceCommand"
#~ msgid "Lock"
#~ msgstr "Zárolás"

#~ msgctxt "ExpenseTypes"
#~ msgid "Sentence"
#~ msgstr "Mondat"

#~ msgctxt "InvoicePaymentStatus"
#~ msgid "Paid"
#~ msgstr "Fizetve"

#~ msgctxt "InvoicePaymentStatus"
#~ msgid "Uncollectible"
#~ msgstr "Behajthatatlan"

#~ msgctxt "InvoicePaymentStatus"
#~ msgid "Unpaid"
#~ msgstr "Kifizetetlen"

#~ msgctxt "InvoiceStatus"
#~ msgid "Accounting"
#~ msgstr "Könyvelve"

#~ msgctxt "InvoiceStatus"
#~ msgid "Approved"
#~ msgstr "Jóváhagyva"

#~ msgctxt "InvoiceStatus"
#~ msgid "Draft"
#~ msgstr "Tervezet"

#~ msgctxt "InvoiceStatus"
#~ msgid "Error"
#~ msgstr "Hiba"

#~ msgctxt "InvoiceStatus"
#~ msgid "Filed"
#~ msgstr "Iktatott"

#~ msgctxt "InvoiceStatus"
#~ msgid "Open"
#~ msgstr "Nyitott"

#~ msgctxt "InvoiceStatus"
#~ msgid "Paid"
#~ msgstr "Fizetve"

#~ msgctxt "InvoiceStatus"
#~ msgid "Pending"
#~ msgstr "Függő"

#~ msgctxt "InvoiceStatus"
#~ msgid "Received"
#~ msgstr "Érkeztetve"

#~ msgctxt "InvoiceStatus"
#~ msgid "Void"
#~ msgstr "Érvénytelen"

#~ msgctxt "AccountsView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "ClientsView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "Contracts"
#~ msgid "Client"
#~ msgstr "Ügyfél"

#~ msgctxt "ProductsView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "InvoicePayment"
#~ msgid "Payments"
#~ msgstr "Pénzforgalom"

#~ msgctxt "BtnLockResource"
#~ msgid "Lock"
#~ msgstr "Lezárás"

#~ msgctxt "Contracts"
#~ msgid "Company"
#~ msgstr "Saját Cég"

#~ msgctxt "Invoice"
#~ msgid "Fulfillment"
#~ msgstr "Teljesítés"

#~ msgid "Activate"
#~ msgstr "Aktiválás"

#~ msgid "Inactivate"
#~ msgstr "Inaktiválás"

#~ msgctxt "Contract"
#~ msgid "Revisions"
#~ msgstr "Módosítások"

#~ msgctxt "Button"
#~ msgid "Create rental"
#~ msgstr "Új bérlemény"

#~ msgctxt "Worksheet"
#~ msgid "File Number"
#~ msgstr "Mappaszám"

#~ msgctxt "Worksheet"
#~ msgid "End date"
#~ msgstr "Záró dátum"

#~ msgctxt "Worksheet"
#~ msgid "GL Acc No."
#~ msgstr "Főkönyvi szám"

#~ msgid "Contract date"
#~ msgstr "Szerződés dátuma"

#~ msgid "Mark notification read"
#~ msgstr "Megjelölés olvasottként"

#~ msgid "mark read"
#~ msgstr "megjelölés olvasottként"

#~ msgid "create new price"
#~ msgstr "új ár felvétele"

#~ msgid "Add Meter Measurement"
#~ msgstr "Mérőállás hozzáadása"

#~ msgid "Edit Rental Service Fee"
#~ msgstr "Szolgáltatás szerkesztése"

#~ msgid "Add Rental Service Fee"
#~ msgstr "Szolgáltatás hozzáadása"

#~ msgctxt "Worksheet"
#~ msgid "Create Worksheet"
#~ msgstr "Munkalap létrehozása"

#~ msgid "Short name/description."
#~ msgstr "Rövid név/leírás."

#~ msgid "Create Product"
#~ msgstr "Új termék"

#~ msgid "Product type"
#~ msgstr "Típus"

#~ msgid "Item Number"
#~ msgstr "Cikkszám"

#~ msgid "Sales tax code"
#~ msgstr "Eladási ÁFA"

#~ msgid "Purchase tax code"
#~ msgstr "Vételi ÁFA"

#~ msgid "Mediated service"
#~ msgstr "Közvetített szolgáltatás"

#~ msgid "Customs Tariff no."
#~ msgstr "Vámtarifaszám"

#~ msgid "TESZOR code"
#~ msgstr "TESZOR kód"

#~ msgid "EWC code"
#~ msgstr "EWC-kód"

#~ msgid "No Contracts have been added yet."
#~ msgstr "Nincsenek megjegyzések."

#~ msgid "open..."
#~ msgstr "megnyitás..."

#~ msgctxt "MainMenu"
#~ msgid "New Vendor Invoice"
#~ msgstr "Új szállítói számla"

#~ msgctxt "MainMenu/Finance"
#~ msgid "Downloads"
#~ msgstr "Letöltések"

#~ msgctxt "MainMenu/Finance/Downloads"
#~ msgid "Outgoing invoice lines"
#~ msgstr "Kimenő számlák"

#~ msgctxt "MainMenu/Finance/Downloads"
#~ msgid "Incoming invoice lines"
#~ msgstr "Szállítói számlák"

#~ msgctxt "MainMenu"
#~ msgid "Create Worksheet"
#~ msgstr "Munkalap létrehozása"

#~ msgctxt "InvoiceRegister"
#~ msgid "Entry"
#~ msgstr "Bejegyzés"

#~ msgctxt "Invoice"
#~ msgid "Invoice Date"
#~ msgstr "Számla dátuma"

#~ msgctxt "Invoice"
#~ msgid "Fulfillment Date"
#~ msgstr "Teljesítés dátuma"

#~ msgctxt "Invoice"
#~ msgid "Billing Period"
#~ msgstr "Számlázási időszak"

#~ msgctxt "LetterRegisterEntry"
#~ msgid "Edit Letter Registry Information"
#~ msgstr "Bejegyzés szerkesztése"

#~ msgctxt "LetterDeliveryMode"
#~ msgid "Email"
#~ msgstr "Email"

#~ msgctxt "LetterDeliveryMode"
#~ msgid "Epaper"
#~ msgstr "E-Papír"

#~ msgctxt "LetterDeliveryMode"
#~ msgid "In person"
#~ msgstr "Személyes"

#~ msgctxt "Invoice register"
#~ msgid "Entry date"
#~ msgstr "Érkezett"

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Code"
#~ msgstr "Azonosító"

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Type"
#~ msgstr "Típus"

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Groups"
#~ msgstr "Csoportok"

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Email"
#~ msgstr "Email"

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Multiple email addresses should be separated by semicolon."
#~ msgstr "Pontosvesszővel elválasztva több email cím is megadható."

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Tax Number"
#~ msgstr "Adószám"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "EU Tax Number"
#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "EU Tax Number"
#~ msgstr "EU adószám"

#, fuzzy
#~| msgid "Contractor"
#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Contractor"
#~ msgstr "Alvállalkozó"

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Natural Person"
#~ msgstr "Magánszemély"

#~ msgctxt "InvoiceRegisterEntry"
#~ msgid "Exclude from claims"
#~ msgstr "Követeléskezelés alól kivont"

#~ msgctxt "LetterRegisterEntry"
#~ msgid "Code"
#~ msgstr "Azonosító"

#~ msgctxt "LetterRegisterEntry"
#~ msgid "Type"
#~ msgstr "Típus"

#~ msgctxt "LetterRegisterEntry"
#~ msgid "Groups"
#~ msgstr "Csoportok"

#~ msgctxt "LetterRegisterEntry"
#~ msgid "Email"
#~ msgstr "Email"

#~ msgctxt "LetterRegisterEntry"
#~ msgid "Multiple email addresses should be separated by semicolon."
#~ msgstr "Pontosvesszővel elválasztva több email cím is megadható."

#~ msgctxt "LetterRegisterEntry"
#~ msgid "Tax Number"
#~ msgstr "Adószám"

#~ msgctxt "LetterRegisterEntry"
#~ msgid "EU Tax Number"
#~ msgstr "EU adószám"

#~ msgctxt "LetterRegisterEntry"
#~ msgid "Registration Number"
#~ msgstr "Cégjegyzékszám"

#~ msgctxt "LetterRegisterEntry"
#~ msgid "Contractor"
#~ msgstr "Alvállalkozó"

#~ msgctxt "LetterRegisterEntry"
#~ msgid "Natural Person"
#~ msgstr "Magánszemély"

#~ msgctxt "LetterRegisterEntry"
#~ msgid "Exclude from claims"
#~ msgstr "Követeléskezelés alól kivont"

#~ msgctxt "PaymentMethod"
#~ msgid "StartCase"
#~ msgstr "StartCase"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "AccountReference"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "ActivateContractCommand"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgid "Status"
#~ msgctxt "ActivateContractCommand"
#~ msgid "Status"
#~ msgstr "Státusz"

#, fuzzy
#~| msgid "Valid From"
#~ msgctxt "ActivateContractCommand"
#~ msgid "Valid From"
#~ msgstr "Érvényesség kezdete"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Address Type"
#~ msgctxt "AddCompanyAddressCommand"
#~ msgid "Address type"
#~ msgstr "Cím típusa"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Building Nr"
#~ msgctxt "AddCompanyAddressCommand"
#~ msgid "Building Nr"
#~ msgstr "Épület"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "City"
#~ msgctxt "AddCompanyAddressCommand"
#~ msgid "City"
#~ msgstr "Város"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Country"
#~ msgctxt "AddCompanyAddressCommand"
#~ msgid "Country"
#~ msgstr "Ország"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "District"
#~ msgctxt "AddCompanyAddressCommand"
#~ msgid "District"
#~ msgstr "Kerület"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Door Nr"
#~ msgctxt "AddCompanyAddressCommand"
#~ msgid "Door Nr"
#~ msgstr "Ajtó"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "External Id"
#~ msgctxt "AddCompanyAddressCommand"
#~ msgid "External Id"
#~ msgstr "Külső Azonosító"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Floor Nr"
#~ msgctxt "AddCompanyAddressCommand"
#~ msgid "Floor Nr"
#~ msgstr "Szint"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "House Nr"
#~ msgctxt "AddCompanyAddressCommand"
#~ msgid "House Nr"
#~ msgstr "Házszám"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "AddCompanyAddressCommand"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgctxt "CompanyBrowserView"
#~| msgid "Is Default"
#~ msgctxt "AddCompanyAddressCommand"
#~ msgid "Is Default"
#~ msgstr "Alapértelmezett"

#, fuzzy
#~| msgctxt "DraftInvoiceBrowserView"
#~| msgid "Line Count"
#~ msgctxt "AddCompanyAddressCommand"
#~ msgid "Line 1"
#~ msgstr "Sortételek száma"

#, fuzzy
#~| msgctxt "DraftInvoiceBrowserView"
#~| msgid "Line Count"
#~ msgctxt "AddCompanyAddressCommand"
#~ msgid "Line 2"
#~ msgstr "Sortételek száma"

#, fuzzy
#~| msgctxt "DraftInvoiceBrowserView"
#~| msgid "Line Count"
#~ msgctxt "AddCompanyAddressCommand"
#~ msgid "Line 3"
#~ msgstr "Sortételek száma"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "AddCompanyAddressCommand"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "AddCompanyAddressCommand"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Other Details"
#~ msgctxt "AddCompanyAddressCommand"
#~ msgid "Other Details"
#~ msgstr "Részletek"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Postal Code"
#~ msgctxt "AddCompanyAddressCommand"
#~ msgid "Postal Code"
#~ msgstr "Irányítószám"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Public Place"
#~ msgctxt "AddCompanyAddressCommand"
#~ msgid "Public Place"
#~ msgstr "Közterület neve"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Public Place Type"
#~ msgctxt "AddCompanyAddressCommand"
#~ msgid "Public Place Type"
#~ msgstr "Közterület jellege"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Region"
#~ msgctxt "AddCompanyAddressCommand"
#~ msgid "Region"
#~ msgstr "Megye/régió"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Street Address"
#~ msgctxt "AddCompanyAddressCommand"
#~ msgid "Street Address"
#~ msgstr "Cím"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Sub Building Nr"
#~ msgctxt "AddCompanyAddressCommand"
#~ msgid "Sub Building Nr"
#~ msgstr "Lépcsőház"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Email"
#~ msgctxt "AddCompanyEmployeeCommand"
#~ msgid "Email"
#~ msgstr "Email"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "External Id"
#~ msgctxt "AddCompanyEmployeeCommand"
#~ msgid "External Id"
#~ msgstr "Külső Azonosító"

#, fuzzy
#~| msgctxt "Contact"
#~| msgid "Fax"
#~ msgctxt "AddCompanyEmployeeCommand"
#~ msgid "Fax"
#~ msgstr "Fax"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "AddCompanyEmployeeCommand"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgctxt "Contact"
#~| msgid "Job Title"
#~ msgctxt "AddCompanyEmployeeCommand"
#~ msgid "Job Title"
#~ msgstr "Munkakör / pozíció"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "AddCompanyEmployeeCommand"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgctxt "Contact"
#~| msgid "Mobile"
#~ msgctxt "AddCompanyEmployeeCommand"
#~ msgid "Mobile"
#~ msgstr "Mobil"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "AddCompanyEmployeeCommand"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "AddCompanyEmployeeCommand"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "Approval date"
#~ msgctxt "ApproveContractCommand"
#~ msgid "Approval Date"
#~ msgstr "Jóváhagyás dátuma"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "ApproveContractCommand"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgid "Status"
#~ msgctxt "ApproveContractCommand"
#~ msgid "Status"
#~ msgstr "Státusz"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "Archive date"
#~ msgctxt "ArchiveContractCommand"
#~ msgid "Archive Date"
#~ msgstr "Archiválás dátuma"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "ArchiveContractCommand"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgid "Status"
#~ msgctxt "ArchiveContractCommand"
#~ msgid "Status"
#~ msgstr "Státusz"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "AssetRef"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "AssetRef"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "Attachment"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "Attachment"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgid "Description"
#~ msgctxt "Attachment"
#~ msgid "Description"
#~ msgstr "Leírás"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "Attachment"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgid "File Size"
#~ msgctxt "Attachment"
#~ msgid "File Size"
#~ msgstr "File méret"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "Attachment"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "Attachment"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "Attachment"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Subject"
#~ msgctxt "Attachment"
#~ msgid "Object Id"
#~ msgstr "Tárgy"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "Attachment"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "Attachment"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "Attachment"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "End"
#~ msgctxt "BillingPeriod"
#~ msgid "End"
#~ msgstr "Lejárt"

#, fuzzy
#~| msgid "Start"
#~ msgctxt "BillingPeriod"
#~ msgid "Start"
#~ msgstr "Indítás"

#, fuzzy
#~| msgid "Description"
#~ msgctxt "Body_create_attachment_api_v1_attachments__post"
#~ msgid "Description"
#~ msgstr "Leírás"

#, fuzzy
#~| msgid "File"
#~ msgctxt "Body_create_attachment_api_v1_attachments__post"
#~ msgid "File"
#~ msgstr "File"

#, fuzzy
#~| msgid "Subject"
#~ msgctxt "Body_create_attachment_api_v1_attachments__post"
#~ msgid "Object Id"
#~ msgstr "Tárgy"

#, fuzzy
#~| msgctxt "BrowseLetterRegisterView"
#~| msgid "Client Id"
#~ msgctxt "Body_token_token_post"
#~ msgid "Client Id"
#~ msgstr "Kliens AZ"

#, fuzzy
#~| msgctxt "ClientsView"
#~| msgid "Client relation"
#~ msgctxt "Body_token_token_post"
#~ msgid "Client Secret"
#~ msgstr "Ügyfélkapcsolat"

#, fuzzy
#~| msgctxt "RealPropertyUnit"
#~| msgid "Unit Type"
#~ msgctxt "Body_token_token_post"
#~ msgid "Grant Type"
#~ msgstr "Típus"

#, fuzzy
#~| msgid "Scope"
#~ msgctxt "Body_token_token_post"
#~ msgid "Scope"
#~ msgstr "Hatály"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Address Type"
#~ msgctxt "ClientAddress"
#~ msgid "Address type"
#~ msgstr "Cím típusa"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Building Nr"
#~ msgctxt "ClientAddress"
#~ msgid "Building Nr"
#~ msgstr "Épület"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "City"
#~ msgctxt "ClientAddress"
#~ msgid "City"
#~ msgstr "Város"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Country"
#~ msgctxt "ClientAddress"
#~ msgid "Country"
#~ msgstr "Ország"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "ClientAddress"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "ClientAddress"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "District"
#~ msgctxt "ClientAddress"
#~ msgid "District"
#~ msgstr "Kerület"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Door Nr"
#~ msgctxt "ClientAddress"
#~ msgid "Door Nr"
#~ msgstr "Ajtó"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "ClientAddress"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Floor Nr"
#~ msgctxt "ClientAddress"
#~ msgid "Floor Nr"
#~ msgstr "Szint"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "House Nr"
#~ msgctxt "ClientAddress"
#~ msgid "House Nr"
#~ msgstr "Házszám"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ClientAddress"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "ClientAddress"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgctxt "CompanyBrowserView"
#~| msgid "Is Default"
#~ msgctxt "ClientAddress"
#~ msgid "Is Default"
#~ msgstr "Alapértelmezett"

#, fuzzy
#~| msgctxt "DraftInvoiceBrowserView"
#~| msgid "Line Count"
#~ msgctxt "ClientAddress"
#~ msgid "Line 1"
#~ msgstr "Sortételek száma"

#, fuzzy
#~| msgctxt "DraftInvoiceBrowserView"
#~| msgid "Line Count"
#~ msgctxt "ClientAddress"
#~ msgid "Line 2"
#~ msgstr "Sortételek száma"

#, fuzzy
#~| msgctxt "DraftInvoiceBrowserView"
#~| msgid "Line Count"
#~ msgctxt "ClientAddress"
#~ msgid "Line 3"
#~ msgstr "Sortételek száma"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "ClientAddress"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "ClientAddress"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "ClientAddress"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Other Details"
#~ msgctxt "ClientAddress"
#~ msgid "Other Details"
#~ msgstr "Részletek"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Postal Code"
#~ msgctxt "ClientAddress"
#~ msgid "Postal Code"
#~ msgstr "Irányítószám"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Public Place"
#~ msgctxt "ClientAddress"
#~ msgid "Public Place"
#~ msgstr "Közterület neve"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Public Place Type"
#~ msgctxt "ClientAddress"
#~ msgid "Public Place Type"
#~ msgstr "Közterület jellege"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Region"
#~ msgctxt "ClientAddress"
#~ msgid "Region"
#~ msgstr "Megye/régió"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "ClientAddress"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Street Address"
#~ msgctxt "ClientAddress"
#~ msgid "Street Address"
#~ msgstr "Cím"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Sub Building Nr"
#~ msgctxt "ClientAddress"
#~ msgid "Sub Building Nr"
#~ msgstr "Lépcsőház"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "ClientAddress"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "ClientAddress"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgid "Bank"
#~ msgctxt "ClientBankAccount"
#~ msgid "Bank"
#~ msgstr "Bank"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "ClientBankAccount"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "ClientBankAccount"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "ClientBankAccount"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Iban"
#~ msgctxt "ClientBankAccount"
#~ msgid "Iban"
#~ msgstr "IBAN"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ClientBankAccount"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "ClientBankAccount"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgctxt "CompanyBrowserView"
#~| msgid "Is Default"
#~ msgctxt "ClientBankAccount"
#~ msgid "Is Default"
#~ msgstr "Alapértelmezett"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "ClientBankAccount"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "ClientBankAccount"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "ClientBankAccount"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "ClientBankAccount"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "ClientBankAccount"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgid "Valid From"
#~ msgctxt "ClientBankAccount"
#~ msgid "Valid From"
#~ msgstr "Érvényesség kezdete"

#, fuzzy
#~| msgid "Valid To"
#~ msgctxt "ClientBankAccount"
#~ msgid "Valid To"
#~ msgstr "Érvényesség vége"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "ClientContact"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "ClientContact"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Email"
#~ msgctxt "ClientContact"
#~ msgid "Email"
#~ msgstr "Email"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "ClientContact"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "External key"
#~ msgctxt "ClientContact"
#~ msgid "External Key"
#~ msgstr "Külső azonosító"

#, fuzzy
#~| msgctxt "Contact"
#~| msgid "Fax"
#~ msgctxt "ClientContact"
#~ msgid "Fax"
#~ msgstr "Fax"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ClientContact"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "ClientContact"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgctxt "Contact"
#~| msgid "Job Title"
#~ msgctxt "ClientContact"
#~ msgid "Job Title"
#~ msgstr "Munkakör / pozíció"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "ClientContact"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgctxt "Contact"
#~| msgid "Mobile"
#~ msgctxt "ClientContact"
#~ msgid "Mobile"
#~ msgstr "Mobil"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "ClientContact"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "ClientContact"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "ClientContact"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "SimplifiedClientView"
#~| msgid "Phone"
#~ msgctxt "ClientContact"
#~ msgid "Phone"
#~ msgstr "Telefonszám"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "ClientContact"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "ClientContact"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "ClientContact"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "ClientEmployee"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "ClientEmployee"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Email"
#~ msgctxt "ClientEmployee"
#~ msgid "Email"
#~ msgstr "Email"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "ClientEmployee"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "External key"
#~ msgctxt "ClientEmployee"
#~ msgid "External Key"
#~ msgstr "Külső azonosító"

#, fuzzy
#~| msgctxt "Contact"
#~| msgid "Fax"
#~ msgctxt "ClientEmployee"
#~ msgid "Fax"
#~ msgstr "Fax"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ClientEmployee"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "ClientEmployee"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgctxt "Contact"
#~| msgid "Job Title"
#~ msgctxt "ClientEmployee"
#~ msgid "Job Title"
#~ msgstr "Munkakör / pozíció"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "ClientEmployee"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgctxt "Contact"
#~| msgid "Mobile"
#~ msgctxt "ClientEmployee"
#~ msgid "Mobile"
#~ msgstr "Mobil"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "ClientEmployee"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "ClientEmployee"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "ClientEmployee"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "SimplifiedClientView"
#~| msgid "Phone"
#~ msgctxt "ClientEmployee"
#~ msgid "Phone"
#~ msgstr "Telefonszám"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "ClientEmployee"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "ClientEmployee"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "ClientEmployee"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ClientReference"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "Comment"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "Comment"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "Comment"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "Comment"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "Comment"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "Comment"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Message"
#~ msgctxt "Comment"
#~ msgid "Message Key"
#~ msgstr "Üzenet"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "Comment"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgid "Subject"
#~ msgctxt "Comment"
#~ msgid "Object Id"
#~ msgstr "Tárgy"

#, fuzzy
#~| msgctxt "MeterSensorDataBrowser"
#~| msgid "Meter Type"
#~ msgctxt "Comment"
#~ msgid "Owner Type"
#~ msgstr "Mérőóra típusa"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "Comment"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "Comment"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "Comment"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Account Numbers"
#~ msgctxt "Company"
#~ msgid "Account Numbers"
#~ msgstr "Számlaszámok"

#, fuzzy
#~| msgid "Addresses"
#~ msgctxt "Company"
#~ msgid "Addresses"
#~ msgstr "Címek"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Command"
#~ msgctxt "Company"
#~ msgid "Command"
#~ msgstr "Parancs"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "Company"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "Company"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Emails"
#~ msgctxt "Company"
#~ msgid "Emails"
#~ msgstr "Emailek"

#, fuzzy
#~| msgid "Employees"
#~ msgctxt "Company"
#~ msgid "Employees"
#~ msgstr "Alkalmazottak"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "Company"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Eu Tax Number"
#~ msgctxt "Company"
#~ msgid "Eu Tax Number"
#~ msgstr "EU adószám"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "External Id"
#~ msgctxt "Company"
#~ msgid "External Id"
#~ msgstr "Külső Azonosító"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "Company"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "Company"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgctxt "CompanyBrowserView"
#~| msgid "Is Default"
#~ msgctxt "Company"
#~ msgid "Is Default"
#~ msgstr "Alapértelmezett"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Is Deleted"
#~ msgctxt "Company"
#~ msgid "Is Deleted"
#~ msgstr "Törölve"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "Company"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "Company"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "ClientsView"
#~| msgid "Owned"
#~ msgctxt "Company"
#~ msgid "Owned"
#~ msgstr "Saját cég"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Payment Period Days"
#~ msgctxt "Company"
#~ msgid "Payment Period Days"
#~ msgstr "Fizetési időszak (nap)"

#, fuzzy
#~| msgid "Revision"
#~ msgctxt "Company"
#~ msgid "Revision"
#~ msgstr "Verzió"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "Company"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "Company"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "Company"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "CompanyAccountNumber"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "CompanyAccountNumber"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "CompanyAccountNumber"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "CompanyAccountNumber"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Is Deleted"
#~ msgctxt "CompanyAccountNumber"
#~ msgid "Is Deleted"
#~ msgstr "Törölve"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "CompanyAccountNumber"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Revision"
#~ msgctxt "CompanyAccountNumber"
#~ msgid "Revision"
#~ msgstr "Verzió"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Address Type"
#~ msgctxt "CompanyAddress"
#~ msgid "Address type"
#~ msgstr "Cím típusa"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Building Nr"
#~ msgctxt "CompanyAddress"
#~ msgid "Building Nr"
#~ msgstr "Épület"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "City"
#~ msgctxt "CompanyAddress"
#~ msgid "City"
#~ msgstr "Város"

#, fuzzy
#~| msgctxt "Contracts"
#~| msgid "Company"
#~ msgctxt "CompanyAddress"
#~ msgid "Company"
#~ msgstr "Saját Cég"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Country"
#~ msgctxt "CompanyAddress"
#~ msgid "Country"
#~ msgstr "Ország"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "CompanyAddress"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "CompanyAddress"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "District"
#~ msgctxt "CompanyAddress"
#~ msgid "District"
#~ msgstr "Kerület"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Door Nr"
#~ msgctxt "CompanyAddress"
#~ msgid "Door Nr"
#~ msgstr "Ajtó"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "CompanyAddress"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "External Id"
#~ msgctxt "CompanyAddress"
#~ msgid "External Id"
#~ msgstr "Külső Azonosító"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Floor Nr"
#~ msgctxt "CompanyAddress"
#~ msgid "Floor Nr"
#~ msgstr "Szint"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "House Nr"
#~ msgctxt "CompanyAddress"
#~ msgid "House Nr"
#~ msgstr "Házszám"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "CompanyAddress"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "CompanyAddress"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgctxt "CompanyBrowserView"
#~| msgid "Is Default"
#~ msgctxt "CompanyAddress"
#~ msgid "Is Default"
#~ msgstr "Alapértelmezett"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Is Deleted"
#~ msgctxt "CompanyAddress"
#~ msgid "Is Deleted"
#~ msgstr "Törölve"

#, fuzzy
#~| msgctxt "DraftInvoiceBrowserView"
#~| msgid "Line Count"
#~ msgctxt "CompanyAddress"
#~ msgid "Line 1"
#~ msgstr "Sortételek száma"

#, fuzzy
#~| msgctxt "DraftInvoiceBrowserView"
#~| msgid "Line Count"
#~ msgctxt "CompanyAddress"
#~ msgid "Line 2"
#~ msgstr "Sortételek száma"

#, fuzzy
#~| msgctxt "DraftInvoiceBrowserView"
#~| msgid "Line Count"
#~ msgctxt "CompanyAddress"
#~ msgid "Line 3"
#~ msgstr "Sortételek száma"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "CompanyAddress"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "CompanyAddress"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "CompanyAddress"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Other Details"
#~ msgctxt "CompanyAddress"
#~ msgid "Other Details"
#~ msgstr "Részletek"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Postal Code"
#~ msgctxt "CompanyAddress"
#~ msgid "Postal Code"
#~ msgstr "Irányítószám"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Public Place"
#~ msgctxt "CompanyAddress"
#~ msgid "Public Place"
#~ msgstr "Közterület neve"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Public Place Type"
#~ msgctxt "CompanyAddress"
#~ msgid "Public Place Type"
#~ msgstr "Közterület jellege"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Region"
#~ msgctxt "CompanyAddress"
#~ msgid "Region"
#~ msgstr "Megye/régió"

#, fuzzy
#~| msgid "Revision"
#~ msgctxt "CompanyAddress"
#~ msgid "Revision"
#~ msgstr "Verzió"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "CompanyAddress"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Street Address"
#~ msgctxt "CompanyAddress"
#~ msgid "Street Address"
#~ msgstr "Cím"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Sub Building Nr"
#~ msgctxt "CompanyAddress"
#~ msgid "Sub Building Nr"
#~ msgstr "Lépcsőház"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "CompanyAddress"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "CompanyAddress"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgctxt "Contracts"
#~| msgid "Company"
#~ msgctxt "CompanyEmployee"
#~ msgid "Company"
#~ msgstr "Saját Cég"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "CompanyEmployee"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "CompanyEmployee"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Email"
#~ msgctxt "CompanyEmployee"
#~ msgid "Email"
#~ msgstr "Email"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "CompanyEmployee"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "External Id"
#~ msgctxt "CompanyEmployee"
#~ msgid "External Id"
#~ msgstr "Külső Azonosító"

#, fuzzy
#~| msgctxt "Contact"
#~| msgid "Fax"
#~ msgctxt "CompanyEmployee"
#~ msgid "Fax"
#~ msgstr "Fax"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "CompanyEmployee"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "CompanyEmployee"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Is Deleted"
#~ msgctxt "CompanyEmployee"
#~ msgid "Is Deleted"
#~ msgstr "Törölve"

#, fuzzy
#~| msgctxt "Contact"
#~| msgid "Job Title"
#~ msgctxt "CompanyEmployee"
#~ msgid "Job Title"
#~ msgstr "Munkakör / pozíció"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "CompanyEmployee"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgctxt "Contact"
#~| msgid "Mobile"
#~ msgctxt "CompanyEmployee"
#~ msgid "Mobile"
#~ msgstr "Mobil"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "CompanyEmployee"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "CompanyEmployee"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "CompanyEmployee"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgid "Revision"
#~ msgctxt "CompanyEmployee"
#~ msgid "Revision"
#~ msgstr "Verzió"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "CompanyEmployee"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "CompanyEmployee"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "CompanyEmployee"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgid "Category"
#~ msgctxt "Contract"
#~ msgid "Category Id"
#~ msgstr "Kategória"

#, fuzzy
#~| msgctxt "DraftInvoiceBrowserView"
#~| msgid "Contract Valid From"
#~ msgctxt "Contract"
#~ msgid "Contract Valid From"
#~ msgstr "Szerz. érvényesség kezdete"

#, fuzzy
#~| msgctxt "DraftInvoiceBrowserView"
#~| msgid "Contract Valid To"
#~ msgctxt "Contract"
#~ msgid "Contract Valid To"
#~ msgstr "Szerz. érvényesség vége"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "Contract"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "Contract"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "Contract"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "External key"
#~ msgctxt "Contract"
#~ msgid "External Key"
#~ msgstr "Külső azonosító"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "Contract"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "Contract"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "Contract"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Metadata"
#~ msgctxt "Contract"
#~ msgid "Metadata"
#~ msgstr "Metaadatok"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "Contract"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "ClientAddressTypes"
#~| msgid "Premise"
#~ msgctxt "Contract"
#~ msgid "Premises"
#~ msgstr "Telephely"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "Revision"
#~ msgctxt "Contract"
#~ msgid "Revision Id"
#~ msgstr "Módosítás"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "Contract"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgid "Services"
#~ msgctxt "Contract"
#~ msgid "Services"
#~ msgstr "Szolgáltatások"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "Contract"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "Contract"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgid "Contract type"
#~ msgctxt "ContractCategory"
#~ msgid "Contract type"
#~ msgstr "Szerződés típusa"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "ContractCategory"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "ContractCategory"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "ContractCategory"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "ContractCategory"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Key"
#~ msgctxt "ContractCategory"
#~ msgid "Key"
#~ msgstr "Kulcs"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "ContractCategory"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "ContractCategory"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "ContractCategory"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "ContractCategory"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "ContractCategory"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgid "Contract type"
#~ msgctxt "ContractCategoryUpdate"
#~ msgid "Contract type"
#~ msgstr "Szerződés típusa"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "ContractCategoryUpdate"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Key"
#~ msgctxt "ContractCategoryUpdate"
#~ msgid "Key"
#~ msgstr "Kulcs"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "ContractCategoryUpdate"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "ContractCategoryUpdate"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgid "Category"
#~ msgctxt "ContractDefaults"
#~ msgid "Category Id"
#~ msgstr "Kategória"

#, fuzzy
#~| msgctxt "Contracts"
#~| msgid "Company"
#~ msgctxt "ContractDefaults"
#~ msgid "Company"
#~ msgstr "Saját Cég"

#, fuzzy
#~| msgctxt "ContractBrowserView"
#~| msgid "Contract Number"
#~ msgctxt "ContractDefaults"
#~ msgid "Contract Number"
#~ msgstr "Szerződés száma"

#, fuzzy
#~| msgid "Contract type"
#~ msgctxt "ContractDefaults"
#~ msgid "Contract type"
#~ msgstr "Szerződés típusa"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "Counterparty"
#~ msgctxt "ContractDefaults"
#~ msgid "Counterparty"
#~ msgstr "Szerződő partner"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "ContractDefaults"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "ContractDefaults"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "External key"
#~ msgctxt "ContractDefaults"
#~ msgid "External Key"
#~ msgstr "Külső azonosító"

#, fuzzy
#~| msgctxt "InvoiceBrowserView"
#~| msgid "Invoice kind"
#~ msgctxt "ContractDefaults"
#~ msgid "Invoicing"
#~ msgstr "Fajta"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "Lifecycle"
#~ msgctxt "ContractDefaults"
#~ msgid "Lifecycle"
#~ msgstr "Életciklus"

#, fuzzy
#~| msgctxt "ClientAddressTypes"
#~| msgid "Premise"
#~ msgctxt "ContractDefaults"
#~ msgid "Premises"
#~ msgstr "Telephely"

#, fuzzy
#~| msgid "Rental"
#~ msgctxt "ContractDefaults"
#~ msgid "Rental"
#~ msgstr "Bérlemény"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "Revision Number"
#~ msgctxt "ContractDefaults"
#~ msgid "Revision Number"
#~ msgstr "Módosítás"

#, fuzzy
#~| msgid "Services"
#~ msgctxt "ContractDefaults"
#~ msgid "Services"
#~ msgstr "Szolgáltatások"

#, fuzzy
#~| msgid "Status"
#~ msgctxt "ContractDefaults"
#~ msgid "Status"
#~ msgstr "Státusz"

#, fuzzy
#~| msgctxt "PaymentStatuses"
#~| msgid "Unpaid"
#~ msgctxt "ContractDefaults"
#~ msgid "Uid"
#~ msgstr "Kifizetetlen"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "ContractDefaults"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "ContractDefaults"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgid "Description"
#~ msgctxt "ContractExtras"
#~ msgid "Description"
#~ msgstr "Leírás"

#, fuzzy
#~| msgctxt "ContractBrowserView"
#~| msgid "Folder Number"
#~ msgctxt "ContractExtras"
#~ msgid "Folder Number"
#~ msgstr "Mappaszám"

#, fuzzy
#~| msgid "Reference Number"
#~ msgctxt "ContractExtras"
#~ msgid "Reference Number"
#~ msgstr "Hivatkozási szám"

#, fuzzy
#~| msgctxt "RentalContractBrowseView"
#~| msgid "Billing Currency"
#~ msgctxt "ContractInvoicingConfig"
#~ msgid "Billing Currency"
#~ msgstr "Számlázási pénznem"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "Billing cycle"
#~ msgctxt "ContractInvoicingConfig"
#~ msgid "Billing Cycle"
#~ msgstr "Számlázási ciklus"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "Payment terms"
#~ msgctxt "ContractInvoicingConfig"
#~ msgid "Payment terms"
#~ msgstr "Fizetési feltételek"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "Auto renewal"
#~ msgctxt "ContractLifecycleConfig"
#~ msgid "Auto Renewal"
#~ msgstr "Automatikus megújítás"

#, fuzzy
#~| msgctxt "RentalContractBrowseView"
#~| msgid "Date Of Occupancy"
#~ msgctxt "ContractLifecycleConfig"
#~ msgid "Date Of Occupancy"
#~ msgstr "Átadás dátuma"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "Date signed"
#~ msgctxt "ContractLifecycleConfig"
#~ msgid "Date Signed"
#~ msgstr "Alárás dátuma"

#, fuzzy
#~| msgctxt "ContractBrowserView"
#~| msgid "Effective Date"
#~ msgctxt "ContractLifecycleConfig"
#~ msgid "Effective Date"
#~ msgstr "Hatálybalépés dátuma"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "Notice Period"
#~ msgctxt "ContractLifecycleConfig"
#~ msgid "Notice Period"
#~ msgstr "Felmondási idő"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "Revision Date"
#~ msgctxt "ContractLifecycleConfig"
#~ msgid "Revision Date"
#~ msgstr "Szerződésmódosítás dátuma"

#, fuzzy
#~| msgctxt "ContractBrowserView"
#~| msgid "Termination Date"
#~ msgctxt "ContractLifecycleConfig"
#~ msgid "Termination Date"
#~ msgstr "Felmondás napja"

#, fuzzy
#~| msgctxt "ContractBrowserView"
#~| msgid "Termination Effective Date"
#~ msgctxt "ContractLifecycleConfig"
#~ msgid "Termination Effective Date"
#~ msgstr "Felmondás lejárata"

#, fuzzy
#~| msgid "Valid From"
#~ msgctxt "ContractLifecycleConfig"
#~ msgid "Valid From"
#~ msgstr "Érvényesség kezdete"

#, fuzzy
#~| msgid "Valid To"
#~ msgctxt "ContractLifecycleConfig"
#~ msgid "Valid To"
#~ msgstr "Érvényesség vége"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "Create revision"
#~ msgctxt "ContractMetadata"
#~ msgid "Can Create Revision"
#~ msgstr "Új szerződésmódosítás"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "Delete revision"
#~ msgctxt "ContractMetadata"
#~ msgid "Can Delete Revision"
#~ msgstr "Szerződésmódosítás törlése"

#, fuzzy
#~| msgctxt "Debt"
#~| msgid "Debt Status"
#~ msgctxt "ContractMetadata"
#~ msgid "Next Statuses"
#~ msgstr "Státusz"

#, fuzzy
#~| msgid "Account Number"
#~ msgctxt "ContractParty"
#~ msgid "Account Number"
#~ msgstr "Számlaszám"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Branch Office"
#~ msgctxt "ContractParty"
#~ msgid "Branch Office"
#~ msgstr "Fiók"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Head Office"
#~ msgctxt "ContractParty"
#~ msgid "Head Office"
#~ msgstr "Székhely"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ContractParty"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "ContractParty"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Registration Number"
#~ msgctxt "ContractParty"
#~ msgid "Registration Number"
#~ msgstr "Cégjegyzékszám"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Representative"
#~ msgctxt "ContractParty"
#~ msgid "Representative"
#~ msgstr "Képviselő"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Statistical Code"
#~ msgctxt "ContractParty"
#~ msgid "Statistical Code"
#~ msgstr "Statisztikai kód"

#, fuzzy
#~| msgid "Tax Number"
#~ msgctxt "ContractParty"
#~ msgid "Tax Number"
#~ msgstr "Adószám"

#, fuzzy
#~| msgctxt "AccountsView"
#~| msgid "Type"
#~ msgctxt "ContractPaymentTerms"
#~ msgid "Type"
#~ msgstr "Típus"

#, fuzzy
#~| msgid "Value"
#~ msgctxt "ContractPaymentTerms"
#~ msgid "Value"
#~ msgstr "Érték"

#, fuzzy
#~| msgctxt "ContractParkingBrowseView"
#~| msgid "Card Number"
#~ msgctxt "ContractPremises"
#~ msgid "Card Number"
#~ msgstr "Parkolókártya száma"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "ContractPremises"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "ContractPremises"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "ContractPremises"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "External key"
#~ msgctxt "ContractPremises"
#~ msgid "External Key"
#~ msgstr "Külső azonosító"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ContractPremises"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "ContractPremises"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "ContractPremises"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "ContractPremises"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "ContractPremises"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "ContractParkingBrowseView"
#~| msgid "Parking Spot Number"
#~ msgctxt "ContractPremises"
#~ msgid "Parking Spot Number"
#~ msgstr "Parkolóhely száma"

#, fuzzy
#~| msgctxt "ContractParkingBrowseView"
#~| msgid "Plate Number"
#~ msgctxt "ContractPremises"
#~ msgid "Plate Number"
#~ msgstr "Rendszám"

#, fuzzy
#~| msgctxt "MeterBrowseView"
#~| msgid "Real Property Unit Id"
#~ msgctxt "ContractPremises"
#~ msgid "Property Unit Id"
#~ msgstr "Ingatlan"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "ContractPremises"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "ContractPremises"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "ContractPremises"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgid "Address"
#~ msgctxt "ContractRental"
#~ msgid "Address"
#~ msgstr "Cím"

#, fuzzy
#~| msgctxt "Rental"
#~| msgid "Area"
#~ msgctxt "ContractRental"
#~ msgid "Area"
#~ msgstr "Alapterület"

#, fuzzy
#~| msgid "Description"
#~ msgctxt "ContractRental"
#~ msgid "Description"
#~ msgstr "Leírás"

#, fuzzy
#~| msgctxt "Rentals"
#~| msgid "House Number"
#~ msgctxt "ContractRental"
#~ msgid "House Number"
#~ msgstr "Épületszám"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ContractRental"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgctxt "Rentals"
#~| msgid "Lot Number"
#~ msgctxt "ContractRental"
#~ msgid "Lot Number"
#~ msgstr "Helyrajzi szám"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "ContractRental"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgid "Description"
#~ msgctxt "ContractRevisionInfo"
#~ msgid "Description"
#~ msgstr "Leírás"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "ContractRevisionInfo"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "Create revision"
#~ msgctxt "ContractRevisionInfo"
#~ msgid "Is Current Revision"
#~ msgstr "Új szerződésmódosítás"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "Revision Date"
#~ msgctxt "ContractRevisionInfo"
#~ msgid "Revision Date"
#~ msgstr "Szerződésmódosítás dátuma"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "Revision Number"
#~ msgctxt "ContractRevisionInfo"
#~ msgid "Revision Number"
#~ msgstr "Módosítás"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "ContractRevisionInfo"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgid "Status"
#~ msgctxt "ContractRevisionInfo"
#~ msgid "Status"
#~ msgstr "Státusz"

#, fuzzy
#~| msgid "Valid From"
#~ msgctxt "ContractRevisionInfo"
#~ msgid "Valid From"
#~ msgstr "Érvényesség kezdete"

#, fuzzy
#~| msgid "Valid To"
#~ msgctxt "ContractRevisionInfo"
#~ msgid "Valid To"
#~ msgstr "Érvényesség vége"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "ContractService"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "ContractService"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "ContractService"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "External key"
#~ msgctxt "ContractService"
#~ msgid "External Key"
#~ msgstr "Külső azonosító"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ContractService"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "ContractService"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "ContractService"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "ContractService"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "CreateContractRevision"
#~| msgid "Options"
#~ msgctxt "ContractService"
#~ msgid "Options"
#~ msgstr "Opciók"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "ContractService"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "MeterRentalServiceOnMeterView"
#~| msgid "Service Id"
#~ msgctxt "ContractService"
#~ msgid "Service Id"
#~ msgstr "Szolgáltatás AZ"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "ContractService"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "ContractService"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgid "Valid From"
#~ msgctxt "ContractService"
#~ msgid "Valid From"
#~ msgstr "Érvényesség kezdete"

#, fuzzy
#~| msgid "Valid To"
#~ msgctxt "ContractService"
#~ msgid "Valid To"
#~ msgstr "Érvényesség vége"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "ContractServiceFee"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "ContractServiceFee"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgid "Currency"
#~ msgctxt "ContractServiceFee"
#~ msgid "Currency"
#~ msgstr "Pénznem"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "ContractServiceFee"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "External key"
#~ msgctxt "ContractServiceFee"
#~ msgid "External Key"
#~ msgstr "Külső azonosító"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ContractServiceFee"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "ContractServiceFee"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Inflation Indexed"
#~ msgctxt "ContractServiceFee"
#~ msgid "Inflation Indexed"
#~ msgstr "Inflációkövető"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "ContractServiceFee"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "ContractServiceFee"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "CreateContractRevision"
#~| msgid "Options"
#~ msgctxt "ContractServiceFee"
#~ msgid "Options"
#~ msgstr "Opciók"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "ContractServiceFee"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "ContractServiceFee"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "ContractServiceFee"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgid "Valid From"
#~ msgctxt "ContractServiceFee"
#~ msgid "Valid From"
#~ msgstr "Érvényesség kezdete"

#, fuzzy
#~| msgid "Valid To"
#~ msgctxt "ContractServiceFee"
#~ msgid "Valid To"
#~ msgstr "Érvényesség vége"

#, fuzzy
#~| msgctxt "ClientsView"
#~| msgid "Code"
#~ msgctxt "Currency"
#~ msgid "Code"
#~ msgstr "Azonosító"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "Currency"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "DebtUpdate"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgid "Status"
#~ msgctxt "DebtUpdate"
#~ msgid "Status"
#~ msgstr "Státusz"

#, fuzzy
#~| msgid "Delete"
#~ msgctxt "DeleteDraftInvoices"
#~ msgid "Delete All"
#~ msgstr "Törlés"

#, fuzzy
#~| msgid "Invoices"
#~ msgctxt "DeleteDraftInvoices"
#~ msgid "Invoices"
#~ msgstr "Számlák"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "DeleteEntityCommand"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "DeleteEntityCommand"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Worksheets"
#~ msgctxt "DeleteWorksheets"
#~ msgid "Worksheets"
#~ msgstr "Munkalapok"

#, fuzzy
#~| msgid "Invoice Date"
#~ msgctxt "DunningLetterItem"
#~ msgid "Invoice Data"
#~ msgstr "Számla dátuma"

#, fuzzy
#~| msgid "Invoice Number"
#~ msgctxt "DunningLetterItem"
#~ msgid "Invoice Number"
#~ msgstr "Számlaszám"

#, fuzzy
#~| msgctxt "BrowseLetterRegisterView"
#~| msgid "Client Id"
#~ msgctxt "DunningLetterJobData"
#~ msgid "Client Id"
#~ msgstr "Kliens AZ"

#, fuzzy
#~| msgctxt "Contracts"
#~| msgid "Company"
#~ msgctxt "DunningLetterJobData"
#~ msgid "Company"
#~ msgstr "Saját Cég"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "DunningLetterJobData"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgid "Customer Data"
#~ msgctxt "DunningLetterJobData"
#~ msgid "Customer Data"
#~ msgstr "Vevő adatai"

#, fuzzy
#~| msgctxt "DunningLettersView"
#~| msgid "Customer Name"
#~ msgctxt "DunningLetterJobData"
#~ msgid "Customer Name"
#~ msgstr "Vevőnév"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "DunningLetterJobData"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "DunningLetterJobData"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Interest Rate"
#~ msgctxt "DunningLetterJobData"
#~ msgid "Interest Rate"
#~ msgstr "Kamat"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "DunningLetterJobData"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "DunningLetterJobData"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgid "Reference Number"
#~ msgctxt "DunningLetterJobData"
#~ msgid "Reference Number"
#~ msgstr "Hivatkozási szám"

#, fuzzy
#~| msgid "Severity"
#~ msgctxt "DunningLetterJobData"
#~ msgid "Severity"
#~ msgstr "Kategória"

#, fuzzy
#~| msgid "Status"
#~ msgctxt "DunningLetterJobData"
#~ msgid "Status"
#~ msgstr "Státusz"

#, fuzzy
#~| msgid "Total"
#~ msgctxt "DunningLetterJobData"
#~ msgid "Total"
#~ msgstr "Végösszeg"

#, fuzzy
#~| msgctxt "Worksheet"
#~| msgid "End Date"
#~ msgctxt "EndContractCommand"
#~ msgid "End Date"
#~ msgstr "Befejezés dátuma"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "EndContractCommand"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgid "Status"
#~ msgctxt "EndContractCommand"
#~ msgid "Status"
#~ msgstr "Státusz"

#, fuzzy
#~| msgid "Bank"
#~ msgctxt "ExchangeRate"
#~ msgid "Bank"
#~ msgstr "Bank"

#, fuzzy
#~| msgid "Currency"
#~ msgctxt "ExchangeRate"
#~ msgid "Currency From"
#~ msgstr "Pénznem"

#, fuzzy
#~| msgid "Currency"
#~ msgctxt "ExchangeRate"
#~ msgid "Currency To"
#~ msgstr "Pénznem"

#, fuzzy
#~| msgid "Date"
#~ msgctxt "ExchangeRate"
#~ msgid "Date"
#~ msgstr "Dátum"

#, fuzzy
#~| msgid "Value"
#~ msgctxt "ExchangeRate"
#~ msgid "Value"
#~ msgstr "Érték"

#, fuzzy
#~| msgctxt "FixedAssetBrowser"
#~| msgid "Acquisition Date"
#~ msgctxt "FixedAsset"
#~ msgid "Acquisition Date"
#~ msgstr "Beszerzés dátuma"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "FixedAsset"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "FixedAsset"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "FixedAsset"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "External Id"
#~ msgctxt "FixedAsset"
#~ msgid "External Id"
#~ msgstr "Külső Azonosító"

#, fuzzy
#~| msgctxt "FixedAssetBrowserView"
#~| msgid "Gl Code"
#~ msgctxt "FixedAsset"
#~ msgid "Gl Code"
#~ msgstr "Főkönyvi szám"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "FixedAsset"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "FixedAsset"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgctxt "FixedAssetBrowserView"
#~| msgid "Inventory No"
#~ msgctxt "FixedAsset"
#~ msgid "Inventory No"
#~ msgstr "Leltári szám"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "FixedAsset"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "FixedAsset"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "FixedAsset"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "FixedAssetBrowserView"
#~| msgid "Serial No"
#~ msgctxt "FixedAsset"
#~ msgid "Serial No"
#~ msgstr "Sorozatszám"

#, fuzzy
#~| msgctxt "FixedAssetBrowserView"
#~| msgid "Sku"
#~ msgctxt "FixedAsset"
#~ msgid "Sku"
#~ msgstr "Cikkszám"

#, fuzzy
#~| msgctxt "FixedAssetBrowserView"
#~| msgid "Type No"
#~ msgctxt "FixedAsset"
#~ msgid "Type No"
#~ msgstr "Típusszám"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "FixedAsset"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "FixedAsset"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgctxt "FixedAssetBrowserView"
#~| msgid "Year Of Production"
#~ msgctxt "FixedAsset"
#~ msgid "Year Of Production"
#~ msgstr "Gyártás éve"

#, fuzzy
#~| msgctxt "BrowseLetterRegisterView"
#~| msgid "Client Id"
#~ msgctxt "FixedAssetWorkResult"
#~ msgid "Client Id"
#~ msgstr "Kliens AZ"

#, fuzzy
#~| msgctxt "WasteBinReadings"
#~| msgid "Client Name"
#~ msgctxt "FixedAssetWorkResult"
#~ msgid "Client Name"
#~ msgstr "Ügyfélnév"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "FixedAssetWorkResult"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Quantity"
#~ msgctxt "FixedAssetWorkResult"
#~ msgid "Quantity"
#~ msgstr "Mennyiség"

#, fuzzy
#~| msgctxt "ContractBrowserView"
#~| msgid "Rental Id"
#~ msgctxt "FixedAssetWorkResult"
#~ msgid "Rental Id"
#~ msgstr "Bérlemény AZ"

#, fuzzy
#~| msgid "Rental Name"
#~ msgctxt "FixedAssetWorkResult"
#~ msgid "Rental Name"
#~ msgstr "Bérlemény neve"

#, fuzzy
#~| msgctxt "MeterRentalServiceOnMeterView"
#~| msgid "Service Id"
#~ msgctxt "FixedAssetWorkResult"
#~ msgid "Service Id"
#~ msgstr "Szolgáltatás AZ"

#, fuzzy
#~| msgid "Unit"
#~ msgctxt "FixedAssetWorkResult"
#~ msgid "Unit"
#~ msgstr "Mennyiségi egység"

#, fuzzy
#~| msgid "Work Items"
#~ msgctxt "FixedAssetWorkResult"
#~ msgid "Work Item Date"
#~ msgstr "Munkák"

#, fuzzy
#~| msgctxt "Worksheet"
#~| msgid "Worksheet Date"
#~ msgctxt "FixedAssetWorkResult"
#~ msgid "Worksheet Date"
#~ msgstr "Munkalap dátuma"

#, fuzzy
#~| msgctxt "CreateWorksheetsFromWasteBinReadingsModal"
#~| msgid "Worksheet description"
#~ msgctxt "FixedAssetWorkResult"
#~ msgid "Worksheet Description"
#~ msgstr "Munkalap megnevezése"

#, fuzzy
#~| msgid "Worksheet"
#~ msgctxt "FixedAssetWorkResult"
#~ msgid "Worksheet Id"
#~ msgstr "Munkalap"

#, fuzzy
#~| msgctxt "Worksheet"
#~| msgid "Worksheet Number"
#~ msgctxt "FixedAssetWorkResult"
#~ msgid "Worksheet Number"
#~ msgstr "Munkalap száma"

#, fuzzy
#~| msgctxt "BrowseLetterRegisterView"
#~| msgid "Client Id"
#~ msgctxt "GetCurrentRentalResult"
#~ msgid "Client Id"
#~ msgstr "Kliens AZ"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Rental Inactive"
#~ msgctxt "GetCurrentRentalResult"
#~ msgid "Client Inactive"
#~ msgstr "Bérlemény inaktív"

#, fuzzy
#~| msgctxt "WorksheetBrowserView"
#~| msgid "Client Code"
#~ msgctxt "GetCurrentRentalResult"
#~ msgid "Client Locked"
#~ msgstr "Ügyfélazonosító"

#, fuzzy
#~| msgctxt "WasteBinReadings"
#~| msgid "Client Name"
#~ msgctxt "GetCurrentRentalResult"
#~ msgid "Client Name"
#~ msgstr "Ügyfélnév"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "GetCurrentRentalResult"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "GetCurrentRentalResult"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "GetCurrentRentalResult"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "GetCurrentRentalResult"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgid "Detail"
#~ msgctxt "HTTPValidationError"
#~ msgid "Detail"
#~ msgstr "Részletek"

#, fuzzy
#~| msgid "Contractor"
#~ msgctxt "Invoice"
#~ msgid "Contractor"
#~ msgstr "Alvállalkozó"

#, fuzzy
#~| msgid "Invoice Number"
#~ msgctxt "Invoice"
#~ msgid "Corrected Invoice Number"
#~ msgstr "Számlaszám"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "Invoice"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "Invoice"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "Invoice"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "External Id"
#~ msgctxt "Invoice"
#~ msgid "External Id"
#~ msgstr "Külső Azonosító"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "External key"
#~ msgctxt "Invoice"
#~ msgid "External Key"
#~ msgstr "Külső azonosító"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "Invoice"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "Invoice"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Invoice Number"
#~ msgctxt "Invoice"
#~ msgid "Invoice Number"
#~ msgstr "Számlaszám"

#, fuzzy
#~| msgid "Language"
#~ msgctxt "Invoice"
#~ msgid "Language"
#~ msgstr "Nyelv"

#, fuzzy
#~| msgctxt "Property"
#~| msgid "Location"
#~ msgctxt "Invoice"
#~ msgid "Location"
#~ msgstr "Helykód"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "Invoice"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgctxt "StatDataBrowseView"
#~| msgid "Meta"
#~ msgctxt "Invoice"
#~ msgid "Meta"
#~ msgstr "Metaadat"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "Invoice"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "AccountsDailyFlowView"
#~| msgid "Payment in"
#~ msgctxt "Invoice"
#~ msgid "Payment Conditions"
#~ msgstr "Befizetés"

#, fuzzy
#~| msgctxt "DebtsView"
#~| msgid "Payment method"
#~ msgctxt "Invoice"
#~ msgid "Payment method"
#~ msgstr "Fizetési mód"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "Invoice"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "InvoicesView"
#~| msgid "Tags"
#~ msgctxt "Invoice"
#~ msgid "Tags"
#~ msgstr "Címkék"

#, fuzzy
#~| msgctxt "DraftInvoices"
#~| msgid "Totals"
#~ msgctxt "Invoice"
#~ msgid "Totals"
#~ msgstr "Végösszeg"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "Invoice"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "Invoice"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgid "Account Number"
#~ msgctxt "InvoiceClient"
#~ msgid "Account Number"
#~ msgstr "Számlaszám"

#, fuzzy
#~| msgid "Address"
#~ msgctxt "InvoiceClient"
#~ msgid "Address"
#~ msgstr "Cím"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Email"
#~ msgctxt "InvoiceClient"
#~ msgid "Email"
#~ msgstr "Email"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Eu Tax Number"
#~ msgctxt "InvoiceClient"
#~ msgid "Eu Tax Number"
#~ msgstr "EU adószám"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Iban"
#~ msgctxt "InvoiceClient"
#~ msgid "Iban"
#~ msgstr "IBAN"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "InvoiceClient"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "InvoiceClient"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "InvoiceClient"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "SimplifiedClientView"
#~| msgid "Phone"
#~ msgctxt "InvoiceClient"
#~ msgid "Phone"
#~ msgstr "Telefonszám"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Swift"
#~ msgctxt "InvoiceClient"
#~ msgid "Swift"
#~ msgstr "SWIFT"

#, fuzzy
#~| msgid "Tax Number"
#~ msgctxt "InvoiceClient"
#~ msgid "Tax Number"
#~ msgstr "Adószám"

#, fuzzy
#~| msgid "Account Number"
#~ msgctxt "InvoiceCompany"
#~ msgid "Account Number"
#~ msgstr "Számlaszám"

#, fuzzy
#~| msgid "Address"
#~ msgctxt "InvoiceCompany"
#~ msgid "Address"
#~ msgstr "Cím"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Email"
#~ msgctxt "InvoiceCompany"
#~ msgid "Email"
#~ msgstr "Email"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Eu Tax Number"
#~ msgctxt "InvoiceCompany"
#~ msgid "Eu Tax Number"
#~ msgstr "EU adószám"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Iban"
#~ msgctxt "InvoiceCompany"
#~ msgid "Iban"
#~ msgstr "IBAN"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "InvoiceCompany"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "InvoiceCompany"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "InvoiceCompany"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "SimplifiedClientView"
#~| msgid "Phone"
#~ msgctxt "InvoiceCompany"
#~ msgid "Phone"
#~ msgstr "Telefonszám"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Swift"
#~ msgctxt "InvoiceCompany"
#~ msgid "Swift"
#~ msgstr "SWIFT"

#, fuzzy
#~| msgid "Tax Number"
#~ msgctxt "InvoiceCompany"
#~ msgid "Tax Number"
#~ msgstr "Adószám"

#, fuzzy
#~| msgid "Address"
#~ msgctxt "InvoiceCompanyAddress"
#~ msgid "Address"
#~ msgstr "Cím"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "City"
#~ msgctxt "InvoiceCompanyAddress"
#~ msgid "City"
#~ msgstr "Város"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Country"
#~ msgctxt "InvoiceCompanyAddress"
#~ msgid "Country"
#~ msgstr "Ország"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Postal Code"
#~ msgctxt "InvoiceCompanyAddress"
#~ msgid "Postal Code"
#~ msgstr "Irányítószám"

#, fuzzy
#~| msgid "Account Number"
#~ msgctxt "InvoiceContractor"
#~ msgid "Account Number"
#~ msgstr "Számlaszám"

#, fuzzy
#~| msgid "Address"
#~ msgctxt "InvoiceContractor"
#~ msgid "Address"
#~ msgstr "Cím"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Email"
#~ msgctxt "InvoiceContractor"
#~ msgid "Email"
#~ msgstr "Email"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Eu Tax Number"
#~ msgctxt "InvoiceContractor"
#~ msgid "Eu Tax Number"
#~ msgstr "EU adószám"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Iban"
#~ msgctxt "InvoiceContractor"
#~ msgid "Iban"
#~ msgstr "IBAN"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "InvoiceContractor"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "InvoiceContractor"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "InvoiceContractor"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "SimplifiedClientView"
#~| msgid "Phone"
#~ msgctxt "InvoiceContractor"
#~ msgid "Phone"
#~ msgstr "Telefonszám"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Swift"
#~ msgctxt "InvoiceContractor"
#~ msgid "Swift"
#~ msgstr "SWIFT"

#, fuzzy
#~| msgid "Tax Number"
#~ msgctxt "InvoiceContractor"
#~ msgid "Tax Number"
#~ msgstr "Adószám"

#, fuzzy
#~| msgid "Amount"
#~ msgctxt "InvoiceForPayments"
#~ msgid "Amount"
#~ msgstr "Összeg"

#, fuzzy
#~| msgctxt "WasteBinReadings"
#~| msgid "Client Name"
#~ msgctxt "InvoiceForPayments"
#~ msgid "Client Name"
#~ msgstr "Ügyfélnév"

#, fuzzy
#~| msgid "Currency"
#~ msgctxt "InvoiceForPayments"
#~ msgid "Currency"
#~ msgstr "Pénznem"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "InvoiceForPayments"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Invoice Date"
#~ msgctxt "InvoiceForPayments"
#~ msgid "Invoice Date"
#~ msgstr "Számla dátuma"

#, fuzzy
#~| msgid "Invoice Number"
#~ msgctxt "InvoiceForPayments"
#~ msgid "Invoice Number"
#~ msgstr "Számlaszám"

#, fuzzy
#~| msgctxt "InvoiceBrowserView"
#~| msgid "Invoice kind"
#~ msgctxt "InvoiceForPayments"
#~ msgid "Invoice kind"
#~ msgstr "Fajta"

#, fuzzy
#~| msgctxt "DebtsView"
#~| msgid "Invoice type"
#~ msgctxt "InvoiceForPayments"
#~ msgid "Invoice type"
#~ msgstr "Típus"

#, fuzzy
#~| msgctxt "DraftInvoiceBrowserView"
#~| msgid "Vat Amount"
#~ msgctxt "InvoiceForPayments"
#~ msgid "Paid Amount"
#~ msgstr "Áfa összege"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "InvoiceGenerationTask"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "InvoiceGenerationTask"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "InvoiceGenerationTask"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "InvoiceGenerationTask"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "InvoiceGenerationTask"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "InvoiceGenerationTask"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "InvoiceGenerationTask"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "CreateContractRevision"
#~| msgid "Options"
#~ msgctxt "InvoiceGenerationTask"
#~ msgid "Options"
#~ msgstr "Opciók"

#, fuzzy
#~| msgctxt "InvoiceBrowserView"
#~| msgid "Rental Data"
#~ msgctxt "InvoiceGenerationTask"
#~ msgid "Result Data"
#~ msgstr "Bérlemény adatai"

#, fuzzy
#~| msgid "Result Notes"
#~ msgctxt "InvoiceGenerationTask"
#~ msgid "Result Text"
#~ msgstr "Eredmény megjegyzések"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "InvoiceGenerationTask"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgid "Status"
#~ msgctxt "InvoiceGenerationTask"
#~ msgid "Status"
#~ msgstr "Státusz"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "InvoiceGenerationTask"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "InvoiceGenerationTask"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgctxt "InvoiceGenerator"
#~| msgid "Billing Period End"
#~ msgctxt "InvoiceGenerationTaskOptions"
#~ msgid "Billing Period End"
#~ msgstr "Számlázási időszak vége"

#, fuzzy
#~| msgctxt "InvoiceGenerator"
#~| msgid "Billing Period Start"
#~ msgctxt "InvoiceGenerationTaskOptions"
#~ msgid "Billing Period Start"
#~ msgstr "Számlázási időszak kezdete"

#, fuzzy
#~| msgid "Client Groups"
#~ msgctxt "InvoiceGenerationTaskOptions"
#~ msgid "Client Groups"
#~ msgstr "Ügyfélcsoportok"

#, fuzzy
#~| msgid "Contracts"
#~ msgctxt "InvoiceGenerationTaskOptions"
#~ msgid "Contracts"
#~ msgstr "Szerződések"

#, fuzzy
#~| msgctxt "InvoiceGenerator"
#~| msgid "Due Date"
#~ msgctxt "InvoiceGenerationTaskOptions"
#~ msgid "Due Date"
#~ msgstr "Esedékesség dátuma"

#, fuzzy
#~| msgctxt "PaymentBrowserView"
#~| msgid "Exchange Rate"
#~ msgctxt "InvoiceGenerationTaskOptions"
#~ msgid "Exchange Rates"
#~ msgstr "Árfolyam"

#, fuzzy
#~| msgid "Client Groups"
#~ msgctxt "InvoiceGenerationTaskOptions"
#~ msgid "Exclude Client Groups"
#~ msgstr "Ügyfélcsoportok"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "End Contract"
#~ msgctxt "InvoiceGenerationTaskOptions"
#~ msgid "Exclude Contracts"
#~ msgstr "Szerződés lezárása"

#, fuzzy
#~| msgctxt "InvoiceGenerator"
#~| msgid "Product Invoice Groups"
#~ msgctxt "InvoiceGenerationTaskOptions"
#~ msgid "Exclude Product Invoice Groups"
#~ msgstr "Számlázási csoportok"

#, fuzzy
#~| msgid "Rentals"
#~ msgctxt "InvoiceGenerationTaskOptions"
#~ msgid "Exclude Rentals"
#~ msgstr "Bérlemények"

#, fuzzy
#~| msgid "Exclude"
#~ msgctxt "InvoiceGenerationTaskOptions"
#~ msgid "Exclude Tenants"
#~ msgstr "Kihagyás"

#, fuzzy
#~| msgid "Fulfillment Date"
#~ msgctxt "InvoiceGenerationTaskOptions"
#~ msgid "Fulfillment Date"
#~ msgstr "Teljesítés dátuma"

#, fuzzy
#~| msgctxt "InvoiceGenerator"
#~| msgid "Ignore meter billing thresholds."
#~ msgctxt "InvoiceGenerationTaskOptions"
#~ msgid "Ignore Meter Billing Thresholds"
#~ msgstr "Hagyja figyelmen kívül a számlázási küszöbértékeket."

#, fuzzy
#~| msgctxt "InvoiceGenerator"
#~| msgid "Include zero consumptions"
#~ msgctxt "InvoiceGenerationTaskOptions"
#~ msgid "Include Negative Consumptions"
#~ msgstr "Nulla fogyasztásokat is tartalmazzon"

#, fuzzy
#~| msgid "Invoice Date"
#~ msgctxt "InvoiceGenerationTaskOptions"
#~ msgid "Invoice Date"
#~ msgstr "Számla dátuma"

#, fuzzy
#~| msgid "Invoice Number"
#~ msgctxt "InvoiceGenerationTaskOptions"
#~ msgid "Invoice Number Prefix"
#~ msgstr "Számlaszám"

#, fuzzy
#~| msgid "Invoice Number"
#~ msgctxt "InvoiceGenerationTaskOptions"
#~ msgid "Invoice Number Start"
#~ msgstr "Számlaszám"

#, fuzzy
#~| msgctxt "InvoiceGenerator"
#~| msgid "Invoice Tags"
#~ msgctxt "InvoiceGenerationTaskOptions"
#~ msgid "Invoice Tags"
#~ msgstr "Számla címkék"

#, fuzzy
#~| msgid "Meter Groups"
#~ msgctxt "InvoiceGenerationTaskOptions"
#~ msgid "Meter Groups"
#~ msgstr "Mérőóra csoportok"

#, fuzzy
#~| msgid "Meter Readings"
#~ msgctxt "InvoiceGenerationTaskOptions"
#~ msgid "Meter Readings End Date"
#~ msgstr "Leolvasások"

#, fuzzy
#~| msgctxt "InvoiceGenerator"
#~| msgid "Meter Readings From"
#~ msgctxt "InvoiceGenerationTaskOptions"
#~ msgid "Meter Readings Start Date"
#~ msgstr "Leolvasások induló dátuma"

#, fuzzy
#~| msgctxt "InvoiceGenerator"
#~| msgid "Product Invoice Groups"
#~ msgctxt "InvoiceGenerationTaskOptions"
#~ msgid "Product Invoice Groups"
#~ msgstr "Számlázási csoportok"

#, fuzzy
#~| msgid "Rentals"
#~ msgctxt "InvoiceGenerationTaskOptions"
#~ msgid "Rentals"
#~ msgstr "Bérlemények"

#, fuzzy
#~| msgctxt "MeterRentalServiceOnMeterView"
#~| msgid "Service Name"
#~ msgctxt "InvoiceGenerationTaskOptions"
#~ msgid "Service Type Measured"
#~ msgstr "Szolgáltatás neve"

#, fuzzy
#~| msgid "Worksheets"
#~ msgctxt "InvoiceGenerationTaskOptions"
#~ msgid "Skip Worksheets"
#~ msgstr "Munkalapok"

#, fuzzy
#~| msgctxt "MeterSensorDataBrowser"
#~| msgid "Tenants"
#~ msgctxt "InvoiceGenerationTaskOptions"
#~ msgid "Tenants"
#~ msgstr "Bérlők"

#, fuzzy
#~| msgid "Bank"
#~ msgctxt "InvoiceGeneratorExchangeRate"
#~ msgid "Bank"
#~ msgstr "Bank"

#, fuzzy
#~| msgid "Currency"
#~ msgctxt "InvoiceGeneratorExchangeRate"
#~ msgid "Currency"
#~ msgstr "Pénznem"

#, fuzzy
#~| msgid "Date"
#~ msgctxt "InvoiceGeneratorExchangeRate"
#~ msgid "Date"
#~ msgstr "Dátum"

#, fuzzy
#~| msgctxt "InvoiceGenerator"
#~| msgid "Billing Period End"
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Billing Period End"
#~ msgstr "Számlázási időszak vége"

#, fuzzy
#~| msgctxt "InvoiceGenerator"
#~| msgid "Billing Period Start"
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Billing Period Start"
#~ msgstr "Számlázási időszak kezdete"

#, fuzzy
#~| msgid "Client Groups"
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Client Groups"
#~ msgstr "Ügyfélcsoportok"

#, fuzzy
#~| msgid "Contracts"
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Contracts"
#~ msgstr "Szerződések"

#, fuzzy
#~| msgctxt "InvoiceGenerator"
#~| msgid "Due Date"
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Due Date"
#~ msgstr "Esedékesség dátuma"

#, fuzzy
#~| msgctxt "PaymentBrowserView"
#~| msgid "Exchange Rate"
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Exchange Rates"
#~ msgstr "Árfolyam"

#, fuzzy
#~| msgid "Client Groups"
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Exclude Client Groups"
#~ msgstr "Ügyfélcsoportok"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "End Contract"
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Exclude Contracts"
#~ msgstr "Szerződés lezárása"

#, fuzzy
#~| msgid "Meter Groups"
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Exclude Meter Groups"
#~ msgstr "Mérőóra csoportok"

#, fuzzy
#~| msgctxt "InvoiceGenerator"
#~| msgid "Product Invoice Groups"
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Exclude Product Invoice Groups"
#~ msgstr "Számlázási csoportok"

#, fuzzy
#~| msgid "Rentals"
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Exclude Rentals"
#~ msgstr "Bérlemények"

#, fuzzy
#~| msgid "Exclude"
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Exclude Tenants"
#~ msgstr "Kihagyás"

#, fuzzy
#~| msgid "Fulfillment Date"
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Fulfillment Date"
#~ msgstr "Teljesítés dátuma"

#, fuzzy
#~| msgctxt "InvoiceGenerator"
#~| msgid "Ignore meter billing thresholds."
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Ignore Meter Billing Thresholds"
#~ msgstr "Hagyja figyelmen kívül a számlázási küszöbértékeket."

#, fuzzy
#~| msgctxt "InvoiceGenerator"
#~| msgid "Include zero consumptions"
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Include Negative Consumptions"
#~ msgstr "Nulla fogyasztásokat is tartalmazzon"

#, fuzzy
#~| msgctxt "InvoiceGenerator"
#~| msgid "Include zero consumptions"
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Include Zero Consumption"
#~ msgstr "Nulla fogyasztásokat is tartalmazzon"

#, fuzzy
#~| msgid "Invoice Date"
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Invoice Date"
#~ msgstr "Számla dátuma"

#, fuzzy
#~| msgid "Invoice Number"
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Invoice Number Prefix"
#~ msgstr "Számlaszám"

#, fuzzy
#~| msgid "Invoice Number"
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Invoice Number Start"
#~ msgstr "Számlaszám"

#, fuzzy
#~| msgctxt "InvoiceGenerator"
#~| msgid "Invoice Tags"
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Invoice Tags"
#~ msgstr "Számla címkék"

#, fuzzy
#~| msgid "Meter Groups"
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Meter Groups"
#~ msgstr "Mérőóra csoportok"

#, fuzzy
#~| msgid "Meter Readings"
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Meter Readings End Date"
#~ msgstr "Leolvasások"

#, fuzzy
#~| msgctxt "InvoiceGenerator"
#~| msgid "Meter Readings From"
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Meter Readings Start Date"
#~ msgstr "Leolvasások induló dátuma"

#, fuzzy
#~| msgctxt "InvoiceGenerator"
#~| msgid "Product Invoice Groups"
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Product Invoice Groups"
#~ msgstr "Számlázási csoportok"

#, fuzzy
#~| msgid "Rentals"
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Rentals"
#~ msgstr "Bérlemények"

#, fuzzy
#~| msgctxt "MeterRentalServiceOnMeterView"
#~| msgid "Service Name"
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Service Type Measured"
#~ msgstr "Szolgáltatás neve"

#, fuzzy
#~| msgid "Worksheets"
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Skip Worksheets"
#~ msgstr "Munkalapok"

#, fuzzy
#~| msgctxt "MeterSensorDataBrowser"
#~| msgid "Tenants"
#~ msgctxt "InvoiceGeneratorOptions"
#~ msgid "Tenants"
#~ msgstr "Bérlők"

#, fuzzy
#~| msgctxt "InvoiceStatus"
#~| msgid "Accounting"
#~ msgctxt "InvoiceLine"
#~ msgid "Accountings"
#~ msgstr "Könyvelés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "InvoiceLine"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "InvoiceLine"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "InvoiceLine"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgid "Expense Type"
#~ msgctxt "InvoiceLine"
#~ msgid "Expense type"
#~ msgstr "Költség típus"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "External Id"
#~ msgctxt "InvoiceLine"
#~ msgid "External Id"
#~ msgstr "Külső Azonosító"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "External key"
#~ msgctxt "InvoiceLine"
#~ msgid "External Key"
#~ msgstr "Külső azonosító"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "InvoiceLine"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "InvoiceLine"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Intermediated Service"
#~ msgctxt "InvoiceLine"
#~ msgid "Intermediated Service"
#~ msgstr "Közvetített szolgáltatás"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "InvoiceLine"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Meter"
#~ msgctxt "InvoiceLine"
#~ msgid "Meter"
#~ msgstr "Mérőóra"

#, fuzzy
#~| msgid "Meters"
#~ msgctxt "InvoiceLine"
#~ msgid "Meters"
#~ msgstr "Mérőórák"

#, fuzzy
#~| msgctxt "DraftInvoiceBrowserView"
#~| msgid "Net Amount"
#~ msgctxt "InvoiceLine"
#~ msgid "Net Amount"
#~ msgstr "Nettó összeg"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "InvoiceLine"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "InvoiceLine"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgid "Product"
#~ msgctxt "InvoiceLine"
#~ msgid "Product"
#~ msgstr "Termék"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "InvoiceLine"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgid "Tax Number"
#~ msgctxt "InvoiceLine"
#~ msgid "Tariff Number"
#~ msgstr "Adószám"

#, fuzzy
#~| msgid "Unit Price"
#~ msgctxt "InvoiceLine"
#~ msgid "Unit Price"
#~ msgstr "Egységár"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "InvoiceLine"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "InvoiceLine"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgctxt "DraftInvoiceBrowserView"
#~| msgid "Vat Amount"
#~ msgctxt "InvoiceLine"
#~ msgid "Vat Amount"
#~ msgstr "Áfa összege"

#, fuzzy
#~| msgid "Contractor"
#~ msgctxt "InvoiceLineAccounting"
#~ msgid "Contractor"
#~ msgstr "Alvállalkozó"

#, fuzzy
#~| msgid "Cost Center"
#~ msgctxt "InvoiceLineAccounting"
#~ msgid "Cost Center"
#~ msgstr "Költséghely"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "InvoiceLineAccounting"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "InvoiceLineAccounting"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "InvoiceLineAccounting"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgid "Expense Type"
#~ msgctxt "InvoiceLineAccounting"
#~ msgid "Expense type"
#~ msgstr "Költség típus"

#, fuzzy
#~| msgid "Handover Date"
#~ msgctxt "InvoiceLineAccounting"
#~ msgid "Handover Date"
#~ msgstr "Átadás dátuma"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "InvoiceLineAccounting"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "InvoiceLineAccounting"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Invoice Lines"
#~ msgctxt "InvoiceLineAccounting"
#~ msgid "Invoice Line Id"
#~ msgstr "Számlasorok"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "InvoiceLineAccounting"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "InvoiceLineAccounting"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "InvoiceLineAccounting"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgid "Quantity"
#~ msgctxt "InvoiceLineAccounting"
#~ msgid "Quantity"
#~ msgstr "Mennyiség"

#, fuzzy
#~| msgid "Rental"
#~ msgctxt "InvoiceLineAccounting"
#~ msgid "Rental"
#~ msgstr "Bérlemény"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "InvoiceLineAccounting"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "InvoiceLineAccounting"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "InvoiceLineAccounting"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgid "Worksheet"
#~ msgctxt "InvoiceLineAccounting"
#~ msgid "Worksheet"
#~ msgstr "Munkalap"

#, fuzzy
#~| msgid "Amount"
#~ msgctxt "InvoiceLineAccountingForWorksheet"
#~ msgid "Amount"
#~ msgstr "Összeg"

#, fuzzy
#~| msgid "Cost Center"
#~ msgctxt "InvoiceLineAccountingForWorksheet"
#~ msgid "Cost Center"
#~ msgstr "Költséghely"

#, fuzzy
#~| msgid "Expense Type"
#~ msgctxt "InvoiceLineAccountingForWorksheet"
#~ msgid "Expense type"
#~ msgstr "Költség típus"

#, fuzzy
#~| msgid "Handover Date"
#~ msgctxt "InvoiceLineAccountingForWorksheet"
#~ msgid "Handover Date"
#~ msgstr "Átadás dátuma"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "InvoiceLineAccountingForWorksheet"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgctxt "BulkUpdateInvoiceStatus"
#~| msgid "Invoice Id"
#~ msgctxt "InvoiceLineAccountingForWorksheet"
#~ msgid "Invoice Id"
#~ msgstr "Számla azonosítója"

#, fuzzy
#~| msgid "Invoice Number"
#~ msgctxt "InvoiceLineAccountingForWorksheet"
#~ msgid "Invoice Number"
#~ msgstr "Számlaszám"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "InvoiceLineAccountingForWorksheet"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "Attachments"
#~| msgid "Edit description"
#~ msgctxt "InvoiceLineAccountingForWorksheet"
#~ msgid "Product Description"
#~ msgstr "Leírás szerkesztése"

#, fuzzy
#~| msgid "Product"
#~ msgctxt "InvoiceLineAccountingForWorksheet"
#~ msgid "Product Id"
#~ msgstr "Termék"

#, fuzzy
#~| msgid "Quantity"
#~ msgctxt "InvoiceLineAccountingForWorksheet"
#~ msgid "Quantity"
#~ msgstr "Mennyiség"

#, fuzzy
#~| msgid "Rental"
#~ msgctxt "InvoiceLineAccountingForWorksheet"
#~ msgid "Rental"
#~ msgstr "Bérlemény"

#, fuzzy
#~| msgid "Unit"
#~ msgctxt "InvoiceLineAccountingForWorksheet"
#~ msgid "Unit"
#~ msgstr "Mennyiségi egység"

#, fuzzy
#~| msgid "Unit Price"
#~ msgctxt "InvoiceLineAccountingForWorksheet"
#~ msgid "Unit Price"
#~ msgstr "Egységár"

#, fuzzy
#~| msgid "Billing multiplier"
#~ msgctxt "InvoiceLineMeter"
#~ msgid "Billing Multiplier"
#~ msgstr "Számlázási szorzó"

#, fuzzy
#~| msgid "Consumption"
#~ msgctxt "InvoiceLineMeter"
#~ msgid "Consumption Amount"
#~ msgstr "Fogyasztás"

#, fuzzy
#~| msgid "Consumption"
#~ msgctxt "InvoiceLineMeter"
#~ msgid "Consumption Unit"
#~ msgstr "Fogyasztás"

#, fuzzy
#~| msgid "Cost Center"
#~ msgctxt "InvoiceLineMeter"
#~ msgid "Cost Center"
#~ msgstr "Költséghely"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "InvoiceLineMeter"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "InvoiceLineMeter"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgid "Description"
#~ msgctxt "InvoiceLineMeter"
#~ msgid "Description"
#~ msgstr "Leírás"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "InvoiceLineMeter"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgid "From Unit"
#~ msgctxt "InvoiceLineMeter"
#~ msgid "From Unit"
#~ msgstr "Egység"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "InvoiceLineMeter"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "InvoiceLineMeter"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Invoice Lines"
#~ msgctxt "InvoiceLineMeter"
#~ msgid "Invoice Line Id"
#~ msgstr "Számlasorok"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "InvoiceLineMeter"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Meter"
#~ msgctxt "InvoiceLineMeter"
#~ msgid "Meter"
#~ msgstr "Mérőóra"

#, fuzzy
#~| msgctxt "MeterReadingBrowserView"
#~| msgid "Meter Id"
#~ msgctxt "InvoiceLineMeter"
#~ msgid "Meter Id"
#~ msgstr "Mérőazonosító"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "InvoiceLineMeter"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "InvoiceLineMeter"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "FixedAsset"
#~| msgid "Serial Number"
#~ msgctxt "InvoiceLineMeter"
#~ msgid "Serial Number"
#~ msgstr "Sorozatszám"

#, fuzzy
#~| msgctxt "CompareMeterReadingTypesView"
#~| msgid "Tag Id"
#~ msgctxt "InvoiceLineMeter"
#~ msgid "Tag Id"
#~ msgstr "Belső AZ"

#, fuzzy
#~| msgid "To Amount"
#~ msgctxt "InvoiceLineMeter"
#~ msgid "To Amount"
#~ msgstr "Záró érték"

#, fuzzy
#~| msgid "To Date"
#~ msgctxt "InvoiceLineMeter"
#~ msgid "To Date"
#~ msgstr "Dátum"

#, fuzzy
#~| msgid "To Unit"
#~ msgctxt "InvoiceLineMeter"
#~ msgid "To Unit"
#~ msgstr "Egység"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "InvoiceLineMeter"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "InvoiceLineMeter"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "InvoiceLineProduct"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "InvoiceLineProduct"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "InvoiceMetadata"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "InvoiceMetadata"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgid "Invoice Status"
#~ msgctxt "InvoiceMetadata"
#~ msgid "Next Invoice Statuses"
#~ msgstr "Számla státusza"

#, fuzzy
#~| msgid "Real Value"
#~ msgctxt "InvoiceMetadata"
#~ msgid "Readonly Values"
#~ msgstr "Valós érték"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "InvoiceMetadata"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "InvoiceMetadata"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "InvoicePayment"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "InvoicePayment"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgid "Currency"
#~ msgctxt "InvoicePayment"
#~ msgid "Currency"
#~ msgstr "Pénznem"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "InvoicePayment"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "PaymentBrowserView"
#~| msgid "Exchange Rate"
#~ msgctxt "InvoicePayment"
#~ msgid "Exchange Rate"
#~ msgstr "Árfolyam"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "External Id"
#~ msgctxt "InvoicePayment"
#~ msgid "External Id"
#~ msgstr "Külső Azonosító"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "InvoicePayment"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "InvoicePayment"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgctxt "BulkUpdateInvoiceStatus"
#~| msgid "Invoice Id"
#~ msgctxt "InvoicePayment"
#~ msgid "Invoice Id"
#~ msgstr "Számla azonosítója"

#, fuzzy
#~| msgctxt "InvoiceBrowserView"
#~| msgid "Invoice kind"
#~ msgctxt "InvoicePayment"
#~ msgid "Invoice Kind"
#~ msgstr "Fajta"

#, fuzzy
#~| msgctxt "DebtsView"
#~| msgid "Invoice type"
#~ msgctxt "InvoicePayment"
#~ msgid "Invoice Type"
#~ msgstr "Típus"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "InvoicePayment"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "InvoicePayment"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Owner Id"
#~ msgctxt "InvoicePayment"
#~ msgid "Order Index"
#~ msgstr "Tulajdonos AZ"

#, fuzzy
#~| msgctxt "Payment"
#~| msgid "Payment Date"
#~ msgctxt "InvoicePayment"
#~ msgid "Payment Date"
#~ msgstr "Dátum"

#, fuzzy
#~| msgctxt "AccountsDailyFlowView"
#~| msgid "Payment In"
#~ msgctxt "InvoicePayment"
#~ msgid "Payment Id"
#~ msgstr "Befizetés"

#, fuzzy
#~| msgid "Payment Method"
#~ msgctxt "InvoicePayment"
#~ msgid "Payment Method"
#~ msgstr "Fizetési mód"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "InvoicePayment"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "InvoicePayment"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "InvoicePayment"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "InvoiceReference"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "InvoiceReference"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "InvoiceReference"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "InvoiceReference"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "InvoiceReference"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "InvoiceReference"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "InvoiceReference"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "Invoice"
#~| msgid "Reference Date"
#~ msgctxt "InvoiceReference"
#~ msgid "Reference Data"
#~ msgstr "Vonatkozó dátum"

#, fuzzy
#~| msgctxt "Invoice"
#~| msgid "References"
#~ msgctxt "InvoiceReference"
#~ msgid "Reference Id"
#~ msgstr "Hivatkozások"

#, fuzzy
#~| msgctxt "Invoice"
#~| msgid "Reference Date"
#~ msgctxt "InvoiceReference"
#~ msgid "Reference Type"
#~ msgstr "Vonatkozó dátum"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "InvoiceReference"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "InvoiceReference"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "InvoiceReference"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgid "Amount"
#~ msgctxt "InvoiceTaxTotal"
#~ msgid "Amount"
#~ msgstr "Összeg"

#, fuzzy
#~| msgid "VAT Code"
#~ msgctxt "InvoiceTaxTotal"
#~ msgid "Tax Code"
#~ msgstr "ÁFA kód"

#, fuzzy
#~| msgid "Client"
#~ msgctxt "InvoiceTemplate"
#~ msgid "Client"
#~ msgstr "Ügyfél"

#, fuzzy
#~| msgctxt "Contracts"
#~| msgid "Company"
#~ msgctxt "InvoiceTemplate"
#~ msgid "Company"
#~ msgstr "Saját Cég"

#, fuzzy
#~| msgid "Currency"
#~ msgctxt "InvoiceTemplate"
#~ msgid "Currency"
#~ msgstr "Pénznem"

#, fuzzy
#~| msgctxt "InvoiceGenerator"
#~| msgid "Due Date"
#~ msgctxt "InvoiceTemplate"
#~ msgid "Due Date"
#~ msgstr "Esedékesség dátuma"

#, fuzzy
#~| msgid "Fulfillment Date"
#~ msgctxt "InvoiceTemplate"
#~ msgid "Fulfillment Date"
#~ msgstr "Teljesítés dátuma"

#, fuzzy
#~| msgid "Invoice Date"
#~ msgctxt "InvoiceTemplate"
#~ msgid "Invoice Date"
#~ msgstr "Számla dátuma"

#, fuzzy
#~| msgctxt "InvoiceBrowserView"
#~| msgid "Invoice kind"
#~ msgctxt "InvoiceTemplate"
#~ msgid "Invoice kind"
#~ msgstr "Fajta"

#, fuzzy
#~| msgctxt "DraftInvoiceBrowserView"
#~| msgid "Invoice status"
#~ msgctxt "InvoiceTemplate"
#~ msgid "Invoice status"
#~ msgstr "Státusz"

#, fuzzy
#~| msgctxt "DebtsView"
#~| msgid "Invoice type"
#~ msgctxt "InvoiceTemplate"
#~ msgid "Invoice type"
#~ msgstr "Típus"

#, fuzzy
#~| msgid "Language"
#~ msgctxt "InvoiceTemplate"
#~ msgid "Language"
#~ msgstr "Nyelv"

#, fuzzy
#~| msgid "Number"
#~ msgctxt "InvoiceTemplate"
#~ msgid "Number"
#~ msgstr "Sorszám"

#, fuzzy
#~| msgid "Paid"
#~ msgctxt "InvoiceTemplate"
#~ msgid "Paid"
#~ msgstr "Fizetve"

#, fuzzy
#~| msgctxt "DebtsView"
#~| msgid "Payment method"
#~ msgctxt "InvoiceTemplate"
#~ msgid "Payment method"
#~ msgstr "Fizetési mód"

#, fuzzy
#~| msgctxt "Invoice"
#~| msgid "References"
#~ msgctxt "InvoiceTemplate"
#~ msgid "References"
#~ msgstr "Hivatkozások"

#, fuzzy
#~| msgid "Paid"
#~ msgctxt "InvoiceTotals"
#~ msgid "Paid"
#~ msgstr "Fizetve"

#, fuzzy
#~| msgid "Total"
#~ msgctxt "InvoiceTotals"
#~ msgid "Subtotal"
#~ msgstr "Végösszeg"

#, fuzzy
#~| msgid "Total"
#~ msgctxt "InvoiceTotals"
#~ msgid "Total"
#~ msgstr "Végösszeg"

#, fuzzy
#~| msgctxt "PaymentStatuses"
#~| msgid "Unpaid"
#~ msgctxt "InvoiceTotals"
#~ msgid "Unpaid"
#~ msgstr "Kifizetetlen"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ListSensorDataResult"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgctxt "MeterReadingBrowserView"
#~| msgid "Meter Id"
#~ msgctxt "ListSensorDataResult"
#~ msgid "Meter Id"
#~ msgstr "Mérőazonosító"

#, fuzzy
#~| msgctxt "MeterBrowserView"
#~| msgid "Main Meter Serial"
#~ msgctxt "ListSensorDataResult"
#~ msgid "Meter Serial"
#~ msgstr "Főmérő"

#, fuzzy
#~| msgctxt "MeterBrowser"
#~| msgid "Meter type"
#~ msgctxt "ListSensorDataResult"
#~ msgid "Meter type"
#~ msgstr "Típus"

#, fuzzy
#~| msgid "Offset"
#~ msgctxt "ListSensorDataResult"
#~ msgid "Offset"
#~ msgstr "Korrekció"

#, fuzzy
#~| msgctxt "MeterCharts"
#~| msgid "Raw"
#~ msgctxt "ListSensorDataResult"
#~ msgid "Raw"
#~ msgstr "Szenzor adat"

#, fuzzy
#~| msgid "Rentals"
#~ msgctxt "ListSensorDataResult"
#~ msgid "Rentals"
#~ msgstr "Bérlemények"

#, fuzzy
#~| msgctxt "MeterSensorDataBrowser"
#~| msgid "Sensor Key"
#~ msgctxt "ListSensorDataResult"
#~ msgid "Sensor"
#~ msgstr "Szenzor azonosító"

#, fuzzy
#~| msgctxt "CompareMeterReadingTypesView"
#~| msgid "Tag Id"
#~ msgctxt "ListSensorDataResult"
#~ msgid "Tag Id"
#~ msgstr "Belső AZ"

#, fuzzy
#~| msgctxt "MeterSensorDataBrowser"
#~| msgid "Tenants"
#~ msgctxt "ListSensorDataResult"
#~ msgid "Tenants"
#~ msgstr "Bérlők"

#, fuzzy
#~| msgctxt "MeterSensorDataBrowser"
#~| msgid "Timestamp"
#~ msgctxt "ListSensorDataResult"
#~ msgid "Timestamp"
#~ msgstr "Időpont"

#, fuzzy
#~| msgid "Unit"
#~ msgctxt "ListSensorDataResult"
#~ msgid "Unit"
#~ msgstr "Mennyiségi egység"

#, fuzzy
#~| msgid "Value"
#~ msgctxt "ListSensorDataResult"
#~ msgid "Value"
#~ msgstr "Érték"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ListSensorDataResultRental"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "ListSensorDataResultRental"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "ListSensorDataResultRental"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ListSensorDataResultTenant"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "ListSensorDataResultTenant"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "ListSensorDataResultTenant"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "Meter"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "Meter"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "MeterBrowserView"
#~| msgid "Deveui"
#~ msgctxt "Meter"
#~ msgid "Deveui"
#~ msgstr "DevEUI"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "Meter"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "External Id"
#~ msgctxt "Meter"
#~ msgid "External Id"
#~ msgstr "Külső Azonosító"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "Meter"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "Meter"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "Meter"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgctxt "MeterBrowserView"
#~| msgid "Model Name"
#~ msgctxt "Meter"
#~ msgid "Model Name"
#~ msgstr "Modell/Típus"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "Meter"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgid "Offset"
#~ msgctxt "Meter"
#~ msgid "Offset"
#~ msgstr "Korrekció"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "Meter"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "FixedAsset"
#~| msgid "Serial Number"
#~ msgctxt "Meter"
#~ msgid "Serial Number"
#~ msgstr "Sorozatszám"

#, fuzzy
#~| msgctxt "DraftInvoiceBrowserView"
#~| msgid "Site Id"
#~ msgctxt "Meter"
#~ msgid "Site Id"
#~ msgstr "Telephely AZ"

#, fuzzy
#~| msgid "Submeters"
#~ msgctxt "Meter"
#~ msgid "Submeters"
#~ msgstr "Almérők"

#, fuzzy
#~| msgctxt "CompareMeterReadingTypesView"
#~| msgid "Tag Id"
#~ msgctxt "Meter"
#~ msgid "Tag Id"
#~ msgstr "Belső AZ"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "Meter"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "Meter"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgid "Valid From"
#~ msgctxt "Meter"
#~ msgid "Valid From"
#~ msgstr "Érvényesség kezdete"

#, fuzzy
#~| msgid "Valid To"
#~ msgctxt "Meter"
#~ msgid "Valid To"
#~ msgstr "Érvényesség vége"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "MeterReading"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "MeterReading"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "MeterReading"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "MeterReading"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "MeterReading"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "MeterReading"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgctxt "MeterReadingBrowserView"
#~| msgid "Meter Id"
#~ msgctxt "MeterReading"
#~ msgid "Meter Id"
#~ msgstr "Mérőazonosító"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "MeterReading"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "MeterReading"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgid "Reading Date"
#~ msgctxt "MeterReading"
#~ msgid "Reading Date"
#~ msgstr "Leolvasás dátuma"

#, fuzzy
#~| msgid "Reading Time"
#~ msgctxt "MeterReading"
#~ msgid "Reading Time"
#~ msgstr "Leolvasás ideje"

#, fuzzy
#~| msgid "Reading Type"
#~ msgctxt "MeterReading"
#~ msgid "Reading Type"
#~ msgstr "Leolvasás típusa"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "MeterReading"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgid "Unit"
#~ msgctxt "MeterReading"
#~ msgid "Unit"
#~ msgstr "Mennyiségi egység"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "MeterReading"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "MeterReading"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgid "Value"
#~ msgctxt "MeterReading"
#~ msgid "Value"
#~ msgstr "Érték"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "Notification"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "Notification"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgid "Data"
#~ msgctxt "Notification"
#~ msgid "Data"
#~ msgstr "Adatok"

#, fuzzy
#~| msgid "Description"
#~ msgctxt "Notification"
#~ msgid "Description"
#~ msgstr "Leírás"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "Notification"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "Notification"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "Notification"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Key"
#~ msgctxt "Notification"
#~ msgid "Key"
#~ msgstr "Kulcs"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "Notification"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "Notification"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "InvoiceBrowserView"
#~| msgid "Rental Data"
#~ msgctxt "Notification"
#~ msgid "Result Data"
#~ msgstr "Bérlemény adatai"

#, fuzzy
#~| msgid "Result Notes"
#~ msgctxt "Notification"
#~ msgid "Result Notes"
#~ msgstr "Eredmény megjegyzések"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "Notification"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "WasteBinReadingModal"
#~| msgid "State"
#~ msgctxt "Notification"
#~ msgid "State"
#~ msgstr "Státusz"

#, fuzzy
#~| msgctxt "AccountsView"
#~| msgid "Type"
#~ msgctxt "Notification"
#~ msgid "Type"
#~ msgstr "Típus"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "Notification"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "Notification"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "Numbering"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "Numbering"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "Numbering"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "Numbering"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "Numbering"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "Numbering"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "Numbering"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "Numbering"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgctxt "Rentals"
#~| msgid "Lot Number"
#~ msgctxt "NumberingInfo"
#~ msgid "Last Number"
#~ msgstr "Helyrajzi szám"

#, fuzzy
#~| msgid "Last value"
#~ msgctxt "NumberingInfo"
#~ msgid "Last Value"
#~ msgstr "Utolsó érték"

#, fuzzy
#~| msgctxt "Numbering"
#~| msgid "Next Number"
#~ msgctxt "NumberingInfo"
#~ msgid "Next Number"
#~ msgstr "A következő szám"

#, fuzzy
#~| msgctxt "Numbering"
#~| msgid "Next value"
#~ msgctxt "NumberingInfo"
#~ msgid "Next Value"
#~ msgstr "Következő érték"

#, fuzzy
#~| msgid "Data type"
#~ msgctxt "NumberingVariable"
#~ msgid "Data Type"
#~ msgstr "Adattípus"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "NumberingVariable"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "NumberingVariable"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgid "Value"
#~ msgctxt "NumberingVariable"
#~ msgid "Value"
#~ msgstr "Érték"

#, fuzzy
#~| msgid "Description"
#~ msgctxt "PartialContractExtras"
#~ msgid "Description"
#~ msgstr "Leírás"

#, fuzzy
#~| msgctxt "ContractBrowserView"
#~| msgid "Folder Number"
#~ msgctxt "PartialContractExtras"
#~ msgid "Folder Number"
#~ msgstr "Mappaszám"

#, fuzzy
#~| msgid "Reference Number"
#~ msgctxt "PartialContractExtras"
#~ msgid "Reference Number"
#~ msgstr "Hivatkozási szám"

#, fuzzy
#~| msgctxt "RentalContractBrowseView"
#~| msgid "Billing Currency"
#~ msgctxt "PartialContractInvoicingConfig"
#~ msgid "Billing Currency"
#~ msgstr "Számlázási pénznem"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "Billing cycle"
#~ msgctxt "PartialContractInvoicingConfig"
#~ msgid "Billing Cycle"
#~ msgstr "Számlázási ciklus"

#, fuzzy
#~| msgid "Invoice Date"
#~ msgctxt "PartialContractInvoicingConfig"
#~ msgid "Invoice Notes"
#~ msgstr "Számla dátuma"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "Payment terms"
#~ msgctxt "PartialContractInvoicingConfig"
#~ msgid "Payment terms"
#~ msgstr "Fizetési feltételek"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "Auto renewal"
#~ msgctxt "PartialContractLifecycleConfig"
#~ msgid "Auto Renewal"
#~ msgstr "Automatikus megújítás"

#, fuzzy
#~| msgctxt "RentalContractBrowseView"
#~| msgid "Date Of Occupancy"
#~ msgctxt "PartialContractLifecycleConfig"
#~ msgid "Date Of Occupancy"
#~ msgstr "Átadás dátuma"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "Date signed"
#~ msgctxt "PartialContractLifecycleConfig"
#~ msgid "Date Signed"
#~ msgstr "Alárás dátuma"

#, fuzzy
#~| msgctxt "ContractBrowserView"
#~| msgid "Effective Date"
#~ msgctxt "PartialContractLifecycleConfig"
#~ msgid "Effective Date"
#~ msgstr "Hatálybalépés dátuma"

#, fuzzy
#~| msgctxt "ContractBrowserView"
#~| msgid "Next Indexation Date"
#~ msgctxt "PartialContractLifecycleConfig"
#~ msgid "Next Indexation Date"
#~ msgstr "Következő indexálás dátuma"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "Notice Period"
#~ msgctxt "PartialContractLifecycleConfig"
#~ msgid "Notice Period"
#~ msgstr "Felmondási idő"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "Revision Date"
#~ msgctxt "PartialContractLifecycleConfig"
#~ msgid "Revision Date"
#~ msgstr "Szerződésmódosítás dátuma"

#, fuzzy
#~| msgctxt "ContractBrowserView"
#~| msgid "Termination Date"
#~ msgctxt "PartialContractLifecycleConfig"
#~ msgid "Termination Date"
#~ msgstr "Felmondás napja"

#, fuzzy
#~| msgctxt "ContractBrowserView"
#~| msgid "Termination Effective Date"
#~ msgctxt "PartialContractLifecycleConfig"
#~ msgid "Termination Effective Date"
#~ msgstr "Felmondás lejárata"

#, fuzzy
#~| msgid "Valid From"
#~ msgctxt "PartialContractLifecycleConfig"
#~ msgid "Valid From"
#~ msgstr "Érvényesség kezdete"

#, fuzzy
#~| msgid "Valid To"
#~ msgctxt "PartialContractLifecycleConfig"
#~ msgid "Valid To"
#~ msgstr "Érvényesség vége"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "Payment"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "Payment"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgid "Currency"
#~ msgctxt "Payment"
#~ msgid "Currency"
#~ msgstr "Pénznem"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "Payment"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "External key"
#~ msgctxt "Payment"
#~ msgid "External Key"
#~ msgstr "Külső azonosító"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "Payment"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "Payment"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "Payment"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "Payment"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "PaymentBrowserView"
#~| msgid "Payment Category"
#~ msgctxt "Payment"
#~ msgid "Payment Category"
#~ msgstr "Fizetési kategória"

#, fuzzy
#~| msgctxt "DebtsView"
#~| msgid "Payment method"
#~ msgctxt "Payment"
#~ msgid "Payment method"
#~ msgstr "Fizetési mód"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "Payment"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "Payment"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "Payment"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "PaymentCategory"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgctxt "AccountsDailyFlowView"
#~| msgid "Account"
#~ msgctxt "PaymentTemplate"
#~ msgid "Account"
#~ msgstr "Folyószámla"

#, fuzzy
#~| msgid "Amount"
#~ msgctxt "PaymentTemplate"
#~ msgid "Amount"
#~ msgstr "Összeg"

#, fuzzy
#~| msgid "Client"
#~ msgctxt "PaymentTemplate"
#~ msgid "Client"
#~ msgstr "Ügyfél"

#, fuzzy
#~| msgid "Currency"
#~ msgctxt "PaymentTemplate"
#~ msgid "Currency"
#~ msgstr "Pénznem"

#, fuzzy
#~| msgid "Description"
#~ msgctxt "PaymentTemplate"
#~ msgid "Description"
#~ msgstr "Leírás"

#, fuzzy
#~| msgctxt "PaymentBrowserView"
#~| msgid "Exchange Rate"
#~ msgctxt "PaymentTemplate"
#~ msgid "Exchange Rate"
#~ msgstr "Árfolyam"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "External key"
#~ msgctxt "PaymentTemplate"
#~ msgid "External Key"
#~ msgstr "Külső azonosító"

#, fuzzy
#~| msgid "File Number"
#~ msgctxt "PaymentTemplate"
#~ msgid "File Number"
#~ msgstr "Mappaszám"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "PaymentTemplate"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgctxt "Invoice"
#~| msgid "Internal Notes"
#~ msgctxt "PaymentTemplate"
#~ msgid "Internal Notes"
#~ msgstr "Belső feljegyzés"

#, fuzzy
#~| msgid "Invoices"
#~ msgctxt "PaymentTemplate"
#~ msgid "Invoices"
#~ msgstr "Számlák"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "PaymentTemplate"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "PaymentTemplate"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "PaymentBrowserView"
#~| msgid "Payment Category"
#~ msgctxt "PaymentTemplate"
#~ msgid "Payment Category"
#~ msgstr "Fizetési kategória"

#, fuzzy
#~| msgctxt "Payment"
#~| msgid "Payment Date"
#~ msgctxt "PaymentTemplate"
#~ msgid "Payment Date"
#~ msgstr "Dátum"

#, fuzzy
#~| msgctxt "PaymentBrowserView"
#~| msgid "Payment Number"
#~ msgctxt "PaymentTemplate"
#~ msgid "Payment Number"
#~ msgstr "Sorszám"

#, fuzzy
#~| msgctxt "DebtsView"
#~| msgid "Payment method"
#~ msgctxt "PaymentTemplate"
#~ msgid "Payment method"
#~ msgstr "Fizetési mód"

#, fuzzy
#~| msgid "Reference Number"
#~ msgctxt "PaymentTemplate"
#~ msgid "Reference Number"
#~ msgstr "Hivatkozási szám"

#, fuzzy
#~| msgctxt "Meter"
#~| msgid "Barcode"
#~ msgctxt "Product"
#~ msgid "Barcodes"
#~ msgstr "Vonalkód"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "Product"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "Product"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgid "Customs Tariff no."
#~ msgctxt "Product"
#~ msgid "Customs Tariff No"
#~ msgstr "Vámtarifaszám"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "Product"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "External Id"
#~ msgctxt "Product"
#~ msgid "External Id"
#~ msgstr "Külső Azonosító"

#, fuzzy
#~| msgctxt "Product"
#~| msgid "External key"
#~ msgctxt "Product"
#~ msgid "External Key"
#~ msgstr "Külső azonosító"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "Product"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "Product"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Intermediated Service"
#~ msgctxt "Product"
#~ msgid "Intermediated Service"
#~ msgstr "Közvetített szolgáltatás"

#, fuzzy
#~| msgid "Invoice Group"
#~ msgctxt "Product"
#~ msgid "Invoice Group Id"
#~ msgstr "Számlázási csoport"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "Product"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "Product"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgid "Prices"
#~ msgctxt "Product"
#~ msgid "Prices"
#~ msgstr "Árak"

#, fuzzy
#~| msgctxt "ProductBrowserView"
#~| msgid "Purchase Vat Code"
#~ msgctxt "Product"
#~ msgid "Purchase Vat Code"
#~ msgstr "Vételi ÁFA"

#, fuzzy
#~| msgctxt "ProductBrowserView"
#~| msgid "Sales Vat Code"
#~ msgctxt "Product"
#~ msgid "Sales Vat Code"
#~ msgstr "Eladási ÁFA"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "Product"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "Product"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "Product"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgctxt "Meter"
#~| msgid "Barcode"
#~ msgctxt "ProductBarcode"
#~ msgid "Barcode"
#~ msgstr "Vonalkód"

#, fuzzy
#~| msgctxt "Meter"
#~| msgid "Barcode"
#~ msgctxt "ProductBarcode"
#~ msgid "Barcode type"
#~ msgstr "Vonalkód"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "ProductBarcode"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "ProductBarcode"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "ProductBarcode"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ProductBarcode"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "ProductBarcode"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "ProductBarcode"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "ProductBarcode"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "ProductBarcode"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "ProductBarcode"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "ProductBarcode"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "ProductBarcode"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "ProductInvoiceGroup"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "ProductInvoiceGroup"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgid "Description"
#~ msgctxt "ProductInvoiceGroup"
#~ msgid "Description"
#~ msgstr "Leírás"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "ProductInvoiceGroup"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ProductInvoiceGroup"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "ProductInvoiceGroup"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "ProductInvoiceGroup"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "ProductInvoiceGroup"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "ProductInvoiceGroup"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "ProductInvoiceGroup"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "ProductInvoiceGroup"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "ProductPrice"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "ProductPrice"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgid "Currency"
#~ msgctxt "ProductPrice"
#~ msgid "Currency"
#~ msgstr "Pénznem"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "ProductPrice"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "External Id"
#~ msgctxt "ProductPrice"
#~ msgid "External Id"
#~ msgstr "Külső Azonosító"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "External key"
#~ msgctxt "ProductPrice"
#~ msgid "External Key"
#~ msgstr "Külső azonosító"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ProductPrice"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Discount price"
#~ msgctxt "ProductPrice"
#~ msgid "Is Discount Price"
#~ msgstr "Kedvezményes ár"

#, fuzzy
#~| msgid "Purchase price"
#~ msgctxt "ProductPrice"
#~ msgid "Is Purchase Price"
#~ msgstr "Beszerzési ár"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "ProductPrice"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Note"
#~ msgctxt "ProductPrice"
#~ msgid "Note"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "ProductPrice"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgid "Meter Groups"
#~ msgctxt "ProductPrice"
#~ msgid "Partner Group Id"
#~ msgstr "Mérőóra csoportok"

#, fuzzy
#~| msgid "Quantity from"
#~ msgctxt "ProductPrice"
#~ msgid "Quantity From"
#~ msgstr "Mennyiség -től"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "ProductPrice"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "ProductPrice"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "ProductPrice"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgid "Valid From"
#~ msgctxt "ProductPrice"
#~ msgid "Valid From"
#~ msgstr "Érvényesség kezdete"

#, fuzzy
#~| msgid "Valid To"
#~ msgctxt "ProductPrice"
#~ msgid "Valid To"
#~ msgstr "Érvényesség vége"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "Property"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "Property"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "Property"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "Property"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "Property"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgctxt "PropertyBrowserView"
#~| msgid "Location Number"
#~ msgctxt "Property"
#~ msgid "Location Number"
#~ msgstr "Helykód"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "Property"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "Property"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Owner Id"
#~ msgctxt "Property"
#~ msgid "Owner Id"
#~ msgstr "Tulajdonos AZ"

#, fuzzy
#~| msgid "Property Unit type"
#~ msgctxt "Property"
#~ msgid "Property Type"
#~ msgstr "Ingatlan típusa"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "Property"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "PropertyBrowserView"
#~| msgid "Unit Of Area"
#~ msgctxt "Property"
#~ msgid "Unit Of Area"
#~ msgstr "Alapterület ME"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "Property"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "Property"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "PropertyType"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "PropertyType"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "PropertyType"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "PropertyType"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "PropertyType"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Groups"
#~ msgctxt "PropertyType"
#~ msgid "Is Group"
#~ msgstr "Csoportok"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "PropertyType"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "PropertyType"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "PropertyType"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "PropertyType"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "PropertyType"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "PropertyType"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgid "Account Number"
#~ msgctxt "ReferencedAccount"
#~ msgid "Account Number"
#~ msgstr "Számlaszám"

#, fuzzy
#~| msgid "Account type"
#~ msgctxt "ReferencedAccount"
#~ msgid "Account type"
#~ msgstr "Számla típusa"

#, fuzzy
#~| msgid "Currency"
#~ msgctxt "ReferencedAccount"
#~ msgid "Currency"
#~ msgstr "Pénznem"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ReferencedAccount"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "ReferencedAccount"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ReferencedClient"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "ReferencedClient"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ReferencedRental"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "ReferencedRental"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgctxt "BrowseLetterRegisterView"
#~| msgid "Company Id"
#~ msgctxt "Rental"
#~ msgid "Company Id"
#~ msgstr "Cég AZ"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "Rental"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "Rental"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "Rental"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "External Id"
#~ msgctxt "Rental"
#~ msgid "External Id"
#~ msgstr "Külső Azonosító"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "External key"
#~ msgctxt "Rental"
#~ msgid "External Key"
#~ msgstr "Külső azonosító"

#, fuzzy
#~| msgctxt "Rentals"
#~| msgid "House Number"
#~ msgctxt "Rental"
#~ msgid "House Number"
#~ msgstr "Épületszám"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "Rental"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "Rental"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgctxt "ReplaceMeterModal"
#~| msgid "Location Code"
#~ msgctxt "Rental"
#~ msgid "Location Code"
#~ msgstr "Hely"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "Rental"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgctxt "Rentals"
#~| msgid "Lot Number"
#~ msgctxt "Rental"
#~ msgid "Lot Number"
#~ msgstr "Helyrajzi szám"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "Rental"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "Rental"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "Rental"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "DraftInvoiceBrowserView"
#~| msgid "Site Id"
#~ msgctxt "Rental"
#~ msgid "Site Id"
#~ msgstr "Telephely AZ"

#, fuzzy
#~| msgctxt "PropertyBrowserView"
#~| msgid "Unit Of Area"
#~ msgctxt "Rental"
#~ msgid "Unit Of Area"
#~ msgstr "Alapterület ME"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "Rental"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "Rental"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgid "Valid From"
#~ msgctxt "Rental"
#~ msgid "Valid From"
#~ msgstr "Érvényesség kezdete"

#, fuzzy
#~| msgid "Valid To"
#~ msgctxt "Rental"
#~ msgid "Valid To"
#~ msgstr "Érvényesség vége"

#, fuzzy
#~| msgid "Asset"
#~ msgctxt "RentalAsset"
#~ msgid "Asset"
#~ msgstr "Tárgyi eszköz"

#, fuzzy
#~| msgid "Asset"
#~ msgctxt "RentalAsset"
#~ msgid "Asset Id"
#~ msgstr "Tárgyi eszköz"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "RentalAsset"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "RentalAsset"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "RentalAsset"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "External Id"
#~ msgctxt "RentalAsset"
#~ msgid "External Id"
#~ msgstr "Külső Azonosító"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "External key"
#~ msgctxt "RentalAsset"
#~ msgid "External Key"
#~ msgstr "Külső azonosító"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "RentalAsset"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "RentalAsset"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "RentalAsset"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "RentalAsset"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "RentalAsset"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "RentalAsset"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "RentalAsset"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "RentalAsset"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgid "Valid From"
#~ msgctxt "RentalAsset"
#~ msgid "Valid From"
#~ msgstr "Érvényesség kezdete"

#, fuzzy
#~| msgid "Valid To"
#~ msgctxt "RentalAsset"
#~ msgid "Valid To"
#~ msgstr "Érvényesség vége"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "RentalProperty"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "RentalProperty"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "RentalProperty"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "External Id"
#~ msgctxt "RentalProperty"
#~ msgid "External Id"
#~ msgstr "Külső Azonosító"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "External key"
#~ msgctxt "RentalProperty"
#~ msgid "External Key"
#~ msgstr "Külső azonosító"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "RentalProperty"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "RentalProperty"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "RentalProperty"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "RentalProperty"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "RentalProperty"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgid "Property"
#~ msgctxt "RentalProperty"
#~ msgid "Property"
#~ msgstr "Ingatlan"

#, fuzzy
#~| msgctxt "MeterBrowseView"
#~| msgid "Real Property Unit Id"
#~ msgctxt "RentalProperty"
#~ msgid "Property Unit Id"
#~ msgstr "Ingatlan"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "RentalProperty"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "RentalProperty"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "RentalProperty"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgid "Valid From"
#~ msgctxt "RentalProperty"
#~ msgid "Valid From"
#~ msgstr "Érvényesség kezdete"

#, fuzzy
#~| msgid "Valid To"
#~ msgctxt "RentalProperty"
#~ msgid "Valid To"
#~ msgstr "Érvényesség vége"

#, fuzzy
#~| msgid "Billing Unit"
#~ msgctxt "RentalService"
#~ msgid "Billing Unit"
#~ msgstr "Számlázási egység"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "RentalService"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "RentalService"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "RentalService"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "External Id"
#~ msgctxt "RentalService"
#~ msgid "External Id"
#~ msgstr "Külső Azonosító"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "External key"
#~ msgctxt "RentalService"
#~ msgid "External Key"
#~ msgstr "Külső azonosító"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "RentalService"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inflation Indexed"
#~ msgctxt "RentalService"
#~ msgid "Inflation Indexed"
#~ msgstr "Inflációkövető"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "RentalService"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgctxt "MeterRentalServiceOnMeterView"
#~| msgid "Meter Factor"
#~ msgctxt "RentalService"
#~ msgid "Meter Factor"
#~ msgstr "Szorzó"

#, fuzzy
#~| msgctxt "MeterReadingBrowserView"
#~| msgid "Meter Id"
#~ msgctxt "RentalService"
#~ msgid "Meter Id"
#~ msgstr "Mérőazonosító"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "RentalService"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "ContractBrowserView"
#~| msgid "Rental Id"
#~ msgctxt "RentalService"
#~ msgid "Rental Id"
#~ msgstr "Bérlemény AZ"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "RentalService"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "MeterRentalServiceOnMeterView"
#~| msgid "Service Id"
#~ msgctxt "RentalService"
#~ msgid "Service Id"
#~ msgstr "Szolgáltatás AZ"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "RentalService"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "RentalService"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgid "Valid From"
#~ msgctxt "RentalService"
#~ msgid "Valid From"
#~ msgstr "Érvényesség kezdete"

#, fuzzy
#~| msgid "Valid To"
#~ msgctxt "RentalService"
#~ msgid "Valid To"
#~ msgstr "Érvényesség vége"

#, fuzzy
#~| msgid "Billing Unit"
#~ msgctxt "RentalServiceDefaults"
#~ msgid "Billing Unit"
#~ msgstr "Számlázási egység"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "External Id"
#~ msgctxt "RentalServiceDefaults"
#~ msgid "External Id"
#~ msgstr "Külső Azonosító"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "External key"
#~ msgctxt "RentalServiceDefaults"
#~ msgid "External Key"
#~ msgstr "Külső azonosító"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "RentalServiceDefaults"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Inflation Indexed"
#~ msgctxt "RentalServiceDefaults"
#~ msgid "Inflation Indexed"
#~ msgstr "Inflációkövető"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "RentalServiceDefaults"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Meter"
#~ msgctxt "RentalServiceDefaults"
#~ msgid "Meter"
#~ msgstr "Mérőóra"

#, fuzzy
#~| msgctxt "MeterRentalServiceOnMeterView"
#~| msgid "Meter Factor"
#~ msgctxt "RentalServiceDefaults"
#~ msgid "Meter Factor"
#~ msgstr "Szorzó"

#, fuzzy
#~| msgctxt "MeterReadingBrowserView"
#~| msgid "Meter Id"
#~ msgctxt "RentalServiceDefaults"
#~ msgid "Meter Id"
#~ msgstr "Mérőazonosító"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "RentalServiceDefaults"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgid "Service"
#~ msgctxt "RentalServiceDefaults"
#~ msgid "Service"
#~ msgstr "Szolgáltatás"

#, fuzzy
#~| msgctxt "MeterRentalServiceOnMeterView"
#~| msgid "Service Id"
#~ msgctxt "RentalServiceDefaults"
#~ msgid "Service Id"
#~ msgstr "Szolgáltatás AZ"

#, fuzzy
#~| msgid "Valid From"
#~ msgctxt "RentalServiceDefaults"
#~ msgid "Valid From"
#~ msgstr "Érvényesség kezdete"

#, fuzzy
#~| msgid "Valid To"
#~ msgctxt "RentalServiceDefaults"
#~ msgid "Valid To"
#~ msgstr "Érvényesség vége"

#, fuzzy
#~| msgctxt "MeterBrowser"
#~| msgid "New meter"
#~ msgctxt "ReplaceMeter"
#~ msgid "New meter"
#~ msgstr "Új mérőóra"

#, fuzzy
#~| msgctxt "MeterTypes"
#~| msgid "Pulse meter"
#~ msgctxt "ReplaceMeter"
#~ msgid "Old meter"
#~ msgstr "Impulzusmérő"

#, fuzzy
#~| msgctxt "ReplaceMeterModal"
#~| msgid "Replacement time"
#~ msgctxt "ReplaceMeter"
#~ msgid "Replacement Time"
#~ msgstr "Csere időpontja"

#, fuzzy
#~| msgctxt "MeterBrowserView"
#~| msgid "Deveui"
#~ msgctxt "ReplaceMeterNewMeter"
#~ msgid "Deveui"
#~ msgstr "DevEUI"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "ReplaceMeterNewMeter"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "ReplaceMeterModal"
#~| msgid "Reading value"
#~ msgctxt "ReplaceMeterNewMeter"
#~ msgid "Reading Value"
#~ msgstr "Mérőállás"

#, fuzzy
#~| msgctxt "CompareMeterReadingTypesView"
#~| msgid "Tag Id"
#~ msgctxt "ReplaceMeterNewMeter"
#~ msgid "Tag Id"
#~ msgstr "Belső AZ"

#, fuzzy
#~| msgid "Unit"
#~ msgctxt "ReplaceMeterNewMeter"
#~ msgid "Unit"
#~ msgstr "Mennyiségi egység"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ReplaceMeterOldMeter"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "ReplaceMeterOldMeter"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "ReplaceMeterModal"
#~| msgid "Reading value"
#~ msgctxt "ReplaceMeterOldMeter"
#~ msgid "Reading Value"
#~ msgstr "Mérőállás"

#, fuzzy
#~| msgid "Unit"
#~ msgctxt "ReplaceMeterOldMeter"
#~ msgid "Unit"
#~ msgstr "Mennyiségi egység"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "RescindContractCommand"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "Rescission date"
#~ msgctxt "RescindContractCommand"
#~ msgid "Rescission Date"
#~ msgstr "Megszüntetés/elállás dátuma"

#, fuzzy
#~| msgid "Status"
#~ msgctxt "RescindContractCommand"
#~ msgid "Status"
#~ msgstr "Státusz"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ServiceRef"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "ServiceRef"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgid "Number"
#~ msgctxt "ServiceRef"
#~ msgid "Number"
#~ msgstr "Sorszám"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "SignContractCommand"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "Signature date"
#~ msgctxt "SignContractCommand"
#~ msgid "Signature Date"
#~ msgstr "Aláírás dátuma"

#, fuzzy
#~| msgid "Status"
#~ msgctxt "SignContractCommand"
#~ msgid "Status"
#~ msgstr "Státusz"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "SuggestClientEmployeeResult"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgctxt "Contact"
#~| msgid "Job Title"
#~ msgctxt "SuggestClientEmployeeResult"
#~ msgid "Job Title"
#~ msgstr "Munkakör / pozíció"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "SuggestClientEmployeeResult"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "SuggestClientEmployeeResult"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "ClientsView"
#~| msgid "Client relation"
#~ msgctxt "SuggestClientResult"
#~ msgid "Client relation"
#~ msgstr "Ügyfélkapcsolat"

#, fuzzy
#~| msgctxt "ClientsView"
#~| msgid "Code"
#~ msgctxt "SuggestClientResult"
#~ msgid "Code"
#~ msgstr "Azonosító"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "SuggestClientResult"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "SuggestClientResult"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Is Contractor"
#~ msgctxt "SuggestClientResult"
#~ msgid "Is Contractor"
#~ msgstr "Alvállalkozó"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Is Natural Person"
#~ msgctxt "SuggestClientResult"
#~ msgid "Is Natural Person"
#~ msgstr "Magánszemély"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "SuggestClientResult"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "SuggestClientResult"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "SuggestCompanyEmployeeResult"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgctxt "Contact"
#~| msgid "Job Title"
#~ msgctxt "SuggestCompanyEmployeeResult"
#~ msgid "Job Title"
#~ msgstr "Munkakör / pozíció"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "SuggestCompanyEmployeeResult"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "SuggestCompanyEmployeeResult"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "SuggestCompanyResult"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "SuggestCompanyResult"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgctxt "CompanyBrowserView"
#~| msgid "Is Default"
#~ msgctxt "SuggestCompanyResult"
#~ msgid "Is Default"
#~ msgstr "Alapértelmezett"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "SuggestCompanyResult"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "SuggestCompanyResult"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgid "Number"
#~ msgctxt "SuggestCompanyResult"
#~ msgid "Number"
#~ msgstr "Sorszám"

#, fuzzy
#~| msgctxt "WasteBinReadings"
#~| msgid "Client Name"
#~ msgctxt "SuggestContractResult"
#~ msgid "Client Name"
#~ msgstr "Ügyfélnév"

#, fuzzy
#~| msgctxt "ContractBrowserView"
#~| msgid "Contract Number"
#~ msgctxt "SuggestContractResult"
#~ msgid "Contract Number"
#~ msgstr "Szerződés száma"

#, fuzzy
#~| msgid "Contract type"
#~ msgctxt "SuggestContractResult"
#~ msgid "Contract Type"
#~ msgstr "Szerződés típusa"

#, fuzzy
#~| msgctxt "Rentals"
#~| msgid "House Number"
#~ msgctxt "SuggestContractResult"
#~ msgid "House Number"
#~ msgstr "Épületszám"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "SuggestContractResult"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "SuggestContractResult"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgctxt "ReplaceMeterModal"
#~| msgid "Location Code"
#~ msgctxt "SuggestContractResult"
#~ msgid "Location Code"
#~ msgstr "Hely"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "SuggestContractResult"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgctxt "Rentals"
#~| msgid "Lot Number"
#~ msgctxt "SuggestContractResult"
#~ msgid "Lot Number"
#~ msgstr "Helyrajzi szám"

#, fuzzy
#~| msgid "Reference Number"
#~ msgctxt "SuggestContractResult"
#~ msgid "Reference Number"
#~ msgstr "Hivatkozási szám"

#, fuzzy
#~| msgid "Rental Name"
#~ msgctxt "SuggestContractResult"
#~ msgid "Rental Name"
#~ msgstr "Bérlemény neve"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "Revision Number"
#~ msgctxt "SuggestContractResult"
#~ msgid "Revision Number"
#~ msgstr "Módosítás"

#, fuzzy
#~| msgid "Status"
#~ msgctxt "SuggestContractResult"
#~ msgid "Status"
#~ msgstr "Státusz"

#, fuzzy
#~| msgid "Description"
#~ msgctxt "SuggestFixedAssetResult"
#~ msgid "Description"
#~ msgstr "Leírás"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "SuggestFixedAssetResult"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "SuggestFixedAssetResult"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgctxt "FixedAssetBrowserView"
#~| msgid "Inventory No"
#~ msgctxt "SuggestFixedAssetResult"
#~ msgid "Inventory No"
#~ msgstr "Leltári szám"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "SuggestFixedAssetResult"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Number"
#~ msgctxt "SuggestFixedAssetResult"
#~ msgid "Number"
#~ msgstr "Sorszám"

#, fuzzy
#~| msgctxt "Meter"
#~| msgid "Barcode"
#~ msgctxt "SuggestMeterResult"
#~ msgid "Barcode"
#~ msgstr "Vonalkód"

#, fuzzy
#~| msgctxt "MeterBrowserView"
#~| msgid "Deveui"
#~ msgctxt "SuggestMeterResult"
#~ msgid "Deveui"
#~ msgstr "DevEUI"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "SuggestMeterResult"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "SuggestMeterResult"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgctxt "MeterBrowser"
#~| msgid "Meter type"
#~ msgctxt "SuggestMeterResult"
#~ msgid "Meter type"
#~ msgstr "Típus"

#, fuzzy
#~| msgctxt "MeterBrowserView"
#~| msgid "Model Name"
#~ msgctxt "SuggestMeterResult"
#~ msgid "Model Name"
#~ msgstr "Modell/Típus"

#, fuzzy
#~| msgctxt "FixedAsset"
#~| msgid "Serial Number"
#~ msgctxt "SuggestMeterResult"
#~ msgid "Serial Number"
#~ msgstr "Sorozatszám"

#, fuzzy
#~| msgctxt "CompareMeterReadingTypesView"
#~| msgid "Tag Id"
#~ msgctxt "SuggestMeterResult"
#~ msgid "Tag Id"
#~ msgstr "Belső AZ"

#, fuzzy
#~| msgid "Unit"
#~ msgctxt "SuggestMeterResult"
#~ msgid "Unit"
#~ msgstr "Mennyiségi egység"

#, fuzzy
#~| msgid "Description"
#~ msgctxt "SuggestPaymentResult"
#~ msgid "Description"
#~ msgstr "Leírás"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "SuggestPaymentResult"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Number"
#~ msgctxt "SuggestPaymentResult"
#~ msgid "Number"
#~ msgstr "Sorszám"

#, fuzzy
#~| msgid "Description"
#~ msgctxt "SuggestProductResult"
#~ msgid "Description"
#~ msgstr "Leírás"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "SuggestProductResult"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "SuggestProductResult"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Intermediated Service"
#~ msgctxt "SuggestProductResult"
#~ msgid "Intermediated Service"
#~ msgstr "Közvetített szolgáltatás"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "SuggestProductResult"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "SuggestProductResult"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgctxt "InvoiceGenerator"
#~| msgid "Product Invoice Groups"
#~ msgctxt "SuggestProductResult"
#~ msgid "Product Invoice Group Id"
#~ msgstr "Számlázási csoportok"

#, fuzzy
#~| msgctxt "InvoiceGenerator"
#~| msgid "Product Invoice Groups"
#~ msgctxt "SuggestProductResult"
#~ msgid "Product Invoice Group Name"
#~ msgstr "Számlázási csoportok"

#, fuzzy
#~| msgid "Product type"
#~ msgctxt "SuggestProductResult"
#~ msgid "Product type"
#~ msgstr "Típus"

#, fuzzy
#~| msgctxt "ProductBrowserView"
#~| msgid "Purchase Vat Code"
#~ msgctxt "SuggestProductResult"
#~ msgid "Purchase Vat Code"
#~ msgstr "Vételi ÁFA"

#, fuzzy
#~| msgctxt "ProductBrowserView"
#~| msgid "Sales Vat Code"
#~ msgctxt "SuggestProductResult"
#~ msgid "Sales Vat Code"
#~ msgstr "Eladási ÁFA"

#, fuzzy
#~| msgid "Unit"
#~ msgctxt "SuggestProductResult"
#~ msgid "Unit"
#~ msgstr "Mennyiségi egység"

#, fuzzy
#~| msgid "Description"
#~ msgctxt "SuggestPropertyResult"
#~ msgid "Description"
#~ msgstr "Leírás"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "SuggestPropertyResult"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "SuggestPropertyResult"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgctxt "PropertyBrowserView"
#~| msgid "Location Number"
#~ msgctxt "SuggestPropertyResult"
#~ msgid "Location Number"
#~ msgstr "Helykód"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "SuggestPropertyResult"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "SuggestPropertyResult"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgctxt "PartBrowseView"
#~| msgid "Part type"
#~ msgctxt "SuggestPropertyResult"
#~ msgid "Ptype"
#~ msgstr "Típus"

#, fuzzy
#~| msgid "Description"
#~ msgctxt "SuggestRentalResult"
#~ msgid "Description"
#~ msgstr "Leírás"

#, fuzzy
#~| msgctxt "Rentals"
#~| msgid "House Number"
#~ msgctxt "SuggestRentalResult"
#~ msgid "House Number"
#~ msgstr "Épületszám"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "SuggestRentalResult"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "SuggestRentalResult"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgctxt "ReplaceMeterModal"
#~| msgid "Location Code"
#~ msgctxt "SuggestRentalResult"
#~ msgid "Location Code"
#~ msgstr "Hely"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "SuggestRentalResult"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgctxt "Rentals"
#~| msgid "Lot Number"
#~ msgctxt "SuggestRentalResult"
#~ msgid "Lot Number"
#~ msgstr "Helyrajzi szám"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "SuggestRentalResult"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "SuggestWorkResult"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgid "Description"
#~ msgctxt "SuggestWorksheetResult"
#~ msgid "Description"
#~ msgstr "Leírás"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "SuggestWorksheetResult"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Number"
#~ msgctxt "SuggestWorksheetResult"
#~ msgid "Number"
#~ msgstr "Sorszám"

#, fuzzy
#~| msgid "Invoices"
#~ msgctxt "SyncInvoices"
#~ msgid "Invoices"
#~ msgstr "Számlák"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "SyncInvoicesInvoice"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Total"
#~ msgctxt "TaskProgress"
#~ msgid "Total"
#~ msgstr "Végösszeg"

#, fuzzy
#~| msgctxt "Address"
#~| msgid "Country"
#~ msgctxt "TaxCode"
#~ msgid "Country"
#~ msgstr "Ország"

#, fuzzy
#~| msgid "Description"
#~ msgctxt "TaxCode"
#~ msgid "Description"
#~ msgstr "Leírás"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "TaxCode"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "TaxCode"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "TaxCode"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgctxt "ContractBrowserView"
#~| msgid "Effective Date"
#~ msgctxt "TerminateContractCommand"
#~ msgid "Effective Date"
#~ msgstr "Hatálybalépés dátuma"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "TerminateContractCommand"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgid "Status"
#~ msgctxt "TerminateContractCommand"
#~ msgid "Status"
#~ msgstr "Státusz"

#, fuzzy
#~| msgctxt "ContractBrowserView"
#~| msgid "Termination Date"
#~ msgctxt "TerminateContractCommand"
#~ msgid "Termination Date"
#~ msgstr "Felmondás napja"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "UnarchiveContractCommand"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgid "Status"
#~ msgctxt "UnarchiveContractCommand"
#~ msgid "Status"
#~ msgstr "Státusz"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "Unit"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "Unit"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "Unit"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "Unit"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "Unit"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Invoice Lines"
#~ msgctxt "Unit"
#~ msgid "Invoice Rounding Precision"
#~ msgstr "Számlasorok"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "Unit"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "Unit"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "Unit"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "RealPropertyUnit"
#~| msgid "Unit Type"
#~ msgctxt "Unit"
#~ msgid "Unit type"
#~ msgstr "Típus"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "Unit"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "Unit"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Email"
#~ msgctxt "UserData"
#~ msgid "Email"
#~ msgstr "Email"

#, fuzzy
#~| msgid "Enabled"
#~ msgctxt "UserData"
#~ msgid "Enabled"
#~ msgstr "Engedélyezve"

#, fuzzy
#~| msgid "Firstname"
#~ msgctxt "UserData"
#~ msgid "Firstname"
#~ msgstr "Keresztnév"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "UserData"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Plate number"
#~ msgctxt "UserData"
#~ msgid "Lastname"
#~ msgstr "Rendszám"

#, fuzzy
#~| msgid "Username"
#~ msgctxt "UserData"
#~ msgid "Username"
#~ msgstr "Felhasználónév"

#, fuzzy
#~| msgctxt "JobStatus"
#~| msgid "Errored"
#~ msgctxt "ValidationError"
#~ msgid "Error Type"
#~ msgstr "Hiba"

#, fuzzy
#~| msgctxt "Property"
#~| msgid "Location"
#~ msgctxt "ValidationError"
#~ msgid "Location"
#~ msgstr "Helykód"

#, fuzzy
#~| msgid "Message"
#~ msgctxt "ValidationError"
#~ msgid "Message"
#~ msgstr "Üzenet"

#, fuzzy
#~| msgctxt "BrowseLetterRegisterView"
#~| msgid "Client Id"
#~ msgctxt "WasteBinReading"
#~ msgid "Client Id"
#~ msgstr "Kliens AZ"

#, fuzzy
#~| msgctxt "WasteBinReadings"
#~| msgid "Client Name"
#~ msgctxt "WasteBinReading"
#~ msgid "Client Name"
#~ msgstr "Ügyfélnév"

#, fuzzy
#~| msgctxt "WasteBinReadings"
#~| msgid "Client Number"
#~ msgctxt "WasteBinReading"
#~ msgid "Client Number"
#~ msgstr "Ügyfélszám"

#, fuzzy
#~| msgctxt "WasteBinReadings"
#~| msgid "Cycle"
#~ msgctxt "WasteBinReading"
#~ msgid "Cycle"
#~ msgstr "Ütem"

#, fuzzy
#~| msgctxt "WasteBinReadings"
#~| msgid "Device ID"
#~ msgctxt "WasteBinReading"
#~ msgid "Device Id"
#~ msgstr "Eszköz azonosító"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "WasteBinReading"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgctxt "ContractBrowserView"
#~| msgid "Rental Id"
#~ msgctxt "WasteBinReading"
#~ msgid "Rental Id"
#~ msgstr "Bérlemény AZ"

#, fuzzy
#~| msgid "Rental Name"
#~ msgctxt "WasteBinReading"
#~ msgid "Rental Name"
#~ msgstr "Bérlemény neve"

#, fuzzy
#~| msgctxt "WasteBinReadingModal"
#~| msgid "State"
#~ msgctxt "WasteBinReading"
#~ msgid "State"
#~ msgstr "Státusz"

#, fuzzy
#~| msgctxt "MeterSensorDataBrowser"
#~| msgid "Timestamp"
#~ msgctxt "WasteBinReading"
#~ msgid "Timestamp"
#~ msgstr "Időpont"

#, fuzzy
#~| msgid "Waste Bin Readings"
#~ msgctxt "WasteBinReading"
#~ msgid "Waste Bin Capacity"
#~ msgstr "Hulladékgyűjtő leolvasások"

#, fuzzy
#~| msgctxt "FixedAssetTypes"
#~| msgid "Waste Bin"
#~ msgctxt "WasteBinReading"
#~ msgid "Waste Bin Id"
#~ msgstr "Hulladékgyűjtő"

#, fuzzy
#~| msgctxt "FixedAssetTypes"
#~| msgid "Waste Bin"
#~ msgctxt "WasteBinReading"
#~ msgid "Waste Bin Name"
#~ msgstr "Hulladékgyűjtő"

#, fuzzy
#~| msgctxt "WasteBinReadingModal"
#~| msgid "Bin Number"
#~ msgctxt "WasteBinReading"
#~ msgid "Waste Bin Number"
#~ msgstr "Azonosító"

#, fuzzy
#~| msgid "Worksheets"
#~ msgctxt "WasteBinReading"
#~ msgid "Worksheets"
#~ msgstr "Munkalapok"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "WasteBinReadingWorksheet"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Number"
#~ msgctxt "WasteBinReadingWorksheet"
#~ msgid "Number"
#~ msgstr "Sorszám"

#, fuzzy
#~| msgid "Amount"
#~ msgctxt "WorkItem"
#~ msgid "Amount"
#~ msgstr "Összeg"

#, fuzzy
#~| msgid "Asset"
#~ msgctxt "WorkItem"
#~ msgid "Asset"
#~ msgstr "Tárgyi eszköz"

#, fuzzy
#~| msgid "Asset"
#~ msgctxt "WorkItem"
#~ msgid "Asset Id"
#~ msgstr "Tárgyi eszköz"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "WorkItem"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "WorkItem"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgid "Currency"
#~ msgctxt "WorkItem"
#~ msgid "Currency"
#~ msgstr "Pénznem"

#, fuzzy
#~| msgid "Date"
#~ msgctxt "WorkItem"
#~ msgid "Date"
#~ msgstr "Dátum"

#, fuzzy
#~| msgid "Discount"
#~ msgctxt "WorkItem"
#~ msgid "Discount"
#~ msgstr "Kedvezmény"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "WorkItem"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "External Id"
#~ msgctxt "WorkItem"
#~ msgid "External Id"
#~ msgstr "Külső Azonosító"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "WorkItem"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "WorkItem"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "WorkItem"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgctxt "DraftInvoiceBrowserView"
#~| msgid "Net Amount"
#~ msgctxt "WorkItem"
#~ msgid "Net Amount"
#~ msgstr "Nettó összeg"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "WorkItem"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "WorkItem"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgid "Quantity"
#~ msgctxt "WorkItem"
#~ msgid "Quantity"
#~ msgstr "Mennyiség"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "WorkItem"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgid "Service"
#~ msgctxt "WorkItem"
#~ msgid "Service"
#~ msgstr "Szolgáltatás"

#, fuzzy
#~| msgctxt "MeterRentalServiceOnMeterView"
#~| msgid "Service Id"
#~ msgctxt "WorkItem"
#~ msgid "Service Id"
#~ msgstr "Szolgáltatás AZ"

#, fuzzy
#~| msgid "Task"
#~ msgctxt "WorkItem"
#~ msgid "Task"
#~ msgstr "Feladat"

#, fuzzy
#~| msgid "VAT Code"
#~ msgctxt "WorkItem"
#~ msgid "Tax Code"
#~ msgstr "ÁFA kód"

#, fuzzy
#~| msgid "Total"
#~ msgctxt "WorkItem"
#~ msgid "Total Time"
#~ msgstr "Végösszeg"

#, fuzzy
#~| msgid "Unit"
#~ msgctxt "WorkItem"
#~ msgid "Unit"
#~ msgstr "Mennyiségi egység"

#, fuzzy
#~| msgid "Unit Price"
#~ msgctxt "WorkItem"
#~ msgid "Unit Price"
#~ msgstr "Egységár"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "WorkItem"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "WorkItem"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgctxt "DraftInvoiceBrowserView"
#~| msgid "Vat Amount"
#~ msgctxt "WorkItem"
#~ msgid "Vat Amount"
#~ msgstr "Áfa összege"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "Worksheet"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "Worksheet"
#~ msgid "Created By"
#~ msgstr "Készítette"

#~ msgctxt "Worksheet"
#~ msgid "End Date"
#~ msgstr "Befejezés dátuma"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "Worksheet"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "External Id"
#~ msgctxt "Worksheet"
#~ msgid "External Id"
#~ msgstr "Külső Azonosító"

#, fuzzy
#~| msgctxt "Contract"
#~| msgid "External key"
#~ msgctxt "Worksheet"
#~ msgid "External Key"
#~ msgstr "Külső azonosító"

#, fuzzy
#~| msgctxt "Worksheet"
#~| msgid "GL Account Number"
#~ msgctxt "Worksheet"
#~ msgid "Gl Account Number"
#~ msgstr "Főkönyvi szám"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "Worksheet"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "Worksheet"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "Worksheet"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#~ msgctxt "Worksheet"
#~ msgid "Number"
#~ msgstr "Sorszám"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "Worksheet"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "Worksheet"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "Worksheet"
#~| msgid "Start date"
#~ msgctxt "Worksheet"
#~ msgid "Start Date"
#~ msgstr "Kezdés dátuma"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "Worksheet"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "Worksheet"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgid "Work Items"
#~ msgctxt "Worksheet"
#~ msgid "Work Items"
#~ msgstr "Munkák"

#, fuzzy
#~| msgid "Account Number"
#~ msgctxt "ReadAccount"
#~ msgid "Account Number"
#~ msgstr "Számlaszám"

#, fuzzy
#~| msgid "Account type"
#~ msgctxt "ReadAccount"
#~ msgid "Account type"
#~ msgstr "Számla típusa"

#, fuzzy
#~| msgid "Bank"
#~ msgctxt "ReadAccount"
#~ msgid "Bank"
#~ msgstr "Bank"

#, fuzzy
#~| msgid "Branch"
#~ msgctxt "ReadAccount"
#~ msgid "Branch"
#~ msgstr "Fiók"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "ReadAccount"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "ReadAccount"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgid "Currency"
#~ msgctxt "ReadAccount"
#~ msgid "Currency"
#~ msgstr "Pénznem"

#, fuzzy
#~| msgid "Description"
#~ msgctxt "ReadAccount"
#~ msgid "Description"
#~ msgstr "Leírás"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "ReadAccount"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "External Id"
#~ msgctxt "ReadAccount"
#~ msgid "External Id"
#~ msgstr "Külső Azonosító"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Iban"
#~ msgctxt "ReadAccount"
#~ msgid "Iban"
#~ msgstr "IBAN"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ReadAccount"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "ReadAccount"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "ReadAccount"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "ReadAccount"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "ReadAccount"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgid "Owner"
#~ msgctxt "ReadAccount"
#~ msgid "Owner"
#~ msgstr "Tulajdonos"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Owner Id"
#~ msgctxt "ReadAccount"
#~ msgid "Owner Id"
#~ msgstr "Tulajdonos AZ"

#, fuzzy
#~| msgctxt "PaymentBrowserView"
#~| msgid "Payment Number"
#~ msgctxt "ReadAccount"
#~ msgid "Payment In Numbering Id"
#~ msgstr "Sorszám"

#, fuzzy
#~| msgctxt "PaymentBrowserView"
#~| msgid "Payment Number"
#~ msgctxt "ReadAccount"
#~ msgid "Payment Out Numbering Id"
#~ msgstr "Sorszám"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "ReadAccount"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Swift"
#~ msgctxt "ReadAccount"
#~ msgid "Swift"
#~ msgstr "SWIFT"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "ReadAccount"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "ReadAccount"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgctxt "BrowseLetterRegisterView"
#~| msgid "Client Id"
#~ msgctxt "ReadDunningLetter"
#~ msgid "Client Id"
#~ msgstr "Kliens AZ"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "ReadDunningLetter"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "ReadDunningLetter"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgid "Customer Data"
#~ msgctxt "ReadDunningLetter"
#~ msgid "Customer Data"
#~ msgstr "Vevő adatai"

#, fuzzy
#~| msgctxt "DunningLettersView"
#~| msgid "Customer Name"
#~ msgctxt "ReadDunningLetter"
#~ msgid "Customer Name"
#~ msgstr "Vevőnév"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "ReadDunningLetter"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ReadDunningLetter"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "ReadDunningLetter"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Is Deletable"
#~ msgctxt "ReadDunningLetter"
#~ msgid "Is Deletable"
#~ msgstr "Törölhető"

#, fuzzy
#~| msgid "Work Items"
#~ msgctxt "ReadDunningLetter"
#~ msgid "Items"
#~ msgstr "Munkák"

#, fuzzy
#~| msgid "Jobs"
#~ msgctxt "ReadDunningLetter"
#~ msgid "Jobs"
#~ msgstr "Folyamatok"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "ReadDunningLetter"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "ReadDunningLetter"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "ReadDunningLetter"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgid "Reference Number"
#~ msgctxt "ReadDunningLetter"
#~ msgid "Reference Number"
#~ msgstr "Hivatkozási szám"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "ReadDunningLetter"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgid "Severity"
#~ msgctxt "ReadDunningLetter"
#~ msgid "Severity"
#~ msgstr "Kategória"

#, fuzzy
#~| msgid "Status"
#~ msgctxt "ReadDunningLetter"
#~ msgid "Status"
#~ msgstr "Státusz"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "ReadDunningLetter"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "ReadDunningLetter"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "ReadDunningLetterEmail"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "ReadDunningLetterEmail"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "DunningLetterStatus"
#~| msgid "Error"
#~ msgctxt "ReadDunningLetterEmail"
#~ msgid "Error"
#~ msgstr "Hiba"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ReadDunningLetterEmail"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgctxt "JobBrowserView"
#~| msgid "Job Type"
#~ msgctxt "ReadDunningLetterEmail"
#~ msgid "Job Type"
#~ msgstr "Folyamat típusa"

#, fuzzy
#~| msgid "File name"
#~ msgctxt "ReadDunningLetterEmail"
#~ msgid "Log Filename"
#~ msgstr "Filenév"

#, fuzzy
#~| msgid "Bill To"
#~ msgctxt "ReadDunningLetterEmail"
#~ msgid "Mail To"
#~ msgstr "Ügyfél"

#, fuzzy
#~| msgid "Number"
#~ msgctxt "ReadDunningLetterEmail"
#~ msgid "Number"
#~ msgstr "Sorszám"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "ReadDunningLetterEmail"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgid "Status"
#~ msgctxt "ReadDunningLetterEmail"
#~ msgid "Status"
#~ msgstr "Státusz"

#, fuzzy
#~| msgctxt "email"
#~| msgid "Subject"
#~ msgctxt "ReadDunningLetterEmail"
#~ msgid "Subject"
#~ msgstr "Tárgy"

#, fuzzy
#~| msgctxt "ContractTypes"
#~| msgid "Parking"
#~ msgctxt "ReadDunningLetterEmail"
#~ msgid "Tracking"
#~ msgstr "Parkoló bérleti"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "ReadDunningLetterEmail"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "ReadDunningLetterPDF"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "ReadDunningLetterPDF"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "DunningLetterStatus"
#~| msgid "Error"
#~ msgctxt "ReadDunningLetterPDF"
#~ msgid "Error"
#~ msgstr "Hiba"

#, fuzzy
#~| msgid "File name"
#~ msgctxt "ReadDunningLetterPDF"
#~ msgid "Html Filename"
#~ msgstr "Filenév"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ReadDunningLetterPDF"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgctxt "JobBrowserView"
#~| msgid "Job Type"
#~ msgctxt "ReadDunningLetterPDF"
#~ msgid "Job Type"
#~ msgstr "Folyamat típusa"

#, fuzzy
#~| msgid "File name"
#~ msgctxt "ReadDunningLetterPDF"
#~ msgid "Log Filename"
#~ msgstr "Filenév"

#, fuzzy
#~| msgid "Number"
#~ msgctxt "ReadDunningLetterPDF"
#~ msgid "Number"
#~ msgstr "Sorszám"

#, fuzzy
#~| msgctxt "InvoiceBrowserView"
#~| msgid "Pdf Filename"
#~ msgctxt "ReadDunningLetterPDF"
#~ msgid "Pdf Filename"
#~ msgstr "Pdf fájlnév"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "ReadDunningLetterPDF"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgid "Status"
#~ msgctxt "ReadDunningLetterPDF"
#~ msgid "Status"
#~ msgstr "Státusz"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "ReadDunningLetterPDF"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "ReadGroup"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "ReadGroup"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgid "Description"
#~ msgctxt "ReadGroup"
#~ msgid "Description"
#~ msgstr "Leírás"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "ReadGroup"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgid "Group Type"
#~ msgctxt "ReadGroup"
#~ msgid "Group Type"
#~ msgstr "Csoporttípus"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ReadGroup"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "ReadGroup"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "ReadGroup"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "ReadGroup"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "ReadGroup"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "ReadGroup"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "ReadGroup"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "ReadGroup"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "ReadJob"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "ReadJob"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "ReadJob"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ReadJob"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "ReadJob"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Job result"
#~ msgctxt "ReadJob"
#~ msgid "Job Result"
#~ msgstr "Eredmény"

#, fuzzy
#~| msgctxt "JobBrowserView"
#~| msgid "Job Type"
#~ msgctxt "ReadJob"
#~ msgid "Job Type"
#~ msgstr "Folyamat típusa"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "ReadJob"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Log"
#~ msgctxt "ReadJob"
#~ msgid "Log"
#~ msgstr "Bejegyzés"

#, fuzzy
#~| msgid "Number"
#~ msgctxt "ReadJob"
#~ msgid "Number"
#~ msgstr "Sorszám"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "ReadJob"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "ReadJob"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgid "Status"
#~ msgctxt "ReadJob"
#~ msgid "Status"
#~ msgstr "Státusz"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "ReadJob"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "ReadJob"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgctxt "LetterRegisterEntry"
#~| msgid "Categories"
#~ msgctxt "ReadLetterRegisterEntry"
#~ msgid "Categories"
#~ msgstr "Kategóriák"

#, fuzzy
#~| msgctxt "BrowseLetterRegisterView"
#~| msgid "Client Id"
#~ msgctxt "ReadLetterRegisterEntry"
#~ msgid "Client Id"
#~ msgstr "Kliens AZ"

#, fuzzy
#~| msgctxt "WasteBinReadings"
#~| msgid "Client Name"
#~ msgctxt "ReadLetterRegisterEntry"
#~ msgid "Client Name"
#~ msgstr "Ügyfélnév"

#, fuzzy
#~| msgctxt "BrowseLetterRegisterView"
#~| msgid "Company Id"
#~ msgctxt "ReadLetterRegisterEntry"
#~ msgid "Company Id"
#~ msgstr "Cég AZ"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "ReadLetterRegisterEntry"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "ReadLetterRegisterEntry"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "BrowseLetterRegisterView"
#~| msgid "Delivery Date"
#~ msgctxt "ReadLetterRegisterEntry"
#~ msgid "Delivery Date"
#~ msgstr "Kézbesítés dátuma"

#, fuzzy
#~| msgctxt "BrowseLetterRegisterView"
#~| msgid "Delivery Modes"
#~ msgctxt "ReadLetterRegisterEntry"
#~ msgid "Delivery Modes"
#~ msgstr "Kézbesítés módja"

#, fuzzy
#~| msgctxt "BrowseLetterRegisterView"
#~| msgid "Entry Date"
#~ msgctxt "ReadLetterRegisterEntry"
#~ msgid "Entry Date"
#~ msgstr "Bejegyzés időpontja"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "ReadLetterRegisterEntry"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ReadLetterRegisterEntry"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "ReadLetterRegisterEntry"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "ReadLetterRegisterEntry"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "ReadLetterRegisterEntry"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "ReadLetterRegisterEntry"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "ReadLetterRegisterEntry"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "email"
#~| msgid "Subject"
#~ msgctxt "ReadLetterRegisterEntry"
#~ msgid "Subject"
#~ msgstr "Tárgy"

#, fuzzy
#~| msgctxt "LetterRegisterEntry"
#~| msgid "Undelivered"
#~ msgctxt "ReadLetterRegisterEntry"
#~ msgid "Undelivered"
#~ msgstr "Kézbesítetlen"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "ReadLetterRegisterEntry"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "ReadLetterRegisterEntry"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "ReadStatData"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "ReadStatData"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgid "Data type"
#~ msgctxt "ReadStatData"
#~ msgid "Data type"
#~ msgstr "Adattípus"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "ReadStatData"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ReadStatData"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "ReadStatData"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "ReadStatData"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Month"
#~ msgctxt "ReadStatData"
#~ msgid "Month"
#~ msgstr "Hónap"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "ReadStatData"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "ReadStatData"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgid "Unit"
#~ msgctxt "ReadStatData"
#~ msgid "Unit"
#~ msgstr "Mennyiségi egység"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "ReadStatData"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "ReadStatData"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgid "Value"
#~ msgctxt "ReadStatData"
#~ msgid "Value"
#~ msgstr "Érték"

#, fuzzy
#~| msgid "Year"
#~ msgctxt "ReadStatData"
#~ msgid "Year"
#~ msgstr "Év"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created At"
#~ msgctxt "ReadTemplate"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Created By"
#~ msgctxt "ReadTemplate"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Etag"
#~ msgctxt "ReadTemplate"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "AccountBrowserView"
#~| msgid "Id"
#~ msgctxt "ReadTemplate"
#~ msgid "Id"
#~ msgstr "AZ"

#, fuzzy
#~| msgid "Inactive"
#~ msgctxt "ReadTemplate"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#, fuzzy
#~| msgctxt "CompanyBrowserView"
#~| msgid "Is Default"
#~ msgctxt "ReadTemplate"
#~ msgid "Is Default"
#~ msgstr "Alapértelmezett"

#, fuzzy
#~| msgid "Locked"
#~ msgctxt "ReadTemplate"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#, fuzzy
#~| msgid "Name"
#~ msgctxt "ReadTemplate"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#, fuzzy
#~| msgid "Notes"
#~ msgctxt "ReadTemplate"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Object"
#~ msgctxt "ReadTemplate"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Self"
#~ msgctxt "ReadTemplate"
#~ msgid "Self"
#~ msgstr "Saját"

#, fuzzy
#~| msgctxt "email"
#~| msgid "Subject"
#~ msgctxt "ReadTemplate"
#~ msgid "Subject"
#~ msgstr "Tárgy"

#, fuzzy
#~| msgid "Template type"
#~ msgctxt "ReadTemplate"
#~ msgid "Template type"
#~ msgstr "Típus"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated At"
#~ msgctxt "ReadTemplate"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "Client"
#~| msgid "Updated By"
#~ msgctxt "ReadTemplate"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#~ msgctxt "AccountBrowserView"
#~ msgid "Account Number"
#~ msgstr "Számlaszám"

#~ msgctxt "AccountBrowserView"
#~ msgid "Account type"
#~ msgstr "Számla típusa"

#~ msgctxt "AccountBrowserView"
#~ msgid "Bank"
#~ msgstr "Bank"

#~ msgctxt "AccountBrowserView"
#~ msgid "Branch"
#~ msgstr "Fiók"

#~ msgctxt "AccountBrowserView"
#~ msgid "Currency"
#~ msgstr "Pénznem"

#~ msgctxt "AccountBrowserView"
#~ msgid "Description"
#~ msgstr "Leírás"

#~ msgctxt "AccountBrowserView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "AccountBrowserView"
#~ msgid "Locked"
#~ msgstr "Zárolva"

#~ msgctxt "AccountBrowserView"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#~ msgctxt "AccountBrowserView"
#~ msgid "Owner Name"
#~ msgstr "Saját cég"

#~ msgctxt "AccountsDailyFlowView"
#~ msgid "Account Id"
#~ msgstr "Számla AZ"

#~ msgctxt "AccountsDailyFlowView"
#~ msgid "Closing Balance"
#~ msgstr "Záró egyenleg"

#~ msgctxt "AccountsDailyFlowView"
#~ msgid "Currency"
#~ msgstr "Pénznem"

#~ msgctxt "AccountsDailyFlowView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "AccountsDailyFlowView"
#~ msgid "Opening Balance"
#~ msgstr "Nyitóegyenleg"

#~ msgctxt "AccountsDailyFlowView"
#~ msgid "Owner Id"
#~ msgstr "Tulajdonos AZ"

#~ msgctxt "AccountsDailyFlowView"
#~ msgid "Owner Name"
#~ msgstr "Saját cég"

#~ msgctxt "AccountsDailyFlowView"
#~ msgid "Payment Out"
#~ msgstr "Kifizetés"

#~ msgctxt "BrowseLetterRegisterView"
#~ msgid "Categories"
#~ msgstr "Kategóriák"

#~ msgctxt "BrowseLetterRegisterView"
#~ msgid "Client Name"
#~ msgstr "Ügyfélnév"

#~ msgctxt "BrowseLetterRegisterView"
#~ msgid "Entry Number"
#~ msgstr "Bejegyzés sorszáma"

#~ msgctxt "BrowseLetterRegisterView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "BrowseLetterRegisterView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "BrowseLetterRegisterView"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#~ msgctxt "BrowseLetterRegisterView"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

# TODO
#~ msgctxt "BrowseLetterRegisterView"
#~ msgid "Subject"
#~ msgstr "Tárgy"

#~ msgctxt "BrowseLetterRegisterView"
#~ msgid "Undelivered"
#~ msgstr "Kézbesítetlen"

#~ msgctxt "BulkUpdateInvoiceStatus"
#~ msgid "Status"
#~ msgstr "Státusz"

#~ msgctxt "BulkUpdateInvoiceStatus"
#~ msgid "Writeback"
#~ msgstr "Visszaírás"

#~ msgctxt "Client"
#~ msgid "Addresses"
#~ msgstr "Címek"

#~ msgctxt "Client"
#~ msgid "Client relation"
#~ msgstr "Ügyfélkapcsolat"

#~ msgctxt "Client"
#~ msgid "Contacts"
#~ msgstr "Kapcsolatok"

#~ msgctxt "Client"
#~ msgid "Employees"
#~ msgstr "Alkalmazottak"

#~ msgctxt "Client"
#~ msgid "Excluded From Claims"
#~ msgstr "Követeléskezelés alól kivont"

#~ msgctxt "Client"
#~ msgid "Id"
#~ msgstr "Az"

#~ msgctxt "Client"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "Client"
#~ msgid "Locked"
#~ msgstr "Zárolva"

#~ msgctxt "ClientBrowserView"
#~ msgid "Client relation"
#~ msgstr "Ügyfélkapcsolat"

#~ msgctxt "ClientBrowserView"
#~ msgid "Code"
#~ msgstr "Azonosító"

#~ msgctxt "ClientBrowserView"
#~ msgid "Emails"
#~ msgstr "Emailek"

#~ msgctxt "ClientBrowserView"
#~ msgid "Eu Tax Number"
#~ msgstr "EU adószám"

#~ msgctxt "ClientBrowserView"
#~ msgid "Excluded From Claims"
#~ msgstr "Követeléskezelés alól kivont"

#~ msgctxt "ClientBrowserView"
#~ msgid "External Id"
#~ msgstr "Külső Azonosító"

#~ msgctxt "ClientBrowserView"
#~ msgid "Id"
#~ msgstr "Az"

#~ msgctxt "ClientBrowserView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "ClientBrowserView"
#~ msgid "Is Contractor"
#~ msgstr "Alvállalkozó"

#~ msgctxt "ClientBrowserView"
#~ msgid "Is Natural Person"
#~ msgstr "Magánszemély"

#~ msgctxt "ClientBrowserView"
#~ msgid "Locked"
#~ msgstr "Zárolva"

#~ msgctxt "ClientBrowserView"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#~ msgctxt "ClientBrowserView"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "ClientBrowserView"
#~ msgid "Owned"
#~ msgstr "Saját"

#~ msgctxt "ClientBrowserView"
#~ msgid "Registration Number"
#~ msgstr "Cégjegyzékszám"

#~ msgctxt "ClientBrowserView"
#~ msgid "Tax Number"
#~ msgstr "Adószám"

#~ msgctxt "CompanyBrowserView"
#~ msgid "Emails"
#~ msgstr "Emailek"

#~ msgctxt "CompanyBrowserView"
#~ msgid "Eu Tax Number"
#~ msgstr "EU adószám"

#~ msgctxt "CompanyBrowserView"
#~ msgid "External Id"
#~ msgstr "Külső Azonosító"

#~ msgctxt "CompanyBrowserView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "CompanyBrowserView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "CompanyBrowserView"
#~ msgid "Locked"
#~ msgstr "Zárolva"

#~ msgctxt "CompanyBrowserView"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#~ msgctxt "CompanyBrowserView"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "CompanyBrowserView"
#~ msgid "Number"
#~ msgstr "Azonosító"

#~ msgctxt "CompanyBrowserView"
#~ msgid "Registration Number"
#~ msgstr "Cégjegyzékszám"

#~ msgctxt "CompanyBrowserView"
#~ msgid "Tax Number"
#~ msgstr "Adószám"

#~ msgctxt "CompareMeterReadingTypesView"
#~ msgid "Auto Reading Date"
#~ msgstr "Auto leolvasás dátuma"

#~ msgctxt "CompareMeterReadingTypesView"
#~ msgid "Auto Reading Time"
#~ msgstr "Auto leolvasás ideje"

#~ msgctxt "CompareMeterReadingTypesView"
#~ msgid "Auto Value"
#~ msgstr "Auto leolvasás értéke"

#~ msgctxt "CompareMeterReadingTypesView"
#~ msgid "Consumption"
#~ msgstr "Fogyasztás"

#~ msgctxt "CompareMeterReadingTypesView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "CompareMeterReadingTypesView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "CompareMeterReadingTypesView"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#~ msgctxt "CompareMeterReadingTypesView"
#~ msgid "Manual Reading Date"
#~ msgstr "Kézi olvasás dátuma"

#~ msgctxt "CompareMeterReadingTypesView"
#~ msgid "Manual Reading Time"
#~ msgstr "Kézi olvasás ideje"

#~ msgctxt "CompareMeterReadingTypesView"
#~ msgid "Manual Unit"
#~ msgstr "Kézi olvasás ME"

#~ msgctxt "CompareMeterReadingTypesView"
#~ msgid "Manual Value"
#~ msgstr "Kézi olvasás értéke"

#~ msgctxt "CompareMeterReadingTypesView"
#~ msgid "Meter type"
#~ msgstr "Mérőóra típusa"

#~ msgctxt "CompareMeterReadingTypesView"
#~ msgid "Serial Number"
#~ msgstr "Sorozatszám"

#~ msgctxt "ContractBrowserView"
#~ msgid "Company Id"
#~ msgstr "Cégazonosító"

#~ msgctxt "ContractBrowserView"
#~ msgid "Contract Date"
#~ msgstr "Szerződés dátuma"

#~ msgctxt "ContractBrowserView"
#~ msgid "Contract type"
#~ msgstr "Szerződés típusa"

#~ msgctxt "ContractBrowserView"
#~ msgid "Counterparty Id"
#~ msgstr "Szerződő partner AZ"

#~ msgctxt "ContractBrowserView"
#~ msgid "Counterparty Name"
#~ msgstr "Szerződő partner"

#~ msgctxt "ContractBrowserView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "ContractBrowserView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "ContractBrowserView"
#~ msgid "Locked"
#~ msgstr "Zárolva"

#~ msgctxt "ContractBrowserView"
#~ msgid "Reference Number"
#~ msgstr "Hivatkozási szám"

#~ msgctxt "ContractBrowserView"
#~ msgid "Rental Name"
#~ msgstr "Bérlemény"

#~ msgctxt "ContractBrowserView"
#~ msgid "Revision Number"
#~ msgstr "Módosítás"

#~ msgctxt "ContractBrowserView"
#~ msgid "Status"
#~ msgstr "Státusz"

#~ msgctxt "ContractBrowserView"
#~ msgid "Valid From"
#~ msgstr "Érvényesség kezdete"

#~ msgctxt "ContractBrowserView"
#~ msgid "Valid To"
#~ msgstr "Érvényesség vége"

#~ msgctxt "Debt"
#~ msgid "Amount"
#~ msgstr "Összeg"

#~ msgctxt "Debt"
#~ msgid "Client Id"
#~ msgstr "Ügyfélazonosító"

#~ msgctxt "Debt"
#~ msgid "Completion Date"
#~ msgstr "Tejlesítés ideje"

#~ msgctxt "Debt"
#~ msgid "Currency"
#~ msgstr "Pénznem"

#~ msgctxt "Debt"
#~ msgid "Customer Id"
#~ msgstr "Vevő ID"

#~ msgctxt "Debt"
#~ msgid "Customer Name"
#~ msgstr "Vevőnév"

#~ msgctxt "Debt"
#~ msgid "Days Past Due"
#~ msgstr "Napok száma"

#~ msgctxt "Debt"
#~ msgid "Debt"
#~ msgstr "Követelés"

#~ msgctxt "Debt"
#~ msgid "Due Date"
#~ msgstr "Fizetési határidő"

#~ msgctxt "Debt"
#~ msgid "Dunning Letters"
#~ msgstr "Felszólítólevelek"

#~ msgctxt "Debt"
#~ msgid "Id"
#~ msgstr "Az"

#~ msgctxt "Debt"
#~ msgid "Invoice Number"
#~ msgstr "Számlaszám"

#~ msgctxt "Debt"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "Debt"
#~ msgid "Paid"
#~ msgstr "Fizetve"

#~ msgctxt "Debt"
#~ msgid "Payment Agreements"
#~ msgstr "Fizetési megállapodások"

#~ msgctxt "Debt"
#~ msgid "Payment Method"
#~ msgstr "Fizetési mód"

#~ msgctxt "Debt"
#~ msgid "Status"
#~ msgstr "Státusz"

#~ msgctxt "Debt"
#~ msgid "Transcast Id"
#~ msgstr "Számlatípus"

#~ msgctxt "DraftInvoiceBrowserView"
#~ msgid "Amount"
#~ msgstr "Összeg"

#~ msgctxt "DraftInvoiceBrowserView"
#~ msgid "Client Id"
#~ msgstr "Ügyfélazonosító"

#~ msgctxt "DraftInvoiceBrowserView"
#~ msgid "Client Name"
#~ msgstr "Ügyfélnév"

#~ msgctxt "DraftInvoiceBrowserView"
#~ msgid "Contract Id"
#~ msgstr "Szerződés AZ"

#~ msgctxt "DraftInvoiceBrowserView"
#~ msgid "Contract Number"
#~ msgstr "Szerződés száma"

#~ msgctxt "DraftInvoiceBrowserView"
#~ msgid "Created At"
#~ msgstr "Készült"

#~ msgctxt "DraftInvoiceBrowserView"
#~ msgid "Created By"
#~ msgstr "Készítette"

#~ msgctxt "DraftInvoiceBrowserView"
#~ msgid "Currency"
#~ msgstr "Pénznem"

#~ msgctxt "DraftInvoiceBrowserView"
#~ msgid "Due Date"
#~ msgstr "Fizetési határidő"

#~ msgctxt "DraftInvoiceBrowserView"
#~ msgid "Email"
#~ msgstr "Email"

#~ msgctxt "DraftInvoiceBrowserView"
#~ msgid "Fulfillment Date"
#~ msgstr "Teljesítés dátuma"

#~ msgctxt "DraftInvoiceBrowserView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "DraftInvoiceBrowserView"
#~ msgid "Invoice Date"
#~ msgstr "Számla dátuma"

#~ msgctxt "DraftInvoiceBrowserView"
#~ msgid "Invoice Number"
#~ msgstr "Számlaszám"

#~ msgctxt "DraftInvoiceBrowserView"
#~ msgid "Rental Id"
#~ msgstr "Bérlemény AZ"

#~ msgctxt "DraftInvoiceBrowserView"
#~ msgid "Rental Name"
#~ msgstr "Bérlemény"

#~ msgctxt "DraftInvoiceBrowserView"
#~ msgid "Sync Job Error"
#~ msgstr "Szinkronizálási feladat hiba"

#~ msgctxt "DraftInvoiceBrowserView"
#~ msgid "Sync Job Position"
#~ msgstr "Feladat pozíciója"

#~ msgctxt "DunningLetterBrowserView"
#~ msgid "Client Id"
#~ msgstr "Ügyfélazonosító"

#~ msgctxt "DunningLetterBrowserView"
#~ msgid "Created At"
#~ msgstr "Készült"

#~ msgctxt "DunningLetterBrowserView"
#~ msgid "Created By"
#~ msgstr "Készítette"

#~ msgctxt "DunningLetterBrowserView"
#~ msgid "Customer Email"
#~ msgstr "Vevő email"

#~ msgctxt "DunningLetterBrowserView"
#~ msgid "Customer Name"
#~ msgstr "Vevőnév"

#~ msgctxt "DunningLetterBrowserView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "DunningLetterBrowserView"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "DunningLetterBrowserView"
#~ msgid "Reference Number"
#~ msgstr "Hivatkozási szám"

#~ msgctxt "DunningLetterBrowserView"
#~ msgid "Severity"
#~ msgstr "Kategória"

#~ msgctxt "DunningLetterBrowserView"
#~ msgid "Status"
#~ msgstr "Státusz"

#~ msgctxt "DunningLetterBrowserView"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#~ msgctxt "DunningLetterBrowserView"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#~ msgctxt "FixedAssetBrowserView"
#~ msgid "Acquisition Date"
#~ msgstr "Beszerzés dátuma"

#~ msgctxt "FixedAssetBrowserView"
#~ msgid "Asset Type"
#~ msgstr "Eszköz típusa"

#~ msgctxt "FixedAssetBrowserView"
#~ msgid "Category"
#~ msgstr "Kategória"

#~ msgctxt "FixedAssetBrowserView"
#~ msgid "Cost"
#~ msgstr "Költség"

#~ msgctxt "FixedAssetBrowserView"
#~ msgid "Description"
#~ msgstr "Leírás"

#~ msgctxt "FixedAssetBrowserView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "FixedAssetBrowserView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "FixedAssetBrowserView"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#~ msgctxt "FixedAssetBrowserView"
#~ msgid "Manufacturer"
#~ msgstr "Gyártó"

#~ msgctxt "FixedAssetBrowserView"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#~ msgctxt "FixedAssetBrowserView"
#~ msgid "Quantity"
#~ msgstr "Mennyiség"

#~ msgctxt "GroupBrowserView"
#~ msgid "Description"
#~ msgstr "Leírás"

#~ msgctxt "GroupBrowserView"
#~ msgid "Group Type"
#~ msgstr "Csoporttípus"

#~ msgctxt "GroupBrowserView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "GroupBrowserView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "GroupBrowserView"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#~ msgctxt "GroupBrowserView"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Billing Period End"
#~ msgstr "Számlázási időszak vége"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Billing Period Start"
#~ msgstr "Számlázási időszak kezdete"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Client Data"
#~ msgstr "Ügyféladatok"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Client Id"
#~ msgstr "Ügyfélazonosító"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Client Name"
#~ msgstr "Ügyfél"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Contract Data"
#~ msgstr "Szerződés dátuma"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Due Date"
#~ msgstr "Fizetési határidő"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Fulfillment Date"
#~ msgstr "Teljesítés dátuma"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Invoice Date"
#~ msgstr "Számla dátuma"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Invoice status"
#~ msgstr "Státusz"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Invoice type"
#~ msgstr "Típus"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Locked"
#~ msgstr "Zárolva"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Net Total"
#~ msgstr "Végösszeg"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Tags"
#~ msgstr "Címkék"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Total"
#~ msgstr "Végösszeg"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Unpaid"
#~ msgstr "Fizetésre vár"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Vat Total"
#~ msgstr "ÁFA"

#~ msgctxt "JobBrowserView"
#~ msgid "Created At"
#~ msgstr "Készült"

#~ msgctxt "JobBrowserView"
#~ msgid "Created By"
#~ msgstr "Készítette"

#~ msgctxt "JobBrowserView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "JobBrowserView"
#~ msgid "Number"
#~ msgstr "Sorszám"

#~ msgctxt "JobBrowserView"
#~ msgid "Status"
#~ msgstr "Státusz"

#~ msgctxt "JobBrowserView"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#~ msgctxt "MeterBrowserView"
#~ msgid "Barcode"
#~ msgstr "Vonalkód"

#~ msgctxt "MeterBrowserView"
#~ msgid "Description"
#~ msgstr "Leírás"

#~ msgctxt "MeterBrowserView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "MeterBrowserView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "MeterBrowserView"
#~ msgid "Latest Invoice Reading Date"
#~ msgstr "Az utolsó számlázott leolvasás dátuma"

#~ msgctxt "MeterBrowserView"
#~ msgid "Latest Invoice Reading Unit"
#~ msgstr "Az utolsó számlázott leolvasás egysége"

#~ msgctxt "MeterBrowserView"
#~ msgid "Latest Invoice Reading Value"
#~ msgstr "Az utolsó számlázott leolvasás értéke"

#~ msgctxt "MeterBrowserView"
#~ msgid "Latest Reading Date"
#~ msgstr "Utolsó leolvasás dátuma"

#~ msgctxt "MeterBrowserView"
#~ msgid "Latest Reading Type"
#~ msgstr "Utolsó leolvasás típusa"

#~ msgctxt "MeterBrowserView"
#~ msgid "Latest Reading Unit"
#~ msgstr "Utolsó leolvasás egysége"

#~ msgctxt "MeterBrowserView"
#~ msgid "Latest Reading Value"
#~ msgstr "Utolsó leolvasás értéke"

#~ msgctxt "MeterBrowserView"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#~ msgctxt "MeterBrowserView"
#~ msgid "Main Meter Id"
#~ msgstr "Főmérő AZ"

#~ msgctxt "MeterBrowserView"
#~ msgid "Meter type"
#~ msgstr "Mérőóra típusa"

#~ msgctxt "MeterBrowserView"
#~ msgid "Multiplier"
#~ msgstr "Szorzó"

#~ msgctxt "MeterBrowserView"
#~ msgid "Rentals"
#~ msgstr "Bérlemények"

#~ msgctxt "MeterBrowserView"
#~ msgid "Serial Number"
#~ msgstr "Sorozatszám"

#~ msgctxt "MeterBrowserView"
#~ msgid "Site Id"
#~ msgstr "Telephely AZ"

#~ msgctxt "MeterBrowserView"
#~ msgid "Site Name"
#~ msgstr "Telephely"

#~ msgctxt "MeterBrowserView"
#~ msgid "Tag Id"
#~ msgstr "Címke"

#~ msgctxt "MeterBrowserView"
#~ msgid "Unit"
#~ msgstr "Mennyiségi egység"

#~ msgctxt "MeterBrowserView"
#~ msgid "Valid From"
#~ msgstr "Érvényesség kezdete"

#~ msgctxt "MeterBrowserView"
#~ msgid "Valid To"
#~ msgstr "Érvényesség vége"

#~ msgctxt "MeterReadingBrowserView"
#~ msgid "Deveui"
#~ msgstr "Dev EUI"

#~ msgctxt "MeterReadingBrowserView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "MeterReadingBrowserView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "MeterReadingBrowserView"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#~ msgctxt "MeterReadingBrowserView"
#~ msgid "Meter type"
#~ msgstr "Mérőóra típusa"

#~ msgctxt "MeterReadingBrowserView"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "MeterReadingBrowserView"
#~ msgid "Reading Date"
#~ msgstr "Leolvasás dátuma"

#~ msgctxt "MeterReadingBrowserView"
#~ msgid "Reading Type"
#~ msgstr "Leolvasás típusa"

#~ msgctxt "MeterReadingBrowserView"
#~ msgid "Serial"
#~ msgstr "Sorozatszám"

#~ msgctxt "MeterReadingBrowserView"
#~ msgid "Tag Id"
#~ msgstr "Címke"

#~ msgctxt "MeterReadingBrowserView"
#~ msgid "Unit"
#~ msgstr "Mennyiségi egység"

#~ msgctxt "MeterReadingBrowserView"
#~ msgid "Value"
#~ msgstr "Érték"

#~ msgctxt "MeterRentalServiceOnMeterView"
#~ msgid "Billing Unit"
#~ msgstr "Számlázási egység"

#~ msgctxt "MeterRentalServiceOnMeterView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "MeterRentalServiceOnMeterView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "MeterRentalServiceOnMeterView"
#~ msgid "Inflation Indexed"
#~ msgstr "Inflációkövető"

#~ msgctxt "MeterRentalServiceOnMeterView"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#~ msgctxt "MeterRentalServiceOnMeterView"
#~ msgid "Meter Id"
#~ msgstr "Mérő azonosítója"

#~ msgctxt "MeterRentalServiceOnMeterView"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "MeterRentalServiceOnMeterView"
#~ msgid "Rental Id"
#~ msgstr "Bérlemény AZ"

#~ msgctxt "MeterRentalServiceOnMeterView"
#~ msgid "Rental Name"
#~ msgstr "Bérlemény neve"

#~ msgctxt "MeterRentalServiceOnMeterView"
#~ msgid "Valid From"
#~ msgstr "Érvényesség kezdete"

#~ msgctxt "MeterRentalServiceOnMeterView"
#~ msgid "Valid To"
#~ msgstr "Érvényesség vége"

#~ msgctxt "PaymentBrowserView"
#~ msgid "Account Id"
#~ msgstr "Száml AZ"

#~ msgctxt "PaymentBrowserView"
#~ msgid "Account Name"
#~ msgstr "Számla neve"

#~ msgctxt "PaymentBrowserView"
#~ msgid "Amount In"
#~ msgstr "Bevétel"

#~ msgctxt "PaymentBrowserView"
#~ msgid "Amount Out"
#~ msgstr "Kiadás"

#~ msgctxt "PaymentBrowserView"
#~ msgid "Client Id"
#~ msgstr "Kliens ID"

#~ msgctxt "PaymentBrowserView"
#~ msgid "Client Name"
#~ msgstr "Ügyfélnév"

#~ msgctxt "PaymentBrowserView"
#~ msgid "Closing Balance"
#~ msgstr "Záró egyenleg"

#~ msgctxt "PaymentBrowserView"
#~ msgid "Company Id"
#~ msgstr "Cég AZ"

#~ msgctxt "PaymentBrowserView"
#~ msgid "Company Name"
#~ msgstr "Cégnév"

#~ msgctxt "PaymentBrowserView"
#~ msgid "File Number"
#~ msgstr "Mappaszám"

#~ msgctxt "PaymentBrowserView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "PaymentBrowserView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "PaymentBrowserView"
#~ msgid "Locked"
#~ msgstr "Zárolva"

#~ msgctxt "PaymentBrowserView"
#~ msgid "Opening Balance"
#~ msgstr "Nyitóegyenleg"

#~ msgctxt "PaymentBrowserView"
#~ msgid "Payment Date"
#~ msgstr "Fizetés dátuma"

#~ msgctxt "PaymentBrowserView"
#~ msgid "Payment method"
#~ msgstr "Fizetési mód"

#~ msgctxt "PaymentBrowserView"
#~ msgid "Reference Number"
#~ msgstr "Hivatkozási szám"

#~ msgctxt "ProductBrowserView"
#~ msgid "Description"
#~ msgstr "Leírás"

#~ msgctxt "ProductBrowserView"
#~ msgid "Groups"
#~ msgstr "Csoportok"

#~ msgctxt "ProductBrowserView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "ProductBrowserView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "ProductBrowserView"
#~ msgid "Invoice Group"
#~ msgstr "Számlázási csoport"

#~ msgctxt "ProductBrowserView"
#~ msgid "Locked"
#~ msgstr "Zárolva"

#~ msgctxt "ProductBrowserView"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#~ msgctxt "ProductBrowserView"
#~ msgid "Number"
#~ msgstr "Azonosító"

#~ msgctxt "ProductBrowserView"
#~ msgid "Product type"
#~ msgstr "Típus"

#~ msgctxt "ProductBrowserView"
#~ msgid "Unit"
#~ msgstr "ME"

#~ msgctxt "PropertyBrowserView"
#~ msgid "Area"
#~ msgstr "Alapterület"

#~ msgctxt "PropertyBrowserView"
#~ msgid "Description"
#~ msgstr "Leírás"

#~ msgctxt "PropertyBrowserView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "PropertyBrowserView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "PropertyBrowserView"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#~ msgctxt "PropertyBrowserView"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#~ msgctxt "PropertyBrowserView"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "PropertyBrowserView"
#~ msgid "Type"
#~ msgstr "Típus"

#~ msgctxt "RentalBrowserView"
#~ msgid "Area"
#~ msgstr "Alapterület"

#~ msgctxt "RentalBrowserView"
#~ msgid "Company Id"
#~ msgstr "Cég ID"

#~ msgctxt "RentalBrowserView"
#~ msgid "Company Name"
#~ msgstr "Cégnév"

#~ msgctxt "RentalBrowserView"
#~ msgid "Current Contract Id"
#~ msgstr "Aktuális szerződésazonosító"

#~ msgctxt "RentalBrowserView"
#~ msgid "Current Contract Number"
#~ msgstr "Aktuális szerződésszám"

#~ msgctxt "RentalBrowserView"
#~ msgid "Current Tenant Name"
#~ msgstr "Aktuális bérlő neve"

#~ msgctxt "RentalBrowserView"
#~ msgid "Description"
#~ msgstr "Megnevezés"

#~ msgctxt "RentalBrowserView"
#~ msgid "House Number"
#~ msgstr "Épületszám"

#~ msgctxt "RentalBrowserView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "RentalBrowserView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "RentalBrowserView"
#~ msgid "Location Code"
#~ msgstr "Hely"

#~ msgctxt "RentalBrowserView"
#~ msgid "Locked"
#~ msgstr "Zárolva"

#~ msgctxt "RentalBrowserView"
#~ msgid "Lot Number"
#~ msgstr "Helyrajzi szám"

#~ msgctxt "RentalBrowserView"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#~ msgctxt "RentalBrowserView"
#~ msgid "Site Id"
#~ msgstr "Telephely AZ"

#~ msgctxt "RentalBrowserView"
#~ msgid "Site Name"
#~ msgstr "Telephely"

#~ msgctxt "RentalBrowserView"
#~ msgid "Unit Of Area"
#~ msgstr "Alapterület ME"

#~ msgctxt "RentalBrowserView"
#~ msgid "Valid From"
#~ msgstr "Érvényesség kezdete"

#~ msgctxt "RentalBrowserView"
#~ msgid "Valid To"
#~ msgstr "Érvényesség vége"

#~ msgctxt "SimplifiedClientView"
#~ msgid "Account Number"
#~ msgstr "Bankszámlaszám"

#~ msgctxt "SimplifiedClientView"
#~ msgid "Address"
#~ msgstr "Cím"

#~ msgctxt "SimplifiedClientView"
#~ msgid "Emails"
#~ msgstr "Emailek"

#~ msgctxt "SimplifiedClientView"
#~ msgid "Eu Tax Number"
#~ msgstr "EU adószám"

#~ msgctxt "SimplifiedClientView"
#~ msgid "Iban"
#~ msgstr "IBAN"

#~ msgctxt "SimplifiedClientView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "SimplifiedClientView"
#~ msgid "Is Contractor"
#~ msgstr "Alvállalkozó"

#~ msgctxt "SimplifiedClientView"
#~ msgid "Is Natural Person"
#~ msgstr "Magánszemély"

#~ msgctxt "SimplifiedClientView"
#~ msgid "Name"
#~ msgstr "Név"

#~ msgctxt "SimplifiedClientView"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "SimplifiedClientView"
#~ msgid "Swift"
#~ msgstr "SWIFT"

#~ msgctxt "SimplifiedClientView"
#~ msgid "Tax Number"
#~ msgstr "Adószám"

#~ msgctxt "StatDataBrowserView"
#~ msgid "Data type"
#~ msgstr "Adattípus"

#~ msgctxt "StatDataBrowserView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "StatDataBrowserView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "StatDataBrowserView"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#~ msgctxt "StatDataBrowserView"
#~ msgid "Month"
#~ msgstr "Hónap"

#~ msgctxt "StatDataBrowserView"
#~ msgid "Unit"
#~ msgstr "Mennyiségi egység"

#~ msgctxt "StatDataBrowserView"
#~ msgid "Value"
#~ msgstr "Érték"

#~ msgctxt "StatDataBrowserView"
#~ msgid "Year"
#~ msgstr "Év"

#~ msgctxt "TemplateBrowserView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "TemplateBrowserView"
#~ msgid "Is Default"
#~ msgstr "Alapértelmezett"

#~ msgctxt "TemplateBrowserView"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#~ msgctxt "TemplateBrowserView"
#~ msgid "Template type"
#~ msgstr "Típus"

#~ msgctxt "UpdateInvoiceStatus"
#~ msgid "Status"
#~ msgstr "Státusz"

#~ msgctxt "WasteBinBrowserView"
#~ msgid "Bin Capacity Liters"
#~ msgstr "Kapacitás (liter)"

#~ msgctxt "WasteBinBrowserView"
#~ msgid "Bin Num"
#~ msgstr "Sorszám"

#~ msgctxt "WasteBinBrowserView"
#~ msgid "Bin Type"
#~ msgstr "Típus"

#~ msgctxt "WasteBinBrowserView"
#~ msgid "Id"
#~ msgstr "Az"

#~ msgctxt "WasteBinBrowserView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "WasteBinBrowserView"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#~ msgctxt "WasteBinBrowserView"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#~ msgctxt "WasteBinBrowserView"
#~ msgid "Rental Client Code"
#~ msgstr "Bérlő AZ"

#~ msgctxt "WasteBinBrowserView"
#~ msgid "Rental Client Id"
#~ msgstr "Bérlő AZ"

#~ msgctxt "WasteBinBrowserView"
#~ msgid "Rental Client Name"
#~ msgstr "Bérlő neve"

#~ msgctxt "WasteBinBrowserView"
#~ msgid "Rental Id"
#~ msgstr "Bérlemény AZ"

#~ msgctxt "WasteBinBrowserView"
#~ msgid "Rental Name"
#~ msgstr "Bérlemény neve"

#~ msgctxt "WorksheetBrowserView"
#~ msgid "Client Id"
#~ msgstr "Ügyfélazonosító"

#~ msgctxt "WorksheetBrowserView"
#~ msgid "Client Name"
#~ msgstr "Ügyfél"

#~ msgctxt "WorksheetBrowserView"
#~ msgid "Company Id"
#~ msgstr "Cég AZ"

#~ msgctxt "WorksheetBrowserView"
#~ msgid "Company Name"
#~ msgstr "Saját cég"

#~ msgctxt "WorksheetBrowserView"
#~ msgid "Company Number"
#~ msgstr "Saját cég sorszáma"

#~ msgctxt "WorksheetBrowserView"
#~ msgid "Contractor Name"
#~ msgstr "Alvállalkozó neve"

#~ msgctxt "WorksheetBrowserView"
#~ msgid "Contractor Number"
#~ msgstr "Alvállalkozó"

#~ msgctxt "WorksheetBrowserView"
#~ msgid "Description"
#~ msgstr "Leírás"

#~ msgctxt "WorksheetBrowserView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "WorksheetBrowserView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "WorksheetBrowserView"
#~ msgid "Locked"
#~ msgstr "Zárolva"

#~ msgctxt "WorksheetBrowserView"
#~ msgid "Number"
#~ msgstr "Sorszám"

#~ msgctxt "WorksheetBrowserView"
#~ msgid "Rental Id"
#~ msgstr "Bérlemény AZ"

#~ msgctxt "WorksheetBrowserView"
#~ msgid "Rental Name"
#~ msgstr "Bérlemény neve"

#~ msgctxt "WorksheetBrowserView"
#~ msgid "Worksheet Date"
#~ msgstr "Munkalap dátuma"

#~ msgctxt "InvoicesView"
#~ msgid "Dataimport..."
#~ msgstr "Adatimport..."

#~ msgctxt "MainMenu"
#~ msgid "Invoices"
#~ msgstr "Számlák"

#~ msgctxt "InvoicesView"
#~ msgid "Invoices"
#~ msgstr "Számlák"

#~ msgctxt "BankAccountBrowserView"
#~ msgid "Account Number"
#~ msgstr "Számlaszám"

#~ msgctxt "BankAccountBrowserView"
#~ msgid "Account type"
#~ msgstr "Számla típusa"

#~ msgctxt "BankAccountBrowserView"
#~ msgid "Bank"
#~ msgstr "Bank"

#~ msgctxt "BankAccountBrowserView"
#~ msgid "Branch"
#~ msgstr "Fiók"

#~ msgctxt "BankAccountBrowserView"
#~ msgid "Currency"
#~ msgstr "Pénznem"

#~ msgctxt "BankAccountBrowserView"
#~ msgid "Description"
#~ msgstr "Leírás"

#~ msgctxt "BankAccountBrowserView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "BankAccountBrowserView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "BankAccountBrowserView"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#~ msgctxt "BankAccountBrowserView"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#~ msgctxt "BankAccountBrowserView"
#~ msgid "Owner Id"
#~ msgstr "Tulajdonos AZ"

#~ msgctxt "BankAccountBrowserView"
#~ msgid "Owner Name"
#~ msgstr "Saját cég"

#~ msgctxt "Client"
#~ msgid "Bank Accounts"
#~ msgstr "Bankszámlák"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Contracts"
#~ msgstr "Szerződések"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Net Amount"
#~ msgstr "Nettó összeg"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Rentals"
#~ msgstr "Bérlemények"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Vat Amount"
#~ msgstr "ÁFA összege"

#~ msgid "Account Type"
#~ msgstr "Számla típusa"

#~ msgid "Closing Balance"
#~ msgstr "Záró egyenleg"

#~ msgctxt "DunningLetterBrowse"
#~ msgid "Reference Number"
#~ msgstr "Hivatkozási szám"

#~ msgctxt "DunningLetterBrowse"
#~ msgid "Created By"
#~ msgstr "Készítette"

#~ msgctxt "ProductBrowser"
#~ msgid "Product type"
#~ msgstr "Típus"

#, fuzzy
#~| msgctxt "ClientsView"
#~| msgid "Owned"
#~ msgctxt "AccountsView"
#~ msgid "Owned"
#~ msgstr "Saját cég"

#~ msgctxt "AccountBrowserView"
#~ msgid "Cash and Bank Accounts"
#~ msgstr "Készpénz- és bankszámlák"

#~ msgctxt "AccountBrowserView"
#~ msgid "Type"
#~ msgstr "Típus"

#, fuzzy
#~| msgctxt "Invoice"
#~| msgid "Invocie Language"
#~ msgctxt "Worksheet"
#~ msgid "Invocie Language"
#~ msgstr "Nyelv"

#~ msgctxt "PaymentBrowserView"
#~ msgid "Amount"
#~ msgstr "Összeg"

#~ msgctxt "Client"
#~ msgid "Owned"
#~ msgstr "Saját"

#~ msgctxt "Client"
#~ msgid "Revision"
#~ msgstr "Módosítás"

#~ msgctxt "DunningLetterBrowse"
#~ msgid "Client Id"
#~ msgstr "Ügyfélazonosító"

#~ msgctxt "DunningLetterBrowse"
#~ msgid "Created At"
#~ msgstr "Készült"

#~ msgctxt "DunningLetterBrowse"
#~ msgid "Id"
#~ msgstr "Az"

#~ msgctxt "DunningLetterBrowse"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "DunningLetterBrowse"
#~ msgid "Severity"
#~ msgstr "Kategória"

#~ msgctxt "DunningLetterBrowse"
#~ msgid "Status"
#~ msgstr "Státusz"

#~ msgctxt "DunningLetterBrowse"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#~ msgctxt "DunningLetterBrowse"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#~ msgctxt "JobBrowse"
#~ msgid "Created At"
#~ msgstr "Készült"

#~ msgctxt "JobBrowse"
#~ msgid "Created By"
#~ msgstr "Készítette"

#~ msgctxt "JobBrowse"
#~ msgid "Id"
#~ msgstr "Az"

#~ msgctxt "JobBrowse"
#~ msgid "Number"
#~ msgstr "Sorszám"

#~ msgctxt "JobBrowse"
#~ msgid "Status"
#~ msgstr "Státusz"

#~ msgctxt "JobBrowse"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#~ msgctxt "StatDataBrowseView"
#~ msgid "Created At"
#~ msgstr "Létrehozva"

#~ msgctxt "StatDataBrowseView"
#~ msgid "Created By"
#~ msgstr "Készítette"

#~ msgctxt "StatDataBrowseView"
#~ msgid "Data type"
#~ msgstr "Adattípus"

#~ msgctxt "StatDataBrowseView"
#~ msgid "Etag"
#~ msgstr "Etag"

#~ msgctxt "StatDataBrowseView"
#~ msgid "Id"
#~ msgstr "Az"

#~ msgctxt "StatDataBrowseView"
#~ msgid "Month"
#~ msgstr "Hónap"

#~ msgctxt "StatDataBrowseView"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#~ msgctxt "StatDataBrowseView"
#~ msgid "Self"
#~ msgstr "Self"

#~ msgctxt "StatDataBrowseView"
#~ msgid "Unit"
#~ msgstr "Mennyiségi egység"

#~ msgctxt "StatDataBrowseView"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#~ msgctxt "StatDataBrowseView"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#~ msgctxt "StatDataBrowseView"
#~ msgid "Value"
#~ msgstr "Érték"

#~ msgctxt "StatDataBrowseView"
#~ msgid "Year"
#~ msgstr "Év"

#~ msgctxt "TemplateBrowseView"
#~ msgid "Id"
#~ msgstr "Az"

#~ msgctxt "TemplateBrowseView"
#~ msgid "Is Default"
#~ msgstr "Alapértelmezett"

#~ msgctxt "TemplateBrowseView"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#~ msgctxt "TemplateBrowseView"
#~ msgid "Template type"
#~ msgstr "Sablon típusa"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Created At"
#~ msgstr "Készült"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Created By"
#~ msgstr "Készítette"

#~ msgctxt "WasteBinsList"
#~ msgid "Capacity (liters)"
#~ msgstr "Kapacitás (liter)"

#~ msgctxt "WasteBinsList"
#~ msgid "Bin Name"
#~ msgstr "Név"

#~ msgctxt "WasteBinsList"
#~ msgid "Worksheets"
#~ msgstr "Munkalapok"

#~ msgctxt "WasteBinsList"
#~ msgid "Tenant"
#~ msgstr "Bérlő"

#~ msgctxt "FixedAsset"
#~ msgid "Bin Type"
#~ msgstr "Hulladékgyűjtő típusa"

#~ msgctxt "FixedAsset"
#~ msgid "Bin Number"
#~ msgstr "Hulladékgyűjtő sorszáma"

#~ msgid "Please confirm deleting the attachment."
#~ msgstr "Erősítse meg a melléklet törlését."

#~ msgid "Delete attachment"
#~ msgstr "Melléklet törlése"

#~ msgid "Add comment"
#~ msgstr "Új megjegyzés"

#~ msgid "Details"
#~ msgstr "Részletek"

#~ msgid "view"
#~ msgstr "nézet"

#~ msgid "Notes to the recipient..."
#~ msgstr "Megjegyzések a címzettnek..."

#~ msgctxt "MeterCharts"
#~ msgid "Unit"
#~ msgstr "Egység"

#~ msgctxt "Employee"
#~ msgid "Mobile"
#~ msgstr "Mobil"

#~ msgctxt "ClientBrowserView"
#~ msgid "Number"
#~ msgstr "Azonosító"

#~ msgctxt "SimplfiedClientView"
#~ msgid "Account Number"
#~ msgstr "Számlaszám"

#~ msgctxt "SimplfiedClientView"
#~ msgid "Address"
#~ msgstr "Cím"

#~ msgctxt "SimplfiedClientView"
#~ msgid "Emails"
#~ msgstr "Emailek"

#~ msgctxt "SimplfiedClientView"
#~ msgid "Eu Tax Number"
#~ msgstr "EU adószám"

#~ msgctxt "SimplfiedClientView"
#~ msgid "Iban"
#~ msgstr "IBAN"

#~ msgctxt "SimplfiedClientView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "SimplfiedClientView"
#~ msgid "Is Contractor"
#~ msgstr "Alvállalkozó"

#~ msgctxt "SimplfiedClientView"
#~ msgid "Is Natural Person"
#~ msgstr "Magánszemély"

#~ msgctxt "SimplfiedClientView"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#~ msgctxt "SimplfiedClientView"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "SimplfiedClientView"
#~ msgid "Swift"
#~ msgstr "SWIFT"

#~ msgctxt "SimplfiedClientView"
#~ msgid "Tax Number"
#~ msgstr "Adószám"

#~ msgctxt "WasteBinBrowserView"
#~ msgid "Rental Client Number"
#~ msgstr "Bérlő száma"

#~ msgctxt "WorksheetBrowserView"
#~ msgid "Client Number"
#~ msgstr "Ügyfélszám"

#~ msgid "Comment"
#~ msgstr "Megjegyzés"

#~ msgctxt "InvoiceBrowserView"
#~ msgid "Type"
#~ msgstr "Típus"

#~ msgctxt "InvoiceLineDetail"
#~ msgid "Meter"
#~ msgstr "Mérőóra"

#~ msgid "Tag ID"
#~ msgstr "Címke"

#~ msgid "C Amount"
#~ msgstr "Fogyasztás"

#~ msgid "C Unit"
#~ msgstr "Egység"

#~ msgid "Select contract type"
#~ msgstr "Válassza ki a szerződés típusát"

#~ msgid "Measurements"
#~ msgstr "Mérőállások"

#, fuzzy
#~| msgid "Tag ID"
#~ msgctxt "ProductBrowser"
#~ msgid "Tag ID"
#~ msgstr "Címke"

#~ msgctxt "ProductList"
#~ msgid "Product type"
#~ msgstr "Típus"

#~ msgctxt "ProductBrowseView"
#~ msgid "Tag ID"
#~ msgstr "Belső AZ"

#, fuzzy
#~| msgid "Property"
#~ msgid "Propertys"
#~ msgstr "Ingatlan"

#~ msgid "New Real Property Unit"
#~ msgstr "Új hely"

#~ msgctxt "RealPropertyUnit"
#~ msgid "Number"
#~ msgstr "Azonosító"

#~ msgctxt "RealPropertyUnit"
#~ msgid "Property Name"
#~ msgstr "Megnevezés"

#~ msgctxt "RealPropertyUnit"
#~ msgid "Description"
#~ msgstr "Leírás"

#~ msgctxt "RealPropertyUnit"
#~ msgid "Area"
#~ msgstr "Alapterület"

#~ msgctxt "RealPropertyUnit"
#~ msgid "Unit"
#~ msgstr "Egység"

#~ msgctxt "RealPropertyUnit"
#~ msgid "Location number"
#~ msgstr "Helyrajzi szám"

#~ msgctxt "Contract"
#~ msgid "Next indexation"
#~ msgstr "Következő indexálás dátuma"

#~ msgctxt "Contract"
#~ msgid "Rescind Contract"
#~ msgstr "Szerződés megszüntetése"

#~ msgctxt "Contract"
#~ msgid "Approve Contract"
#~ msgstr "Szerződés jóváhagyása"

#~ msgctxt "Contract"
#~ msgid "Activate Contract"
#~ msgstr "Szerződés aktiválása"

#~ msgctxt "Contract"
#~ msgid "Terminate Contract"
#~ msgstr "Szerződés felmondása"

#~ msgctxt "SetContractStatus"
#~ msgid "Terminating..."
#~ msgstr "Megszüntetés..."

#~ msgctxt "ContractStatus"
#~ msgid "Not signed"
#~ msgstr "Nincs aláírva"

#~ msgctxt "ContractStatus"
#~ msgid "Terminating"
#~ msgstr "Felmondás alatt"

#~ msgctxt "ContractStatus"
#~ msgid "Unknown"
#~ msgstr "Ismeretlen"

#~ msgctxt "MeterRentalServiceOnMeterView"
#~ msgid "Billing Frequency"
#~ msgstr "Számlázási gyakoriság"

#~ msgctxt "MeterRentalServiceOnMeterView"
#~ msgid "Billing Group"
#~ msgstr "Számlázási csoport"

#~ msgctxt "MeterBrowseView"
#~ msgid "Tag ID"
#~ msgstr "Címke"

#~ msgctxt "PropertyBrowserView"
#~ msgid "Is Contractor"
#~ msgstr "Alvállalkozó"

#~ msgctxt "PropertyBrowserView"
#~ msgid "Owned"
#~ msgstr "Saját"

#~ msgid "Rental Number"
#~ msgstr "Bérlemény azonosító"

#~ msgctxt "Rental"
#~ msgid "Number"
#~ msgstr "Azonosító"

#~ msgid "No services have been added yet."
#~ msgstr "Nincsenek szolgáltatások hozzáadva."

#~ msgctxt "MeterBrowserView"
#~ msgid "Location Number"
#~ msgstr "Lokáció"

#~ msgctxt "MeterBrowserView"
#~ msgid "Rental Number"
#~ msgstr "Bérlemény azonosító"

#~ msgctxt "MeterBrowserView"
#~ msgid "Tenant Name"
#~ msgstr "Bérlő"

#~ msgid "Compare Readings"
#~ msgstr "Leolvasások összehasonlítása"

#~ msgctxt "ExportFilename"
#~ msgid "auto-readings"
#~ msgstr "automata-leolvasások"

#~ msgid "Connection Type"
#~ msgstr "Kapcsolattípus"

#~ msgctxt "MetersDataImportFormat"
#~ msgid "IotNET"
#~ msgstr "IotNET"

#~ msgctxt "ImportMeterOffsetsModal"
#~ msgid "Offsets from Edil Fin journal"
#~ msgstr "Korrekciók importálása az okosmérés projekt file-ból"

#~ msgctxt "MetersDataImportFormat"
#~ msgid "Meters from Edil Fin journal"
#~ msgstr "Korrekciók importálása az okosmérés projekt file-ból"

#~ msgctxt "MetersDataImportFormat"
#~ msgid "Meter replacement protocol"
#~ msgstr "Mérőóra csere protokoll file"

#~ msgid "Import meter offsets."
#~ msgstr "Korrekciók importálása."

#~ msgctxt "ImportMeterOffsetsModal"
#~ msgid "Format"
#~ msgstr "Formátum"

#~ msgctxt "ImportMeterOffsetsModal"
#~ msgid "Worksheets"
#~ msgstr "Munkalapok"

#~ msgctxt "ImportMeterOffsetsModal"
#~ msgid "Date"
#~ msgstr "Dátum"

#~ msgctxt "ImportMeterOffsetsModal"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "ImportMeterOffsetsModal"
#~ msgid "Import"
#~ msgstr "Importálás"

#~ msgctxt "Meter"
#~ msgid "Channels"
#~ msgstr "Adatcsatornák"

#~ msgctxt "Meter"
#~ msgid "Calibrations"
#~ msgstr "Kalibrálások"

#~ msgid "Related Devices"
#~ msgstr "Kapcsolódó eszközök"

#~ msgid "No graph available."
#~ msgstr "Grafikon nem elérhető."

#~ msgid "No smart reader data received yet."
#~ msgstr "Nem érkezett automatikus adat a merőórához."

#~ msgid "The offset to apply to automated readings."
#~ msgstr ""
#~ "Az impulzusmérő által küldött óraálláshoz hozzáadandó korrekciós érték."

#~ msgctxt "MeterReadingTypes"
#~ msgid "Manual"
#~ msgstr "Manuális"

#~ msgctxt "MeterReadingTypes"
#~ msgid "Auto"
#~ msgstr "IoT"

#~ msgctxt "MeterReadings"
#~ msgid "Reading type"
#~ msgstr "Leolvasás típusa"

#~ msgctxt "MeterReadings"
#~ msgid "Date"
#~ msgstr "Dátum"

#~ msgctxt "MeterReadings"
#~ msgid "Serial"
#~ msgstr "Sorozatszám"

#~ msgctxt "MeterReadings"
#~ msgid "Meter type"
#~ msgstr "Mérőóra típusa"

#~ msgctxt "MeterReadings"
#~ msgid "Value"
#~ msgstr "Érték"

#~ msgctxt "MeterReadings"
#~ msgid "Unit"
#~ msgstr "M.e."

#~ msgctxt "MeterReadings"
#~ msgid "DevEUI"
#~ msgstr "DevEUI"

#~ msgctxt "MeterReadings"
#~ msgid "Custom code"
#~ msgstr "Beszédes kód"

#~ msgid "Meter Readings Comparison"
#~ msgstr "Leolvasások összehasonlítása"

#~ msgctxt "ExportFilename"
#~ msgid "meter-readings-comparison"
#~ msgstr "mérő-leolvasás-összehasonlítás"

#~ msgctxt "MeterReadingsComparisonGrid"
#~ msgid "Serial number"
#~ msgstr "Sorozatszám"

#~ msgctxt "MeterReadingsComparisonGrid"
#~ msgid "Tag ID"
#~ msgstr "Belső AZ"

#~ msgctxt "MeterReadingsComparisonGrid"
#~ msgid "Meter type"
#~ msgstr "Mérőóra típusa"

#~ msgid "Import meters"
#~ msgstr "Mérőórák importálása"

#~ msgctxt "MetersDataIportFormat"
#~ msgid "IotNET"
#~ msgstr "IotNET"

#~ msgctxt "MetersDataIportFormat"
#~ msgid "Extended"
#~ msgstr "Kiterjesztett"

#~ msgid "Excel format"
#~ msgstr "Excel formátum"

#~ msgid "Sheet number"
#~ msgstr "Munkalap"

#~ msgctxt "MeterChannels"
#~ msgid "Calibration time"
#~ msgstr "Kalibrálás időpontja"

#~ msgctxt "MeterChannels"
#~ msgid "Offset"
#~ msgstr "Korrekció"

#~ msgctxt "MeterChannelCalibrationModal"
#~ msgid "Calibrate Channel"
#~ msgstr "Csatorna kalibrálása"

#~ msgctxt "MeterChannelCalibrationModal"
#~ msgid "Edit Channel Calibration"
#~ msgstr "Kalibrálás szerkesztése"

#~ msgctxt "MeterChannelCalibration"
#~ msgid "Calibration time"
#~ msgstr "Kalibrálás időpontja"

#~ msgctxt "MeterChannelCalibration"
#~ msgid "Offset"
#~ msgstr "Korrekció"

#~ msgctxt "MeterChannelCalibration"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "MeterChannels"
#~ msgid "Connect meter"
#~ msgstr "Mérőóra csatlakoztatása"

#~ msgctxt "MeterChannels"
#~ msgid "Model name"
#~ msgstr "Modell/Típus"

#~ msgctxt "MeterChannels"
#~ msgid "Disconnection time"
#~ msgstr "Leválasztás időpontja"

#~ msgctxt "MeterChannelConnectionModal"
#~ msgid "Connect Meter"
#~ msgstr "Mérő csatlakoztatása"

#~ msgctxt "MeterChannelConnectionModal"
#~ msgid "Disconnect Meter"
#~ msgstr "Mérő leválasztása"

#~ msgctxt "MeterChannelConnectionModal"
#~ msgid "Edit Connection"
#~ msgstr "Kapcsolat szerkesztése"

#~ msgctxt "MeterChannelsSubmit"
#~ msgid "Connect Meter"
#~ msgstr "Mérő csatlakoztatása"

#~ msgctxt "MeterChannelsSubmit"
#~ msgid "Disconnect"
#~ msgstr "Leválasztás"

#~ msgctxt "MeterChannelsSubmit"
#~ msgid "Save"
#~ msgstr "Mentés"

#~ msgctxt "MeterChannelConnection"
#~ msgid "Meter"
#~ msgstr "Mérőóra"

#~ msgctxt "MeterChannelConnection"
#~ msgid "Channel"
#~ msgstr "Adatcsatorna"

#~ msgctxt "MeterChannelConnection"
#~ msgid "Connection time"
#~ msgstr "Csatlakoztatás időpontja"

#~ msgctxt "MeterChannelConnection"
#~ msgid "Disconnection time"
#~ msgstr "Leválasztás időpontja"

#~ msgctxt "MeterChannelConnection"
#~ msgid "Offset"
#~ msgstr "Korrekció"

#~ msgctxt "MeterChannelConnection"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "MeterChannelModal"
#~ msgid "Edit Channel"
#~ msgstr "Csatorna szerkesztése"

#~ msgctxt "MeterChannelModal"
#~ msgid "Create Channel"
#~ msgstr "Csatorna létrehozása"

#~ msgctxt "MeterChannels"
#~ msgid "Delete channel"
#~ msgstr "Csatorna törlése"

#~ msgctxt "MeterChannels"
#~ msgid "No channels have been added yet."
#~ msgstr "Nincsenek csatornák."

#~ msgctxt "MeterChannels"
#~ msgid "Add channel"
#~ msgstr "Csatorna hozzáadása"

#~ msgctxt "MeterChannels"
#~ msgid "Add connection"
#~ msgstr "Csatlakoztatás"

#~ msgctxt "MeterStats"
#~ msgid "Time"
#~ msgstr "Időpont"

#~ msgctxt "MeterStats"
#~ msgid "Date"
#~ msgstr "Dátum"

#~ msgctxt "MeterStats"
#~ msgid "Offset"
#~ msgstr "Korrekció"

#~ msgctxt "MeterStats"
#~ msgid "From"
#~ msgstr "Tól"

#~ msgctxt "MeterStats"
#~ msgid "To"
#~ msgstr "Ig"

#~ msgctxt "MeterStats"
#~ msgid "Device"
#~ msgstr "Eszköz"

#~ msgid "TAG ID"
#~ msgstr "Címke"

#~ msgctxt "InvoiceGenerator"
#~ msgid "Fulfilment Date"
#~ msgstr "Teljesítés dátuma"

#~ msgctxt "Contract"
#~ msgid "Activation date"
#~ msgstr "Aktiválás dátuma"

#~ msgctxt "DraftInvoiceBrowserView"
#~ msgid "Rental Number"
#~ msgstr "Bérlemény azonosító"

#, fuzzy
#~| msgctxt "Contracts"
#~| msgid "Type"
#~ msgid "Type:"
#~ msgstr "Típus"

#, fuzzy
#~| msgid "Value"
#~ msgid "Value:"
#~ msgstr "Érték"

#, fuzzy
#~| msgid "Create Invoice"
#~ msgid "Save') : gettext('Create Invoice"
#~ msgstr "Számla létrehozása"

#, fuzzy
#~| msgid "Create Product"
#~ msgid "Save') : gettext('Create Product"
#~ msgstr "Új termék"

#, fuzzy
#~| msgid "Create Worksheet"
#~ msgid "Save') : gettext('Create Worksheet"
#~ msgstr "Munkalap létrehozása"

#~ msgid "Additional Data"
#~ msgstr "További adatok"

#~ msgid "Exchange Rate Bank"
#~ msgstr "Árfolyam bank"

#~ msgid "Include"
#~ msgstr "Tartalmazza"

#~ msgid "Add Filter"
#~ msgstr "Szűrő hozzáadása"

#~ msgid "No filters"
#~ msgstr "Nincsenek szűrők"

#~ msgid "Start of Period"
#~ msgstr "Az időszak kezdete"

#~ msgid "Fulfilment Date"
#~ msgstr "Teljesítés dátuma"

#~ msgid "Counter party"
#~ msgstr "Szerződő partner"

#~ msgid "Termination date"
#~ msgstr "Felmondás napja"

#~ msgid "Termination effective date"
#~ msgstr "Felmondás lejárata"

#~ msgid "Next indexation date"
#~ msgstr "Következő indexálás dátuma"

#~ msgctxt "ContractServiceFeeBrowseView"
#~ msgid "Contract Id"
#~ msgstr "Szerződés AZ"

#~ msgctxt "ContractServiceFeeBrowseView"
#~ msgid "Contract Number"
#~ msgstr "Szerződés száma"

#~ msgctxt "ContractServiceFeeBrowseView"
#~ msgid "Contract Version"
#~ msgstr "Szerződés verziója"

#~ msgctxt "ContractServiceFeeBrowseView"
#~ msgid "Contract type"
#~ msgstr "Szerződés típusa"

#~ msgctxt "ContractServiceFeeBrowseView"
#~ msgid "Counterparty Id"
#~ msgstr "Szerződő partner AZ"

#~ msgctxt "ContractServiceFeeBrowseView"
#~ msgid "Counterparty Name"
#~ msgstr "Szerződő partner"

#~ msgctxt "ContractServiceFeeBrowseView"
#~ msgid "Counterparty Number"
#~ msgstr "Szerződő partner sorszáma"

#~ msgctxt "ContractServiceFeeBrowseView"
#~ msgid "Currency"
#~ msgstr "Pénznem"

#~ msgctxt "ContractServiceFeeBrowseView"
#~ msgid "Description"
#~ msgstr "Leírás"

#~ msgctxt "ContractServiceFeeBrowseView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "ContractServiceFeeBrowseView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "ContractServiceFeeBrowseView"
#~ msgid "Inflation Indexed"
#~ msgstr "Inflációkövető"

#~ msgctxt "ContractServiceFeeBrowseView"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#~ msgctxt "ContractServiceFeeBrowseView"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "ContractServiceFeeBrowseView"
#~ msgid "Price"
#~ msgstr "Ár"

#~ msgctxt "ContractServiceFeeBrowseView"
#~ msgid "Rental Id"
#~ msgstr "Bérlemény AZ"

#~ msgctxt "ContractServiceFeeBrowseView"
#~ msgid "Rental Number"
#~ msgstr "Bérlemény azonosító"

#~ msgctxt "ContractServiceFeeBrowseView"
#~ msgid "Unit"
#~ msgstr "Mennyiségi egység"

#~ msgctxt "ContractServiceFeeBrowseView"
#~ msgid "Valid From"
#~ msgstr "Érvényesség kezdete"

#~ msgctxt "ContractServiceFeeBrowseView"
#~ msgid "Valid To"
#~ msgstr "Érvényesség vége"

#~ msgctxt "ContractStatuses"
#~ msgid "Sentence"
#~ msgstr "Mondat"

#~ msgid "Contracting party"
#~ msgstr "Szerződő fél"

#~ msgctxt "Button"
#~ msgid "Create contract"
#~ msgstr "Új szerződés"

#~ msgctxt "Contract Version Abbr"
#~ msgid "Ver."
#~ msgstr "Sz.ver"

#~ msgctxt "Valid from Abbr"
#~ msgid "Valid from"
#~ msgstr "Érv. kezd."

#~ msgctxt "Valid to Abbr"
#~ msgid "Valid to"
#~ msgstr "Érv. vége"

#~ msgctxt "Inflation Indexed Abbr"
#~ msgid "Idx"
#~ msgstr "Ind."

#~ msgid "Parking spot number"
#~ msgstr "Parkolóhely száma"

#~ msgid "Card number"
#~ msgstr "Parkolókártya száma"

#~ msgid "Plate number"
#~ msgstr "Rendszám"

#~ msgid "Attach file..."
#~ msgstr "File csatolása..."

#~ msgctxt "Client"
#~ msgid "Bank Account Number"
#~ msgstr "Bankszámlaszám"

#~ msgctxt "Company"
#~ msgid "Bank Account Number"
#~ msgstr "Bankszámlaszám"

#~ msgctxt "Rental"
#~ msgid "LOT nr."
#~ msgstr "Helyrajzi szám"

#~ msgctxt "ContractServices"
#~ msgid "Add fee"
#~ msgstr "Díj hozzáadása"

#~ msgid "Parking Spots"
#~ msgstr "Gépkocsibeállók"

#~ msgid "Agreements"
#~ msgstr "Megállapodások"

#~ msgctxt "Contracts"
#~ msgid "End date"
#~ msgstr "Záró dátum"

#~ msgctxt "ContractBrowserView"
#~ msgid "Company Number"
#~ msgstr "Saját cég sorszáma"

#~ msgctxt "ContractBrowserView"
#~ msgid "Contract Version"
#~ msgstr "Szerződés verziója"

#~ msgctxt "ContractBrowserView"
#~ msgid "Contract Version Name"
#~ msgstr "Szerződés verzióneve"

#~ msgctxt "ContractBrowserView"
#~ msgid "Counter Party Number"
#~ msgstr "Szerződő partner sorszáma"

#~ msgctxt "ContractBrowserView"
#~ msgid "End Date"
#~ msgstr "Záró dátum"

#~ msgctxt "ContractBrowserView"
#~ msgid "Rental Number"
#~ msgstr "Bérlemény azonosító"

#~ msgid "Parcel number"
#~ msgstr "Helyrajzi szám"

#~ msgctxt "Rentals"
#~ msgid "Parcel Number"
#~ msgstr "Helyrajzi szám"

#~ msgctxt "RentalBrowserView"
#~ msgid "Number"
#~ msgstr "Azonosító"

#~ msgctxt "RentalBrowserView"
#~ msgid "Parcel Number"
#~ msgstr "Helyrajzi szám"

#~ msgctxt "WorksheetBrowserView"
#~ msgid "Rental Number"
#~ msgstr "Bérlemény azonosító"

#, fuzzy
#~ msgctxt "Rentals"
#~ msgid "Parces Number"
#~ msgstr "Helyrajzi szám"

#~ msgctxt "MeterMeasurementBrowseView"
#~ msgid "Meter type"
#~ msgstr "Mérőóra típusa"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Contract Number"
#~ msgstr "Szerződésszám"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Contract Version"
#~ msgstr "Szerződés verziója"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Contract status"
#~ msgstr "Szerződés státusza"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Contract type"
#~ msgstr "Szerződés típusa"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Counter Party Id"
#~ msgstr "Szerződő partner AZ"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Counter Party Name"
#~ msgstr "Szerződő partner"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Counter Party Number"
#~ msgstr "Szerződő partner sorszáma"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Currency"
#~ msgstr "Pénznem"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Description"
#~ msgstr "Leírás"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Inflation Indexed"
#~ msgstr "Inflációkövető"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Locked"
#~ msgstr "Zárolt"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Price"
#~ msgstr "Ár"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Rental Id"
#~ msgstr "Bérlemény AZ"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Rental Number"
#~ msgstr "Bérlemény sorszáma"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Unit"
#~ msgstr "ME"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Valid From"
#~ msgstr "Érvényesség kezdete"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Valid To"
#~ msgstr "Érvényesség vége"

#~ msgctxt "MeterReadingBrowserView"
#~ msgid "Barcode"
#~ msgstr "Vonalkód"

#~ msgctxt "MeterReadingBrowserView"
#~ msgid "Created At"
#~ msgstr "Készült"

#~ msgctxt "MeterReadingBrowserView"
#~ msgid "Created By"
#~ msgstr "Készítette"

#~ msgctxt "MeterReadingBrowserView"
#~ msgid "Description"
#~ msgstr "Leírás"

#~ msgctxt "MeterReadingBrowserView"
#~ msgid "Reading Time"
#~ msgstr "Leolvasás ideje"

#~ msgctxt "MeterReadingBrowserView"
#~ msgid "Serial Number"
#~ msgstr "Sorozatszám"

#~ msgctxt "TaskStates"
#~ msgid "F A I L U R E"
#~ msgstr "Hiba"

#~ msgctxt "TaskStates"
#~ msgid "I G N O R E D"
#~ msgstr "Kihagyva"

#~ msgctxt "TaskStates"
#~ msgid "P E N D I N G"
#~ msgstr "Várakozik"

#~ msgctxt "TaskStates"
#~ msgid "R E T R Y"
#~ msgstr "Újrakezdve"

#~ msgctxt "TaskStates"
#~ msgid "R E V O K E D"
#~ msgstr "Visszavonva"

#~ msgctxt "TaskStates"
#~ msgid "S T A R T E D"
#~ msgstr "Elkezdve"

#~ msgctxt "TaskStates"
#~ msgid "S U C C E S S"
#~ msgstr "Sikeres"

#~ msgid "Flat Rate Services"
#~ msgstr "Átalánydíjas szolgáltatások"

#~ msgid "Measured Services"
#~ msgstr "Mért szolgáltatások"

#~ msgctxt "BulkInvoiceBrowserView"
#~ msgid "Client Name"
#~ msgstr "Ügyfél"

#~ msgctxt "BulkInvoiceBrowserView"
#~ msgid "Created By"
#~ msgstr "Készítette"

#~ msgctxt "BulkInvoiceBrowserView"
#~ msgid "Currency"
#~ msgstr "Pénznem"

#~ msgctxt "BulkInvoiceBrowserView"
#~ msgid "Due Date"
#~ msgstr "Fizetési határidő"

#~ msgctxt "BulkInvoiceBrowserView"
#~ msgid "Email"
#~ msgstr "Email"

#~ msgctxt "BulkInvoiceBrowserView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "BulkInvoiceBrowserView"
#~ msgid "Invoice Number"
#~ msgstr "Számlaszám"

#~ msgctxt "BulkInvoiceBrowserView"
#~ msgid "Rental Number"
#~ msgstr "Bérlemény azonosító"

#~ msgctxt "TaskRunStatus"
#~ msgid "Completed"
#~ msgstr "Kész"

#~ msgctxt "TaskRunStatus"
#~ msgid "Disabled"
#~ msgstr "Kikapcsolt"

#~ msgctxt "TaskRunStatus"
#~ msgid "Not started"
#~ msgstr "Nincs elindítva"

#~ msgctxt "TaskRunStatus"
#~ msgid "Pending"
#~ msgstr "Felfüggesztve"

#~ msgctxt "TaskRunStatus"
#~ msgid "Rerunning"
#~ msgstr "Újra futtatva"

#~ msgctxt "WasteBinBrowserView"
#~ msgid "Rental Number"
#~ msgstr "Bérlemény azonosító"

#~ msgctxt "FixedAsset"
#~ msgid "Type"
#~ msgstr "Típus"

#~ msgctxt "FixedAssetBrowseView"
#~ msgid "Category"
#~ msgstr "Kategória"

#~ msgctxt "FixedAssetBrowseView"
#~ msgid "Cost"
#~ msgstr "Költség"

#~ msgctxt "FixedAssetBrowseView"
#~ msgid "Description"
#~ msgstr "Megnevezés"

#~ msgctxt "FixedAssetBrowseView"
#~ msgid "Id"
#~ msgstr "Az"

#~ msgctxt "FixedAssetBrowseView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "FixedAssetBrowseView"
#~ msgid "Locked"
#~ msgstr "Lezárva"

#~ msgctxt "FixedAssetBrowseView"
#~ msgid "Manufacturer"
#~ msgstr "Gyártó"

#~ msgctxt "FixedAssetBrowseView"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#~ msgctxt "FixedAssetBrowseView"
#~ msgid "Number"
#~ msgstr "Sorszám"

#~ msgctxt "FixedAssetBrowseView"
#~ msgid "Quantity"
#~ msgstr "Mennyiség"

#~ msgctxt "WasteBinBrowserView"
#~ msgid "Number"
#~ msgstr "Azonosító"

#~ msgid "Meter Validation..."
#~ msgstr "Mérőóra hitelesítése..."

#~ msgid "Import meter validation"
#~ msgstr "Hiteles leolvasás"

#~ msgid "Sheets"
#~ msgstr "Munkalapok"

#~ msgid "Asset Data"
#~ msgstr "Eszközadatok"

#~ msgid "Process"
#~ msgstr "Feldolgozás"

#~ msgctxt "ContractBrowseView"
#~ msgid "Contract type"
#~ msgstr "Szerződés típusa"

#~ msgctxt "ContractBrowseView"
#~ msgid "End Date"
#~ msgstr "Záró dátum"

#~ msgctxt "ContractBrowseView"
#~ msgid "Id"
#~ msgstr "Az"

#~ msgctxt "ContractBrowseView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "ContractBrowseView"
#~ msgid "Locked"
#~ msgstr "Lezárva"

#~ msgctxt "ContractBrowseView"
#~ msgid "Origin"
#~ msgstr "Forrás"

#~ msgctxt "ContractBrowseView"
#~ msgid "Reference Number"
#~ msgstr "Hivatkozási szám"

#~ msgctxt "ContractBrowseView"
#~ msgid "Rental Id"
#~ msgstr "Bérlemény AZ"

#~ msgctxt "ContractBrowseView"
#~ msgid "Rental Number"
#~ msgstr "Bérlemény sorszáma"

#~ msgctxt "ContractBrowseView"
#~ msgid "Status"
#~ msgstr "Státusz"

#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Contract Id"
#~ msgstr "Szerződés AZ"

#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Contract Number"
#~ msgstr "Szerződésszám"

#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Contract Version"
#~ msgstr "Szerződés verziója"

#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Contract status"
#~ msgstr "Szerződés státusza"

#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Contract type"
#~ msgstr "Szerződés típusa"

#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Counter Party Id"
#~ msgstr "Szerződő partner AZ"

#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Counter Party Name"
#~ msgstr "Szerződő partner"

#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Counter Party Number"
#~ msgstr "Szerződő partner sorszáma"

#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Id"
#~ msgstr "AZ"

#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Locked"
#~ msgstr "Lezárva"

#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Note"
#~ msgstr "Megjegyzés"

#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Rental Id"
#~ msgstr "Bérlemény AZ"

#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Rental Number"
#~ msgstr "Bérlemény azonosító"

#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Valid From"
#~ msgstr "Érvényesség kezdete"

#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Valid To"
#~ msgstr "Érvényesség vége"

#~ msgctxt "ContractSearchRefTypes"
#~ msgid "Company"
#~ msgstr "Cég"

#~ msgctxt "ContractSearchRefTypes"
#~ msgid "Customer"
#~ msgstr "Vevő"

#~ msgctxt "ContractSearchRefTypes"
#~ msgid "Part"
#~ msgstr "Cikk"

#~ msgctxt "ContractSearchRefTypes"
#~ msgid "Rental"
#~ msgstr "Bérlemény"

#~ msgctxt "ResourceOrigin"
#~ msgid "Irent"
#~ msgstr "Irent"

#~ msgctxt "ResourceOrigin"
#~ msgid "Local"
#~ msgstr "Helyi"

#~ msgctxt "UpdateInvoiceStatus"
#~ msgid "Value"
#~ msgstr "Érték"

#~ msgctxt "MeterStats"
#~ msgid "Difference"
#~ msgstr "Eltérés"

#~ msgctxt "MeterRentalServiceOnMeterView"
#~ msgid "Note"
#~ msgstr "Megjegyzés"

#~ msgctxt "MeterRentalServiceOnMeterView"
#~ msgid "Part Name"
#~ msgstr "Megnevezés"

#~ msgid "MeterTypes', 'Pulse meter"
#~ msgstr "Impulzusmérő"

#~ msgctxt "MeterChannelCalibrationModal"
#~ msgid "Calibration time"
#~ msgstr "Kalibrálás időpontja"

#~ msgctxt "MeterChannelCalibrationModal"
#~ msgid "Offset"
#~ msgstr "Korrekció"

#~ msgctxt "MeterStats"
#~ msgid "Daily Consumption"
#~ msgstr "Napi fogyasztás"

#~ msgctxt "CompanyBrowseView"
#~ msgid "Email"
#~ msgstr "Email"

#~ msgctxt "CompanyBrowseView"
#~ msgid "Id"
#~ msgstr "Az"

#~ msgctxt "CompanyBrowseView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "CompanyBrowseView"
#~ msgid "Locked"
#~ msgstr "Lezárva"

#~ msgctxt "CompanyBrowseView"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#~ msgctxt "CompanyBrowseView"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "CompanyBrowseView"
#~ msgid "Number"
#~ msgstr "Sorszám"

#~ msgctxt "CompanyBrowseView"
#~ msgid "Partner type"
#~ msgstr "Partner típusa"

#~ msgctxt "CompanyBrowseView"
#~ msgid "Registration Number"
#~ msgstr "Cégjegyzékszám"

#~ msgctxt "CompanyBrowseView"
#~ msgid "Tax Number"
#~ msgstr "Adószám"

#~ msgctxt "Debt"
#~ msgid "Counter Party Id"
#~ msgstr "Szerződő partner AZ"

#~ msgctxt "DunningLetterBrowse"
#~ msgid "Customer Id"
#~ msgstr "Vevő Az"

#~ msgctxt "PartBrowseView"
#~ msgid "Description"
#~ msgstr "Leírás"

#~ msgctxt "PartBrowseView"
#~ msgid "Groups"
#~ msgstr "Csoportok"

#~ msgctxt "PartBrowseView"
#~ msgid "Id"
#~ msgstr "Az"

#~ msgctxt "PartBrowseView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "PartBrowseView"
#~ msgid "Locked"
#~ msgstr "Lezárva"

#~ msgctxt "PartBrowseView"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#~ msgctxt "PartBrowseView"
#~ msgid "Number"
#~ msgstr "Sorszám"

#~ msgctxt "PartBrowseView"
#~ msgid "Unit"
#~ msgstr "Mennyiségi egység"

#~ msgctxt "PartTypes"
#~ msgid "Product"
#~ msgstr "Termék"

#~ msgctxt "PartTypes"
#~ msgid "Service"
#~ msgstr "Szolgáltatás"

#~ msgctxt "PartnerTypes"
#~ msgid "Both"
#~ msgstr "Mindkettő"

#~ msgctxt "PartnerTypes"
#~ msgid "Customer"
#~ msgstr "Vevő"

#~ msgctxt "PartnerTypes"
#~ msgid "Vendor"
#~ msgstr "Szállító"

#~ msgctxt "RentalBrowseView"
#~ msgid "Area"
#~ msgstr "Alapterület"

#~ msgctxt "RentalBrowseView"
#~ msgid "Company Id"
#~ msgstr "Cég ID"

#~ msgctxt "RentalBrowseView"
#~ msgid "Company Name"
#~ msgstr "Saját cég"

#~ msgctxt "RentalBrowseView"
#~ msgid "Description"
#~ msgstr "Leírás"

#~ msgctxt "RentalBrowseView"
#~ msgid "Id"
#~ msgstr "Az"

#~ msgctxt "RentalBrowseView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "RentalBrowseView"
#~ msgid "Locked"
#~ msgstr "Lezárva"

#~ msgctxt "RentalBrowseView"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#~ msgctxt "RentalBrowseView"
#~ msgid "Number"
#~ msgstr "Azonosító"

#~ msgctxt "RentalBrowseView"
#~ msgid "Valid From"
#~ msgstr "Érvényesség kezdete"

#~ msgctxt "RentalBrowseView"
#~ msgid "Valid To"
#~ msgstr "Érvényesség vége"

#~ msgid "Sensor DevEUI"
#~ msgstr "Szenzor DevEUI"

#~ msgctxt "MeterBrowseView"
#~ msgid "Barcode"
#~ msgstr "Vonalkód"

#~ msgctxt "MeterBrowseView"
#~ msgid "Description"
#~ msgstr "Leírás"

#~ msgctxt "MeterBrowseView"
#~ msgid "Id"
#~ msgstr "Az"

#~ msgctxt "MeterBrowseView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "MeterBrowseView"
#~ msgid "Location Name"
#~ msgstr "Lokáció Megnevezése"

#~ msgctxt "MeterBrowseView"
#~ msgid "Locked"
#~ msgstr "Lezárva"

#~ msgctxt "MeterBrowseView"
#~ msgid "Rental Number"
#~ msgstr "Bérlemény azonosító"

#~ msgctxt "MeterBrowseView"
#~ msgid "Serial Number"
#~ msgstr "Sorozatszám"

#~ msgctxt "MeterBrowseView"
#~ msgid "Unit"
#~ msgstr "Me"

#~ msgctxt "MeterBrowseView"
#~ msgid "Valid From"
#~ msgstr "Érvényesség kezdete"

#~ msgctxt "MeterBrowseView"
#~ msgid "Valid To"
#~ msgstr "Érvényesség vége"

#~ msgctxt "MeterReadingBrowseView"
#~ msgid "Barcode"
#~ msgstr "Vonalkód"

#~ msgctxt "MeterReadingBrowseView"
#~ msgid "Created At"
#~ msgstr "Készült"

#~ msgctxt "MeterReadingBrowseView"
#~ msgid "Created By"
#~ msgstr "Készítette"

#~ msgctxt "MeterReadingBrowseView"
#~ msgid "Deveui"
#~ msgstr "Deveui"

#~ msgctxt "MeterReadingBrowseView"
#~ msgid "Id"
#~ msgstr "Az"

#~ msgctxt "MeterReadingBrowseView"
#~ msgid "Locked"
#~ msgstr "Lezárva"

#~ msgctxt "MeterReadingBrowseView"
#~ msgid "Meter type"
#~ msgstr "Mérő típusa"

#~ msgctxt "MeterReadingBrowseView"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "MeterReadingBrowseView"
#~ msgid "Reading Date"
#~ msgstr "Leolvasás dáruma"

#~ msgctxt "MeterReadingBrowseView"
#~ msgid "Reading Time"
#~ msgstr "Leolvasás ideje"

#~ msgctxt "MeterReadingBrowseView"
#~ msgid "Reading Type"
#~ msgstr "Leolvasás típusa"

#~ msgctxt "MeterReadingBrowseView"
#~ msgid "Serial Number"
#~ msgstr "Sorozatszám"

#~ msgctxt "MeterReadingBrowseView"
#~ msgid "Tag Id"
#~ msgstr "Címke"

#~ msgctxt "MeterReadingBrowseView"
#~ msgid "Unit"
#~ msgstr "Mennyiségi egység"

#~ msgctxt "MeterReadingBrowseView"
#~ msgid "Value"
#~ msgstr "Érték"

#~ msgctxt "PaymentBrowserView"
#~ msgid "Clients"
#~ msgstr "Ügyfelek"

#~ msgctxt "PaymentBrowserView"
#~ msgid "Created At"
#~ msgstr "Készült"

#~ msgctxt "PaymentBrowserView"
#~ msgid "Created By"
#~ msgstr "Készítette"

#~ msgctxt "PaymentBrowserView"
#~ msgid "Huf In"
#~ msgstr "HUF bevétel"

#~ msgctxt "PaymentBrowserView"
#~ msgid "Huf Out"
#~ msgstr "HUF kiadás"

#~ msgctxt "PaymentBrowserView"
#~ msgid "Invoice Numbers"
#~ msgstr "Számlaszámok"

#~ msgctxt "PaymentBrowserView"
#~ msgid "Transaction Number"
#~ msgstr "Tranzakció száma"

#~ msgctxt "WasteBinBrowserView"
#~ msgid "Client Id"
#~ msgstr "Kliens AZ"

#~ msgid "Search Rentals"
#~ msgstr "Bérlemények keresése"

#~ msgid "Search Contracts"
#~ msgstr "Szerződések keresése"

#~ msgid "Search for contracts..."
#~ msgstr "Szerződések keresése..."

#~ msgid "Search Clients"
#~ msgstr "Ügyfél keresése"

#~ msgid "Search for client..."
#~ msgstr "Ügyfél keresése..."

#~ msgctxt "StatDataType"
#~ msgid "Sentence"
#~ msgstr "Sentence"

#, fuzzy
#~| msgid "Invoice number"
#~ msgid "Invoices Invoices"
#~ msgstr "Számlaszám"

#~ msgid "Customer type"
#~ msgstr "Vevőtípus"

#~ msgctxt "Client"
#~ msgid "Address"
#~ msgstr "Cím"

#~ msgctxt "Client"
#~ msgid "Address Notes"
#~ msgstr "Címadat megjegyzés"

#~ msgctxt "Client"
#~ msgid "Customertype Id"
#~ msgstr "Vevőtípus"

#~ msgctxt "Client"
#~ msgid "Eutaxnumber"
#~ msgstr "EU adószám"

#~ msgctxt "Client"
#~ msgid "Regnumber"
#~ msgstr "Regisztrációs szám"

#~ msgctxt "Client"
#~ msgid "Taxnumber"
#~ msgstr "Adószám"

#~ msgctxt "Client"
#~ msgid "Zipcode"
#~ msgstr "Irányítószám"

#~ msgctxt "CompanyBrowseView"
#~ msgid "Created By"
#~ msgstr "Készítette"

#~ msgctxt "CompanyBrowseView"
#~ msgid "Etag"
#~ msgstr "Etag"

#~ msgctxt "CompanyBrowseView"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#~ msgctxt "CompanyBrowseView"
#~ msgid "Self"
#~ msgstr "Self"

#~ msgctxt "CompanyBrowseView"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#~ msgctxt "CompanyBrowseView"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#~ msgid "Identifier"
#~ msgstr "Azonosító"

#~ msgid "Create Meter Measurements"
#~ msgstr "Leolvasások generálása"

#~ msgctxt "MeterMeasurementGenerateButton"
#~ msgid "Create Measurements"
#~ msgstr "Mérőállások generálása"

#, fuzzy
#~| msgid "Dunning letter"
#~ msgid "{{ 'Dunning letter"
#~ msgstr "Felszólítólevél"

#~ msgid "New Fixed Asset"
#~ msgstr "Új tárgyi eszköz"

#~ msgctxt "CustomerView"
#~ msgid "Account"
#~ msgstr "Számlaszám"

#~ msgctxt "CustomerView"
#~ msgid "Address"
#~ msgstr "Cím"

#~ msgctxt "CustomerView"
#~ msgid "Address Notes"
#~ msgstr "Címadat megjegyzés"

#~ msgctxt "CustomerView"
#~ msgid "City"
#~ msgstr "Város"

#~ msgctxt "CustomerView"
#~ msgid "Country"
#~ msgstr "Ország"

#~ msgctxt "CustomerView"
#~ msgid "Customertype Id"
#~ msgstr "Vevőtípus"

#~ msgctxt "CustomerView"
#~ msgid "Email"
#~ msgstr "Email"

#~ msgctxt "CustomerView"
#~ msgid "Eutaxnumber"
#~ msgstr "EU adószám"

#~ msgctxt "CustomerView"
#~ msgid "Id"
#~ msgstr "Az"

#~ msgctxt "CustomerView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "CustomerView"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#~ msgctxt "CustomerView"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "CustomerView"
#~ msgid "Number"
#~ msgstr "Sorszám"

#~ msgctxt "CustomerView"
#~ msgid "Regnumber"
#~ msgstr "Regisztrációs szám"

#~ msgctxt "CustomerView"
#~ msgid "State"
#~ msgstr "Státusz"

#~ msgctxt "CustomerView"
#~ msgid "Taxnumber"
#~ msgstr "Adószám"

#~ msgctxt "CustomerView"
#~ msgid "Zipcode"
#~ msgstr "Irányítószám"

#~ msgctxt "FixedAssetBrowseView"
#~ msgid "Created At"
#~ msgstr "Készült"

#~ msgctxt "FixedAssetBrowseView"
#~ msgid "Created By"
#~ msgstr "Készítette"

#~ msgctxt "FixedAssetBrowseView"
#~ msgid "Etag"
#~ msgstr "Etag"

#~ msgctxt "FixedAssetBrowseView"
#~ msgid "Groups"
#~ msgstr "Csoportok"

#~ msgctxt "FixedAssetBrowseView"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#~ msgctxt "FixedAssetBrowseView"
#~ msgid "Self"
#~ msgstr "Self"

#~ msgctxt "FixedAssetBrowseView"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#~ msgctxt "FixedAssetBrowseView"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#~ msgid "Contract reference number"
#~ msgstr "Szerződés hivatkozási száma"

#~ msgid "Contract locked"
#~ msgstr "Szerződés lezárva"

#~ msgid "Rental number"
#~ msgstr "Bérlemény száma"

#~ msgid "Rental place number"
#~ msgstr "Bérlemény helyrajzi száma"

#~ msgid "Lessor number"
#~ msgstr "Bérbeadó ügyfélszáma"

#~ msgid "Lessor EU taxnumber"
#~ msgstr "Bérbeadó EU adószáma"

#~ msgid "Lessor notes"
#~ msgstr "Bérbeadó megjegyzés"

#~ msgid "Lessor registration number"
#~ msgstr "Bérbeadó cégjegyzék száma"

#~ msgid "Tenant number"
#~ msgstr "Bérlő ügyfélszáma"

#~ msgid "Tenant taxnumber"
#~ msgstr "Bérlő adószáma"

#~ msgid "Tenant EU taxnumber"
#~ msgstr "Bérlő EU adószáma"

#~ msgid "Tenant notes"
#~ msgstr "Bérlő megjegyzés"

#~ msgid "Tenant registration number"
#~ msgstr "Bérlő cégjegyzékszáma"

#~ msgid "Measurement Type"
#~ msgstr "Leolvasás típusa"

#~ msgctxt "MeterMeasurementBrowseView"
#~ msgid "Barcode"
#~ msgstr "Vonalkód"

#~ msgctxt "MeterMeasurementBrowseView"
#~ msgid "Created At"
#~ msgstr "Készült"

#~ msgctxt "MeterMeasurementBrowseView"
#~ msgid "Created By"
#~ msgstr "Készítette"

#~ msgctxt "MeterMeasurementBrowseView"
#~ msgid "Deveui"
#~ msgstr "DevEUI"

#~ msgctxt "MeterMeasurementBrowseView"
#~ msgid "Id"
#~ msgstr "Az"

#~ msgctxt "MeterMeasurementBrowseView"
#~ msgid "Locked"
#~ msgstr "Lezárva"

#~ msgctxt "MeterMeasurementBrowseView"
#~ msgid "Measurement Date"
#~ msgstr "Leolvasás dátuma"

#~ msgctxt "MeterMeasurementBrowseView"
#~ msgid "Measurement Time"
#~ msgstr "Leolvasás ideje"

#~ msgctxt "MeterMeasurementBrowseView"
#~ msgid "Measurement Type"
#~ msgstr "Leolvasás típusa"

#~ msgctxt "MeterMeasurementBrowseView"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "MeterMeasurementBrowseView"
#~ msgid "Serial Number"
#~ msgstr "Sorozatszám"

#~ msgctxt "MeterMeasurementBrowseView"
#~ msgid "Tag Id"
#~ msgstr "Címke"

#~ msgctxt "MeterMeasurementBrowseView"
#~ msgid "Unit"
#~ msgstr "Mennyiségi egység"

#~ msgctxt "MeterMeasurementBrowseView"
#~ msgid "Value"
#~ msgstr "Érték"

#~ msgctxt "PartBrowseView"
#~ msgid "Created At"
#~ msgstr "Készült"

#~ msgctxt "PartBrowseView"
#~ msgid "Created By"
#~ msgstr "Készítette"

#~ msgctxt "PartBrowseView"
#~ msgid "Etag"
#~ msgstr "Etag"

#~ msgctxt "PartBrowseView"
#~ msgid "External Id"
#~ msgstr "Külső Azonosító"

#~ msgctxt "PartBrowseView"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#~ msgctxt "PartBrowseView"
#~ msgid "Self"
#~ msgstr "Self"

#~ msgctxt "PartBrowseView"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#~ msgctxt "PartBrowseView"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#~ msgctxt "RentalBrowseView"
#~ msgid "Created At"
#~ msgstr "Készült"

#~ msgctxt "RentalBrowseView"
#~ msgid "Created By"
#~ msgstr "Készítette"

#~ msgctxt "RentalBrowseView"
#~ msgid "Etag"
#~ msgstr "Etag"

#~ msgctxt "RentalBrowseView"
#~ msgid "External Id"
#~ msgstr "Külső Azonosító"

#~ msgctxt "RentalBrowseView"
#~ msgid "Self"
#~ msgstr "Self"

#~ msgctxt "RentalBrowseView"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#~ msgctxt "RentalBrowseView"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#~ msgctxt "TemplateBrowse"
#~ msgid "Created At"
#~ msgstr "Létrehozva"

#~ msgctxt "TemplateBrowse"
#~ msgid "Created By"
#~ msgstr "Készítette"

#~ msgctxt "TemplateBrowse"
#~ msgid "Id"
#~ msgstr "Az"

#~ msgctxt "TemplateBrowse"
#~ msgid "Name"
#~ msgstr "Megnevezés"

#~ msgctxt "TemplateBrowse"
#~ msgid "Template type"
#~ msgstr "Sablon típusa"

#~ msgctxt "TemplateBrowse"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#~ msgctxt "TemplateBrowse"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Contract Status"
#~ msgstr "Szerződés státusza"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Inactive rental"
#~ msgstr "Inaktív bérlemény"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Lessor"
#~ msgstr "Bérbeadó"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Lessor registration number"
#~ msgstr "Bérbeadó cégjegyzékszáma"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Tenant"
#~ msgstr "Bérlő"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Tenant EU taxnumber"
#~ msgstr "Bérlő EU adószáma"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Tenant registration number"
#~ msgstr "Bérlő cégjegyzékszáma"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Contract Locked"
#~ msgstr "Szerződés lezárva"

#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Contract Reference Number"
#~ msgstr "Szerződés hivatkozási száma"

#, fuzzy
#~| msgctxt "CompanyBrowseView"
#~| msgid "Created At"
#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "DunningLetterBrowse"
#~| msgid "Created By"
#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "CompanyBrowseView"
#~| msgid "Etag"
#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Lessor Account"
#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Lessor Account"
#~ msgstr "Bérbeadó számlaszáma"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Lessor Eutaxnumber"
#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Lessor Eutaxnumber"
#~ msgstr "Bérbeadó EU-adószáma"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Lessor Id"
#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Lessor Id"
#~ msgstr "Bérbeadó"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Lessor Notes"
#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Lessor Notes"
#~ msgstr "Bérbeadó megjegyzés"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Lessor Number"
#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Lessor Number"
#~ msgstr "Bérbeadó ügyfélszáma"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Lessor Regnumber"
#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Lessor Regnumber"
#~ msgstr "Bérlő cégjegyzékszáma"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Lessor Taxnumber"
#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Lessor Taxnumber"
#~ msgstr "Bérbeadó adószáma"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Rental Description"
#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Rental Description"
#~ msgstr "Bérlemény megnevezés"

#, fuzzy
#~| msgctxt "CompanyBrowseView"
#~| msgid "Self"
#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Self"
#~ msgstr "Self"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Tenant Eutaxnumber"
#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Tenant Eutaxnumber"
#~ msgstr "Bérlő EU-adószáma"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Tenant Notes"
#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Tenant Notes"
#~ msgstr "Bérlő megjegyzés"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Tenant Number"
#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Tenant Number"
#~ msgstr "Bérlő ügyfélszáma"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Tenant Regnumber"
#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Tenant Regnumber"
#~ msgstr "Bérlő cégjegyzékszáma"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Tenant Taxnumber"
#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Tenant Taxnumber"
#~ msgstr "Bérlő adószáma"

#, fuzzy
#~| msgctxt "CompanyBrowseView"
#~| msgid "Updated At"
#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "CompanyBrowseView"
#~| msgid "Updated By"
#~ msgctxt "ContractFeeBrowseView"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#, fuzzy
#~| msgctxt "RentalContractFeeBrowseView"
#~| msgid "Contract Locked"
#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Contract Locked"
#~ msgstr "Szerződés lezárva"

#, fuzzy
#~| msgctxt "RentalContractFeeBrowseView"
#~| msgid "Contract Reference Number"
#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Contract Reference Number"
#~ msgstr "Szerződés hivatkozási száma"

#, fuzzy
#~| msgctxt "CompanyBrowseView"
#~| msgid "Created At"
#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Created At"
#~ msgstr "Készült"

#, fuzzy
#~| msgctxt "DunningLetterBrowse"
#~| msgid "Created By"
#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Created By"
#~ msgstr "Készítette"

#, fuzzy
#~| msgctxt "CompanyBrowseView"
#~| msgid "Etag"
#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Etag"
#~ msgstr "Etag"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Lessor Account"
#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Lessor Account"
#~ msgstr "Bérbeadó számlaszáma"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Lessor Eutaxnumber"
#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Lessor Eutaxnumber"
#~ msgstr "Bérbeadó EU-adószáma"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Lessor Id"
#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Lessor Id"
#~ msgstr "Bérbeadó"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Lessor Name"
#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Lessor Name"
#~ msgstr "Bérbeadó neve"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Lessor Notes"
#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Lessor Notes"
#~ msgstr "Bérbeadó megjegyzés"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Lessor Number"
#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Lessor Number"
#~ msgstr "Bérbeadó ügyfélszáma"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Lessor Regnumber"
#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Lessor Regnumber"
#~ msgstr "Bérlő cégjegyzékszáma"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Lessor Taxnumber"
#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Lessor Taxnumber"
#~ msgstr "Bérbeadó adószáma"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Rental Company Id"
#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Rental Company Id"
#~ msgstr "Bérbeadó cég"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Rental Description"
#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Rental Description"
#~ msgstr "Bérlemény megnevezés"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Rental Inactive"
#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Rental Inactive"
#~ msgstr "Bérlemény inaktív"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Rental Notes"
#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Rental Notes"
#~ msgstr "Bérlemény megjegyzés"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Rental Place Number"
#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Rental Place Number"
#~ msgstr "Házszám"

#, fuzzy
#~| msgctxt "CompanyBrowseView"
#~| msgid "Self"
#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Self"
#~ msgstr "Self"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Tenant Eutaxnumber"
#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Tenant Eutaxnumber"
#~ msgstr "Bérlő EU-adószáma"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Tenant Id"
#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Tenant Id"
#~ msgstr "Bérlő Az"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Tenant Notes"
#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Tenant Notes"
#~ msgstr "Bérlő megjegyzés"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Tenant Number"
#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Tenant Number"
#~ msgstr "Bérlő ügyfélszáma"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Tenant Regnumber"
#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Tenant Regnumber"
#~ msgstr "Bérlő cégjegyzékszáma"

#, fuzzy
#~| msgctxt "RentalContractAgreementBrowseView"
#~| msgid "Tenant Taxnumber"
#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Tenant Taxnumber"
#~ msgstr "Bérlő adószáma"

#, fuzzy
#~| msgctxt "CompanyBrowseView"
#~| msgid "Updated At"
#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#, fuzzy
#~| msgctxt "CompanyBrowseView"
#~| msgid "Updated By"
#~ msgctxt "ContractParkingBrowseView"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#~ msgctxt "RentalContractAgreementBrowseView"
#~ msgid "Created At"
#~ msgstr "Készült"

#~ msgctxt "RentalContractAgreementBrowseView"
#~ msgid "Created By"
#~ msgstr "Készítette"

#~ msgctxt "RentalContractAgreementBrowseView"
#~ msgid "Etag"
#~ msgstr "Etag"

#~ msgctxt "RentalContractAgreementBrowseView"
#~ msgid "Id"
#~ msgstr "Az"

#~ msgctxt "RentalContractAgreementBrowseView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "RentalContractAgreementBrowseView"
#~ msgid "Locked"
#~ msgstr "Lezárva"

#~ msgctxt "RentalContractAgreementBrowseView"
#~ msgid "Self"
#~ msgstr "Self"

#~ msgctxt "RentalContractAgreementBrowseView"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#~ msgctxt "RentalContractAgreementBrowseView"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#~ msgctxt "RentalContractAgreementBrowseView"
#~ msgid "Valid From"
#~ msgstr "Érvényesség kezdete"

#~ msgctxt "RentalContractAgreementBrowseView"
#~ msgid "Valid To"
#~ msgstr "Érvényesség vége"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Created At"
#~ msgstr "Létrehozva"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Created By"
#~ msgstr "Készítette"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "External Id"
#~ msgstr "Külső Azonosító"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Id"
#~ msgstr "Az"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Last Modified Date"
#~ msgstr "Utolsó módosítás ideje"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Lessor Account"
#~ msgstr "Bérbeadó számlaszáma"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Lessor Eutaxnumber"
#~ msgstr "Bérbeadó EU-adószáma"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Lessor Id"
#~ msgstr "Bérbeadó"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Lessor Name"
#~ msgstr "Bérbeadó neve"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Lessor Notes"
#~ msgstr "Bérbeadó megjegyzés"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Lessor Number"
#~ msgstr "Bérbeadó ügyfélszáma"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Lessor Regnumber"
#~ msgstr "Bérlő cégjegyzékszáma"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Lessor Taxnumber"
#~ msgstr "Bérbeadó adószáma"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Number"
#~ msgstr "Sorszám"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Period Of Notice"
#~ msgstr "Felmondási idő"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Rental Company Id"
#~ msgstr "Bérbeadó"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Rental Description"
#~ msgstr "Bérlemény megnevezés"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Rental Id"
#~ msgstr "Bérlemény Az"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Rental Inactive"
#~ msgstr "Bérlemény inaktív"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Rental Notes"
#~ msgstr "Bérlemény megjegyzés"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Rental Number"
#~ msgstr "Bérlemény azonosító"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Rental Place Number"
#~ msgstr "Házszám"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Status"
#~ msgstr "Státusz"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Sync Status"
#~ msgstr "Szinkronizáció státusza"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Tenant Account"
#~ msgstr "Bérlő számlaszáma"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Tenant Eutaxnumber"
#~ msgstr "Bérlő EU-adószáma"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Tenant Id"
#~ msgstr "Bérlő Az"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Tenant Name"
#~ msgstr "Bérlő"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Tenant Notes"
#~ msgstr "Bérlő megjegyzés"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Tenant Number"
#~ msgstr "Bérlő ügyfélszáma"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Tenant Regnumber"
#~ msgstr "Bérlő cégjegyzékszáma"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Tenant Taxnumber"
#~ msgstr "Bérlő adószáma"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Contract Id"
#~ msgstr "Szerződés ID"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Contract Number"
#~ msgstr "Szerződésszám"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Contract Version"
#~ msgstr "Szerződés verziója"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Contract status"
#~ msgstr "Szerződés státusza"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Created At"
#~ msgstr "Készült"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Created By"
#~ msgstr "Készítette"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Currency"
#~ msgstr "Pénznem"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Description"
#~ msgstr "Leírás"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Etag"
#~ msgstr "Etag"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Id"
#~ msgstr "Az"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Lessor Account"
#~ msgstr "Bérbeadó számlaszáma"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Lessor Eutaxnumber"
#~ msgstr "Bérbeadó EU-adószáma"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Lessor Id"
#~ msgstr "Bérbeadó"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Lessor Name"
#~ msgstr "Bérbeadó neve"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Lessor Notes"
#~ msgstr "Bérbeadó megjegyzés"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Lessor Number"
#~ msgstr "Bérbeadó ügyfélszáma"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Lessor Regnumber"
#~ msgstr "Bérbeadó cégjegyzékszáma"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Lessor Taxnumber"
#~ msgstr "Bérbeadó adószáma"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Locked"
#~ msgstr "Lezárva"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Notes"
#~ msgstr "Megjegyzés"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Price"
#~ msgstr "Ár"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Rental Company Id"
#~ msgstr "Bérbeadó"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Rental Description"
#~ msgstr "Bérlemény megnevezés"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Rental Id"
#~ msgstr "Bérlemény Az"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Rental Inactive"
#~ msgstr "Bérlemény inaktív"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Rental Notes"
#~ msgstr "Bérlemény megjegyzés"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Rental Number"
#~ msgstr "Bérlemény azonosító"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Rental Place Number"
#~ msgstr "Házszám"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Self"
#~ msgstr "Self"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Tenant Account"
#~ msgstr "Bérlő számlaszáma"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Tenant Eutaxnumber"
#~ msgstr "Bérlő EU-adószáma"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Tenant Id"
#~ msgstr "Bérlő Az"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Tenant Name"
#~ msgstr "Bérlő neve"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Tenant Notes"
#~ msgstr "Bérlő megjegyzés"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Tenant Number"
#~ msgstr "Bérlő ügyfélszáma"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Tenant Regnumber"
#~ msgstr "Bérlő cégjegyzék száma"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Tenant Taxnumber"
#~ msgstr "Bérlő adószáma"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Unit"
#~ msgstr "Mennyiségi egység"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Valid From"
#~ msgstr "Érvényesség kezdete"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Valid To"
#~ msgstr "Érvényesség vége"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Contract Id"
#~ msgstr "Szerződés ID"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Contract Locked"
#~ msgstr "Szerződés lezárva"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Contract Number"
#~ msgstr "Szerződésszám"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Contract Reference Number"
#~ msgstr "Szerződés hivatkozási száma"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Contract Version"
#~ msgstr "Szerződés verziója"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Contract status"
#~ msgstr "Szerződés státusza"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Created At"
#~ msgstr "Készült"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Created By"
#~ msgstr "Készítette"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Etag"
#~ msgstr "Etag"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Id"
#~ msgstr "Az"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Lessor Account"
#~ msgstr "Bérbeadó számlaszáma"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Lessor Eutaxnumber"
#~ msgstr "Bérbeadó EU-adószáma"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Lessor Id"
#~ msgstr "Bérbeadó"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Lessor Name"
#~ msgstr "Bérbeadó neve"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Lessor Notes"
#~ msgstr "Bérbeadó megjegyzés"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Lessor Number"
#~ msgstr "Bérbeadó ügyfélszáma"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Lessor Regnumber"
#~ msgstr "Bérlő cégjegyzékszáma"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Lessor Taxnumber"
#~ msgstr "Bérbeadó adószáma"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Locked"
#~ msgstr "Lezárva"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Note"
#~ msgstr "Megjegyzés"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Rental Company Id"
#~ msgstr "Bérbeadó"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Rental Description"
#~ msgstr "Bérlemény megnevezés"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Rental Id"
#~ msgstr "Bérlemény Az"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Rental Inactive"
#~ msgstr "Bérlemény inaktív"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Rental Notes"
#~ msgstr "Bérlemény megjegyzés"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Rental Number"
#~ msgstr "Bérlemény azonosító"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Rental Place Number"
#~ msgstr "Házszám"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Self"
#~ msgstr "Self"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Tenant Account"
#~ msgstr "Bérlő számlaszáma"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Tenant Eutaxnumber"
#~ msgstr "Bérlő EU-adószáma"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Tenant Id"
#~ msgstr "Bérlő Az"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Tenant Name"
#~ msgstr "Bérlő neve"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Tenant Notes"
#~ msgstr "Bérlő megjegyzés"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Tenant Number"
#~ msgstr "Bérlő ügyfélszáma"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Tenant Regnumber"
#~ msgstr "Bérlő cégjegyzék száma"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Tenant Taxnumber"
#~ msgstr "Bérlő adószáma"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Valid From"
#~ msgstr "Érvényesség kezdete"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Valid To"
#~ msgstr "Érvényesség vége"

#~ msgctxt "RentalContractSearchRefTypes"
#~ msgid "Customer"
#~ msgstr "Vevő"

#~ msgctxt "RentalContractSearchRefTypes"
#~ msgid "Rental"
#~ msgstr "Bérlemény"

#~ msgid "Rental contracts"
#~ msgstr "Bérleti szerződések"

#~ msgid "New Rental Contract"
#~ msgstr "Új bérleti szerződés"

#~ msgid "Rental contract fees"
#~ msgstr "Díjak és szolgáltatások"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Inactive rental"
#~ msgstr "Inaktív bérlemény"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Lessor"
#~ msgstr "Bérbeadó"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Lessor registration number"
#~ msgstr "Bérbeadó cégjegyzékszáma"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Tenant"
#~ msgstr "Bérlő"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Tenant EU taxnumber"
#~ msgstr "Bérlő EU adószáma"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Tenant registration number"
#~ msgstr "Bérlő cégjegyzékszáma"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Synchronization status"
#~ msgstr "Szinkronizásió státusza"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Last modified"
#~ msgstr "Utolsó módosítás ideje"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Inactive rental"
#~ msgstr "Inaktív bérlemény"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Lessor"
#~ msgstr "Bérbeadó"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Lessor EU taxnumber"
#~ msgstr "Bérbeadó EU adószáma"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Lessor registration number"
#~ msgstr "Bérbeadó cégjegyzékszáma"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Tenant"
#~ msgstr "Bérlő"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Tenant EU taxnumber"
#~ msgstr "Bérlő EU adószáma"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Tenant registration number"
#~ msgstr "Bérlő cégjegyzékszáma"

#~ msgid "Real property unit"
#~ msgstr "Ingatlan"

#~ msgid "Create Real Property Unit"
#~ msgstr "Új ingatlan"

#~ msgid "Real Property Units"
#~ msgstr "Ingatlanok"

#~ msgid "New real property unit"
#~ msgstr "Új ingatlan"

#~ msgctxt "MeterMeasurementBrowseView"
#~ msgid "Etag"
#~ msgstr "Etag"

#~ msgctxt "MeterMeasurementBrowseView"
#~ msgid "Inactive"
#~ msgstr "Inaktív"

#~ msgctxt "MeterMeasurementBrowseView"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#~ msgctxt "MeterMeasurementBrowseView"
#~ msgid "Self"
#~ msgstr "Self"

#~ msgctxt "MeterMeasurementBrowseView"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#~ msgctxt "MeterMeasurementBrowseView"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#~ msgctxt "MeterBrowseView"
#~ msgid "Created At"
#~ msgstr "Készült"

#~ msgctxt "MeterBrowseView"
#~ msgid "Created By"
#~ msgstr "Készítette"

#~ msgctxt "MeterBrowseView"
#~ msgid "Etag"
#~ msgstr "Etag"

#~ msgctxt "MeterBrowseView"
#~ msgid "External Id"
#~ msgstr "Külső Azonosító"

#~ msgctxt "MeterBrowseView"
#~ msgid "Groups"
#~ msgstr "Csoportok"

#~ msgctxt "MeterBrowseView"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#~ msgctxt "MeterBrowseView"
#~ msgid "Parent"
#~ msgstr "Szülő"

#~ msgctxt "MeterBrowseView"
#~ msgid "Real Property Unit"
#~ msgstr "Ingatlan"

#~ msgctxt "MeterBrowseView"
#~ msgid "Self"
#~ msgstr "Self"

#~ msgctxt "MeterBrowseView"
#~ msgid "Submeters"
#~ msgstr "Almérők"

#~ msgctxt "MeterBrowseView"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#~ msgctxt "MeterBrowseView"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#~ msgctxt "RentalBrowseView"
#~ msgid "Company"
#~ msgstr "Cég"

#~ msgctxt "RentalBrowseView"
#~ msgid "Object"
#~ msgstr "Objektum típusa"

#~ msgctxt "RentalContractAgreementBrowseView"
#~ msgid "Active"
#~ msgstr "Aktív"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Active"
#~ msgstr "Aktív"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Contract Id"
#~ msgstr "Szerződés Az"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Contract Version"
#~ msgstr "Szerződés verziója"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Created At"
#~ msgstr "Készült"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Created By"
#~ msgstr "Készítette"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Description"
#~ msgstr "Leírás"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Etag"
#~ msgstr "Etag"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Id"
#~ msgstr "Az"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Lessor Account"
#~ msgstr "Bérbeadó számlaszáma"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Lessor Eutaxnumber"
#~ msgstr "Bérbeadó EU-adószáma"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Lessor Id"
#~ msgstr "Bérbeadó"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Lessor Name"
#~ msgstr "Bérbeadó neve"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Lessor Notes"
#~ msgstr "Bérbeadó megjegyzés"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Lessor Number"
#~ msgstr "Bérbeadó ügyfélszáma"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Lessor Regnumber"
#~ msgstr "Bérlő cégjegyzékszáma"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Lessor Taxnumber"
#~ msgstr "Bérbeadó adószáma"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Locked"
#~ msgstr "Lezárva"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Rental Company Id"
#~ msgstr "Bérbeadó cég"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Rental Description"
#~ msgstr "Bérlemény megnevezés"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Rental Id"
#~ msgstr "Bérlemény Az"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Rental Inactive"
#~ msgstr "Bérlemény inaktív"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Rental Notes"
#~ msgstr "Bérlemény megjegyzés"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Rental Number"
#~ msgstr "Bérlemény azonosító"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Rental Place Number"
#~ msgstr "Házszám"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Self"
#~ msgstr "Self"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Tenant Account"
#~ msgstr "Bérlő számlaszáma"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Tenant Eutaxnumber"
#~ msgstr "Bérlő EU-adószáma"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Tenant Id"
#~ msgstr "Bérlő Az"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Tenant Name"
#~ msgstr "Bérlő"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Tenant Notes"
#~ msgstr "Bérlő megjegyzés"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Tenant Number"
#~ msgstr "Bérlő ügyfélszáma"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Tenant Regnumber"
#~ msgstr "Bérlő cégjegyzékszáma"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Tenant Taxnumber"
#~ msgstr "Bérlő adószáma"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Updated At"
#~ msgstr "Utolsó módosítás ideje"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Updated By"
#~ msgstr "Módosította"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Valid From"
#~ msgstr "Érvényesség kezdete"

#~ msgctxt "RentalContractAttachmentBrowseView"
#~ msgid "Valid To"
#~ msgstr "Érvényesség vége"

#~ msgctxt "RentalContractFeeBrowseView"
#~ msgid "Active"
#~ msgstr "Aktív"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Active"
#~ msgstr "Aktív"

#~ msgctxt "Validation"
#~ msgid "The field may only contain alphabetic characters"
#~ msgstr "A mező kizárólag betűket tartalmazhat"

#~ msgctxt "Validation"
#~ msgid "The field may only contain alpha-numeric characters"
#~ msgstr "A mező kizárólag betűket és számokat tartalmazhat"

#~ msgctxt "Validation"
#~ msgid ""
#~ "The field may contain alpha-numeric characters as well as dashes and "
#~ "underscores"
#~ msgstr ""
#~ "A mező kizárólag betűket, számokat, kötőjeleket és alulvonásokat "
#~ "tartalmazhat"

#~ msgctxt "Validation"
#~ msgid "The field may only contain alphabetic characters as well as spaces"
#~ msgstr "A mező kizárólag betűket és szóközöket tartalmazhat"

#~ msgctxt "Validation"
#~ msgid "The field must be between {min} and {max}"
#~ msgstr "A mező értéke {min} és {max} között kell, hogy legyen"

#~ msgctxt "Validation"
#~ msgid "The field confirmation does not match"
#~ msgstr "A mező nem egyezik a megerősítéssel"

#~ msgctxt "Validation"
#~ msgid "The field must be numeric and exactly contain {length} digits"
#~ msgstr "A mező {length} számjegyű kell, hogy legyen"

#~ msgctxt "Validation"
#~ msgid "The field must be {width} pixels by {height} pixels"
#~ msgstr ""
#~ "A mező felbontása {width} és {height} pixel között kell, hogy legyen"

#~ msgctxt "Validation"
#~ msgid "The field must be a valid email"
#~ msgstr "A mező nem érvényes email formátum"

#~ msgctxt "Validation"
#~ msgid "The field is not a valid value"
#~ msgstr "A mező értéke érvénytelen"

#~ msgctxt "Validation"
#~ msgid "The field is not a valid file"
#~ msgstr "A mező nem érvényes fájl"

#~ msgctxt "Validation"
#~ msgid "The field must be an image"
#~ msgstr "A mező képfálj kell, hogy legyen"

#~ msgctxt "Validation"
#~ msgid "The field must be an integer"
#~ msgstr "A mező értéke csak egész szám lehet"

#~ msgctxt "Validation"
#~ msgid "The field must be {length} long"
#~ msgstr "A mező {length} karakter hosszú kell legyen"

#~ msgctxt "Validation"
#~ msgid "The field must be {max} or less"
#~ msgstr "A mező értéke {max} vagy kevesebb lehet"

#~ msgctxt "Validation"
#~ msgid "The field may not be greater than {length} characters"
#~ msgstr "A mező értéke nem lehet hosszabb {length} karakternél"

#~ msgctxt "Validation"
#~ msgid "The field must have a valid file type"
#~ msgstr "Érvénytelen file formátum"

#~ msgctxt "Validation"
#~ msgid "The field must be {min} or more"
#~ msgstr "A mező értéke {min} vagy nagyobb lehet"

#~ msgctxt "Validation"
#~ msgid "The field must be at least {length} characters"
#~ msgstr "A mező minimum {length} karakter hosszú kell legyen"

#~ msgctxt "Validation"
#~ msgid "The field may only contain numeric characters"
#~ msgstr "A mező értéke szám kell, hogy legyen"

#~ msgctxt "Validation"
#~ msgid "The field format is invalid"
#~ msgstr "A mező formátuma érvénytelen"

#~ msgctxt "Validation"
#~ msgid "The field is required"
#~ msgstr "Kötelező mező"

#~ msgctxt "Validation"
#~ msgid "The field size must be less than {size}KB"
#~ msgstr "A mező méretének {size} kilobájtnál kisebbnek kell lennie"

#~ msgctxt "Validation"
#~ msgid "The field must be a valid decimal"
#~ msgstr "A mezőnek érvényes decimálisnak kell lennie"

#~ msgid "System Dashboard"
#~ msgstr "Dashboard"

#, fuzzy
#~| msgctxt "FixedAssetBrowseView"
#~| msgid "Manufacturer"
#~ msgid "Manufactorer"
#~ msgstr "Gyártó"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Etag"
#~ msgstr "Etag"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Self"
#~ msgstr "Self"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Description"
#~ msgstr "Leírás"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Reference Number"
#~ msgstr "Hivatkozási szám"

#, fuzzy
#~| msgid "Status"
#~ msgid "TaskRunStatus"
#~ msgstr "Státusz"

#, fuzzy
#~| msgid "Email"
#~ msgid "email"
#~ msgstr "Email"

#~ msgctxt "StatDataBrowseView"
#~ msgid "External Stat Data Type"
#~ msgstr "Adattípus"

#~ msgctxt "JobBrowse"
#~ msgid "Job Status"
#~ msgstr "Státusz"

#~ msgctxt "RentalContractBrowseView"
#~ msgid "Contract Status"
#~ msgstr "Szerződés státusza"

#~ msgctxt "RentalContractParkingBrowseView"
#~ msgid "Contract Status"
#~ msgstr "Szerződés státusza"

#~ msgctxt "slickgrid"
#~ msgid "Reload"
#~ msgstr "Újratöltés"

#~ msgctxt "slickgrid"
#~ msgid "Export table data"
#~ msgstr "Az adatok exportálása"

#~ msgid "save"
#~ msgstr "mentés"

#~ msgid "delete"
#~ msgstr "törlés"

#~ msgid "end date"
#~ msgstr "záró dátum"

#~ msgid "cancel"
#~ msgstr "mégsem"

#, fuzzy
#~| msgid "settled"
#~ msgid "Settled"
#~ msgstr "kész"

#~ msgid "close"
#~ msgstr "bezárás"

#, fuzzy
#~| msgid "Dunning letters"
#~ msgid "page-dunning-letter.no-events"
#~ msgstr "Felszólítólevelek"

#, fuzzy
#~| msgid "Dunning letters"
#~ msgid "page-dunning-letter.email-addressee"
#~ msgstr "Felszólítólevelek"

#, fuzzy
#~| msgid "Dunning letters"
#~ msgid "page-dunning-letter.email-subject"
#~ msgstr "Felszólítólevelek"

#, fuzzy
#~| msgid "Please confirm delete."
#~ msgid "page-template.please-confirm-delete"
#~ msgstr "Törlés jóváhagyása."

#~ msgid "template"
#~ msgstr "template"

#, fuzzy
#~| msgid "Created At"
#~ msgid "Executed At"
#~ msgstr "Létrehozva"

#, fuzzy
#~| msgid "Last value"
#~ msgid "Lastvalue"
#~ msgstr "Utolsó érték"

#, fuzzy
#~| msgid "File Size"
#~ msgid "Page Size"
#~ msgstr "File méret"

#, fuzzy
#~| msgid "Start"
#~ msgid "Page Start"
#~ msgstr "Indítás"

#, fuzzy
#~| msgid "Subject"
#~ msgid "Parent Object Id"
#~ msgstr "Tárgy"

#~ msgid "Success"
#~ msgstr "Sikeres"

#~ msgid "Task Id"
#~ msgstr "Feladat Az"

#~ msgid "Task Name"
#~ msgstr "Feladat Megnevezése"

#~ msgid "Task Params"
#~ msgstr "Feladat Paraméterek"

#~ msgid "Updated Records"
#~ msgstr "Módosította"

#~ msgid "completed"
#~ msgstr "kész"

#~ msgid "customer"
#~ msgstr "vevő"

#~ msgid "deleted"
#~ msgstr "törölve"

#~ msgid "disabled"
#~ msgstr "kikapcsolt"

#~ msgid "errored"
#~ msgstr "hibás"

#~ msgid "html"
#~ msgstr "HTML"

#~ msgid "invalid"
#~ msgstr "érvénytelen"

#~ msgid "mjml"
#~ msgstr "mjml"

#~ msgid "part"
#~ msgstr "rész"

#~ msgid "sent"
#~ msgstr "elküldve"

#~ msgid "settled"
#~ msgstr "kész"

#, fuzzy
#~| msgid "Rental description"
#~ msgid ".input-email-description"
#~ msgstr "Bérlemény leírása"

#, fuzzy
#~| msgid "Dunning letters"
#~ msgid ".colname-dunning-letters"
#~ msgstr "Felszólítólevelek"

#, fuzzy
#~| msgid "Rental description"
#~ msgid ".last-value-description"
#~ msgstr "Bérlemény leírása"

#, fuzzy
#~| msgid "Contract reference number"
#~ msgid ".input-starting-reference-number-label"
#~ msgstr "Szerződés hivatkozási száma"

#, fuzzy
#~| msgid "Rental notes"
#~ msgid ".input-label-notes"
#~ msgstr "Díjak és szolgáltatások"

#, fuzzy
#~| msgid "Rental contracts"
#~ msgid ".nav-contracts"
#~ msgstr "Bérleti szerződések"

#, fuzzy
#~| msgid "Rental contracts"
#~ msgid ".nav-rental-contracts"
#~ msgstr "Bérleti szerződések"

#, fuzzy
#~| msgid "Rental contract fees"
#~ msgid ".nav-rental-contract-fees"
#~ msgstr "Díjak és szolgáltatások"

#, fuzzy
#~| msgid "Rental contract parking places"
#~ msgid ".nav-rental-contract-parkings"
#~ msgstr "Bérleti szerződés parkolóhelyek"

#, fuzzy
#~| msgid "template"
#~ msgid ".nav-templates"
#~ msgstr "sablon"

#, fuzzy
#~| msgid "Contract description"
#~ msgid ".input-template-description"
#~ msgstr "Szerződés leírása"

#, fuzzy
#~| msgid "Contract description"
#~ msgid ".input-subject-description"
#~ msgstr "Szerződés leírása"

#, fuzzy
#~| msgid "template"
#~ msgid ".header-templates"
#~ msgstr "sablon"

#~ msgid "Rental contract parking places"
#~ msgstr "Bérleti szerződés parkolóhelyek"

#~ msgid "dunning_letter"
#~ msgstr "felszólítólevél"
